import { InferenceStream } from '@wm-front/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** Returns a stream for the inference that will return each token chunk by chunk */
  InferenceStream: { input: InferenceStream; output: InferenceStream; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
  /** Value for the input */
  ValueOfInput: { input: any; output: any; }
};

export type AccessTokenResponse = {
  __typename?: 'AccessTokenResponse';
  access_token: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  expires_in: Scalars['Float']['output'];
  refresh_token?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  token_type: Scalars['String']['output'];
};

/** Represent the Account of a client organization */
export type Account = {
  __typename?: 'Account';
  /** The account company name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The account's country code */
  countryCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Returns the salesforce url to the account */
  sfUrl: Scalars['String']['output'];
};

export enum AccountOrmEntitySortableFields {
  CompanyName = 'companyName',
  CountryCode = 'countryCode',
  Id = 'id'
}

export type AcknowledgeSignalInput = {
  /** Whether to create a breakdown for this signal if one does not already exist */
  createBreakdown: Scalars['Boolean']['input'];
  /** The ID of the signal to acknowledge */
  signalId: Scalars['ID']['input'];
  /** The version of the signal */
  version: Scalars['String']['input'];
};

export type Acknowledgement = {
  __typename?: 'Acknowledgement';
  /** If a breakdown was created */
  createBreakdown: Scalars['Boolean']['output'];
  /** The user who acknowledged the signal */
  userInfo: SignalFeedbackUserInfo;
};

/** Who holds an action, as a WeMaintain role. CSM is the unit's CSM, SUPPLY the request's supply chain manager. The support teams hold a support need until they assign a SUPPORT_ENGINEER; MECHANIC and SUPPORT_ENGINEER are one person, see RepairRequestAction.holder */
export enum ActionHolderRole {
  Csm = 'CSM',
  Mechanic = 'MECHANIC',
  RepairSupportTeam = 'REPAIR_SUPPORT_TEAM',
  Supply = 'SUPPLY',
  SupportEngineer = 'SUPPORT_ENGINEER',
  TechSupportTeam = 'TECH_SUPPORT_TEAM'
}

/** Who the request is waiting on: the holder, or the customer for a CSM action hidden until late */
export enum ActionWaitingOn {
  Csm = 'CSM',
  Customer = 'CUSTOMER',
  Mechanic = 'MECHANIC',
  RepairSupportTeam = 'REPAIR_SUPPORT_TEAM',
  Supply = 'SUPPLY',
  SupportEngineer = 'SUPPORT_ENGINEER',
  TechSupportTeam = 'TECH_SUPPORT_TEAM'
}

/** Type of sensor used for the presence detection to activate the door opening */
export enum ActivationType {
  ActivationRadar = 'ACTIVATION_RADAR',
  BadgeReader = 'BADGE_READER',
  DamCell = 'DAM_CELL',
  Digicode = 'DIGICODE',
  EagleActivation = 'EAGLE_ACTIVATION',
  GroundLoop = 'GROUND_LOOP',
  PresenceSensor = 'PRESENCE_SENSOR',
  PushButton = 'PUSH_BUTTON',
  RemoteBip = 'REMOTE_BIP',
  SideScreenSafetySensor = 'SIDE_SCREEN_SAFETY_SENSOR'
}

export type Activity = {
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type ActivityDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ActivityTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ActivityOrmEntitySortableFields {
  Date = 'date'
}

/** Input to add an external part item to a repair request */
export type AddExternalPartItemInput = {
  /** The description */
  description: Scalars['String']['input'];
  /** The photos for the external part */
  photos?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** The quantity */
  quantity: Scalars['Int']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
  /** The supplier link */
  supplierLink: Scalars['String']['input'];
};

/** Input to add an installation item to a repair request */
export type AddInstallationItemInput = {
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
};

/** Input create man hour repair request item */
export type AddManHourItemInput = {
  /** The on-site hours */
  noOfHours: Scalars['Int']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
  /** The travel hours, at least 1. The device market's default travel hours when not given */
  travelHours?: InputMaybe<Scalars['Int']['input']>;
};

/** Input to add a part item to a repair request */
export type AddPartItemInput = {
  /** The currency for the part price */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The part ID in the catalog */
  partId: Scalars['String']['input'];
  /** The quantity */
  quantity: Scalars['Int']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
};

export type Admin = User & {
  __typename?: 'Admin';
  CreateDashboardPdfQuery: Scalars['String']['output'];
  GetDashboardQuery: Dashboard;
  RunDashboardQuery: QueryResult;
  RunDrilldownQuery: QueryResult;
  accessibleBuildingsCount?: Maybe<Scalars['Float']['output']>;
  /** Country of the admin, null until they pick one at enrol */
  countryCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Renamed, use email instead */
  emailId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  hasMaximize?: Maybe<Scalars['Boolean']['output']>;
  /**
   * id of the admin
   * @deprecated Id property does not exist, for now the userId is returned instead
   */
  id: Scalars['ID']['output'];
  intercomHashId: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** Set when this user is an alias merged into another user: the id of that user */
  mergedIntoUserId?: Maybe<Scalars['Int']['output']>;
  mobileNo?: Maybe<Scalars['String']['output']>;
  subscriptionInfo: SubscriptionInfo;
  /** Territories this admin has access to, only works on me{} query for now */
  territories: Array<Territory>;
  /** The user id */
  userId?: Maybe<Scalars['Float']['output']>;
};


export type AdminCreateDashboardPdfQueryArgs = {
  query: CreateDashboardPdfForUserInput;
};


export type AdminGetDashboardQueryArgs = {
  query: GetDashboardQueryInput;
};


export type AdminRunDashboardQueryArgs = {
  query: RunDashboardQueryForUserInput;
};


export type AdminRunDrilldownQueryArgs = {
  query: RunDrilldownQueryForUserInput;
};

export type AdminFixProblemAuditReportLinesInput = {
  /** When the items were fixed, between the latest item discovery date and now. Not given with a task. */
  fixedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The mechanic who fixed the items. Not given with a task. */
  fixedByMechanicId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** The problem whose items are marked as fixed */
  problemId: Scalars['ID']['input'];
  /** The task the items were fixed in, which gives the mechanic and the fixed-on date. Give either the task, or the fixedAt and the fixedByMechanicId. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type AlarmSystem = {
  __typename?: 'AlarmSystem';
  id: Scalars['ID']['output'];
  /** Communication protocol used by the alarm system */
  protocol: Scalars['String']['output'];
};

/** Set of filters to apply to the alarm systems */
export type AlarmSystemsFilters = {
  /** Get only alarm systems matching these identifiers */
  alarmSystemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Annotation = {
  __typename?: 'Annotation';
  /**
   * Explain why the device is stopped
   * @deprecated Use internalComment instead
   */
  comment?: Maybe<Scalars['String']['output']>;
  /** Explain why the device is stopped to WeMaintain */
  internalComment?: Maybe<Scalars['String']['output']>;
  /** The status of the device for annnoation */
  opsStatus?: Maybe<AnnotationOpsStatus>;
  /** Explain why the device is stopped to the Customer */
  publicComment?: Maybe<Scalars['String']['output']>;
};

export type AnnotationInput = {
  /**
   * Explain why the device is stopped
   * @deprecated Use internalComment instead
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The id of the device */
  deviceId: Scalars['String']['input'];
  /** Explain why the device is stopped, visible by Wemaintain only */
  internalComment?: InputMaybe<Scalars['String']['input']>;
  /** The status of the device for annnoation */
  opsStatus?: InputMaybe<AnnotationOpsStatus>;
  /** Explain why the device is stopped, visible by the customer */
  publicComment?: InputMaybe<Scalars['String']['input']>;
};

/** Different types of status for a device stopped given by the operation team member */
export enum AnnotationOpsStatus {
  AwaitingCustomerFeedback = 'AWAITING_CUSTOMER_FEEDBACK',
  Modernization = 'MODERNIZATION',
  OrderedPiece = 'ORDERED_PIECE',
  Other = 'OTHER',
  PieceAtTheRepairer = 'PIECE_AT_THE_REPAIRER',
  PieceTakenToTheRepairer = 'PIECE_TAKEN_TO_THE_REPAIRER',
  PlannedIntervention = 'PLANNED_INTERVENTION',
  QuoteAccepted = 'QUOTE_ACCEPTED',
  QuoteSent = 'QUOTE_SENT',
  VisitOfATechnicalExpert = 'VISIT_OF_A_TECHNICAL_EXPERT',
  WaitingForAccess = 'WAITING_FOR_ACCESS',
  WaitingForATechnicalExpertOrATechnician = 'WAITING_FOR_A_TECHNICAL_EXPERT_OR_A_TECHNICIAN',
  WaitingForPieceOrder = 'WAITING_FOR_PIECE_ORDER',
  WaitingForPieceStatement = 'WAITING_FOR_PIECE_STATEMENT',
  WaitingForReceiptOfPiece = 'WAITING_FOR_RECEIPT_OF_PIECE'
}

/**
 * The answer for a question.
 * There is one answer for one question.
 * An answer is represented by one or more choices, one or more photo and a comment.
 *
 * We assume that the mobile application should fill the answeredAt field
 * To prevent some race condition from a slow network
 * So if the api receive an old answer, we just skip this answer and keep the latest response
 */
export type Answer = {
  __typename?: 'Answer';
  /**
   * Time at which this answer was **LAST** modified
   * @deprecated Use lastModifiedAt instead
   */
  answeredAt: Scalars['DateTime']['output'];
  /** The list of the selected choice for a question */
  choices?: Maybe<Array<IAnswerChoice>>;
  /** Comment from the mechanic */
  comment?: Maybe<Scalars['String']['output']>;
  /** Time at which this answer was received for the first time by the backend */
  createdAt: Scalars['DateTimeISO']['output'];
  /** The features of the answer, used for various optimizations and to trigger some specific behavior in the frontend */
  features?: Maybe<AnswerFeatures>;
  /** Time at which this answer was first answered by the mechanic */
  firstAnsweredAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  /** Time at which this answer was **LAST** modified by the client */
  lastModifiedAt: Scalars['DateTimeISO']['output'];
  /** The list of media attached to the answer */
  media: Array<AnswerPhoto>;
  /** The list of photo attached to the answer */
  photos?: Maybe<Array<AnswerPhoto>>;
  /** Question of the answer */
  question: Question;
  /** ID of the Question this is the answer to */
  questionId: Scalars['String']['output'];
  /**
   * ID of the QuestionTemplate this is the answer to
   * @deprecated Use question.id instead
   */
  questionTemplateId: Scalars['String']['output'];
  /** Task in which this question was asked */
  task: Task;
  /**
   * ID of the Task this answer is linked to
   * @deprecated Use task.id instead
   */
  taskId: Scalars['String']['output'];
};


/**
 * The answer for a question.
 * There is one answer for one question.
 * An answer is represented by one or more choices, one or more photo and a comment.
 *
 * We assume that the mobile application should fill the answeredAt field
 * To prevent some race condition from a slow network
 * So if the api receive an old answer, we just skip this answer and keep the latest response
 */
export type AnswerMediaArgs = {
  filters?: InputMaybe<FindManyAnswerMediaInput>;
};

/** One of the selected choice for one question */
export type AnswerChoice = IAnswerChoice & IQuestionChoice & {
  __typename?: 'AnswerChoice';
  /** Template for this answer, containing its translation, what it impacts and all other information */
  answerTemplate: IAnswerTemplate;
  /**
   * Answer template which contains the actual text of the answer
   * @deprecated Use answerTemplate.id instead
   */
  answerTemplateId: Scalars['String']['output'];
  /** Key to group the answers by. */
  displayGroup?: Maybe<Scalars['String']['output']>;
  /** Contains information on how to display the answer template in the front-end side */
  displayOptions: AnswerDisplayOption;
  /** The additional answer for this choice */
  followUp: FollowUp;
  /** Does the answer ask for followup */
  hasFollowUp: Scalars['Boolean']['output'];
  /** Answer ID used to match mulitple question between them, provided by the author. */
  humanKey: Scalars['String']['output'];
  /** A problemKey is always associated with a stateKey and describes what's wrong. A basic example would be the problemKey 'BROKEN' on the stateKey 'car.lighting'. */
  problemKey?: Maybe<Scalars['String']['output']>;
  /** Part of the device this questions is about. A stateKey is a representation of component and subcomponent of a device. For example 'car' or 'car.lighting' */
  stateKey?: Maybe<Scalars['String']['output']>;
  stateKeyTranslation?: Maybe<AnswerTemplateAvailableStateKey>;
  /** The text of the answer which will be displayed to the mechanic */
  title: Scalars['String']['output'];
};


/** One of the selected choice for one question */
export type AnswerChoiceDisplayGroupArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** One of the selected choice for one question */
export type AnswerChoiceStateKeyTranslationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** One of the selected choice for one question */
export type AnswerChoiceTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A selected choice for an answer */
export type AnswerChoiceInput = {
  /** Specific input for an answer choice state key, to return data like the problem key linked to the choice */
  answerChoiceStateKeyInput?: InputMaybe<AnswerChoiceStateKeyInput>;
  /** Id of the answer template this is the answer to */
  answerTemplateId: Scalars['String']['input'];
  /** Follow up to the answer */
  followUp?: InputMaybe<FollowUpInput>;
};

/** One of the selected choice for one question describing a device component issue */
export type AnswerChoiceStateKey = IAnswerChoice & IQuestionChoice & {
  __typename?: 'AnswerChoiceStateKey';
  /** Template for this answer, containing its translation, what it impacts and all other information */
  answerTemplate: IAnswerTemplate;
  /**
   * Answer template which contains the actual text of the answer
   * @deprecated Use answerTemplate.id instead
   */
  answerTemplateId: Scalars['String']['output'];
  /** Key to group the answers by. */
  displayGroup?: Maybe<Scalars['String']['output']>;
  /** Contains information on how to display the answer template in the front-end side */
  displayOptions: AnswerDisplayOption;
  /** The additional answer for this choice */
  followUp: FollowUp;
  /** Does the answer ask for followup */
  hasFollowUp: Scalars['Boolean']['output'];
  /** Answer ID used to match mulitple question between them, provided by the author. */
  humanKey: Scalars['String']['output'];
  /** problem key (device component issue) that describe this answer */
  pickedProblemKey: Scalars['String']['output'];
  /** Translations of the picked problem key for this answer choice */
  pickedProblemKeyTranslation?: Maybe<PickedProblemkeyTranslation>;
  /** A problemKey is always associated with a stateKey and describes what's wrong. A basic example would be the problemKey 'BROKEN' on the stateKey 'car.lighting'. */
  problemKey?: Maybe<Scalars['String']['output']>;
  /** Part of the device this questions is about. A stateKey is a representation of component and subcomponent of a device. For example 'car' or 'car.lighting' */
  stateKey?: Maybe<Scalars['String']['output']>;
  stateKeyTranslation?: Maybe<AnswerTemplateAvailableStateKey>;
  /** The text of the answer which will be displayed to the mechanic */
  title: Scalars['String']['output'];
};


/** One of the selected choice for one question describing a device component issue */
export type AnswerChoiceStateKeyDisplayGroupArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** One of the selected choice for one question describing a device component issue */
export type AnswerChoiceStateKeyPickedProblemKeyTranslationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** One of the selected choice for one question describing a device component issue */
export type AnswerChoiceStateKeyStateKeyTranslationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** One of the selected choice for one question describing a device component issue */
export type AnswerChoiceStateKeyTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Specific input for an answer choice state key, to return data like the problem key linked to the choice */
export type AnswerChoiceStateKeyInput = {
  /** The problem key (component issue) selected as an answer by the engineer */
  pickedProblemKey: Scalars['String']['input'];
};

/** A Condition that will depends on the answer to another question */
export type AnswerCondition = IQuestionCondition & {
  __typename?: 'AnswerCondition';
  /** The list of criteria that must all be fullfilled for the condition to apply */
  choices: Array<AnswerConditionCriteria>;
  outcome: QuestionConditionOutcome;
  /** The humanKey of the question to evaluate */
  questionKey: Scalars['String']['output'];
  /** When true, only evaluate the condition against answers from the same work order */
  sameWorkOrder?: Maybe<Scalars['Boolean']['output']>;
  type: QuestionConditionType;
};

/** The criteria that must evaluate to fulfill the condition */
export type AnswerConditionCriteria = {
  __typename?: 'AnswerConditionCriteria';
  /** The answer key that should be selected in the given question */
  key: Scalars['String']['output'];
};

/** How to display a specific option in the mobile */
export type AnswerDisplayOption = {
  __typename?: 'AnswerDisplayOption';
  /** color to use to highlight this choice when selected */
  color: AnswerDisplayOptionColor;
};

/** Colors to use when displaying an answer */
export enum AnswerDisplayOptionColor {
  Bad = 'BAD',
  Good = 'GOOD',
  Neutral = 'NEUTRAL'
}

/** The features of the answer, used for various optimizations and to trigger some specific behavior in the frontend */
export type AnswerFeatures = {
  __typename?: 'AnswerFeatures';
  workOrderForm?: Maybe<AnswerFeaturesOutput_WorkOrderForm>;
};

export type AnswerFeaturesInput = {
  workOrderForm?: InputMaybe<AnswerFeaturesInput_WorkOrderForm>;
};

export type AnswerFeaturesInput_WorkOrderForm = {
  /** WorkOrderFormAnswerFeatureCreateInput: */
  create?: InputMaybe<WorkOrderFormAnswerFeatureCreateInput>;
  workOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type AnswerFeaturesOutput_WorkOrderForm = {
  __typename?: 'AnswerFeaturesOutput_WorkOrderForm';
  /** WorkOrderFormAnswerFeatureCreateOutput: */
  create?: Maybe<WorkOrderFormAnswerFeatureCreateOutput>;
  workOrderId?: Maybe<Scalars['String']['output']>;
};

/**
 * An attached photo for an answer.
 * There is only one unique photo per question and par task.
 */
export type AnswerPhoto = {
  __typename?: 'AnswerPhoto';
  /** Answer to which this photo is linked. If none exist, that means the picture was deleted by the mechanic after being taken */
  answer?: Maybe<Answer>;
  /** Unique ID of the AnswerPhoto */
  id: Scalars['ID']['output'];
  /** Path on the mobile device where this picture is stored. This will be used as a unique indentifier to prevent dup uploads as well as an index to restore pictures locally */
  localPath: Scalars['String']['output'];
  /** Kind of media stored (photo, video) */
  mediaKind: MediaKind;
  /**
   * ID of the Question this picture is linked to
   * @deprecated Use questionTemplate.id instead
   */
  questionId: Scalars['String']['output'];
  /** @deprecated Use question.template.id */
  questionTemplateId: Scalars['String']['output'];
  /** Unique remote path where the picture is stored. For the URL refer to remoteUrl */
  remotePath: Scalars['String']['output'];
  remoteUrl: Scalars['String']['output'];
  /** Task in which this photo was taken */
  task: Task;
  /**
   * ID of the Task this picture is linked to
   * @deprecated Use task.id instead
   */
  taskId: Scalars['String']['output'];
};

/** The photo to attached */
export type AnswerPhotoInput = {
  /**
   * Path on the mobile device where this picture is stored.
   * This will be used as a unique indentifier to prevent dup uploads as well as an index to restore pictures locally
   */
  localPath: Scalars['String']['input'];
};

export enum AnswerPhotoSortableFields {
  AnsweredAt = 'answeredAt',
  Id = 'id',
  LocalPath = 'localPath',
  MediaKind = 'mediaKind',
  QuestionId = 'questionId',
  RemotePath = 'remotePath',
  TaskId = 'taskId'
}

export type AnswerPhotoUpload = {
  /** Actual file to upload */
  file: Scalars['Upload']['input'];
  /** Path on the mobile device where this picture is stored. This will be used as a unique indentifier to prevent dup uploads as well as an index to restore pictures locally */
  localPath: Scalars['String']['input'];
  /** ID of the question this picture should be linked to */
  questionId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * ID of the QuestionTemplate this picture should be linked to
   * @deprecated use questionId instead
   */
  questionTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the Task this picture should be linked to */
  taskId: Scalars['ID']['input'];
};

export enum AnswerSortableFields {
  Comment = 'comment',
  CreatedAt = 'createdAt',
  Features = 'features',
  FirstAnsweredAt = 'firstAnsweredAt',
  Id = 'id',
  LastModifiedAt = 'lastModifiedAt',
  QuestionTemplateId = 'questionTemplateId',
  TaskId = 'taskId'
}

/** The entire response for a answer */
export type AnswerTaskInput = {
  /** Time at which the client LAST modified the answer, ie: lastModifiedAt */
  answeredAt: Scalars['DateTime']['input'];
  /** Actual answers */
  choices?: InputMaybe<Array<AnswerChoiceInput>>;
  /** Comment of the mech */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Additional features for the answer */
  features?: InputMaybe<AnswerFeaturesInput>;
  /** Photos linked to the answer */
  photos?: InputMaybe<Array<AnswerPhotoInput>>;
  /** Question this is the answer to */
  questionId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Question template this is the answer to
   * @deprecated you should use questionId instead
   */
  questionTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Task this answer should be linked to */
  taskId: Scalars['String']['input'];
};

/** Possible answer to a question asked to a mechanic */
export type AnswerTemplate = IAnswerTemplate & {
  __typename?: 'AnswerTemplate';
  /** Key to group the answers by. */
  displayGroup?: Maybe<Scalars['String']['output']>;
  /** Contains information on how to display the answer template in the front-end side */
  displayOptions: AnswerDisplayOption;
  /** Does the answer ask for followup */
  hasFollowUp: Scalars['Boolean']['output'];
  /** Answer ID used to match mulitple question between them, provided by the author. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** A problemKey is always associated with a stateKey and describes what's wrong. A basic example would be the problemKey 'BROKEN' on the stateKey 'car.lighting'. */
  problemKey?: Maybe<Scalars['String']['output']>;
  /** Part of the device this questions is about. A stateKey is a representation of component and subcomponent of a device. For example 'car' or 'car.lighting' */
  stateKey?: Maybe<Scalars['String']['output']>;
  stateKeyTranslation?: Maybe<AnswerTemplateAvailableStateKey>;
  /** The text of the answer which will be displayed to the mechanic */
  title: Scalars['String']['output'];
};


/** Possible answer to a question asked to a mechanic */
export type AnswerTemplateDisplayGroupArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Possible answer to a question asked to a mechanic */
export type AnswerTemplateStateKeyTranslationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Possible answer to a question asked to a mechanic */
export type AnswerTemplateTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represent a state key (device component) with its problem keys (device component issues) that can be picked as a value to answer to a question with an AnswerTemplateStateKey */
export type AnswerTemplateAvailableStateKey = {
  __typename?: 'AnswerTemplateAvailableStateKey';
  /** The translation of the root stateKey (for car.door the translation of the root would be Cabin in english */
  category?: Maybe<Scalars['String']['output']>;
  /** Problem keys allowed for this state key (A car.door stateKey can be BROKEN, DIRTY,... */
  problemKeys?: Maybe<Array<AnswerTemplateProblemKey>>;
  /** The unique id of the stateKey (car.door) */
  stateKey: Scalars['String']['output'];
  /** The translation of the statekey */
  stateKeyTranslation?: Maybe<Scalars['String']['output']>;
};

/** Problem key(BROKEN,...) potentially linked to a stateKey (car,...) */
export type AnswerTemplateProblemKey = {
  __typename?: 'AnswerTemplateProblemKey';
  /** The translation of the problem key */
  translation?: Maybe<Scalars['String']['output']>;
  /** The value of the problem key: BROKEN, DIRTY,...  */
  value: Scalars['String']['output'];
};

/** Answer template related to a stateKey/problemKey combo */
export type AnswerTemplateStateKey = IAnswerTemplate & {
  __typename?: 'AnswerTemplateStateKey';
  /** State keys (device component) with their problem keys (device component issue) that can be picked as a value to return with this answer */
  availableStateKeys?: Maybe<Array<AnswerTemplateAvailableStateKey>>;
  /** Key to group the answers by. */
  displayGroup?: Maybe<Scalars['String']['output']>;
  /** Contains information on how to display the answer template in the front-end side */
  displayOptions: AnswerDisplayOption;
  /** Does the answer ask for followup */
  hasFollowUp: Scalars['Boolean']['output'];
  /** Answer ID used to match mulitple question between them, provided by the author. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** A problemKey is always associated with a stateKey and describes what's wrong. A basic example would be the problemKey 'BROKEN' on the stateKey 'car.lighting'. */
  problemKey?: Maybe<Scalars['String']['output']>;
  /** Part of the device this questions is about. A stateKey is a representation of component and subcomponent of a device. For example 'car' or 'car.lighting' */
  stateKey?: Maybe<Scalars['String']['output']>;
  stateKeyTranslation?: Maybe<AnswerTemplateAvailableStateKey>;
  /** The text of the answer which will be displayed to the mechanic */
  title: Scalars['String']['output'];
};


/** Answer template related to a stateKey/problemKey combo */
export type AnswerTemplateStateKeyAvailableStateKeysArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Answer template related to a stateKey/problemKey combo */
export type AnswerTemplateStateKeyDisplayGroupArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Answer template related to a stateKey/problemKey combo */
export type AnswerTemplateStateKeyStateKeyTranslationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Answer template related to a stateKey/problemKey combo */
export type AnswerTemplateStateKeyTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Set of filters to apply to the answers */
export type AnswersFilters = {
  /** Get only answers for these devices */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only answers from completed tasks */
  fromCompletedTask?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only the latest answer for each question and device */
  latestAnswersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only answers given for questions described by these human keys */
  questionHumanKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only answers that have at least one choice (excludes skipped / N/A answers) */
  withSubstantiveChoicesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only answers given in the context of these work orders (by work order ID) */
  workOrderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ApplyPriceToTargetInput = {
  quoteId: Scalars['String']['input'];
  quoteVersion: Scalars['Int']['input'];
};

/** Customer period of missions/tasks reports to archive */
export type ArchiveReportCustomerPeriodInput = {
  accountId: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

/** Missions/Tasks ID of reports to archive */
export type ArchiveReportsInput = {
  customerPeriod?: InputMaybe<ArchiveReportCustomerPeriodInput>;
  missionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taskIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input to assign an existing photo to an answer */
export type AssignMediaToAnswerInput = {
  /** The ID of the answer to which the media will be assigned */
  answerId?: InputMaybe<Scalars['String']['input']>;
  /** The local path of the media to be assigned */
  localPath: Scalars['String']['input'];
  /** The kind of media to be assigned (photo, video) */
  mediaKind: MediaKind;
  /** The ID of the question to which the media will be assigned */
  questionId: Scalars['String']['input'];
  /** The remote path of the media to be assigned */
  remotePath: Scalars['String']['input'];
  /** The ID of the task to which the media will be assigned */
  taskId: Scalars['String']['input'];
};

export type AssignQuoteOnRepairRequestInput = {
  /**
   * Quote to assign to the repair request to.
   *     Can be either:
   *     - Salesforce ID (0Q0AX00000044jW0AQ)
   *     - Salesforce quote number (00003007)
   *     - Or a salesforce link to the quote (https://url.lightning.force.com/lightning/r/Quote/[id]/view)
   */
  quote: Scalars['ID']['input'];
  /** ID or Number of the repair request to change quote */
  repairRequest: Scalars['ID']['input'];
};

/**
 * Name of the AuditOffice. For now we only handle VERITAS separately
 *   because they do 70% of audit checks
 */
export enum AuditOffice {
  Allianz = 'ALLIANZ',
  BritishEng = 'BRITISH_ENG',
  Other = 'OTHER',
  Veritas = 'VERITAS',
  Zurich = 'ZURICH'
}

/**
 * An Audit Office is a regulator issuing recommandations/obligations
 * on parts that should be fixed on elevators.
 */
export type AuditOfficeIdentity = {
  __typename?: 'AuditOfficeIdentity';
  /** The audit office reference to this elevator */
  internalId: Scalars['String']['output'];
  /** The Audit Office name */
  officeName: AuditOffice;
};

/** An AuditReport is the result of an audit check done by an external office */
export type AuditReport = {
  __typename?: 'AuditReport';
  /** When the Report was transcribed by Madagascar */
  analyzedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Name of the AuditOffice. For now we only handle VERITAS separately
   * because they do 70% of audit checks
   */
  auditOffice: AuditOffice;
  /** Reference under which the audit report is known to the audit office which issued it */
  auditOfficeRef?: Maybe<Scalars['String']['output']>;
  /** Get the fields to display when querying an audit report form of a line */
  auditReportLineForm: Array<AuditReportFormField>;
  /** @deprecated Replaced by AuditReport.lines, which is paginated */
  auditReportLines: Array<AuditReportLine>;
  building: Building;
  /** When the Report was imported by the Ops */
  createdAt: Scalars['DateTime']['output'];
  /** Audit report defects progress counts */
  defectsProgress: DefectsProgress;
  devices: AuditReportAuditReportDeviceDeviceConnection;
  /** When the Report was created by the Audit Office */
  emittedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the Report is expired (a new audit report should be emitted that will replace this one.).
   * The given date marks the moment it is expired (isExpired = (NOW() >= expiredAt))
   */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The lines transcribed from the report */
  lines: AuditReportAuditReportLineConnection;
  /** When the Report was received by WeMaintain */
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  reportFileName: Scalars['String']['output'];
  reportUrl: Scalars['String']['output'];
  /** When the Report was validated by the Ops Team */
  reviewedByOpsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The report can be either awaiting transcription by Madagascar, ready for review
   * by the WM Ops Team, or reviewed, and therefore completely processed.
   */
  status: AuditReportStatus;
  /** Type of the report */
  type: AuditReportType;
};


/** An AuditReport is the result of an audit check done by an external office */
export type AuditReportDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An AuditReport is the result of an audit check done by an external office */
export type AuditReportLinesArgs = {
  order?: InputMaybe<Array<AuditReportAuditReportLineOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};

export type AuditReportAuditReportConnection = {
  __typename?: 'AuditReportAuditReportConnection';
  edges: Array<AuditReportAuditReportEdge>;
  pageInfo: AuditReportPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type AuditReportAuditReportDeviceDeviceConnection = {
  __typename?: 'AuditReportAuditReportDeviceDeviceConnection';
  edges: Array<AuditReportAuditReportDeviceDeviceEdge>;
  pageInfo: AuditReportPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type AuditReportAuditReportDeviceDeviceEdge = {
  __typename?: 'AuditReportAuditReportDeviceDeviceEdge';
  auditReport: AuditReport;
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  /** Audit report's device defects progress counts */
  defectsProgress: DefectsProgress;
  /** The device id */
  id: Scalars['ID']['output'];
  /** The lines transcribed from the report */
  lines: AuditReportAuditReportLineConnection;
  node: Device;
};


export type AuditReportAuditReportDeviceDeviceEdgeLinesArgs = {
  order?: InputMaybe<Array<AuditReportAuditReportLineOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};

export type AuditReportAuditReportEdge = {
  __typename?: 'AuditReportAuditReportEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: AuditReport;
};

export type AuditReportAuditReportLineConnection = {
  __typename?: 'AuditReportAuditReportLineConnection';
  edges: Array<AuditReportAuditReportLineEdge>;
  pageInfo: AuditReportPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type AuditReportAuditReportLineEdge = {
  __typename?: 'AuditReportAuditReportLineEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: AuditReportLine;
};

export type AuditReportAuditReportLineOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: AuditReportLineSortableFields;
};

export type AuditReportAuditReportOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: AuditReportSortableFields;
};

/** Allows filtering the available report types of a country */
export type AuditReportConfigDetailsFilters = {
  country: SupportedCountries;
};

export type AuditReportConfigDetailsObject = {
  __typename?: 'AuditReportConfigDetailsObject';
  /** The available report types of the selected country */
  availableReportTypes: Array<AuditReportType>;
};

export type AuditReportConfigObject = {
  __typename?: 'AuditReportConfigObject';
  /** The report types expected for the building */
  expectedReportTypes: Array<AuditReportType>;
  /** The report types absent for the building */
  missingReportTypes: Array<AuditReportType>;
  /** The non-obligatory possible report types for the building */
  optionalReportTypes: Array<AuditReportType>;
  /** The report types present from the building */
  presentReportTypes: Array<AuditReportType>;
};

export type AuditReportConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Used to filter audit reports */
export type AuditReportFilters = {
  /** Filter audit reports that are link to specifics accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Queries specific reports by IDs */
  auditReportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Building ids to filter audit reports by */
  buildingIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  /**
   * Filter audit reports that are link to specifics accounts
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Internal Wemaintain id of the device
   * @deprecated Replaced by lineDeviceIds field
   */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter reports where deviceIds appears on AuditReportLines.deviceId */
  lineDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter audit reports by the manager of the ops referent user on the building's contract. Given a list of user IDs, audit reports whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter invoice items by users that manage the current contract for the audit report */
  referentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter reports where deviceIds are listed in AuditReport.devices */
  reportDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters Audit Reports by their statuses. Transcriber can only see the
   * TODO reports.
   * @deprecated Use 'statuses' instead
   */
  status?: InputMaybe<AuditReportStatus>;
  /**
   * Filters Audit Reports by their statuses. Transcriber can only see the
   * TODO reports.
   */
  statuses?: InputMaybe<Array<AuditReportStatus>>;
  /** Get only AuditReports located in a specific territory. Only takes ISO 2 country codes for now (eg: FR, GB, SG...). */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents a single input that belongs to the form of an audit check */
export type AuditReportFormField = {
  /** The identifier of the field */
  key: Scalars['String']['output'];
  /** Whether the field should be required or not. */
  required: Scalars['Boolean']['output'];
  /** The translations for the field name */
  title?: Maybe<Scalars['String']['output']>;
};

export type AuditReportFormFieldCheckbox = AuditReportFormField & {
  __typename?: 'AuditReportFormFieldCheckbox';
  /** The identifier of the field */
  key: Scalars['String']['output'];
  /** Whether the field should be required or not. */
  required: Scalars['Boolean']['output'];
  /** The translations for the field name */
  title?: Maybe<Scalars['String']['output']>;
};

export type AuditReportFormFieldDate = AuditReportFormField & {
  __typename?: 'AuditReportFormFieldDate';
  /** The identifier of the field */
  key: Scalars['String']['output'];
  /** Whether the field should be required or not. */
  required: Scalars['Boolean']['output'];
  /** The translations for the field name */
  title?: Maybe<Scalars['String']['output']>;
};

export type AuditReportFormFieldOption = AuditReportFormField & {
  __typename?: 'AuditReportFormFieldOption';
  /** The identifier of the field */
  key: Scalars['String']['output'];
  options: Array<AuditReportFormFieldOptionItem>;
  /** Whether the field should be required or not. */
  required: Scalars['Boolean']['output'];
  /** The translations for the field name */
  title?: Maybe<Scalars['String']['output']>;
};

export type AuditReportFormFieldOptionItem = {
  __typename?: 'AuditReportFormFieldOptionItem';
  /** The name of the option in the select input */
  label: Scalars['String']['output'];
  /** The value of the option in the select input */
  value: Scalars['String']['output'];
};

export type AuditReportFormFieldRadio = AuditReportFormField & {
  __typename?: 'AuditReportFormFieldRadio';
  /** The identifier of the field */
  key: Scalars['String']['output'];
  options: Array<AuditReportFormFieldOptionItem>;
  /** Whether the field should be required or not. */
  required: Scalars['Boolean']['output'];
  /** The translations for the field name */
  title?: Maybe<Scalars['String']['output']>;
};

export type AuditReportFormFieldText = AuditReportFormField & {
  __typename?: 'AuditReportFormFieldText';
  /** The identifier of the field */
  key: Scalars['String']['output'];
  /** Whether the field should be required or not. */
  required: Scalars['Boolean']['output'];
  /** The translations for the field name */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * An AuditReportLine is a selected reserve from the auditReport file.
 *   This selection is created by the Madagash people aka transcribers and validated by our ops team
 */
export type AuditReportLine = {
  __typename?: 'AuditReportLine';
  auditReport: AuditReport;
  /** The url to the stored certificate of completion of the underlying defect. */
  certificateUrl?: Maybe<Scalars['String']['output']>;
  /** The text of the report line */
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The type of defect that will be emitted from this report-line, defining the behavior for fixing. See DefectType. */
  defectType: DefectType;
  device: Device;
  /** The device this report line refers to */
  deviceId: Scalars['ID']['output'];
  /**
   * Date at which the defect was dicovered.
   *       Most often it's the date of the current report
   */
  discoveredAt: Scalars['DateTime']['output'];
  /** @deprecated Use device instead */
  elevator: Device;
  /** external ID we would like the line to be linked against if applicable */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Set when an admin (CSM) recorded the fix of the AuditReportLine. The work itself was done by the fixedByMechanic. */
  fixRecordedByAdmin?: Maybe<FixRecord>;
  /** Date at which the defect has been fixed */
  fixedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Resolve the Mechanic that fixed the AuditReportLine */
  fixedByMechanic?: Maybe<Mechanic>;
  /**
   * The mechanic that fixed the defect during a visit
   * Notes: This information is known only for the AuditReportLine fixed after the import (2021.12.21)
   */
  fixedByMechanicId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** The current issue state associated to this specific audit report line */
  issue?: Maybe<IssueSnapshot>;
  /**
   * The top left X position of the report line
   *     calculated from the left border of the report.
   */
  positionX: Scalars['Float']['output'];
  /**
   * The top left Y position of the report line
   *     calculated from the top of the report.
   */
  positionY: Scalars['Float']['output'];
  /** The problem associated to this audit report line */
  problem?: Maybe<Problem>;
  /** Whether this report line is included or not or non-applicable to the customer contract */
  qualification?: Maybe<Qualification>;
  /**
   * Status of the reportLine.
   * @deprecated Use repairRequest.quoteState in place of this field. Quotes are now manage through repair requests.
   */
  quoteStatus?: Maybe<QuoteStatus>;
  /** The repair status of this audit report line, if it needs a repair request, a request is ongoing, a repair can be done on field or the repair has been done */
  repairStatus?: Maybe<AuditReportLineRepairStatus>;
  /** The report this line belongs to */
  reportId: Scalars['ID']['output'];
  /** Status of the reportLine. */
  status: AuditReportLineStatus;
  /** The summary of the report line, can be an augmented summary of all defects that have the same problem */
  summary: Scalars['String']['output'];
  /** The date before which the report line needs to be done by the engineer. */
  toBeDoneBefore?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Whether a report line was brought up before the contract started. */
  wasDiscoveredBeforeContractStartedAt: Scalars['Boolean']['output'];
};

/** Filters by audit report line for device */
export type AuditReportLineDeviceFilters = {
  /** Group results by problem id, returning only one line per problem to avoid duplicates */
  groupByProblem?: InputMaybe<Scalars['Boolean']['input']>;
  /** When filtering by repairRequestQuoteStates, include lines with a null quote state if true (no-op if used without repairRequestQuoteStates filter) */
  includeNullRepairRequestQuoteState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter AuditReportLines by active contract status. true (default when omitted) = only lines under active contracts, false = only lines under inactive contracts, null = no filter (returns lines regardless of contract status). */
  onlyActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
  /** Find only reports lines matching these qualifications */
  qualifications?: InputMaybe<Array<Qualification>>;
  /** Find line whose quote is of a given status */
  quoteStatus?: InputMaybe<Array<InputQuoteStatus>>;
  /** Find only reports lines that are linked to repair request with a quote in these states */
  repairRequestQuoteStates?: InputMaybe<Array<WorkOrdersRepairRequestQuoteState>>;
  /** Find only reports lines matching these statuses */
  statuses?: InputMaybe<Array<AuditReportLineStatus>>;
};

export type AuditReportLineFilters = {
  /** Get invoice items based on the contract buildings belonging to the requested accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Find lines of specific reports */
  auditReportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Find lines of specific buildings */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Get invoice items based on the contract buildings belonging to the requested accounts
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter AuditReportLine by matching DefectTypes */
  defectTypes?: InputMaybe<Array<DefectType>>;
  /** Find lines of specific devices */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter on AuditReportLine that where fixedAt using DateFilter rules
   *
   * Each item in the filters list is treated as an OR condition
   * [
   *   DateFilterA,
   *   // OR
   *   DateFilterB,
   * ]
   */
  fixedAt?: InputMaybe<Array<DateFilter>>;
  /** Filter lines by the mechanic that fixed the AuditReportLine */
  fixedByMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Group results by problem id, returning only one line per problem to avoid duplicates */
  groupByProblem?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter AuditReportLines to only those that have a fixed item in their problem if true, only those without a fixed item in their problem if false. Can only be used when groupByProblem is true. */
  hasFixedItemInProblem?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter AuditReportLines to only those that have multiple problem items associated if true, only those with a single problem item if false. Can only be used when groupByProblem is true. */
  hasMultipleProblemItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fetch lines by their ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When filtering by repairRequestQuoteStates, include lines with a null quote state if true (no-op if used without repairRequestQuoteStates filter) */
  includeNullRepairRequestQuoteState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters lines by the buildings of attached mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter AuditReportLines by active contract status. true (default when omitted) = only lines under active contracts, false = only lines under inactive contracts, null = no filter (returns lines regardless of contract status). */
  onlyActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
  /** Find only reports lines for each latest report type */
  onlyLatestReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter audit report line items by the manager of the ops referent user on the device's contract. Given a list of user IDs, audit report line items whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Find only reports lines matching these qualifications */
  qualifications?: InputMaybe<Array<Qualification>>;
  /**
   * Find line whose quote is of a given status
   * @deprecated Use the repairRequestQuoteStates filter in place of this filter. It will fetch the quote status directly from the repair request linked to the defect.
   */
  quoteStatus?: InputMaybe<Array<InputQuoteStatus>>;
  /** Filter invoice items by users that manage the current contract for the audit report line item */
  referentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Find only reports lines that are linked to repair request with a quote in these states */
  repairRequestQuoteStates?: InputMaybe<Array<WorkOrdersRepairRequestQuoteState>>;
  /** Find only reports lines that are linked to repair request with these states */
  repairRequestStates?: InputMaybe<Array<RepairRequestState>>;
  /** Find only reports lines that have these repair statuses(ex: request needed, request on going, request ready to be executed or done) */
  repairStatuses?: InputMaybe<Array<AuditReportLineRepairStatus>>;
  /** Find lines whose report is of one of those types */
  reportTypes?: InputMaybe<Array<AuditReportType>>;
  /** Find only reports lines matching these statuses */
  statuses?: InputMaybe<Array<AuditReportLineStatus>>;
  /** Get only AuditReportLines located in a specific territory. Only takes ISO 2 country codes for now (eg: FR, GB, SG...). */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AuditReportLineMembers = {
  __typename?: 'AuditReportLineMembers';
  count?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  fixedAt?: Maybe<TimeDimension>;
  fixedByMechanicId?: Maybe<Scalars['String']['output']>;
  onTime?: Maybe<Scalars['String']['output']>;
  progressStage?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AuditReportLineOrderByInput = {
  count?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  fixedAt?: InputMaybe<OrderBy>;
  fixedByMechanicId?: InputMaybe<OrderBy>;
  onTime?: InputMaybe<OrderBy>;
  progressStage?: InputMaybe<OrderBy>;
  reportId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** The status of the work related to repairing this defect. */
export enum AuditReportLineRepairStatus {
  OngoingRequest = 'ONGOING_REQUEST',
  ReadyToBeFixed = 'READY_TO_BE_FIXED',
  RequestToCreate = 'REQUEST_TO_CREATE',
  WorkDone = 'WORK_DONE'
}

export enum AuditReportLineSortableFields {
  CertificateUrl = 'certificateUrl',
  Content = 'content',
  CreatedAt = 'createdAt',
  DefectType = 'defectType',
  DeviceId = 'deviceId',
  DiscoveredAt = 'discoveredAt',
  ExternalId = 'externalId',
  FixedAt = 'fixedAt',
  FixedByMechanicId = 'fixedByMechanicId',
  Id = 'id',
  PositionX = 'positionX',
  PositionY = 'positionY',
  Qualification = 'qualification',
  QuoteStatus = 'quoteStatus',
  RepairStatus = 'repairStatus',
  ReportId = 'reportId',
  Status = 'status',
  Summary = 'summary',
  ToBeDoneBefore = 'toBeDoneBefore',
  UpdatedAt = 'updatedAt'
}

/**
 * The status of a given AuditReportLine in the internal WM process
 * before or after validation by ops.
 */
export enum AuditReportLineStatus {
  Fixed = 'FIXED',
  ReadyForValidation = 'READY_FOR_VALIDATION',
  Validated = 'VALIDATED'
}

export type AuditReportLineWhereInput = {
  AND?: InputMaybe<Array<AuditReportLineWhereInput>>;
  OR?: InputMaybe<Array<AuditReportLineWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  deviceId?: InputMaybe<StringFilter>;
  fixedAt?: InputMaybe<DateTimeFilter>;
  fixedByMechanicId?: InputMaybe<StringFilter>;
  onTime?: InputMaybe<StringFilter>;
  progressStage?: InputMaybe<StringFilter>;
  reportId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type AuditReportPageInfo = {
  __typename?: 'AuditReportPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum AuditReportSortableFields {
  AnalyzedAt = 'analyzedAt',
  AuditOffice = 'auditOffice',
  AuditOfficeRef = 'auditOfficeRef',
  CreatedAt = 'createdAt',
  EmittedAt = 'emittedAt',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  ReceivedAt = 'receivedAt',
  ReviewedByOpsAt = 'reviewedByOpsAt',
  Status = 'status',
  Type = 'type'
}

/**
 * The status of a given Audit Report in the internal WM process. Can be either
 * to retranscribe, to review by the ops, or reviewed and therefore done.
 */
export enum AuditReportStatus {
  Done = 'DONE',
  ReadyForReview = 'READY_FOR_REVIEW',
  Reviewed = 'REVIEWED',
  TodoMadagascar = 'TODO_MADAGASCAR'
}

/** Type of the auditReport depending on the frequency */
export enum AuditReportType {
  Audit = 'AUDIT',
  Insurance = 'INSURANCE',
  Periodique = 'PERIODIQUE',
  Quinquennal = 'QUINQUENNAL'
}

export type AvailabilityRate = {
  __typename?: 'AvailabilityRate';
  /** The availability rate ratio of the devices */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Filters the type of availability rate you want */
export type AvailabilityRateFilters = {
  /** The availability rate compute based on a specific algorithm, for example DBT_STRONG... */
  sourceType: DowntimeSourceType;
  /** Type of availability rate you want for example last week */
  type: AvailabilityRateType;
  /** Used with type: DAY, request the availability rate of a specific day */
  typeDayDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AvailabilityRateMembers = {
  __typename?: 'AvailabilityRateMembers';
  availabilityRate?: Maybe<Scalars['Float']['output']>;
  avgRate?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<TimeDimension>;
  defectOnlyAvailabilityRate?: Maybe<Scalars['Float']['output']>;
  defectOnlyAvgRate?: Maybe<Scalars['Float']['output']>;
  defectOnlyDowntime?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  downtime?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxAvailability?: Maybe<Scalars['Float']['output']>;
  sumDowntime?: Maybe<Scalars['Float']['output']>;
  sumMaxAvailability?: Maybe<Scalars['Float']['output']>;
};

export type AvailabilityRateOrderByInput = {
  availabilityRate?: InputMaybe<OrderBy>;
  avgRate?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  defectOnlyAvailabilityRate?: InputMaybe<OrderBy>;
  defectOnlyAvgRate?: InputMaybe<OrderBy>;
  defectOnlyDowntime?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  downtime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxAvailability?: InputMaybe<OrderBy>;
  sumDowntime?: InputMaybe<OrderBy>;
  sumMaxAvailability?: InputMaybe<OrderBy>;
};

/** Type of availability rate we want, for example last week availability rate of the devices. */
export enum AvailabilityRateType {
  Day = 'DAY',
  LastWeek = 'LAST_WEEK'
}

export type AvailabilityRateWhereInput = {
  AND?: InputMaybe<Array<AvailabilityRateWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityRateWhereInput>>;
  availabilityRate?: InputMaybe<FloatFilter>;
  avgRate?: InputMaybe<FloatFilter>;
  date?: InputMaybe<DateTimeFilter>;
  defectOnlyAvailabilityRate?: InputMaybe<FloatFilter>;
  defectOnlyAvgRate?: InputMaybe<FloatFilter>;
  defectOnlyDowntime?: InputMaybe<FloatFilter>;
  deviceId?: InputMaybe<StringFilter>;
  downtime?: InputMaybe<FloatFilter>;
  id?: InputMaybe<StringFilter>;
  maxAvailability?: InputMaybe<FloatFilter>;
  sumDowntime?: InputMaybe<FloatFilter>;
  sumMaxAvailability?: InputMaybe<FloatFilter>;
};

export type AvailabilityRatesMembers = {
  __typename?: 'AvailabilityRatesMembers';
  accountIds?: Maybe<Scalars['String']['output']>;
  availabilityRate?: Maybe<Scalars['Float']['output']>;
  avgAvailabilityRate?: Maybe<Scalars['Float']['output']>;
  avgContractualAvailabilityRate?: Maybe<Scalars['Float']['output']>;
  avgContractualDowntime?: Maybe<Scalars['Float']['output']>;
  avgDowntime?: Maybe<Scalars['Float']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  contractualAvailabilityRate?: Maybe<Scalars['Float']['output']>;
  contractualDowntime?: Maybe<Scalars['Float']['output']>;
  day?: Maybe<TimeDimension>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceLocation?: Maybe<Scalars['String']['output']>;
  deviceNumber?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  downtime?: Maybe<Scalars['Float']['output']>;
  internalAvailabilityRate?: Maybe<Scalars['Float']['output']>;
  internalDowntime?: Maybe<Scalars['Float']['output']>;
};

export type AvailabilityRatesOrderByInput = {
  accountIds?: InputMaybe<OrderBy>;
  availabilityRate?: InputMaybe<OrderBy>;
  avgAvailabilityRate?: InputMaybe<OrderBy>;
  avgContractualAvailabilityRate?: InputMaybe<OrderBy>;
  avgContractualDowntime?: InputMaybe<OrderBy>;
  avgDowntime?: InputMaybe<OrderBy>;
  buildingId?: InputMaybe<OrderBy>;
  contractualAvailabilityRate?: InputMaybe<OrderBy>;
  contractualDowntime?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  deviceLocation?: InputMaybe<OrderBy>;
  deviceNumber?: InputMaybe<OrderBy>;
  deviceType?: InputMaybe<OrderBy>;
  downtime?: InputMaybe<OrderBy>;
  internalAvailabilityRate?: InputMaybe<OrderBy>;
  internalDowntime?: InputMaybe<OrderBy>;
};

export type AvailabilityRatesWhereInput = {
  AND?: InputMaybe<Array<AvailabilityRatesWhereInput>>;
  OR?: InputMaybe<Array<AvailabilityRatesWhereInput>>;
  accountIds?: InputMaybe<StringFilter>;
  availabilityRate?: InputMaybe<FloatFilter>;
  avgAvailabilityRate?: InputMaybe<FloatFilter>;
  avgContractualAvailabilityRate?: InputMaybe<FloatFilter>;
  avgContractualDowntime?: InputMaybe<FloatFilter>;
  avgDowntime?: InputMaybe<FloatFilter>;
  buildingId?: InputMaybe<StringFilter>;
  contractualAvailabilityRate?: InputMaybe<FloatFilter>;
  contractualDowntime?: InputMaybe<FloatFilter>;
  day?: InputMaybe<DateTimeFilter>;
  deviceId?: InputMaybe<StringFilter>;
  deviceLocation?: InputMaybe<StringFilter>;
  deviceNumber?: InputMaybe<StringFilter>;
  deviceType?: InputMaybe<StringFilter>;
  downtime?: InputMaybe<FloatFilter>;
  internalAvailabilityRate?: InputMaybe<FloatFilter>;
  internalDowntime?: InputMaybe<FloatFilter>;
};

/** The available icon formats exposed by the API. */
export enum AvailableIconSizes {
  Large = 'LARGE',
  Small = 'SMALL',
  Xsmall = 'XSMALL'
}

/** The available task to do for a mission */
export type AvailableTask = {
  __typename?: 'AvailableTask';
  /**
   * The list a question group ids for this task
   * @deprecated Use questions references instead
   */
  questionGroupIds: Array<Maybe<Scalars['ID']['output']>>;
  /** The questions reference asked for this task (question ids with their answer if any) */
  questionRefs: Array<Maybe<QuestionWithAnswerReference>>;
  /**
   * The list a question group ids for this task
   * @deprecated Use questionGroupIds instead
   */
  questionTemplateGroupIds: Array<Maybe<Scalars['ID']['output']>>;
  task: Task;
};

export type BatchCollectPartsInput = {
  items: Array<BatchCollectPartsInput_Items>;
};

export type BatchCollectPartsInput_Items = {
  itemId: Scalars['String']['input'];
  repairRequestId: Scalars['String']['input'];
};

/** The action to apply to a blocklist entry – ADD to block access, REMOVE to restore it. */
export enum BlocklistAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

/**
 * A breakdown is a period of unavailability of a given device.
 *   Detected either manually or through IoT, it links all the state snapshots of the device
 *   All of the issues that caused that period of unavailability as well as (in the future) all the
 *   repair jobs that happened during that period
 */
export type Breakdown = {
  __typename?: 'Breakdown';
  /** Date at which the breakdown was closed. When null, indicates that the breakdown is still open */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The origin of a breakdown is the "why" of the issues its linked to. Ie: This device is broken because component XXX is broken.
   *     But what was the origin of that failure of XXX? It could be a technical fault, or it could be vandalism for example.
   *
   *     Can be null when no origin was declared by the engineer
   */
  origin?: Maybe<BreakdownOrigin>;
  /** Date at which the breakdown was first opened */
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BreakdownMembers = {
  __typename?: 'BreakdownMembers';
  averageDuration?: Maybe<Scalars['Float']['output']>;
  breakdownId?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<TimeDimension>;
  deviceId?: Maybe<Scalars['String']['output']>;
  /** Duration of this breakdown in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<TimeDimension>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<TimeDimension>;
  status?: Maybe<Scalars['String']['output']>;
  /** Total duration of unavailability in seconds */
  totalDuration?: Maybe<Scalars['Float']['output']>;
};

export type BreakdownOrderByInput = {
  averageDuration?: InputMaybe<OrderBy>;
  breakdownId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  maxDuration?: InputMaybe<OrderBy>;
  origin?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  totalDuration?: InputMaybe<OrderBy>;
};

/** Underlaying origin of the issue that caused the breakdown. Ie: why did something go wrong */
export enum BreakdownOrigin {
  /** Defective material, this is a technical issue */
  Defective = 'Defective',
  /** External causes: flooding, heat-wave... */
  External = 'External',
  /** Bad usage of the device caused the issue */
  Misuse = 'Misuse',
  /** Vandalism or intentional degradation of the device by a third party */
  Vandalism = 'Vandalism',
  /** Everything worked when the engineer inspected the device. This breakdown is probably a false positive */
  Works = 'Works'
}

export type BreakdownSnapshotMembers = {
  __typename?: 'BreakdownSnapshotMembers';
  averageDuration?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<TimeDimension>;
  deviceId?: Maybe<Scalars['String']['output']>;
  /** Duration of this breakdown in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<TimeDimension>;
  maxDuration?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<TimeDimension>;
  status?: Maybe<Scalars['String']['output']>;
  /** Total duration of unavailability in seconds */
  totalDuration?: Maybe<Scalars['Float']['output']>;
};

export type BreakdownSnapshotOrderByInput = {
  averageDuration?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  maxDuration?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  totalDuration?: InputMaybe<OrderBy>;
};

export type BreakdownSnapshotWhereInput = {
  AND?: InputMaybe<Array<BreakdownSnapshotWhereInput>>;
  OR?: InputMaybe<Array<BreakdownSnapshotWhereInput>>;
  averageDuration?: InputMaybe<FloatFilter>;
  count?: InputMaybe<FloatFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deviceId?: InputMaybe<StringFilter>;
  duration?: InputMaybe<FloatFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  maxDuration?: InputMaybe<FloatFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
  totalDuration?: InputMaybe<FloatFilter>;
};

export type BreakdownWhereInput = {
  AND?: InputMaybe<Array<BreakdownWhereInput>>;
  OR?: InputMaybe<Array<BreakdownWhereInput>>;
  averageDuration?: InputMaybe<FloatFilter>;
  breakdownId?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deviceId?: InputMaybe<StringFilter>;
  duration?: InputMaybe<FloatFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  maxDuration?: InputMaybe<FloatFilter>;
  origin?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
  totalDuration?: InputMaybe<FloatFilter>;
};

/** Signal for a buffer anomaly. */
export type BufferSignal = StrongSignal & {
  __typename?: 'BufferSignal';
  /** An acknowledgement if the signal was acknowledged. */
  acknowledgement?: Maybe<Acknowledgement>;
  /** Which buffer was activated */
  buffer?: Maybe<Scalars['String']['output']>;
  /** The closest level delta. */
  closestLevelDelta?: Maybe<Scalars['Float']['output']>;
  /** The closest level height. */
  closestLevelHeight?: Maybe<Scalars['Float']['output']>;
  /** The closest level label. */
  closestLevelLabel?: Maybe<Scalars['String']['output']>;
  /** The date and time when the signal was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time when the signal was last updated. This attribute has to be sent when acknowledging a signal. */
  date: Scalars['DateTime']['output'];
  /** Details about this signal */
  details: Array<StrongSignalDetail>;
  /** The device associated with the signal */
  device?: Maybe<Device>;
  /** A dismissal if the signal was dismissed. */
  dismissal?: Maybe<Dismissal>;
  /** Technical description of the signal meant for the engineer */
  engineerDescription: Scalars['String']['output'];
  /** The state of the strong signal. */
  engineerSorting: StrongSignalStateEnum;
  /** Human understandable explanation detailing this signal, trying to make it legible even by non technical users */
  explanation: Scalars['String']['output'];
  /** The ID of the signal in the backend. */
  id: Scalars['ID']['output'];
  /** The relevancy feedback of the signal. */
  relevancyFeedback?: Maybe<SignalRelevancyFeedback>;
  /** The reported height of the car */
  reportedHeight?: Maybe<Scalars['Float']['output']>;
  /** Human readable sub title detailing this signal */
  subtitle: Scalars['String']['output'];
  /** The thing associated with the signal */
  thing?: Maybe<Thing>;
  /** The thing name that emitted the signal. */
  thingName: Scalars['String']['output'];
  /** Human readable title for this signal */
  title: Scalars['String']['output'];
};


/** Signal for a buffer anomaly. */
export type BufferSignalDetailsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Signal for a buffer anomaly. */
export type BufferSignalEngineerDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Signal for a buffer anomaly. */
export type BufferSignalExplanationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Signal for a buffer anomaly. */
export type BufferSignalSubtitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Signal for a buffer anomaly. */
export type BufferSignalTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type Building = {
  __typename?: 'Building';
  /** The access code to enter in the building */
  accessCode?: Maybe<Scalars['String']['output']>;
  /** Returns the expected configuration for the audit-report types for the building */
  auditReportConfig?: Maybe<AuditReportConfigObject>;
  /** Get the fields to display when querying an audit report form of a building */
  auditReportForm: Array<AuditReportFormField>;
  /** Audit reports associated with this building */
  auditReports: Array<AuditReport>;
  /** Average availability rate of all the devices inside the building */
  availabilityRate?: Maybe<AvailabilityRate>;
  contacts: Array<Contact>;
  /** Contracts of this building */
  contracts: ContractsContractBuildingContractConnection;
  /** Identify who created the building */
  createdBy: Scalars['Float']['output'];
  /** The date when this building was added to the database */
  createdDate: Scalars['DateTimeISO']['output'];
  customer: Customer;
  dateDeleted?: Maybe<Scalars['DateTimeISO']['output']>;
  /**
   * Determine if defects of the building have been handled:
   * - ON_TIME: All applicable defects were fixed on time
   * - LATE: One defect was fixed after toBeDoneBefore or toBeDoneBefore is passed
   * - NON_APPLICABLE: No defects were applicable
   * @deprecated Replaced by the resolver defectHandlingStatus
   */
  defectHandlingForBuildingStatus: DefectHandlingForBuildingStatus;
  /**
   * Determine if defects of the building have been handled:
   * - ON_TIME: All applicable defects were fixed on time
   * - LATE: One defect was fixed after toBeDoneBefore or toBeDoneBefore is passed
   * - NON_APPLICABLE: No defects were applicable
   */
  defectHandlingStatus: DefectHandlingStatus;
  /** Building defects progress counts */
  defectsProgress: DefectsProgress;
  /** If all the devices of a building are online or not */
  deviceStatus: DeviceStatus;
  /** Devices inside the building */
  devices: Array<Device>;
  /** Elevators inside the building */
  elevators: Array<Maybe<Elevator>>;
  /** Shorthand to get a human readable string of [streetadress, zipcode city.] For more granular control, please consider using .location instead */
  fullAddress: Scalars['String']['output'];
  /** Building is equipped with IOT */
  hasIot: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The type the building image (from the google map picker or the own customer photo) */
  imageType: BuildingImageType;
  /** Picture of the building in situ */
  imageUrl: Scalars['String']['output'];
  /** If the filed is `true`, all invoices will be subject to 10% VAT, 20%  else */
  isVATReduced?: Maybe<Scalars['Boolean']['output']>;
  /** The list of issues relating to all the devices of the building */
  issues: Array<IssueSnapshot>;
  /** Identify who updated the building */
  lastUpdatedBy: Scalars['Float']['output'];
  /** The last date when any information on this building was last updated */
  lastUpdatedDate: Scalars['DateTimeISO']['output'];
  location: Location;
  /** Get the building's mapbox geoson feature representation */
  mapbox: Array<MapboxFeatureRepresentation>;
  /** Missions of this building */
  missions: MissionsMissionConnection;
  /** A short name of the building (eg: NOKIA) */
  name?: Maybe<Scalars['String']['output']>;
  /** Number of devices inside the building */
  noOfDevices: Scalars['Int']['output'];
  /** Number of elevators inside the building */
  noOfElevators: Scalars['Int']['output'];
  /** The configuration related to the notes of the building */
  noteConfiguration: BuildingNoteConfiguration;
  /** List all notes left by a techician concerning the current building */
  notes: BuildingsNoteConnection;
  plans?: Maybe<BuildingPlan>;
  /** Retrieve the list of repair requests linked to this building */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  /** The name of the sale who is in charge of the building (implicity to the customer) */
  saleOwner?: Maybe<Scalars['String']['output']>;
  /** Tasks of this building */
  tasks: MissionsTaskConnection;
  /** Identify if it's a RESIDENTIAL or a COMMERCIAL building. Usually, a commercial building will have several elevators while a residential will have few elevators */
  type: BuildingType;
  /** List the types of vertical composing the building with their vertical icon */
  verticalTypes?: Maybe<Array<VerticalType>>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingAuditReportsArgs = {
  filters?: InputMaybe<BuildingAuditReportFilters>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingAvailabilityRateArgs = {
  filters: AvailabilityRateFilters;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingDevicesArgs = {
  filters?: InputMaybe<BuildingDeviceFilters>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingIssuesArgs = {
  filters?: InputMaybe<BuildingIssueFilters>;
  order?: InputMaybe<Array<DeviceStateIssueSnapshotOrderOptions>>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingMissionsArgs = {
  filters?: InputMaybe<MissionsFilters>;
  order?: InputMaybe<Array<MissionsMissionOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingNoOfDevicesArgs = {
  filters?: InputMaybe<BuildingDeviceFilters>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingNoOfElevatorsArgs = {
  filters?: InputMaybe<BuildingElevatorFilters>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingNotesArgs = {
  pagination?: InputMaybe<BuildingsConnectionArgs>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingRepairRequestsArgs = {
  filters?: InputMaybe<RepairRequestForBuildingInputFilters>;
  order?: InputMaybe<Array<WorkOrdersRepairRequestOrmEntityOrderOptions>>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingTasksArgs = {
  filters?: InputMaybe<TaskFilters>;
  order?: InputMaybe<Array<MissionsTaskOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


/**
 * The building that contains elevators.
 * We can distinguish 2 type of building: "RESIDENTIAL" and "COMMERCIAL"
 * It has a precise location with a lontitude, a latitude and an address
 */
export type BuildingVerticalTypesArgs = {
  filters?: InputMaybe<BuildingVerticalFilters>;
};

/** Input to filter audit reports */
export type BuildingAuditReportFilters = {
  /** filter audit report to only retrieve the latest of each type */
  onlyLatestsReports?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A building entry in the blocklist update payload */
export type BuildingBlocklistItem = {
  /** Whether to add or remove the building from the blocklist */
  action: BlocklistAction;
  /** Unique identifier of the building */
  id: Scalars['Int']['input'];
};

/** Used to filter devices attached to a building */
export type BuildingDeviceFilters = {
  /** Filter devices that are attached to an active contract */
  withActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Used to filter elevators attached to a building */
export type BuildingElevatorFilters = {
  /** Filter elevators that are attached to an active contract */
  withActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The building image type */
export enum BuildingImageType {
  DesktopImage = 'DESKTOP_IMAGE',
  GoogleMapsImage = 'GOOGLE_MAPS_IMAGE'
}

/** The filters of the issues */
export type BuildingIssueFilters = {
  /** Return also issues that have been fixed */
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of events in the issue */
  providers: Array<EventProvider>;
};

export type BuildingMembers = {
  __typename?: 'BuildingMembers';
  accountIds?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

/** Stands for additional information on a building (ie when a technician wants to leaves some details after a visit) */
export type BuildingNote = {
  __typename?: 'BuildingNote';
  /** The content of the note */
  content: Scalars['String']['output'];
  /** The creation date of the note */
  createdAt: Scalars['DateTime']['output'];
  /** The id of the note */
  id: Scalars['ID']['output'];
  /** The mechanic who wrote the note */
  mechanic: Mechanic;
};

/** The configuration related to the notes of a building */
export type BuildingNoteConfiguration = {
  __typename?: 'BuildingNoteConfiguration';
  /** The maximum number of note a building can have */
  maxNoteCount: Scalars['Int']['output'];
  /** The max number of characters a note can have */
  maxNoteLength: Scalars['Int']['output'];
};

/** The input to create a building note */
export type BuildingNoteCreateInput = {
  /** The id of the building the note is written to */
  buildingId: Scalars['ID']['input'];
  /** The content of the note */
  content: Scalars['String']['input'];
  /** The id of the mechanic who wrote the note */
  mechanicId: Scalars['ID']['input'];
};

/** The input to delete a building note */
export type BuildingNoteDeleteInput = {
  /** The id of the building the note to delete is written to */
  buildingId: Scalars['ID']['input'];
  /** The id of the note to delete */
  noteId: Scalars['ID']['input'];
};

export type BuildingOrderByInput = {
  accountIds?: InputMaybe<OrderBy>;
  address?: InputMaybe<OrderBy>;
  city?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  countryCode?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  zipcode?: InputMaybe<OrderBy>;
};

/** The plan of the building */
export type BuildingPlan = {
  __typename?: 'BuildingPlan';
  floorPlans: Array<FloorPlan>;
  id: Scalars['ID']['output'];
  planItems: Array<PlanItem>;
};

export enum BuildingSortableFields {
  AccessCode = 'accessCode',
  CreatedBy = 'createdBy',
  CreatedDate = 'createdDate',
  DateDeleted = 'dateDeleted',
  Id = 'id',
  ImageType = 'imageType',
  IsVatReduced = 'isVATReduced',
  LastUpdatedBy = 'lastUpdatedBy',
  LastUpdatedDate = 'lastUpdatedDate',
  Name = 'name',
  Notes = 'notes',
  SaleOwner = 'saleOwner',
  Type = 'type'
}

/** The building type */
export enum BuildingType {
  Commercial = 'COMMERCIAL',
  GovernmentFacility = 'GOVERNMENT_FACILITY',
  Residential = 'RESIDENTIAL'
}

/** The input to update a building */
export type BuildingUpdateInput = {
  /** The new access code */
  accessCode: Scalars['String']['input'];
};

/** Used to filter verticals of devices type composing the building */
export type BuildingVerticalFilters = {
  /** Filter verticals that have at least one device that are attached to an active contract */
  withActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildingWhereInput = {
  AND?: InputMaybe<Array<BuildingWhereInput>>;
  OR?: InputMaybe<Array<BuildingWhereInput>>;
  accountIds?: InputMaybe<StringFilter>;
  address?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
  countryCode?: InputMaybe<StringFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  zipcode?: InputMaybe<StringFilter>;
};

export type BuildingsBuildingConnection = {
  __typename?: 'BuildingsBuildingConnection';
  edges: Array<BuildingsBuildingEdge>;
  pageInfo: BuildingsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type BuildingsBuildingCustomerBuildingConnection = {
  __typename?: 'BuildingsBuildingCustomerBuildingConnection';
  edges: Array<BuildingsBuildingCustomerBuildingEdge>;
  pageInfo: BuildingsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type BuildingsBuildingCustomerBuildingEdge = {
  __typename?: 'BuildingsBuildingCustomerBuildingEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  /** Does the customer have access to this building */
  hasAccess: Scalars['Boolean']['output'];
  node: Building;
};

export type BuildingsBuildingEdge = {
  __typename?: 'BuildingsBuildingEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Building;
};

export type BuildingsBuildingOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: BuildingSortableFields;
};

export type BuildingsConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters to apply when fetching one or more buildings */
export type BuildingsFilters = {
  /** Fetching by customerIds will return only the buildings that are linked to the accountds passed in parameters. (ie: only those he has a contract / pre-visit on) */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter buildings which have audit report lines with the following statuses */
  auditReportLineStatuses?: InputMaybe<Array<AuditReportLineStatus>>;
  /** Filter buildings by their id */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter buildings by their specified contract */
  contractIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Fetching by customer ID will return only the buildings that a customer owns. (ie: only those he has a contract / pre-visit on)
   * @deprecated Use customerIds instead
   */
  customerId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Fetching by customerIds will return only the buildings that are linked to the accountds passed in parameters. (ie: only those the account has a contract / pre-visit on)
   * @deprecated use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter buildings which has iot devices */
  hasIot?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fetching by mechanicId will return only the buildings that a mechanic owns. (ie: only those he has a contract / pre-visit on)
   * @deprecated Use mechanicIds instead
   */
  mechanicId?: InputMaybe<Scalars['Int']['input']>;
  /** Fetching by mechanicIds will return only the buildings that these mechanics own. (ie: only those they have a contract / pre-visit on) */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter buildings by the user managing the related contract */
  referentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter buildings with a search on building name, city name, zipcode or address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter missions by the location of the building (iso 3166-1 alpha-2 format: FR, EN) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter buildings which have currently active contracts */
  withActiveContractAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter buildings which have audit reports */
  withAuditReport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter buildings which have signed contracts */
  withContract?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter buildings which have at least one undone mission of the given type attached to them. MUST provide mechanicIds too. */
  withMissionOfTypes?: InputMaybe<Array<TaskType>>;
};

export type BuildingsNoteConnection = {
  __typename?: 'BuildingsNoteConnection';
  edges: Array<BuildingsNoteEdge>;
  pageInfo: BuildingsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type BuildingsNoteEdge = {
  __typename?: 'BuildingsNoteEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: BuildingNote;
};

export type BuildingsPageInfo = {
  __typename?: 'BuildingsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type CanvasQuestion = Question & {
  __typename?: 'CanvasQuestion';
  /** Different answers that can be chosen for this question */
  answerTemplates: Array<IAnswerTemplate>;
  conditions: Array<IQuestionCondition>;
  /** The category the question refers to (car, ...) */
  displayCategory?: Maybe<Scalars['String']['output']>;
  /** The sub-category the question refers to, used to group questions in the same category */
  displaySubCategory?: Maybe<QuestionSubCategory>;
  /**
   * Defines the presence & requiredness of choices, photos and comments.
   *     By default, they are all present and optional
   */
  features: QuestionTemplateFeature;
  /** Hint to help the user answer the question */
  hint?: Maybe<Scalars['String']['output']>;
  /** A manual question ID, set in the question spreadsheet. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** QuestionTemplate that was used to create that question */
  questionTemplate: QuestionTemplate;
  /** The part of the elevator the question is about */
  stateKey?: Maybe<Scalars['String']['output']>;
  /** The text of the question to be asked to the mechanic */
  title: Scalars['String']['output'];
  /** Work order linked to that question */
  workOrder?: Maybe<RepairRequest>;
};


export type CanvasQuestionHintArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CanvasQuestionTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input to change the chargeable status of a repair request */
export type ChangeRepairRequestChargeableStatusInput = {
  /** The new chargeable status of the repair request */
  isChargeable: Scalars['Boolean']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
};

/** Input to change the delivery address of a repair request */
export type ChangeRepairRequestDeliveryOptionInput = {
  /** ID of the new delivery option of the repair request */
  deliveryOptionId: Scalars['ID']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
};

/** Input to indicate if the field execution of this repair will be subcontracted or not */
export type ChangeRepairRequestSubcontractedStatusInput = {
  /** True if the request will be done by a subcontractor, false otherwise */
  isSubcontracted: Scalars['Boolean']['input'];
  /** The id of the repair request we want to update */
  repairRequestId: Scalars['ID']['input'];
};

/** Input to change the urgency level of a repair request */
export type ChangeRepairRequestUrgencyLevelInput = {
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
  /** The new urgency level of the repair request */
  urgencyLevel: UrgencyLevel;
};

/** Input to change the price of a request item */
export type ChangeRequestItemPriceInput = {
  /** The new price of the request item */
  price: Scalars['Float']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
  /** The id of the request item */
  requestItemId: Scalars['String']['input'];
  /** Optional PDF file containing the quote from one of our supplier we're using to set that price */
  supplierQuote?: InputMaybe<Scalars['Upload']['input']>;
};

/** Input to change the quantity of a request item */
export type ChangeRequestItemQuantityInput = {
  /** The new quantity of the request item */
  quantity: Scalars['Int']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
  /** The id of the request item */
  requestItemId: Scalars['String']['input'];
};

export type ChaseRepairRequestActionInput = {
  /** The open action to chase, late or not */
  actionId: Scalars['String']['input'];
  /** Posted after the mention, optional. Trimmed, a blank one gives none, at most 500 characters. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** When to look again, in the future. Left out: the step's normal duration from now. The step is not late before then. */
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** The work order the action is on */
  repairRequestId: Scalars['String']['input'];
  /** Who to ask, @-mentioned on the work order feed and shown the step in Chased me. Required, unless the step waits on the customer or a supplier: chased off-platform. */
  toUserId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckboxInput = FormInput & FormThing & {
  __typename?: 'CheckboxInput';
  /** If set, means that changing this field would update 1<->1 to the corresponding key in the entity */
  entityKey?: Maybe<Scalars['String']['output']>;
  /** The identifier of this input, to be sent back to the backend */
  key?: Maybe<Scalars['String']['output']>;
  /** configuration for the display/validation of this input */
  settings: IInputSettings;
  title: Scalars['String']['output'];
  /** Current value associated to the input */
  value?: Maybe<Scalars['ValueOfInput']['output']>;
};

export type ChoiceInput = {
  displayGroup?: InputMaybe<DisplayGroupInput>;
  hasFollowUp: Scalars['Boolean']['input'];
  humanKey?: InputMaybe<Scalars['String']['input']>;
  problemKey?: InputMaybe<Scalars['String']['input']>;
  stateKey?: InputMaybe<Scalars['String']['input']>;
  translations: Array<TranslationInput>;
};

/**
 * A chunk is a way to split a mission up in multiple block of alloted time.
 *   Where some mission can have zero chunks and be done freely, some others require that time be alloted
 *   in advance by somebody else than the mechanic. (think an appointment where the customer wants to be here)
 *   or a previsit which we have to do between 8AM and 11AM on a given day
 */
export type Chunk = {
  __typename?: 'Chunk';
  /** The date when the chunk is unscheduled. By default, the date is null, the chunk is scheduled */
  dateDeleted?: Maybe<Scalars['DateTime']['output']>;
  /** DateTime at which this chunk ends (ie: you can work on this mission until this time) */
  dateEnd: Scalars['DateTime']['output'];
  /** DateTime at which this chunk starts (ie: you can work on this mission starting from this time) */
  dateStart: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** Mission this chunk is linked to */
  mission: Mission;
  /**
   * A startStrict chunk means that you HAVE to start it around its dateStart,
   *     otherwise you will be considered late.
   *     Think appointment with the client where you HAVE to be there at 9AM
   */
  startStrict: Scalars['Boolean']['output'];
  /**
   * Indicates how many task we *think* we can fit in that chunk. This is nothing more than
   *       a little helper for admins scheduling chunks, helping them keep track of how much time they've alloted to the mechanic so far
   */
  taskCount: Scalars['Int']['output'];
};

/** Input type for creating / updating a chunk */
export type ChunkInput = {
  /** Date at which the chunk stops */
  dateEnd: Scalars['DateTime']['input'];
  /** Date at which the chunk starts */
  dateStart: Scalars['DateTime']['input'];
  /** Mechanic to whom the chunk is affected */
  mechanicId?: InputMaybe<Scalars['Float']['input']>;
  /** If we need the mechanic to be considered late if he misses the dateStart */
  startStrict?: InputMaybe<Scalars['Boolean']['input']>;
  /** How many tasks the admin creating this chunk thinks can fit */
  taskCount: Scalars['Int']['input'];
};

export enum ChunkSortableFields {
  DateDeleted = 'dateDeleted',
  DateEnd = 'dateEnd',
  DateStart = 'dateStart',
  Id = 'id',
  StartStrict = 'startStrict',
  TaskCount = 'taskCount'
}

/** Set of filters to apply to the chunks query */
export type ChunksFilters = {
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** if present, return only chunks belonging to missions that are done/not done */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  mechanicId?: InputMaybe<Scalars['Int']['input']>;
  missionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** used to filter by address */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A city for a building */
export type City = {
  __typename?: 'City';
  id: Scalars['ID']['output'];
  /** The city name */
  name: Scalars['String']['output'];
};

export type ClientActivityReportPeriod = {
  /** End of the period (format: YYYY-MM-DD) */
  end: Scalars['Date']['input'];
  /** Start of the period (format: YYYY-MM-DD) */
  start: Scalars['Date']['input'];
};

/** Reasons to close an issue */
export enum CloseReason {
  FalseAlert = 'FALSE_ALERT',
  Other = 'OTHER',
  ShutdownUnit = 'SHUTDOWN_UNIT',
  WrongUnit = 'WRONG_UNIT'
}

export type CloseRepairRequestActionInput = {
  /** The open action to close */
  actionId: Scalars['String']['input'];
  /** Why, optional. Trimmed, a blank one gives none, at most 500 characters. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The work order the action is on */
  repairRequestId: Scalars['String']['input'];
};

export enum CoefficientAppliesTo {
  OffListPart = 'OFF_LIST_PART',
  Subcontractor = 'SUBCONTRACTOR'
}

export type CoefficientLine = PriceListLine & {
  __typename?: 'CoefficientLine';
  /** CoefficientAppliesTo */
  appliesTo: CoefficientAppliesTo;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: PriceListLineKind;
  label: Scalars['String']['output'];
  priceListId: Scalars['String']['output'];
  rawRow?: Maybe<Scalars['JSON']['output']>;
  reference: Scalars['String']['output'];
  /** The labour/price tier this row belongs to; null = one price for the line */
  tier?: Maybe<PriceListTier>;
  tierId?: Maybe<Scalars['String']['output']>;
  /** The rate family in force alongside this row — every tier the contract prices this reference at, this line included, ordered by tier ordinal. One element when the reference is priced once regardless of the time of day, and never a tier that has since been retired */
  tierVariants: Array<PriceListLine>;
  validFrom: Scalars['DateTimeISO']['output'];
  validTo?: Maybe<Scalars['DateTimeISO']['output']>;
  value: Scalars['Float']['output'];
};

export enum ColumnType {
  BarChart = 'barChart',
  Number = 'number'
}

export type Comment = {
  __typename?: 'Comment';
  /** Actor: */
  actor: User;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  /** Mention: */
  mentions?: Maybe<Array<Mention>>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CommentActivityInput = {
  activityId: Scalars['String']['input'];
  /** MentionInput: */
  mentions?: InputMaybe<Array<MentionInput>>;
  text: Scalars['String']['input'];
};

export type CommentMembers = {
  __typename?: 'CommentMembers';
  answer?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

export type CommentOnFeedInput = {
  feedName: Scalars['String']['input'];
  /** MentionInput: */
  mentions?: InputMaybe<Array<MentionInput>>;
  text: Scalars['String']['input'];
};

export type CommentOrderByInput = {
  answer?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
};

/** Adds or modify a comment on a given repair request */
export type CommentRepairRequestInput = {
  /** Comment to add to the repair request */
  comment: Scalars['String']['input'];
  /** Comment type we want to set, if not defined then if will be based on the user role (engineer comment for mechanic and internal comment for admin) */
  commentType?: InputMaybe<WorkOrdersRepairRequestCommentType>;
  /** The id of the repair request */
  repairRequestId: Scalars['ID']['input'];
};

export type CommentWhereInput = {
  AND?: InputMaybe<Array<CommentWhereInput>>;
  OR?: InputMaybe<Array<CommentWhereInput>>;
  answer?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
};

/** Type of the company of the mechanic */
export enum CompanyType {
  Eirl = 'EIRL',
  Eurl = 'EURL',
  Sas = 'SAS',
  Sasu = 'SASU'
}

export type CompletedTask = {
  __typename?: 'CompletedTask';
  completedAt: Scalars['DateTimeISO']['output'];
  taskId: Scalars['ID']['output'];
};

export type CompletedTaskInput = {
  /** Actual date at which the engineer pushed the Done button for that task */
  completedAt: Scalars['DateTimeISO']['input'];
  /** If present, override the timestamps of the task with the given values */
  override?: InputMaybe<TimestampOverrideInput>;
  taskId: Scalars['ID']['input'];
};

/** Filters to apply when fetching the device components state */
export type ComponentsFilters = {
  /** Filter which device component you want the state using the state key (ex: car.parachute).NOTE: works only with one state key at a time for the moment. */
  stateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** ConditionalVisualFormat */
export type ConditionalVisualFormat = {
  __typename?: 'ConditionalVisualFormat';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  bold: Scalars['Boolean']['output'];
  fontColor?: Maybe<Scalars['String']['output']>;
  italic: Scalars['Boolean']['output'];
  strikethrough: Scalars['Boolean']['output'];
  /** the rule for the visual formatting, ie: greater than, equal to */
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * A contact for the building.
 * A contact should have at least a name (firstName or lastName) or a role (eg: Gardian)
 * AND should have a least an email or phone number
 */
export type Contact = {
  __typename?: 'Contact';
  building: Building;
  /** The email of the contact */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The fullname of the contact. This is a concatenation of his first name and his last name */
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the contact */
  phoneNo?: Maybe<Scalars['String']['output']>;
  /** The role of the contact for the related building (eg: Gardian) */
  role?: Maybe<Scalars['String']['output']>;
};

/** The input to add a new contact on a building */
export type ContactInput = {
  /** The email of the contact */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the contact, should be 9 digits */
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  /** The role of the contact (eg: Gardian) */
  role?: InputMaybe<Scalars['String']['input']>;
};

export type Contract = {
  __typename?: 'Contract';
  /** Yearly amount invoiced to the customer for this contract (VAT included) */
  amount: Scalars['Float']['output'];
  /** @deprecated Deprecated. Contracts are now linked to multiple buildings. Use buildings instead */
  building: Building;
  /** Buildings linked to this contract */
  buildings: ContractsContractBuildingExternalBuildingConnection;
  /** @deprecated use amount instead */
  contractAnnualCharge: Scalars['Float']['output'];
  /** @deprecated this is completely deprecated and not used anymore */
  contractCommissionPercentage: Scalars['Float']['output'];
  /** @deprecated use startDate/endDate instead */
  contractDuration: Scalars['Int']['output'];
  /** @deprecated use endDate instead */
  contractEndDate: Scalars['DateTime']['output'];
  contractNo: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  contractPaymentTerms: Scalars['Int']['output'];
  /** @deprecated use startDate instead */
  contractStartDate: Scalars['DateTime']['output'];
  /** @deprecated use amount instead */
  contractTotalCharge: Scalars['Float']['output'];
  /** @deprecated DEPRECATED: use type instead */
  contractType: ContractType;
  createdAt: Scalars['DateTimeISO']['output'];
  /** @deprecated use createdAt instead */
  createdDate: Scalars['DateTimeISO']['output'];
  /** Customer of this contract */
  customer: Customer;
  /** @deprecated use endDate instead */
  dateCancelled?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated not used anymore */
  discount: Scalars['Float']['output'];
  elevators: ContractsContractDeviceDeviceConnection;
  endDate: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  legacyContractId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Deprecated. Contracts are now linked to multiple buildings and hence multiple mechanics. You can find mechanics for a given building through contract.buildings */
  mechanic: Mechanic;
  noOfElevators: Scalars['Int']['output'];
  /** @deprecated not used anymore */
  onboarding_email: Scalars['Boolean']['output'];
  /**
   * Ops responsible of managing this contract
   * @deprecated Ops are now assigned at the device level rather than the contract level, please look at device.opsReferent or device.contract.edge.opsReferent
   */
  opsReferent?: Maybe<Admin>;
  /** The Schedule of Rates in force for this contract; null = no price list */
  priceList?: Maybe<PriceList>;
  /** Link to the Salesforce contract */
  sfLink?: Maybe<Scalars['String']['output']>;
  signedContractUrl?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTimeISO']['output'];
  /** Type of contract */
  type: ContractType;
  updatedAt: Scalars['DateTimeISO']['output'];
  /** @deprecated Use maintenancePlan instead */
  visitFrequency: Scalars['Int']['output'];
};


export type ContractBuildingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ContractElevatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractBuilding = {
  __typename?: 'ContractBuilding';
  /** Yearly value of the contract invoiced to the customer (VAT included) */
  amount: Scalars['Float']['output'];
  building: Building;
  contract: Contract;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use devices.contracts edges to retrieve the mechanic, mechanics are now linked to a device instead of a building */
  mechanic: Mechanic;
  /** Returns all the mechanics that are assigned to this building */
  mechanics: ContractsBuildingMechanicMechanicConnection;
  /** Amount of devices included in this contract for this building */
  noOfDevices: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type ContractBuildingMechanicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractBuildingMembers = {
  __typename?: 'ContractBuildingMembers';
  amount?: Maybe<Scalars['Float']['output']>;
  buildingId?: Maybe<Scalars['Float']['output']>;
  contractid?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  createdat?: Maybe<TimeDimension>;
  deletedat?: Maybe<TimeDimension>;
  updatedat?: Maybe<TimeDimension>;
};

export type ContractBuildingOrderByInput = {
  amount?: InputMaybe<OrderBy>;
  buildingId?: InputMaybe<OrderBy>;
  contractid?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  createdat?: InputMaybe<OrderBy>;
  deletedat?: InputMaybe<OrderBy>;
  updatedat?: InputMaybe<OrderBy>;
};

export type ContractBuildingWhereInput = {
  AND?: InputMaybe<Array<ContractBuildingWhereInput>>;
  OR?: InputMaybe<Array<ContractBuildingWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  buildingId?: InputMaybe<FloatFilter>;
  contractid?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
  createdat?: InputMaybe<DateTimeFilter>;
  deletedat?: InputMaybe<DateTimeFilter>;
  updatedat?: InputMaybe<DateTimeFilter>;
};

/** Filters to apply when fetching contracts associated to a device */
export type ContractDeviceFilters = {
  /** Filter active contracts (default: all, true: only active, false: only not active) */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractDeviceMembers = {
  __typename?: 'ContractDeviceMembers';
  amountMonth?: Maybe<Scalars['Float']['output']>;
  amountYear?: Maybe<Scalars['Float']['output']>;
  contractBuildingId?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  maintenanceplanId?: Maybe<Scalars['String']['output']>;
  mechanicId?: Maybe<Scalars['String']['output']>;
  sumAmountMonth?: Maybe<Scalars['Float']['output']>;
  weekBdEndH?: Maybe<Scalars['String']['output']>;
  weekBdStartH?: Maybe<Scalars['String']['output']>;
  weekendBdEndH?: Maybe<Scalars['String']['output']>;
  weekendBdStartH?: Maybe<Scalars['String']['output']>;
};

export type ContractDeviceOrderByInput = {
  amountMonth?: InputMaybe<OrderBy>;
  amountYear?: InputMaybe<OrderBy>;
  contractBuildingId?: InputMaybe<OrderBy>;
  contractId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  maintenanceplanId?: InputMaybe<OrderBy>;
  mechanicId?: InputMaybe<OrderBy>;
  sumAmountMonth?: InputMaybe<OrderBy>;
  weekBdEndH?: InputMaybe<OrderBy>;
  weekBdStartH?: InputMaybe<OrderBy>;
  weekendBdEndH?: InputMaybe<OrderBy>;
  weekendBdStartH?: InputMaybe<OrderBy>;
};

export type ContractDeviceWhereInput = {
  AND?: InputMaybe<Array<ContractDeviceWhereInput>>;
  OR?: InputMaybe<Array<ContractDeviceWhereInput>>;
  amountMonth?: InputMaybe<FloatFilter>;
  amountYear?: InputMaybe<FloatFilter>;
  contractBuildingId?: InputMaybe<StringFilter>;
  contractId?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
  deviceId?: InputMaybe<StringFilter>;
  maintenanceplanId?: InputMaybe<StringFilter>;
  mechanicId?: InputMaybe<StringFilter>;
  sumAmountMonth?: InputMaybe<FloatFilter>;
  weekBdEndH?: InputMaybe<StringFilter>;
  weekBdStartH?: InputMaybe<StringFilter>;
  weekendBdEndH?: InputMaybe<StringFilter>;
  weekendBdStartH?: InputMaybe<StringFilter>;
};

/** Filter capacities for selecting contracts */
export type ContractFilters = {
  /** Filter contracts that belong to the accounts passed in parameters */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter contracts covering buildingIds */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter contracts by their IDs */
  contractIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter contracts that belong to the accounts passed in parameters
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter contracts covering deviceIds */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter active contracts (default: all, true: only active, false: only not active) */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractMembers = {
  __typename?: 'ContractMembers';
  accountIds?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  contractLocationKey?: Maybe<Scalars['String']['output']>;
  contractNo?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<TimeDimension>;
  endDate?: Maybe<TimeDimension>;
  isActive?: Maybe<Scalars['String']['output']>;
  referentUserId?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<TimeDimension>;
};

export type ContractMonthsMembers = {
  __typename?: 'ContractMonthsMembers';
  date?: Maybe<TimeDimension>;
};

export type ContractMonthsOrderByInput = {
  date?: InputMaybe<OrderBy>;
};

export type ContractMonthsWhereInput = {
  AND?: InputMaybe<Array<ContractMonthsWhereInput>>;
  OR?: InputMaybe<Array<ContractMonthsWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
};

/** Set of filters to apply to the contracts of the customer */
export type ContractOfCustomerFilters = {
  /** Only return contracts that are active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractOrderByInput = {
  accountIds?: InputMaybe<OrderBy>;
  amount?: InputMaybe<OrderBy>;
  contractLocationKey?: InputMaybe<OrderBy>;
  contractNo?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  referentUserId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
};

export enum ContractSortableFields {
  Amount = 'amount',
  ContractNo = 'contractNo',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EndDate = 'endDate',
  Id = 'id',
  LegacyContractId = 'legacyContractId',
  StartDate = 'startDate',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

/** Type of contract */
export enum ContractType {
  Advanced = 'ADVANCED',
  Basic = 'BASIC',
  ClientSpecific = 'CLIENT_SPECIFIC',
  Comprehensive = 'COMPREHENSIVE'
}

export type ContractWhereInput = {
  AND?: InputMaybe<Array<ContractWhereInput>>;
  OR?: InputMaybe<Array<ContractWhereInput>>;
  accountIds?: InputMaybe<StringFilter>;
  amount?: InputMaybe<FloatFilter>;
  contractLocationKey?: InputMaybe<StringFilter>;
  contractNo?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
  customerId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  isActive?: InputMaybe<StringFilter>;
  referentUserId?: InputMaybe<FloatFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
};

export type ContractsBuildingMechanicMechanicConnection = {
  __typename?: 'ContractsBuildingMechanicMechanicConnection';
  edges: Array<ContractsBuildingMechanicMechanicEdge>;
  pageInfo: ContractsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ContractsBuildingMechanicMechanicEdge = {
  __typename?: 'ContractsBuildingMechanicMechanicEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Mechanic;
};

export type ContractsConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsContractBuildingContractConnection = {
  __typename?: 'ContractsContractBuildingContractConnection';
  edges: Array<ContractsContractBuildingContractEdge>;
  pageInfo: ContractsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ContractsContractBuildingContractEdge = {
  __typename?: 'ContractsContractBuildingContractEdge';
  /** Yearly value of the contract invoiced to the customer (VAT included) */
  amount: Scalars['Float']['output'];
  building: Building;
  contract: Contract;
  createdAt: Scalars['DateTime']['output'];
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use devices.contracts edges to retrieve the mechanic, mechanics are now linked to a device instead of a building */
  mechanic: Mechanic;
  /** Returns all the mechanics that are assigned to this building */
  mechanics: ContractsBuildingMechanicMechanicConnection;
  /** Amount of devices included in this contract for this building */
  noOfDevices: Scalars['Float']['output'];
  node: Contract;
  updatedAt: Scalars['DateTime']['output'];
};


export type ContractsContractBuildingContractEdgeMechanicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsContractBuildingExternalBuildingConnection = {
  __typename?: 'ContractsContractBuildingExternalBuildingConnection';
  edges: Array<ContractsContractBuildingExternalBuildingEdge>;
  pageInfo: ContractsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ContractsContractBuildingExternalBuildingEdge = {
  __typename?: 'ContractsContractBuildingExternalBuildingEdge';
  /** Yearly value of the contract invoiced to the customer (VAT included) */
  amount: Scalars['Float']['output'];
  building: Building;
  contract: Contract;
  createdAt: Scalars['DateTime']['output'];
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use devices.contracts edges to retrieve the mechanic, mechanics are now linked to a device instead of a building */
  mechanic: Mechanic;
  /** Returns all the mechanics that are assigned to this building */
  mechanics: ContractsBuildingMechanicMechanicConnection;
  /** Amount of devices included in this contract for this building */
  noOfDevices: Scalars['Float']['output'];
  node: Building;
  updatedAt: Scalars['DateTime']['output'];
};


export type ContractsContractBuildingExternalBuildingEdgeMechanicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsContractConnection = {
  __typename?: 'ContractsContractConnection';
  edges: Array<ContractsContractEdge>;
  pageInfo: ContractsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ContractsContractDeviceContractConnection = {
  __typename?: 'ContractsContractDeviceContractConnection';
  edges: Array<ContractsContractDeviceContractEdge>;
  pageInfo: ContractsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ContractsContractDeviceContractEdge = {
  __typename?: 'ContractsContractDeviceContractEdge';
  /** yearly price for this device in this contract (VAT included) */
  amount: Scalars['Float']['output'];
  contract: Contract;
  /** @deprecated use amount instead */
  contractAnnualCharge: Scalars['Float']['output'];
  contractBuilding: ContractBuilding;
  /** @deprecated this is completely deprecated and not used anymore */
  contractCommissionPercentage: Scalars['Float']['output'];
  /** @deprecated use amount instead */
  contractTotalCharge: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  maintenancePlanId?: Maybe<Scalars['String']['output']>;
  /** Mechanic associated to the contract of this device */
  mechanic?: Maybe<Mechanic>;
  node: Contract;
  /** Ops responsible of managing this device in this contract */
  opsReferent?: Maybe<Admin>;
  /** @deprecated use amount instead */
  price: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContractsContractDeviceDeviceConnection = {
  __typename?: 'ContractsContractDeviceDeviceConnection';
  edges: Array<ContractsContractDeviceDeviceEdge>;
  pageInfo: ContractsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ContractsContractDeviceDeviceEdge = {
  __typename?: 'ContractsContractDeviceDeviceEdge';
  /** yearly price for this device in this contract (VAT included) */
  amount: Scalars['Float']['output'];
  contract: Contract;
  /** @deprecated use amount instead */
  contractAnnualCharge: Scalars['Float']['output'];
  contractBuilding: ContractBuilding;
  /** @deprecated this is completely deprecated and not used anymore */
  contractCommissionPercentage: Scalars['Float']['output'];
  /** @deprecated use amount instead */
  contractTotalCharge: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  maintenancePlanId?: Maybe<Scalars['String']['output']>;
  /** Mechanic associated to the contract of this device */
  mechanic?: Maybe<Mechanic>;
  node: Device;
  /** Ops responsible of managing this device in this contract */
  opsReferent?: Maybe<Admin>;
  /** @deprecated use amount instead */
  price: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContractsContractEdge = {
  __typename?: 'ContractsContractEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Contract;
};

export type ContractsContractOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: ContractSortableFields;
};

export type ContractsPageInfo = {
  __typename?: 'ContractsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ContractsPriceListGqlConnection = {
  __typename?: 'ContractsPriceListGQLConnection';
  edges: Array<ContractsPriceListGqlEdge>;
  pageInfo: ContractsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ContractsPriceListGqlEdge = {
  __typename?: 'ContractsPriceListGQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: PriceList;
};

export type ContractsPriceListLineGqlConnection = {
  __typename?: 'ContractsPriceListLineGQLConnection';
  edges: Array<ContractsPriceListLineGqlEdge>;
  pageInfo: ContractsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ContractsPriceListLineGqlEdge = {
  __typename?: 'ContractsPriceListLineGQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: PriceListLine;
};

export type CostControlConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CostControlOvertimeGqlConnection = {
  __typename?: 'CostControlOvertimeGQLConnection';
  edges: Array<CostControlOvertimeGqlEdge>;
  pageInfo: CostControlPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type CostControlOvertimeGqlEdge = {
  __typename?: 'CostControlOvertimeGQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Overtime;
};

export type CostControlOvertimeOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: OvertimeOrmEntitySortableFields;
};

export type CostControlPageInfo = {
  __typename?: 'CostControlPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * The payload for adding a report line to a report,
 * with the position of the defect on the report, the page
 * on which the defect is located, and the defect text itself.
 */
export type CreateAuditReportLinePayload = {
  /** The defect text as selected by the Transcriber */
  content: Scalars['String']['input'];
  /** The type of defect that will be emitted from this report-line, defining behavior for fixing. See DefectType. */
  defectType?: InputMaybe<DefectType>;
  /** The device that is referenced by the line being created */
  deviceId: Scalars['ID']['input'];
  /**
   * Date at which the described defect was discovered.
   *     This is most often the date of the audit report
   */
  discoveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The top left X position of the report line
   *     calculated from the left border of the report.
   */
  positionX: Scalars['Float']['input'];
  /**
   * The top left Y position of the report line
   *     calculated from the top of the report.
   */
  positionY: Scalars['Float']['input'];
  /** The report on which the line being created is located */
  reportId: Scalars['ID']['input'];
  /** Date before which the underlying defect should be fixed. STANDARD defects use a value of 6 months, for all other types, this value must be provided. */
  toBeDoneBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateDashboardPdfForUserInput = {
  dashboardType: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
  /** If true, the PDF will be generated with mobile dimensions */
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuestionInput = {
  category: Scalars['String']['input'];
  choices?: InputMaybe<Array<ChoiceInput>>;
  /**
   * Defines the presence & requiredness of choices, photos and comments.
   *     By default, they are all present and optional
   */
  feature: QuestionTemplateFeatureInput;
  groupTemplateId: Scalars['ID']['input'];
  humanKey?: InputMaybe<Scalars['String']['input']>;
  stateKey?: InputMaybe<Scalars['String']['input']>;
  translations: Array<TranslationInput>;
};

/** Payload to create a repair request */
export type CreateRepairRequestInput = {
  /** If this repair request needs to be invoiced to the customer */
  chargeable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Add comment to this repair request, for example more information for ops or supply */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Describe where the engineer wants the parts if any to be delivered */
  deliveryOptionId?: InputMaybe<Scalars['ID']['input']>;
  /** Short text describing the repair request purpose */
  description: Scalars['String']['input'];
  /** The id of the device concerned by the repair request */
  deviceId: Scalars['ID']['input'];
  /** Link issues related to the repair you want to create */
  issueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The id of the mechanic concerned by the repair request
   * @deprecated Not use anymore as we use the dedicated engineer of the device
   */
  mechanicId?: InputMaybe<Scalars['ID']['input']>;
  /** List items (external parts, catalog parts or man hours) that are needed for this repair */
  requestItems?: InputMaybe<RequestItemsInput>;
  /** The id of the user who did the request */
  requesterId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional title for the repair request */
  title?: InputMaybe<Scalars['String']['input']>;
  /** A repair request can have a deadline which means that, depending on the level, the request has to be treated as soon as possible (urgent) or at a later date (ie for this week) */
  urgencyLevel: UrgencyLevel;
  /** The type of work order: REPAIR or CALLOUT */
  workOrderType?: InputMaybe<WorkOrderType>;
};

/** The criticality the system must ensure in emergency ventilation in case of fire and in case of loss of primary ventilation functions */
export enum Criticality {
  High = 'HIGH',
  Low = 'LOW'
}

export type Customer = User & {
  __typename?: 'Customer';
  CreateDashboardPdfQuery: Scalars['String']['output'];
  FilterSuggestionsQuery: FilterSuggestions;
  FindDowntimesQuery: DevicesState2DowntimeGqlConnection;
  FindNotificationsQuery: MonitoringNotificationGqlConnection;
  GetDashboardQuery: Dashboard;
  RunDashboardQuery: QueryResult;
  RunDrilldownQuery: QueryResult;
  accessibleBuildingsCount?: Maybe<Scalars['Float']['output']>;
  /** Get the Account associated w/ the User */
  account: Account;
  /** Returns all the accounts that are accessible by the user */
  accounts: UsersUserCustomerGraphqlAccountConnection;
  /** List the buildings of a customer */
  buildings: BuildingsBuildingCustomerBuildingConnection;
  /**
   * The company number (e.g: SIRET for France)
   * @deprecated Not available anymore
   */
  companyIdentificationNo?: Maybe<Scalars['String']['output']>;
  /**
   * The company name
   * @deprecated User account.companyName instead
   */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Contracts of this customer */
  contracts: ContractsContractConnection;
  /**
   * The company's country code
   * @deprecated User account.countryCode instead
   */
  countryCode: Scalars['String']['output'];
  /** Returns a 3 letter alphabetic code (ISO 4217 format) to indicate the currency used by the customer */
  currencyIsoCode?: Maybe<Scalars['String']['output']>;
  /** List the devices of a customer */
  devices: ElevatorsAccessibleDeviceDeviceGraphqlConnection;
  /** List elevators of a customer */
  elevators: ElevatorsElevatorGraphqlConnection;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Renamed, use email instead */
  emailId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  hasMaximize?: Maybe<Scalars['Boolean']['output']>;
  /** Determine if this User can login into the Client Platform */
  hasPlatformAccess?: Maybe<Scalars['Boolean']['output']>;
  /** The Customer ID */
  id: Scalars['ID']['output'];
  intercomHashId: Scalars['String']['output'];
  /** Determine if this User is the recipient of documents, notifications & others emails. */
  isContactByDefault?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Set when this user is an alias merged into another user: the id of that user */
  mergedIntoUserId?: Maybe<Scalars['Int']['output']>;
  mobileNo?: Maybe<Scalars['String']['output']>;
  /** Return the sale of the account having the most active contracts */
  sale: Admin;
  subscriptionInfo: SubscriptionInfo;
  /** List elevators of an account */
  tasks: MissionsTaskConnection;
  /** @deprecated The user information are now embeded in the Customer object */
  user: User;
  /** The user id */
  userId?: Maybe<Scalars['Float']['output']>;
};


export type CustomerCreateDashboardPdfQueryArgs = {
  query: CreateDashboardPdfForUserInput;
};


export type CustomerFilterSuggestionsQueryArgs = {
  query: FilterSuggestionsQueryInput;
};


export type CustomerFindDowntimesQueryArgs = {
  filters?: InputMaybe<FindDowntimesQueryInput>;
  order?: InputMaybe<Array<DevicesState2DowntimeOrmEntityOrderOptions>>;
  pagination?: InputMaybe<DevicesState2ConnectionArgs>;
};


export type CustomerFindNotificationsQueryArgs = {
  filters?: InputMaybe<FindNotificationsQueryInput>;
  order?: InputMaybe<Array<MonitoringNotificationOrmEntityOrderOptions>>;
  pagination?: InputMaybe<MonitoringConnectionArgs>;
};


export type CustomerGetDashboardQueryArgs = {
  query: GetDashboardQueryInput;
};


export type CustomerRunDashboardQueryArgs = {
  query: RunDashboardQueryForUserInput;
};


export type CustomerRunDrilldownQueryArgs = {
  query: RunDrilldownQueryForUserInput;
};


export type CustomerAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerBuildingsArgs = {
  filters?: InputMaybe<CustomerBuildingFilters>;
  order?: InputMaybe<Array<BuildingsBuildingOrderOptions>>;
  pagination?: InputMaybe<BuildingsConnectionArgs>;
};


export type CustomerContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ContractOfCustomerFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerDevicesArgs = {
  filters?: InputMaybe<CustomerDeviceFilters>;
  order?: InputMaybe<Array<ElevatorsDeviceOrmEntityOrderOptions>>;
  pagination?: InputMaybe<ElevatorsConnectionArgs>;
};


export type CustomerElevatorsArgs = {
  filters?: InputMaybe<CustomerElevatorsFilters>;
  pagination?: InputMaybe<ElevatorsConnectionArgs>;
};


export type CustomerTasksArgs = {
  filters?: InputMaybe<CustomerTaskFilters>;
  order?: InputMaybe<Array<MissionsTaskOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};

/** Set of filters to apply to the buildings of the customer */
export type CustomerBuildingFilters = {
  /** Filter buildings which have audit report lines with the following statuses */
  auditReportLineStatuses?: InputMaybe<Array<AuditReportLineStatus>>;
  /** Filter buildings by their id */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter buildings which has iot devices */
  hasIot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fetching by mechanicIds will return only the buildings that these mechanics own. (ie: only those they have a contract / pre-visit on) */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter buildings by the manager of the ops referent user on the building's contract. Given a list of user IDs, buildings whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter buildings with a search on building name, city name, zipcode or address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter missions by the location of the building (iso 3166-1 alpha-2 format: FR, EN) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter buildings which have currently active contracts */
  withActiveContractAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter buildings which have audit reports */
  withAuditReport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter buildings which have signed contracts */
  withContract?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters to apply for customer device list */
export type CustomerDeviceFilters = {
  /** Get only devices belonging to the specified buildings */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only devices on buildings  belonging to the specified contracts */
  contractIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only devices matching these identifiers */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter devices based on their iot equipment */
  hasIot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter devices that have a related onboarding */
  hasOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only devices which have at least one problem (or not) */
  hasProblems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only devices on buildings whose maintenance is owned by the specified mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only devices which are currently paused */
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Get only devices belonging to the specified users.
   *     Note: Filtering referent user devices can only be done in association with withActiveContract (true or false),
   *           asking for devices of referent user on all active and inactive contract at the same time is not managed yet.
   */
  referentUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** used to filter by wing name or device number */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Get only devices whose specs match all of the given key/values filters (the keys/values are those returned by deviceSpecsFilterOptions) */
  specsFilters?: InputMaybe<Array<DeviceSpecFilterInput>>;
  /** Get only devices in the required statuses */
  statuses?: InputMaybe<Array<QueryDeviceStatus>>;
  /** Get only devices which are currently into service (or not) */
  stopped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only devices located in a specific territory. Only takes ISO 2 country codes for now (eg: FR, GB, SG...) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only devices with the requested types */
  types?: InputMaybe<Array<DeviceType>>;
  /** Get only devices that have an active contract or that do not */
  withActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only devices which are working properly (or not) */
  working?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Set of filters to apply to the elevators of the customer */
export type CustomerElevatorsFilters = {
  /** Get only elevators belonging to the specified buildings */
  buildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Get only devices matching these identifiers */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Get only elevators matching these identifiers
   * @deprecated Use deviceIds instead
   */
  elevatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter elevators based on their iot equipment */
  hasIot?: InputMaybe<Scalars['Boolean']['input']>;
  /** used to filter by wing name or elevator number */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Get only elevators the required statuses */
  statuses?: InputMaybe<Array<ElevatorStatus>>;
  /** Get only elevators located in a specific territory. Only takes ISO 2 country codes for now (eg: FR, GB, SG...) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only elevators that have an active contract or that do not */
  withActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerMembers = {
  __typename?: 'CustomerMembers';
  companyname?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  countrycode?: Maybe<Scalars['String']['output']>;
};

export type CustomerOrderByInput = {
  companyname?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  countrycode?: InputMaybe<OrderBy>;
};

/** Set of filters to apply to the tasks of a customer */
export type CustomerTaskFilters = {
  /** Get only tasks belonging to specified buildings */
  buildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter task that have been completed on or after this date */
  completedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter task that have been completed on or before this date */
  completedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Get only tasks belonging to specified Devices */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter tasks by the device subtypes they relate to */
  deviceSubTypes?: InputMaybe<Array<DeviceSubTypeEnum>>;
  /** Filter tasks by the device types they relate to */
  deviceTypes?: InputMaybe<Array<DeviceTypeEnum>>;
  /** Get only tasks done to specified mechanics */
  doneByMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only tasks belonging to specified elevators */
  elevatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter tasks by their IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** true to only get tasks currently in progress (an engineer is currently in an active visit), false to get every tasks but the ongoing ones */
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to only get Tasks which are done, false to get only Tasks which are still to be completed */
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to only get tasks which are late (ie: past their deadline), false to only get tasks currently meeting their deadlines */
  isLate?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to only get tasks that were started (task is done or task is paused/inprogress and one question was answered), false to get only not started ones */
  isStarted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only tasks belonging to specified mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter tasks by the manager of the ops referent user on the device's contract. Given a list of user IDs, tasks whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only the tasks whose reference contains this text — a whole reference as printed on a worksheet (BDN26-000004, BDN26-S12345-1), or a shutdown number, which returns every sheet of that chain. */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Get only tasks affected to some specific referent users */
  referentUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** used to filter by address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter tasks by the location of the building (iso 3166-1 alpha-2 format: FR, EN) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only tasks of certain types */
  types?: InputMaybe<Array<TaskType>>;
  /** DEPRECATED: Use updatedAt.after */
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter tasks that have been updated between a certain date */
  updatedAt?: InputMaybe<DateFilter>;
  /** Also return tasks that have been soft deleted */
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerWhereInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  companyname?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
  countrycode?: InputMaybe<StringFilter>;
};

/** Filters to apply when fetching one or more customers */
export type CustomersFilters = {
  /** Filter customers by the accounts he has access to */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter customers by the accounts he has access to
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter customers with a search on customer company name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter customers of given territories */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter customers using their userIds */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  /** DashboardFilters:Represents a filter element of a dashboard */
  filters: Array<DashboardFilters>;
  /** DashboardLayout:Represents an element of a dashboard */
  layout: Array<DashboardLayout>;
};

export type DashboardFilter = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** DashboardFilters:Represents a filter element of a dashboard */
export type DashboardFilters = {
  __typename?: 'DashboardFilters';
  /** Allowed value to be used with this filter */
  allowedValues?: Maybe<Array<DashboardFilters_AllowedValues>>;
  displayOrder: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DashboardFilters_AllowedValues = {
  __typename?: 'DashboardFilters_AllowedValues';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** DashboardLayout:Represents an element of a dashboard */
export type DashboardLayout = {
  __typename?: 'DashboardLayout';
  bodyText?: Maybe<Scalars['String']['output']>;
  column: Scalars['Int']['output'];
  /** Dashboard filters that this query listens to and can be filtered by */
  dashboardFilters?: Maybe<Array<ListenToDashboardFilter>>;
  height: Scalars['Int']['output'];
  queryId?: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type DashboardPdf = {
  __typename?: 'DashboardPdf';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DataTable = QueryResult & {
  __typename?: 'DataTable';
  cellHtml?: Maybe<Array<Visualization_CellHtml>>;
  color?: Maybe<Array<Scalars['String']['output']>>;
  columns?: Maybe<Array<DataTable_Columns>>;
  /** ConditionalVisualFormat */
  conditionalVisualFormat?: Maybe<Array<ConditionalVisualFormat>>;
  /** Dataset */
  dataset?: Maybe<Dataset>;
  drillFields?: Maybe<Array<Visualization_DrillFields>>;
  labelValueFormat?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Visualization_Links>>;
  /** Note */
  note?: Maybe<Note>;
  series?: Maybe<Array<Visualization_Series>>;
  /** Sort */
  sort?: Maybe<Sort>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<DataTable_Total>;
  /** ValueFormat */
  valueFormat?: Maybe<Array<ValueFormat>>;
  /** VisualMap */
  visualMap?: Maybe<Array<VisualMap>>;
  xAxis?: Maybe<Visualization_XAxis>;
  yAxes?: Maybe<Array<Visualization_YAxes>>;
  yAxis?: Maybe<Visualization_YAxis>;
};

export type DataTable_Columns = {
  __typename?: 'DataTable_Columns';
  /** Hex colours used to do the colors gradient */
  colors?: Maybe<Array<Scalars['String']['output']>>;
  /** The index of the dimension in the dataset */
  dimension: Scalars['Int']['output'];
  /** ColumnType */
  type: ColumnType;
};

export type DataTable_Total = {
  __typename?: 'DataTable_Total';
  /** Whether to show the total row */
  show: Scalars['Boolean']['output'];
};

/** Dataset */
export type Dataset = {
  __typename?: 'Dataset';
  dimensions: Array<Dimension>;
  source: Array<Array<Scalars['String']['output']>>;
};

export type DateFilter = {
  /** Filter date that are equal or after to this date */
  after?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter date that are equal or before to this date */
  before?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Used to filter a date between a given time-range */
export type DateFilters = {
  /** End date to which we want to filter */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Start date from which we want to filter */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  afterDate?: InputMaybe<Scalars['String']['input']>;
  beforeDate?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inDateRange?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notEquals?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notInDateRange?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Default state for a MxCore Pin
 *  eg: If the pin value is 1 then the default state of the circuit is closed
 */
export enum DefaultPinState {
  DefaultClose = 'defaultClose',
  DefaultOpen = 'defaultOpen'
}

/** The status of the defect handling for a building report. */
export enum DefectHandlingForBuildingStatus {
  Late = 'LATE',
  NonApplicable = 'NON_APPLICABLE',
  OnTime = 'ON_TIME'
}

/** The status of the defect handling for a building/device/audit report. */
export enum DefectHandlingStatus {
  Late = 'LATE',
  NonApplicable = 'NON_APPLICABLE',
  OnTime = 'ON_TIME'
}

export type DefectLocationMembers = {
  __typename?: 'DefectLocationMembers';
  answer?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

export type DefectLocationOrderByInput = {
  answer?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
};

export type DefectLocationWhereInput = {
  AND?: InputMaybe<Array<DefectLocationWhereInput>>;
  OR?: InputMaybe<Array<DefectLocationWhereInput>>;
  answer?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
};

export type DefectOriginMembers = {
  __typename?: 'DefectOriginMembers';
  answer?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

export type DefectOriginOrderByInput = {
  answer?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
};

export type DefectOriginWhereInput = {
  AND?: InputMaybe<Array<DefectOriginWhereInput>>;
  OR?: InputMaybe<Array<DefectOriginWhereInput>>;
  answer?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
};

/**
 * The type of the defect created by an audit-report-line ; influences
 * how short the deadline to fix the defect is, or whether the deadline is
 * set automatically or not.
 */
export enum DefectType {
  Immediate = 'IMMEDIATE',
  Recommandation = 'RECOMMANDATION',
  Standard = 'STANDARD',
  Timed = 'TIMED'
}

export type DefectsProgress = {
  __typename?: 'DefectsProgress';
  /** Number of fixed/resolved defects for a building or an elevator */
  done: Scalars['Int']['output'];
  /** Total number of defects for a building or an elevator */
  total: Scalars['Int']['output'];
};

/** Set of filters to apply to the deleteInvoiceItem mutation */
export type DeleteInvoiceItemsFilters = {
  /** Select items to delete by their mission id */
  missionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeleteVisitPayload = {
  /** Id of the visit to be soft deleted */
  id: Scalars['ID']['input'];
};

export type Device = {
  /**
   * The audit offices possess an internal id refering to this specific Device
   *       that was registered during the ingest of an Audit Report.
   */
  auditOfficeIdentities: Array<Maybe<AuditOfficeIdentity>>;
  /** Returns the expected configuration for the audit-report types for the Device */
  auditReportConfig: AuditReportConfigObject;
  /** The audit reports lines of the device */
  auditReportLines: AuditReportAuditReportLineConnection;
  /** Audit reports associated with this building */
  auditReports: Array<AuditReport>;
  /** Availability rate of the device */
  availabilityRate?: Maybe<AvailabilityRate>;
  /** Brand of the device */
  brand?: Maybe<ElevatorBrand>;
  /** Date at which the elevator stopped working, usually as reported by call centers. This is different from the "stoppedSince" field. */
  brokenSince?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Building of the elevator */
  building: Building;
  /** Contracts of this device */
  contracts: ContractsContractDeviceContractConnection;
  /**
   * Determine if defects of the device have been handled:
   * - ON_TIME: All applicable defects were fixed on time
   * - LATE: One defect was fixed after toBeDoneBefore or toBeDoneBefore is passed
   * - NON_APPLICABLE: No defects were applicable
   */
  defectHandlingStatus: DefectHandlingStatus;
  /** Device defects progress counts */
  defectsProgress: DefectsProgress;
  /** Public identifier of a device */
  deviceNumber?: Maybe<Scalars['String']['output']>;
  /** Retrieve the status of the device: WORKING, STOPPED or HAS_ISSUES (working but with issues) */
  deviceStatus: DeviceStatuses;
  /** This device's dilap window state at the given instant — defaults to now; NO_WINDOW when no dilap period is configured or the device has no active contract line */
  dilapStatus: DilapStatus;
  /** This device's dilap window — the dilapidation coverage period; null when no dilap period is configured or the device has no active contract line */
  dilapWindow?: Maybe<DilapWindow>;
  /** List of events for a given device (currently only implements IOT) */
  events: IotEventConnection;
  /** Return whether or not the device is equipped with IOT */
  hasIot: Scalars['Boolean']['output'];
  /** Verify if there exists at least one AuditReportLine with a quote to send in this report */
  hasLineWithQuoteStatusToSend: Scalars['Boolean']['output'];
  /** The icon for the device */
  icon: Icon;
  id: Scalars['ID']['output'];
  /** Live status of the device */
  liveStatus?: Maybe<LiveDeviceStatus>;
  /** form to display a mechanic to update this device */
  mechanicIdentifyForm?: Maybe<DeviceSpecsForm>;
  /** Missions that have at least one task on this device */
  missions: MissionsMissionConnection;
  /** Details about the device location inside the building */
  name?: Maybe<Scalars['String']['output']>;
  /** onboarding form of an onboarding */
  onboardingForm?: Maybe<OnboardingDeviceForm>;
  /** Ops responsible of managing this device in this contract */
  opsReferent?: Maybe<Admin>;
  /** Indicates if the device is in a paused state */
  paused?: Maybe<Scalars['Boolean']['output']>;
  /** The Schedule of Rates in force for this device: its active contract's annex, or WeMaintain's standard list for its country and device type when the contract carries none; null = no price list either way */
  priceList?: Maybe<PriceList>;
  /** Retrieve the list of repair requests linked to this device */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  state?: Maybe<StateSnapshot>;
  /** Get the list of state for a device between a range of date */
  stateSnapshots: DeviceStateStateSnapshotConnection;
  /**
   * If the elevator is ONLINE or OFFLINE
   * @deprecated **DO NOT USE** Should use Device.deviceStatus instead.
   */
  status: DeviceStatuses;
  stoppedReason?: Maybe<Scalars['String']['output']>;
  /** Date at which the device was stopped, denoting that an engineer purposely put it offline for safety reason. This is usually a few hours after the device broke down. */
  stoppedSince?: Maybe<Scalars['DateTime']['output']>;
  /** Tasks of this device */
  tasks: MissionsTaskConnection;
  /**
   * The WM serial number of the IoT-device currently attached to the device
   * @deprecated A device can now have mulitple things. Use the `things` field
   */
  thingName?: Maybe<Scalars['String']['output']>;
  /** The things attached to this device */
  things: Array<Maybe<Thing>>;
  /** Media associated with the device from visits */
  visitMedia: VisitsAnswerPhotoConnection;
};


export type DeviceAuditReportLinesArgs = {
  filters?: InputMaybe<AuditReportLineDeviceFilters>;
  order?: InputMaybe<Array<AuditReportAuditReportLineOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};


export type DeviceAvailabilityRateArgs = {
  filters: AvailabilityRateFilters;
};


export type DeviceContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ContractDeviceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DeviceDilapStatusArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DeviceEventsArgs = {
  pagination?: InputMaybe<IotConnectionArgs>;
};


export type DeviceIconArgs = {
  size: AvailableIconSizes;
};


export type DeviceMechanicIdentifyFormArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type DeviceMissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DevicePausedArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DeviceRepairRequestsArgs = {
  filters?: InputMaybe<RepairRequestForDeviceInputFilters>;
  order?: InputMaybe<Array<WorkOrdersRepairRequestOrmEntityOrderOptions>>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type DeviceStateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DeviceStateSnapshotsArgs = {
  filters?: InputMaybe<StateSnapshotInput>;
  pagination?: InputMaybe<DeviceStateConnectionArgs>;
};


export type DeviceStoppedReasonArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type DeviceTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deviceTaskFilters?: InputMaybe<DeviceTaskFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MissionsTaskOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


export type DeviceVisitMediaArgs = {
  filters?: InputMaybe<FindManyDevicePhotosInput>;
  order?: InputMaybe<Array<VisitsAnswerPhotoOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

/** A device entry in the blocklist update payload */
export type DeviceBlocklistItem = {
  /** Whether to add or remove the device from the blocklist */
  action: BlocklistAction;
  /** Unique identifier of the device */
  id: Scalars['String']['input'];
};

/** Input parameters to generate a device component certificate */
export type DeviceComponentCertificateInputPayload = {
  /** The date which you want the component state */
  date: Scalars['DateTime']['input'];
  /** The device you want the certificate for */
  deviceId: Scalars['ID']['input'];
  /** The component you want the certificate for */
  stateKey: Scalars['String']['input'];
};

export type DeviceMembers = {
  __typename?: 'DeviceMembers';
  buildingDetailsWithDeviceNameAndLocation?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<TimeDimension>;
  deletedAt?: Maybe<TimeDimension>;
  deviceno?: Maybe<Scalars['String']['output']>;
  hasIot?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPaused?: Maybe<Scalars['String']['output']>;
  rollingCount?: Maybe<Scalars['Float']['output']>;
  specs?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  underContract?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<TimeDimension>;
  wingname?: Maybe<Scalars['String']['output']>;
  withIssue?: Maybe<Scalars['String']['output']>;
};

/** Availability rate of the devices targeted by this metric */
export type DeviceMetricAvailability = {
  __typename?: 'DeviceMetricAvailability';
  /** details about the rate of each device targeted by this metric. Ordered by rate ASC by default */
  byDevice: Array<DeviceMetricAvailabilityDetail>;
  /** Average rate of availability of the selected list of devices */
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Availability rate per device */
export type DeviceMetricAvailabilityDetail = {
  __typename?: 'DeviceMetricAvailabilityDetail';
  device: Device;
  /** availability rate for this specific device */
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Availability rate of the devices targeted by this metric */
export type DeviceMetricAvailabilityPerMonth = {
  __typename?: 'DeviceMetricAvailabilityPerMonth';
  /** The first day of the month for the metric */
  date: Scalars['DateTime']['output'];
  /** Rate as a percentage of devices in working orders */
  rate?: Maybe<Scalars['Float']['output']>;
};

export type DeviceMetrics = {
  __typename?: 'DeviceMetrics';
  /** Availability rate (downtime/period) of the specified devices */
  availability: DeviceMetricAvailability;
  /** Availability rate (downtime/period) of the specified devices grouped per month */
  availabilityPerMonth: Array<DeviceMetricAvailabilityPerMonth>;
  /** ids of the devices these metrics are about */
  deviceIds: Array<Maybe<Scalars['ID']['output']>>;
  /** Number of tickets opened and devices linked to them for a given period of time */
  numberOfTicketsPerMonth: Array<DeviceMetricsTicketsPerMonth>;
  /** Get the count of devices in each status WORKING, HAS_ISSUES or STOPPED */
  statusCount: Array<DeviceStatusCount>;
};


export type DeviceMetricsAvailabilityArgs = {
  filters?: InputMaybe<DateFilters>;
};


export type DeviceMetricsAvailabilityPerMonthArgs = {
  filters?: InputMaybe<DateFilters>;
};


export type DeviceMetricsNumberOfTicketsPerMonthArgs = {
  filters?: InputMaybe<DateFilters>;
};

/** Used to specify the targets of the metrics we want to get */
export type DeviceMetricsInput = {
  /** Target all the devices  on buildings belonging to the supplied accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Target all the devices of the supplied buildings */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Target all the devices  on buildings belonging to the supplied accounts
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Target a set of devices directly */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter devices by their types (ELEVATOR, ESCALATOR) */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /** Target a set of devices whose contracts are owned by the given mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter devices by the user owning the contract on these devices */
  referentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only devices located in a specific territory. Only takes ISO 2 country codes for now (eg: FR, GB, SG...). */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter on devices which have active contract. Will return devices with no active contract too ONLY if explicitely specified. */
  withContract?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceMetricsTicketsPerMonth = {
  __typename?: 'DeviceMetricsTicketsPerMonth';
  /** Number of devices on which tickets were open during target month */
  impactedDevices: Scalars['Int']['output'];
  /** Month of the metrics, 0-based index */
  month: Scalars['Int']['output'];
  /** Number of tickets for target month */
  ticketCount: Scalars['Int']['output'];
  /** Year of the metrics, yyyy */
  year: Scalars['Int']['output'];
};

export type DeviceOrderByInput = {
  buildingDetailsWithDeviceNameAndLocation?: InputMaybe<OrderBy>;
  buildingId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deviceno?: InputMaybe<OrderBy>;
  hasIot?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPaused?: InputMaybe<OrderBy>;
  rollingCount?: InputMaybe<OrderBy>;
  specs?: InputMaybe<OrderBy>;
  subtype?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  underContract?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  wingname?: InputMaybe<OrderBy>;
  withIssue?: InputMaybe<OrderBy>;
};

export enum DeviceOrmEntitySortableFields {
  BrokenSince = 'brokenSince',
  DeviceNumber = 'deviceNumber',
  Name = 'name',
  StoppedSince = 'stoppedSince'
}

/** Input to pause a device */
export type DevicePauseInput = {
  /** Device ID to pause */
  deviceId: Scalars['ID']['input'];
  /** Date of the pause */
  pauseAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DevicePauseMembers = {
  __typename?: 'DevicePauseMembers';
  count?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<TimeDimension>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<TimeDimension>;
};

export type DevicePauseOrderByInput = {
  count?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
};

export type DevicePausePeriodMembers = {
  __typename?: 'DevicePausePeriodMembers';
  count?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<TimeDimension>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<TimeDimension>;
};

export type DevicePausePeriodOrderByInput = {
  count?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
};

export type DevicePausePeriodWhereInput = {
  AND?: InputMaybe<Array<DevicePausePeriodWhereInput>>;
  OR?: InputMaybe<Array<DevicePausePeriodWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  deviceId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
};

export type DevicePauseWhereInput = {
  AND?: InputMaybe<Array<DevicePauseWhereInput>>;
  OR?: InputMaybe<Array<DevicePauseWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  deviceId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
};

/** The internal auditOffice reference for each device */
export type DeviceRefMatching = {
  /** External reference used by the auditOffice to reference the device in the report */
  auditOfficeRef: Scalars['String']['input'];
  /** Internal Wemaintain id of the device */
  deviceId: Scalars['ID']['input'];
};

/** Filter devices by a spec field key (as returned by deviceSpecsFilterOptions) matching any of the given values */
export type DeviceSpecFilterInput = {
  /** The spec field key, e.g. specs.emergencyServices */
  key: Scalars['String']['input'];
  /** Devices whose spec value matches any of these values. Include null to also match devices where this spec is not set */
  values: Array<InputMaybe<Scalars['String']['input']>>;
};

/** All available options for a single filterable spec field */
export type DeviceSpecFilterOption = {
  __typename?: 'DeviceSpecFilterOption';
  /** The spec field key (e.g. gsmGateway, engineType) */
  key: Scalars['String']['output'];
  /** The list of selectable options */
  options: Array<DeviceSpecFilterOptionValue>;
  /** The human-readable translated title of the field */
  title: Scalars['String']['output'];
};

/** A single option value for a spec filter */
export type DeviceSpecFilterOptionValue = {
  __typename?: 'DeviceSpecFilterOptionValue';
  /** The human-readable translated label */
  label: Scalars['String']['output'];
  /** The raw enum value used as filter */
  value: Scalars['String']['output'];
};

export type DeviceSpecsForm = GraphQlForm & {
  __typename?: 'DeviceSpecsForm';
  /** The inputs that belong inside this form */
  inputs: Array<FormThing>;
  targets: Array<FormTarget>;
};

export type DeviceStateConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceStateIssueSnapshotConnection = {
  __typename?: 'DeviceStateIssueSnapshotConnection';
  edges: Array<DeviceStateIssueSnapshotEdge>;
  pageInfo: DeviceStatePageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type DeviceStateIssueSnapshotEdge = {
  __typename?: 'DeviceStateIssueSnapshotEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: IssueSnapshot;
};

export type DeviceStateIssueSnapshotOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: IssueSnapshotSortableFields;
};

export type DeviceStatePageInfo = {
  __typename?: 'DeviceStatePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type DeviceStateProblemGqlConnection = {
  __typename?: 'DeviceStateProblemGQLConnection';
  edges: Array<DeviceStateProblemGqlEdge>;
  pageInfo: DeviceStatePageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type DeviceStateProblemGqlEdge = {
  __typename?: 'DeviceStateProblemGQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Problem;
};

export type DeviceStateProblemOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: ProblemOrmEntitySortableFields;
};

export type DeviceStateStateSnapshotConnection = {
  __typename?: 'DeviceStateStateSnapshotConnection';
  edges: Array<DeviceStateStateSnapshotEdge>;
  pageInfo: DeviceStatePageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type DeviceStateStateSnapshotEdge = {
  __typename?: 'DeviceStateStateSnapshotEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: StateSnapshot;
};

/** The status of the device */
export enum DeviceStateStatus {
  Breakdown = 'BREAKDOWN',
  HasIssues = 'HAS_ISSUES',
  Paused = 'PAUSED',
  Stopped = 'STOPPED',
  Working = 'WORKING'
}

/** Represents wether all the devices of a specific building are online or if at least one is down */
export enum DeviceStatus {
  AllDevicesOk = 'ALL_DEVICES_OK',
  AtLeastOneOffline = 'AT_LEAST_ONE_OFFLINE'
}

export type DeviceStatusCount = {
  __typename?: 'DeviceStatusCount';
  /** The number of device in this status */
  count: Scalars['Float']['output'];
  /** The status of the devices */
  status: DeviceStatuses;
};

/**
 * The status of the device for metrics
 *   WORKING: The device is working fin and have no issues opened
 *   HAS_ISSUES: The device is working but still have issues opened
 *   STOPPED: The device is stopped
 *   ONLINE: The device is online (DEPRECATED)
 *   OFFLINE: The device is offline (DEPRECATED
 */
export enum DeviceStatuses {
  HasIssues = 'HAS_ISSUES',
  /** @deprecated Not used in our API, kept for gateway-public. */
  Offline = 'OFFLINE',
  /** @deprecated Not used in our API, kept for gateway-public. */
  Online = 'ONLINE',
  Stopped = 'STOPPED',
  Working = 'WORKING'
}

/** The available device subtypes */
export enum DeviceSubTypeEnum {
  AccordionDoor = 'ACCORDION_DOOR',
  AutomaticDoor = 'AUTOMATIC_DOOR',
  BarrierLevante = 'BARRIER_LEVANTE',
  Bent = 'BENT',
  Drum = 'DRUM',
  Elevator = 'ELEVATOR',
  Escalator = 'ESCALATOR',
  FighterDoor = 'FIGHTER_DOOR',
  FireAlarm = 'FIRE_ALARM',
  FireSafety = 'FIRE_SAFETY',
  FreightElevator = 'FREIGHT_ELEVATOR',
  Hvac = 'HVAC',
  ManualDoor = 'MANUAL_DOOR',
  MetallicCurtain = 'METALLIC_CURTAIN',
  MovingWalk = 'MOVING_WALK',
  PlatformLift = 'PLATFORM_LIFT',
  RetractableTerminal = 'RETRACTABLE_TERMINAL',
  RollerShutter = 'ROLLER_SHUTTER',
  SectionalDoor = 'SECTIONAL_DOOR',
  SlidingGate = 'SLIDING_GATE',
  SlidingPedestrianDoor = 'SLIDING_PEDESTRIAN_DOOR',
  SpeedGate = 'SPEED_GATE',
  TelescopicPedestrianDoor = 'TELESCOPIC_PEDESTRIAN_DOOR',
  TiltingDoor = 'TILTING_DOOR'
}

/** Filters to apply for device.task */
export type DeviceTaskFilters = {
  /** Get only tasks from the buildings of specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only tasks belonging to specified buildings */
  buildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter task that have been completed on or after this date */
  completedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter task that have been completed on or before this date */
  completedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Get only tasks from the buildings of specified accounts */
  customerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter tasks by the device subtypes they relate to */
  deviceSubTypes?: InputMaybe<Array<DeviceSubTypeEnum>>;
  /** Filter tasks by the device types they relate to */
  deviceTypes?: InputMaybe<Array<DeviceTypeEnum>>;
  /** Get only tasks done to specified mechanics */
  doneByMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter tasks by their IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** true to only get tasks currently in progress (an engineer is currently in an active visit), false to get every tasks but the ongoing ones */
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to only get Tasks which are done, false to get only Tasks which are still to be completed */
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to only get tasks which are late (ie: past their deadline), false to only get tasks currently meeting their deadlines */
  isLate?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to only get tasks that were started (task is done or task is paused/inprogress and one question was answered), false to get only not started ones */
  isStarted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only tasks belonging to specified mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter tasks by the manager of the ops referent user on the device's contract. Given a list of user IDs, tasks whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only the tasks whose reference contains this text — a whole reference as printed on a worksheet (BDN26-000004, BDN26-S12345-1), or a shutdown number, which returns every sheet of that chain. */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Get only tasks affected to some specific referent users */
  referentUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** used to filter by address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter tasks by the location of the building (iso 3166-1 alpha-2 format: FR, EN) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only tasks of certain types */
  types?: InputMaybe<Array<TaskType>>;
  /** DEPRECATED: Use updatedAt.after */
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter tasks that have been updated between a certain date */
  updatedAt?: InputMaybe<DateFilter>;
  /** Also return tasks that have been soft deleted */
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The available types representing a vertical */
export enum DeviceType {
  Door = 'DOOR',
  Elevator = 'ELEVATOR',
  Escalator = 'ESCALATOR',
  FireAlarm = 'FIRE_ALARM',
  Hvac = 'HVAC'
}

/** The available device types */
export enum DeviceTypeEnum {
  Door = 'DOOR',
  Elevator = 'ELEVATOR',
  Escalator = 'ESCALATOR',
  FireAlarm = 'FIRE_ALARM',
  Hvac = 'HVAC'
}

/** Spec filter options grouped by device type */
export type DeviceTypeSpecFilterOptions = {
  __typename?: 'DeviceTypeSpecFilterOptions';
  /** The device type these specs belong to */
  deviceType: DeviceType;
  /** All filterable spec fields and their available values */
  specs: Array<DeviceSpecFilterOption>;
};

/** Input to unpause a device */
export type DeviceUnpauseInput = {
  /** Device ID to unpause */
  deviceId: Scalars['ID']['input'];
  /** Date of the unpause */
  unpauseAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeviceWhereInput = {
  AND?: InputMaybe<Array<DeviceWhereInput>>;
  OR?: InputMaybe<Array<DeviceWhereInput>>;
  buildingDetailsWithDeviceNameAndLocation?: InputMaybe<StringFilter>;
  buildingId?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeFilter>;
  deviceno?: InputMaybe<StringFilter>;
  hasIot?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isPaused?: InputMaybe<StringFilter>;
  rollingCount?: InputMaybe<FloatFilter>;
  specs?: InputMaybe<StringFilter>;
  subtype?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  underContract?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  wingname?: InputMaybe<StringFilter>;
  withIssue?: InputMaybe<StringFilter>;
};

/** Set of filters to apply to the devices */
export type DevicesFilters = {
  /** Get only devices on buildings  belonging to the specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only devices belonging to the specified buildings */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only devices on buildings  belonging to the specified contracts */
  contractIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Get only devices on buildings belonging to the specified account
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only devices matching these identifiers */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter devices based on their iot equipment */
  hasIot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter devices that have a related onboarding */
  hasOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only devices which have at least one problem (or not) */
  hasProblems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only devices on buildings whose maintenance is owned by the specified mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only devices which are currently paused */
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Get only devices belonging to the specified users.
   *     Note: Filtering referent user devices can only be done in association with withActiveContract (true or false),
   *           asking for devices of referent user on all active and inactive contract at the same time is not managed yet.
   */
  referentUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** used to filter by wing name or device number */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Get only devices whose specs match all of the given key/values filters (the keys/values are those returned by deviceSpecsFilterOptions) */
  specsFilters?: InputMaybe<Array<DeviceSpecFilterInput>>;
  /**
   * Get only devices in the required statuses
   * @deprecated Use working, stopped, paused and hasProblems filters instead
   */
  statuses?: InputMaybe<Array<QueryDeviceStatus>>;
  /** Get only devices which are currently into service (or not) */
  stopped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only devices located in a specific territory. Only takes ISO 2 country codes for now (eg: FR, GB, SG...) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only devices with the requested types */
  types?: InputMaybe<Array<DeviceType>>;
  /** Get only devices that have an active contract or that do not */
  withActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only devices which are working properly (or not) */
  working?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DevicesState2ConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DevicesState2DowntimeConnection = {
  __typename?: 'DevicesState2DowntimeConnection';
  edges: Array<DevicesState2DowntimeEdge>;
  pageInfo: DevicesState2PageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type DevicesState2DowntimeEdge = {
  __typename?: 'DevicesState2DowntimeEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Downtime;
};

export type DevicesState2DowntimeGqlConnection = {
  __typename?: 'DevicesState2DowntimeGQLConnection';
  edges: Array<DevicesState2DowntimeGqlEdge>;
  pageInfo: DevicesState2PageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type DevicesState2DowntimeGqlEdge = {
  __typename?: 'DevicesState2DowntimeGQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Downtime;
};

export type DevicesState2DowntimeOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: DowntimeOrmEntitySortableFields;
};

export type DevicesState2PageInfo = {
  __typename?: 'DevicesState2PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type DevicesState2TimelineMarkerGqlConnection = {
  __typename?: 'DevicesState2TimelineMarkerGQLConnection';
  edges: Array<DevicesState2TimelineMarkerGqlEdge>;
  pageInfo: DevicesState2PageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type DevicesState2TimelineMarkerGqlEdge = {
  __typename?: 'DevicesState2TimelineMarkerGQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: TimelineMarker;
};

/** A device's dilap window state at a given instant */
export enum DilapStatus {
  Closed = 'CLOSED',
  NotYetOpen = 'NOT_YET_OPEN',
  NoWindow = 'NO_WINDOW',
  Open = 'OPEN'
}

export type DilapWindow = {
  __typename?: 'DilapWindow';
  /** When this device's dilap window closes */
  closesAt: Scalars['DateTime']['output'];
  /** When this device's dilap window opens */
  opensAt: Scalars['DateTime']['output'];
};

/** Dimension */
export type Dimension = {
  __typename?: 'Dimension';
  /** The type of the data. ie string, or date_quarter */
  dataType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** If the dimension is hidden in the UI */
  hidden: Scalars['Boolean']['output'];
  /** if it is a dimension or a measure, important for drilldown filtering. */
  kind?: Maybe<DimensionKind>;
  /** If pivoted, the name of the measure before pivot */
  measureName?: Maybe<Scalars['String']['output']>;
  /** Human friendly name */
  name: Scalars['String']['output'];
  /** If pivoted, the key of the pivot */
  pivotKey?: Maybe<Scalars['String']['output']>;
  /** If pivoted, the label of the pivot */
  pivotLabel?: Maybe<Scalars['String']['output']>;
  /** If pivoted, the name of the pivot */
  pivotName?: Maybe<Scalars['String']['output']>;
  /** For merged queries: the name of the source query this dimension originated from */
  sourceQueryName?: Maybe<Scalars['String']['output']>;
};

export enum DimensionKind {
  Dimension = 'dimension',
  Measure = 'measure'
}

export type DismissSignalInput = {
  /** The reason why the signal is being dismissed */
  dismissalReason: SignalDismissalReason;
  /** An explanation for the dismissal */
  explanation?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the signal to dismiss */
  signalId: Scalars['ID']['input'];
  /** The version of the signal */
  version: Scalars['String']['input'];
};

export type Dismissal = {
  __typename?: 'Dismissal';
  /** An explanation of why the signal was dismissed if the reason is other */
  explanation?: Maybe<Scalars['String']['output']>;
  /** The reason why the signal was dismissed */
  reason: SignalDismissalReason;
  /** The user who dismissed the signal */
  userInfo: SignalFeedbackUserInfo;
};

export enum DispatchStatus {
  Error = 'ERROR',
  Sent = 'SENT',
  ToSent = 'TO_SENT'
}

export type DisplayGroupInput = {
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<TranslationInput>>;
};

export type DocumentsConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentsPageInfo = {
  __typename?: 'DocumentsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type DocumentsStateComponentCertificateGraphqlConnection = {
  __typename?: 'DocumentsStateComponentCertificateGraphqlConnection';
  edges: Array<DocumentsStateComponentCertificateGraphqlEdge>;
  pageInfo: DocumentsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type DocumentsStateComponentCertificateGraphqlEdge = {
  __typename?: 'DocumentsStateComponentCertificateGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: StateComponentCertificate;
};

export type DocumentsStateComponentCertificateGraphqlOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort?: StateComponentOrmEntitySortableFields;
};

export type Door = Device & {
  __typename?: 'Door';
  /**
   * The audit offices possess an internal id refering to this specific Device
   *       that was registered during the ingest of an Audit Report.
   */
  auditOfficeIdentities: Array<Maybe<AuditOfficeIdentity>>;
  /** Returns the expected configuration for the audit-report types for the Device */
  auditReportConfig: AuditReportConfigObject;
  /** The audit reports lines of the device */
  auditReportLines: AuditReportAuditReportLineConnection;
  /** Audit reports associated with this building */
  auditReports: Array<AuditReport>;
  /** Availability rate of the device */
  availabilityRate?: Maybe<AvailabilityRate>;
  /** Brand of the device */
  brand?: Maybe<ElevatorBrand>;
  /** Date at which the elevator stopped working, usually as reported by call centers. This is different from the "stoppedSince" field. */
  brokenSince?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Building of the elevator */
  building: Building;
  /** Contracts of this device */
  contracts: ContractsContractDeviceContractConnection;
  /**
   * Determine if defects of the device have been handled:
   * - ON_TIME: All applicable defects were fixed on time
   * - LATE: One defect was fixed after toBeDoneBefore or toBeDoneBefore is passed
   * - NON_APPLICABLE: No defects were applicable
   */
  defectHandlingStatus: DefectHandlingStatus;
  /** Device defects progress counts */
  defectsProgress: DefectsProgress;
  /** Public identifier of a device */
  deviceNumber?: Maybe<Scalars['String']['output']>;
  /** Retrieve the status of the device: WORKING, STOPPED or HAS_ISSUES (working but with issues) */
  deviceStatus: DeviceStatuses;
  /** This device's dilap window state at the given instant — defaults to now; NO_WINDOW when no dilap period is configured or the device has no active contract line */
  dilapStatus: DilapStatus;
  /** This device's dilap window — the dilapidation coverage period; null when no dilap period is configured or the device has no active contract line */
  dilapWindow?: Maybe<DilapWindow>;
  /** List of events for a given device (currently only implements IOT) */
  events: IotEventConnection;
  /** Return whether or not the device is equipped with IOT */
  hasIot: Scalars['Boolean']['output'];
  /** Verify if there exists at least one AuditReportLine with a quote to send in this report */
  hasLineWithQuoteStatusToSend: Scalars['Boolean']['output'];
  /** The icon for the device */
  icon: Icon;
  id: Scalars['ID']['output'];
  /** Live status of the device */
  liveStatus?: Maybe<LiveDeviceStatus>;
  /** form to display a mechanic to update this device */
  mechanicIdentifyForm: DeviceSpecsForm;
  /** Missions that have at least one task on this device */
  missions: MissionsMissionConnection;
  /** Details about the device location inside the building */
  name?: Maybe<Scalars['String']['output']>;
  /** onboarding form of an onboarding */
  onboardingForm?: Maybe<OnboardingDeviceForm>;
  /** Ops responsible of managing this device in this contract */
  opsReferent?: Maybe<Admin>;
  /** Indicates if the device is in a paused state */
  paused?: Maybe<Scalars['Boolean']['output']>;
  /** The Schedule of Rates in force for this device: its active contract's annex, or WeMaintain's standard list for its country and device type when the contract carries none; null = no price list either way */
  priceList?: Maybe<PriceList>;
  /** Retrieve the list of repair requests linked to this device */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  /** Technical specs relative to a door (ie: serialnumber...) */
  specs: DoorSpecs;
  state?: Maybe<StateSnapshot>;
  /** Get the list of state for a device between a range of date */
  stateSnapshots: DeviceStateStateSnapshotConnection;
  /**
   * If the elevator is ONLINE or OFFLINE
   * @deprecated **DO NOT USE** Should use Device.deviceStatus instead.
   */
  status: DeviceStatuses;
  stoppedReason?: Maybe<Scalars['String']['output']>;
  /** Date at which the device was stopped, denoting that an engineer purposely put it offline for safety reason. This is usually a few hours after the device broke down. */
  stoppedSince?: Maybe<Scalars['DateTime']['output']>;
  /** Subtype of the door */
  subtype: DoorSubType;
  /** Tasks of this device */
  tasks: MissionsTaskConnection;
  /**
   * The WM serial number of the IoT-device currently attached to the device
   * @deprecated A device can now have mulitple things. Use the `things` field
   */
  thingName?: Maybe<Scalars['String']['output']>;
  /** The things attached to this device */
  things: Array<Maybe<Thing>>;
  /** Media associated with the device from visits */
  visitMedia: VisitsAnswerPhotoConnection;
};


export type DoorAuditReportLinesArgs = {
  filters?: InputMaybe<AuditReportLineDeviceFilters>;
  order?: InputMaybe<Array<AuditReportAuditReportLineOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};


export type DoorAvailabilityRateArgs = {
  filters: AvailabilityRateFilters;
};


export type DoorContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ContractDeviceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DoorDilapStatusArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DoorEventsArgs = {
  pagination?: InputMaybe<IotConnectionArgs>;
};


export type DoorIconArgs = {
  size: AvailableIconSizes;
};


export type DoorMechanicIdentifyFormArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type DoorMissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DoorPausedArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DoorRepairRequestsArgs = {
  filters?: InputMaybe<RepairRequestForDeviceInputFilters>;
  order?: InputMaybe<Array<WorkOrdersRepairRequestOrmEntityOrderOptions>>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type DoorStateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DoorStateSnapshotsArgs = {
  filters?: InputMaybe<StateSnapshotInput>;
  pagination?: InputMaybe<DeviceStateConnectionArgs>;
};


export type DoorStoppedReasonArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type DoorTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deviceTaskFilters?: InputMaybe<DeviceTaskFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MissionsTaskOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


export type DoorVisitMediaArgs = {
  filters?: InputMaybe<FindManyDevicePhotosInput>;
  order?: InputMaybe<Array<VisitsAnswerPhotoOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

/** A door anomaly strong signal. */
export type DoorAnomaly = StrongSignal & {
  __typename?: 'DoorAnomaly';
  /** An acknowledgement if the signal was acknowledged. */
  acknowledgement?: Maybe<Acknowledgement>;
  /** The date and time when the signal was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time when the signal was last updated. This attribute has to be sent when acknowledging a signal. */
  date: Scalars['DateTime']['output'];
  /** Details about this signal */
  details: Array<StrongSignalDetail>;
  /** The device associated with the signal */
  device?: Maybe<Device>;
  /** A dismissal if the signal was dismissed. */
  dismissal?: Maybe<Dismissal>;
  /** Technical description of the signal meant for the engineer */
  engineerDescription: Scalars['String']['output'];
  /** The state of the strong signal. */
  engineerSorting: StrongSignalStateEnum;
  /** Human understandable explanation detailing this signal, trying to make it legible even by non technical users */
  explanation: Scalars['String']['output'];
  /** The floor. */
  floor?: Maybe<Scalars['String']['output']>;
  /** The label of the floor. */
  floorLabel?: Maybe<Scalars['String']['output']>;
  /** The ID of the signal in the backend. */
  id: Scalars['ID']['output'];
  /** The relevancy feedback of the signal. */
  relevancyFeedback?: Maybe<SignalRelevancyFeedback>;
  /** Human readable sub title detailing this signal */
  subtitle: Scalars['String']['output'];
  /** The thing associated with the signal */
  thing?: Maybe<Thing>;
  /** The thing name that emitted the signal. */
  thingName: Scalars['String']['output'];
  /** The timestamp of the anomaly. */
  timestamp: Scalars['Timestamp']['output'];
  /** Human readable title for this signal */
  title: Scalars['String']['output'];
  /** The type of the door anomaly. */
  type?: Maybe<Scalars['String']['output']>;
};


/** A door anomaly strong signal. */
export type DoorAnomalyDetailsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A door anomaly strong signal. */
export type DoorAnomalyEngineerDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A door anomaly strong signal. */
export type DoorAnomalyExplanationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A door anomaly strong signal. */
export type DoorAnomalySubtitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A door anomaly strong signal. */
export type DoorAnomalyTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Contains all technical specifications of a door */
export type DoorSpecs = {
  __typename?: 'DoorSpecs';
  /** Type of sensor used for the external presence detection to activate the door opening */
  externalActivationType?: Maybe<ActivationType>;
  /** Type of sensor used for the internal presence detection to activate the door opening */
  internalActivationType?: Maybe<ActivationType>;
  /** The model of the door */
  model?: Maybe<Scalars['String']['output']>;
  /** Type of motor used to open the door */
  motorType?: Maybe<MotorType>;
  /** The maximum opening width of the door */
  openingWidth?: Maybe<Scalars['Float']['output']>;
  /** Type of safety device */
  physicalSafety?: Maybe<PhysicalSafety>;
  /** Type of radar used to detect presence */
  radarType?: Maybe<RadarType>;
  /** The safety risk of this door depending on who uses it (children, elderly...) */
  risk?: Maybe<Risk>;
  /** the serial number of the device */
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/** Sub Type of a door */
export enum DoorSubType {
  AccordionDoor = 'ACCORDION_DOOR',
  AutomaticDoor = 'AUTOMATIC_DOOR',
  BarrierLevante = 'BARRIER_LEVANTE',
  Bent = 'BENT',
  Drum = 'DRUM',
  FighterDoor = 'FIGHTER_DOOR',
  ManualDoor = 'MANUAL_DOOR',
  MetallicCurtain = 'METALLIC_CURTAIN',
  RetractableTerminal = 'RETRACTABLE_TERMINAL',
  RollerShutter = 'ROLLER_SHUTTER',
  SectionalDoor = 'SECTIONAL_DOOR',
  SlidingGate = 'SLIDING_GATE',
  SlidingPedestrianDoor = 'SLIDING_PEDESTRIAN_DOOR',
  SpeedGate = 'SPEED_GATE',
  TelescopicPedestrianDoor = 'TELESCOPIC_PEDESTRIAN_DOOR',
  TiltingDoor = 'TILTING_DOOR'
}

export type Downtime = {
  __typename?: 'Downtime';
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  device: Device;
  end?: Maybe<Scalars['DateTimeISO']['output']>;
  /** EvaluationStatus:The evaluation status of the downtime */
  evaluationStatus: EvaluationStatus;
  id: Scalars['String']['output'];
  interventions: Array<Downtime_Interventions>;
  /** DowntimeSourceType:Type of source reporting this downtime */
  sourceType: DowntimeSourceType;
  start: Scalars['DateTimeISO']['output'];
  stateId: Scalars['String']['output'];
  /** List of signals that happened during the downtime. */
  strongSignals: IotStrongSignalGraphQlConnection;
  /** Timeline markers for this downtime */
  timeline: DevicesState2TimelineMarkerGqlConnection;
  /** Type:Type of the downtime, either an intervention by an engineer or a breakdown */
  type: Type;
  unexpectedIdlePeriods: Array<Downtime_UnexpectedIdlePeriods>;
};


export type DowntimeStrongSignalsArgs = {
  filters?: InputMaybe<DowntimeStrongSignalsInputFilters>;
  order?: InputMaybe<Array<IotSignalOrmEntityOrderOptions>>;
  pagination?: InputMaybe<IotConnectionArgs>;
};


export type DowntimeTimelineArgs = {
  pagination?: InputMaybe<DevicesState2ConnectionArgs>;
};

export enum DowntimeOrmEntitySortableFields {
  End = 'end',
  Start = 'start'
}

/** Type of source reporting this downtime */
export enum DowntimeSourceType {
  DbtUnavailabilityPeriod = 'DBT_UNAVAILABILITY_PERIOD',
  IotLive = 'IOT_LIVE'
}

export type DowntimeStrongSignalsInputFilters = {
  /** Filter by signal IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter all signals even those which are not whitelisted */
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A downtime timeline marker */
export type DowntimeTimelineMarker = TimelineMarker & {
  __typename?: 'DowntimeTimelineMarker';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  type: TimelineMarkerType;
};

export type Downtime_Interventions = {
  __typename?: 'Downtime_Interventions';
  discarded?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['DateTimeISO']['output']>;
  start?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type Downtime_UnexpectedIdlePeriods = {
  __typename?: 'Downtime_UnexpectedIdlePeriods';
  discarded?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['DateTimeISO']['output']>;
  start?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type Elevator = Device & {
  __typename?: 'Elevator';
  /** Type of alarm system */
  alarmSystem?: Maybe<AlarmSystem>;
  /** @deprecated Use the alarmSystem field instead */
  alarm_system: AlarmSystem;
  /**
   * The audit offices possess an internal id refering to this specific Device
   *       that was registered during the ingest of an Audit Report.
   */
  auditOfficeIdentities: Array<Maybe<AuditOfficeIdentity>>;
  /** Returns the expected configuration for the audit-report types for the Device */
  auditReportConfig: AuditReportConfigObject;
  /** The audit reports lines of the device */
  auditReportLines: AuditReportAuditReportLineConnection;
  /** Audit reports associated with this building */
  auditReports: Array<AuditReport>;
  /** Availability rate of the device */
  availabilityRate?: Maybe<AvailabilityRate>;
  /** Brand of the device */
  brand?: Maybe<ElevatorBrand>;
  /** Date at which the elevator stopped working, usually as reported by call centers. This is different from the "stoppedSince" field. */
  brokenSince?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Building of the elevator */
  building: Building;
  /**
   * Weight capacity of the elevator
   * @deprecated Use specs.capacity instead
   */
  capacity?: Maybe<Scalars['Float']['output']>;
  /**
   * Measurement unit of the weight capacity
   * @deprecated This property is not used anymore
   */
  capacityMeasurementUnit?: Maybe<ElevatorCapacityMeasurementUnit>;
  /** Contracts of this device */
  contracts: ContractsContractDeviceContractConnection;
  /**
   * Determine if defects of the device have been handled:
   * - ON_TIME: All applicable defects were fixed on time
   * - LATE: One defect was fixed after toBeDoneBefore or toBeDoneBefore is passed
   * - NON_APPLICABLE: No defects were applicable
   */
  defectHandlingStatus: DefectHandlingStatus;
  /** Device defects progress counts */
  defectsProgress: DefectsProgress;
  /** Public identifier of a device */
  deviceNumber?: Maybe<Scalars['String']['output']>;
  /** Retrieve the status of the device: WORKING, STOPPED or HAS_ISSUES (working but with issues) */
  deviceStatus: DeviceStatuses;
  /** This device's dilap window state at the given instant — defaults to now; NO_WINDOW when no dilap period is configured or the device has no active contract line */
  dilapStatus: DilapStatus;
  /** This device's dilap window — the dilapidation coverage period; null when no dilap period is configured or the device has no active contract line */
  dilapWindow?: Maybe<DilapWindow>;
  /**
   * Public identifier of an elevator. Should be prefix with WM
   * @deprecated Should use deviceNumber instead
   */
  elevatorNo?: Maybe<Scalars['String']['output']>;
  /**
   * Type of elevator engine (eg: hydraulic, electric...)
   * @deprecated Use specs.engineType instead
   */
  engineType?: Maybe<ElevatorEngineType>;
  /** List of events for a given device (currently only implements IOT) */
  events: IotEventConnection;
  /** Return whether or not the device is equipped with IOT */
  hasIot: Scalars['Boolean']['output'];
  /** Verify if there exists at least one AuditReportLine with a quote to send in this report */
  hasLineWithQuoteStatusToSend: Scalars['Boolean']['output'];
  /** The icon for the device */
  icon: Icon;
  id: Scalars['ID']['output'];
  /** Live status of the device */
  liveStatus?: Maybe<LiveDeviceStatus>;
  /** form to display a mechanic to update this device */
  mechanicIdentifyForm: DeviceSpecsForm;
  /** Missions that have at least one task on this device */
  missions: MissionsMissionConnection;
  /** Details about the device location inside the building */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Number of floors served by the elevator
   * @deprecated Use specs.noOfFloor instead
   */
  noOfFloor?: Maybe<Scalars['Float']['output']>;
  /** onboarding form of an onboarding */
  onboardingForm?: Maybe<OnboardingDeviceForm>;
  /** Ops responsible of managing this device in this contract */
  opsReferent?: Maybe<Admin>;
  /** Indicates if the device is in a paused state */
  paused?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Phone line of the alarm system
   * @deprecated Use specs.phoneLine instead
   */
  phoneLine?: Maybe<Scalars['String']['output']>;
  /** The Schedule of Rates in force for this device: its active contract's annex, or WeMaintain's standard list for its country and device type when the contract carries none; null = no price list either way */
  priceList?: Maybe<PriceList>;
  /** Retrieve the list of repair requests linked to this device */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  /** Technical specs relative to an escalator (ie: speed, motorRoom...) */
  specs: ElevatorSpecs;
  /**
   * Speed of the elevator
   * @deprecated Use specs.speed instead
   */
  speed?: Maybe<Scalars['Float']['output']>;
  /**
   * Mesurement unit of the elevators speed (eg: meter per second)
   * @deprecated This property is not used anymore
   */
  speedMeasurementUnit?: Maybe<ElevatorSpeedMeasurementUnit>;
  state?: Maybe<StateSnapshot>;
  /** Get the list of state for a device between a range of date */
  stateSnapshots: DeviceStateStateSnapshotConnection;
  /**
   * If the elevator is ONLINE or OFFLINE
   * @deprecated **DO NOT USE** Should use Device.deviceStatus instead.
   */
  status: DeviceStatuses;
  stoppedReason?: Maybe<Scalars['String']['output']>;
  /** Date at which the device was stopped, denoting that an engineer purposely put it offline for safety reason. This is usually a few hours after the device broke down. */
  stoppedSince?: Maybe<Scalars['DateTime']['output']>;
  /** Subtype of the elevator */
  subtype: ElevatorSubType;
  /** Tasks of this device */
  tasks: MissionsTaskConnection;
  /**
   * The WM serial number of the IoT-device currently attached to the device
   * @deprecated A device can now have mulitple things. Use the `things` field
   */
  thingName?: Maybe<Scalars['String']['output']>;
  /** The things attached to this device */
  things: Array<Maybe<Thing>>;
  /** Type of elevator */
  type: ElevatorType;
  /** Media associated with the device from visits */
  visitMedia: VisitsAnswerPhotoConnection;
  /**
   * Details about the elevator location inside the building
   * @deprecated Should use name instead
   */
  wingName?: Maybe<Scalars['String']['output']>;
};


export type ElevatorAuditReportLinesArgs = {
  filters?: InputMaybe<AuditReportLineDeviceFilters>;
  order?: InputMaybe<Array<AuditReportAuditReportLineOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};


export type ElevatorAvailabilityRateArgs = {
  filters: AvailabilityRateFilters;
};


export type ElevatorContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ContractDeviceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ElevatorDilapStatusArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ElevatorEventsArgs = {
  pagination?: InputMaybe<IotConnectionArgs>;
};


export type ElevatorIconArgs = {
  size: AvailableIconSizes;
};


export type ElevatorMechanicIdentifyFormArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ElevatorMissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ElevatorPausedArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ElevatorRepairRequestsArgs = {
  filters?: InputMaybe<RepairRequestForDeviceInputFilters>;
  order?: InputMaybe<Array<WorkOrdersRepairRequestOrmEntityOrderOptions>>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type ElevatorStateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ElevatorStateSnapshotsArgs = {
  filters?: InputMaybe<StateSnapshotInput>;
  pagination?: InputMaybe<DeviceStateConnectionArgs>;
};


export type ElevatorStoppedReasonArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ElevatorTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deviceTaskFilters?: InputMaybe<DeviceTaskFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MissionsTaskOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


export type ElevatorVisitMediaArgs = {
  filters?: InputMaybe<FindManyDevicePhotosInput>;
  order?: InputMaybe<Array<VisitsAnswerPhotoOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

export type ElevatorBrand = {
  __typename?: 'ElevatorBrand';
  id: Scalars['ID']['output'];
  /** Brand of the elevator (eg: Otis, Thyssenkrupp...) */
  name: Scalars['String']['output'];
};

/** The type of lighting in the cabin */
export enum ElevatorCabinLightingSpecsType {
  Halogen = 'HALOGEN',
  Led = 'LED',
  Neon = 'NEON',
  NotApplicable = 'NOT_APPLICABLE'
}

/** The type of motion in the cabin */
export enum ElevatorCabinMotionSpecsType {
  Rail = 'RAIL',
  Roller = 'ROLLER',
  RollerAndRail = 'ROLLER_AND_RAIL'
}

/** The measurement unit of the elevator weight */
export enum ElevatorCapacityMeasurementUnit {
  Kilograms = 'KILOGRAMS'
}

/** The type of door opening */
export enum ElevatorDoorsOpeningType {
  Center = 'CENTER',
  Left = 'LEFT',
  Other = 'OTHER',
  Right = 'RIGHT',
  Swing = 'SWING'
}

/** Is the eco-mode supported */
export enum ElevatorEcoMode {
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Unknown = 'UNKNOWN',
  Yes = 'YES'
}

/** The regulation of the lift related to emergency services */
export enum ElevatorEmergencyServices {
  EvacuationLift = 'EVACUATION_LIFT',
  FirefightersLift = 'FIREFIGHTERS_LIFT',
  FiremenLift = 'FIREMEN_LIFT',
  FireFightingLift = 'FIRE_FIGHTING_LIFT',
  ModernizedLiftForFireService = 'MODERNIZED_LIFT_FOR_FIRE_SERVICE',
  NonApplicable = 'NON_APPLICABLE'
}

/** The sub type of the engine */
export enum ElevatorEngineSpecsSubType {
  Drum = 'DRUM',
  Gearless = 'GEARLESS',
  NotApplicable = 'NOT_APPLICABLE',
  Winch = 'WINCH'
}

/** Type of elevator drive system (eg: hydraulic, electric...) */
export enum ElevatorEngineType {
  Electric = 'ELECTRIC',
  Hydraulic = 'HYDRAULIC',
  MrlHydraulic = 'MRL_HYDRAULIC',
  MrlTraction = 'MRL_TRACTION',
  Other = 'OTHER'
}

/** The frequency variator of the engine */
export enum ElevatorFrequencySpecsVariator {
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Yes = 'YES'
}

/** The location of the landing indicators */
export enum ElevatorLandingIndicatorsLocation {
  All = 'ALL',
  GroundFloorOnly = 'GROUND_FLOOR_ONLY',
  NotApplicable = 'NOT_APPLICABLE'
}

/** Availability rate of the elevators targeted by this metric */
export type ElevatorMetricAvailability = {
  __typename?: 'ElevatorMetricAvailability';
  /** details about the rate of each elevator targeted by this metric. Ordered by rate ASC by default */
  byElevator: Array<ElevatorMetricAvailabilityDetail>;
  /** Average rate of availability of the selected list of elevators */
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Availability rate per elevator */
export type ElevatorMetricAvailabilityDetail = {
  __typename?: 'ElevatorMetricAvailabilityDetail';
  elevator: Device;
  /** availability rate for this specific elevator */
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Availability rate of the elevators targeted by this metric */
export type ElevatorMetricAvailabilityPerMonth = {
  __typename?: 'ElevatorMetricAvailabilityPerMonth';
  /** The first day of the month for the metric */
  date: Scalars['DateTime']['output'];
  /** Rate as a percentage of devices in working orders */
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Statuses of the elevators targeted by this metric */
export type ElevatorMetricStatuses = {
  __typename?: 'ElevatorMetricStatuses';
  /** Count of devices not in working order */
  countOffline: Scalars['Int']['output'];
  /** Count of devices in working orders */
  countOnline: Scalars['Int']['output'];
};

export type ElevatorMetrics = {
  __typename?: 'ElevatorMetrics';
  /** Availability rate for the given elevators */
  availability: ElevatorMetricAvailability;
  /** Availability rate for the given elevators */
  availabilityPerMonth: Array<ElevatorMetricAvailabilityPerMonth>;
  /** ids of the elevators these metrics are about */
  elevatorIds: Array<Maybe<Scalars['ID']['output']>>;
  /** Number of tickets opened and elevators linked to them for a given period of time */
  numberOfTicketsPerMonth: Array<ElevatorMetricsTicketsPerMonth>;
  statusCount: Array<ElevatorStatusCount>;
  /**
   * statuses of elevators (ONLINE/OFFLINE) in these metrics
   * @deprecated Use field statusCount to get an enumerable
   */
  statuses: ElevatorMetricStatuses;
};


export type ElevatorMetricsAvailabilityArgs = {
  filters?: InputMaybe<DateFilters>;
};


export type ElevatorMetricsAvailabilityPerMonthArgs = {
  filters?: InputMaybe<DateFilters>;
};


export type ElevatorMetricsNumberOfTicketsPerMonthArgs = {
  filters?: InputMaybe<DateFilters>;
};

/** Used to specify the targets of the metrics we want to get */
export type ElevatorMetricsInput = {
  /** Target all the elevators of the supplied buildings */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Target all the elevators belonging to supplied customers */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Target a set of elevators directly */
  elevatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Target a set of elevators whose contracts are owned by the given mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only elevators located in a specific territory. Only takes ISO 2 country codes for now (eg: FR, GB, SG...). */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter on elevators which have active contract. Will return elevators with no active contract too ONLY if explicitely specified. */
  withContract?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ElevatorMetricsTicketsPerMonth = {
  __typename?: 'ElevatorMetricsTicketsPerMonth';
  /** Number of elevators on which tickets were open during target month */
  impactedElevators: Scalars['Int']['output'];
  /** Month of the metrics, 0-based index */
  month: Scalars['Int']['output'];
  /** Number of tickets for target month */
  ticketCount: Scalars['Int']['output'];
  /** Year of the metrics, yyyy */
  year: Scalars['Int']['output'];
};

export type ElevatorModel = {
  __typename?: 'ElevatorModel';
  id: Scalars['ID']['output'];
  /** Model of the elevator (eg: Gen2, MonoSpace...) */
  name: Scalars['String']['output'];
};

/** Elevator Module floor information */
export type ElevatorModuleFloorSetup = {
  __typename?: 'ElevatorModuleFloorSetup';
  /** The sort key for the floor */
  id: Scalars['Int']['output'];
  /** Return wheter or not the floor is accessible by an engineer */
  isAccessible: Scalars['Boolean']['output'];
  /** The label of the floor */
  label: Scalars['String']['output'];
};

/** The desired Elevator module floor information */
export type ElevatorModuleFloorSetupInput = {
  /** The sort key for the floor */
  id: Scalars['Int']['input'];
  /** Return wheter or not the floor is accessible by an engineer */
  isAccessible: Scalars['Boolean']['input'];
  /** The label of the floor */
  label: Scalars['String']['input'];
};

/** The elevator module thing setup */
export type ElevatorModuleSetup = {
  __typename?: 'ElevatorModuleSetup';
  /** The list of floors for this thing installation */
  floors: Array<ElevatorModuleFloorSetup>;
  /** The list of inputs for this thing installation */
  inputs?: Maybe<Array<InputSetup>>;
  /** Return whether or not the elevator module is installed downwards */
  isInverted: Scalars['Boolean']['output'];
};

/** The desired elevator module thing setup */
export type ElevatorModuleSetupInput = {
  /** The list of floors for this thing installation */
  floors: Array<ElevatorModuleFloorSetupInput>;
  /** The list of inputs for this thing installation */
  inputs?: InputMaybe<Array<InputSetupInput>>;
  /** Return whether or not the elevator module is installed downwards */
  isInverted: Scalars['Boolean']['input'];
};

/** Elevator Module Thing. Provides elevator trips, doors, and traffic data */
export type ElevatorModuleThing = Thing & {
  __typename?: 'ElevatorModuleThing';
  /** Building where this thing is installed */
  building: Building;
  /** List of devices this thing is installed on */
  devices: Array<Maybe<Device>>;
  /** The Thing uuid */
  id: Scalars['String']['output'];
  installationDate: Scalars['DateTime']['output'];
  /** The Thing Model */
  model: ThingModel;
  /** The URL were the thing can be monitored (online/offline,...) */
  monitoringUrl?: Maybe<Scalars['Boolean']['output']>;
  /** The Thing name, used by MQTT for example. (eg: TYXXXX) */
  name: Scalars['String']['output'];
  /** The elevator module's setup information */
  setup: ElevatorModuleSetup;
  type: ThingType;
};

/** The location of the motor room */
export enum ElevatorMotorRoomLocation {
  Above = 'ABOVE',
  Below = 'BELOW',
  Intermediate = 'INTERMEDIATE',
  Unknown = 'UNKNOWN'
}

/** The type of lighting in the shaft */
export enum ElevatorShaftLightingSpecsType {
  Led = 'LED',
  OldType = 'OLD_TYPE'
}

/** Contains all technical specifications of an elevator */
export type ElevatorSpecs = {
  __typename?: 'ElevatorSpecs';
  /** What kind of lighting is used in the lift cabin */
  cabinLightingType?: Maybe<ElevatorCabinLightingSpecsType>;
  /** What kind of friction is used to move the lift up and down */
  cabinMotionType?: Maybe<ElevatorCabinMotionSpecsType>;
  /** Indicates how many cables are used to draw the lift */
  cableNumber?: Maybe<Scalars['Float']['output']>;
  /**
   * Reference (ie the brand but it could also be the model number)
   * of the cables used to draw the lift
   */
  cableReference?: Maybe<Scalars['String']['output']>;
  /** Diameter of the cables used to draw the lift */
  cableThickness?: Maybe<Scalars['Float']['output']>;
  /** Weight capacity of the elevator */
  capacity?: Maybe<Scalars['Float']['output']>;
  /** What kind of doors opening does the car use */
  carDoorsOpeningType?: Maybe<ElevatorDoorsOpeningType>;
  /** Since when has the controller been running */
  controllerYear?: Maybe<Scalars['String']['output']>;
  /** Does the Elevator support the eco-mode */
  ecoMode?: Maybe<ElevatorEcoMode>;
  /** What kind of emergency services the lift is adapted for */
  emergencyServices?: Maybe<ElevatorEmergencyServices>;
  /**
   * Since every engines are in fact electrical machines,
   * this field indicates more precisly what is running underneath the engine
   */
  engineSubType?: Maybe<ElevatorEngineSpecsSubType>;
  /** Type of elevator engine (eg: hydraulic, electric...) */
  engineType?: Maybe<ElevatorSpecsEngineType>;
  /** Mechanism used to adjust the engine speed */
  frequencyVariator?: Maybe<ElevatorFrequencySpecsVariator>;
  /** Type of Gateway for the alarm system */
  gsmGateway?: Maybe<ElevatorSpecsGsmGateway>;
  /** Is the elevator part of a group (multiplex) */
  isPartOfGroup?: Maybe<YesNoType>;
  /** Is the lift a through car (2 entrances) */
  isThroughCar?: Maybe<YesNoType>;
  /** The location of the landing indicators */
  landingIndicatorsLocation?: Maybe<ElevatorLandingIndicatorsLocation>;
  /** When was the lift installed */
  liftInstallationYear?: Maybe<Scalars['String']['output']>;
  /** The model of the elevator, resolved from the soft modelId reference */
  model?: Maybe<ElevatorModel>;
  /** Soft reference to the device_model selected for this elevator */
  modelId?: Maybe<Scalars['ID']['output']>;
  /** The location of the motor room */
  motorRoomLocation?: Maybe<ElevatorMotorRoomLocation>;
  /** Since when has the motor been running */
  motorYear?: Maybe<Scalars['String']['output']>;
  /** Number of floors served by the elevator */
  noOfFloor?: Maybe<Scalars['Float']['output']>;
  /** Phone line of the alarm system */
  phoneLine?: Maybe<Scalars['String']['output']>;
  /** The PROM number of the alarm system */
  promNumber?: Maybe<Scalars['String']['output']>;
  /** the serial number of the device */
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** What kind of doors opening does the shaft use */
  shaftDoorsOpeningType?: Maybe<ElevatorDoorsOpeningType>;
  /** What kind of lighting is used in the lift shaft */
  shaftLightingType?: Maybe<ElevatorShaftLightingSpecsType>;
  /** speed of the device */
  speed?: Maybe<Scalars['Float']['output']>;
  /** What kind of traction (belt, cable, ect...) is used to pull the elevator up and down */
  tractionType?: Maybe<ElevatorSpecsTractionType>;
};

/** Type of elevator drive system (eg: hydraulic, electric...) */
export enum ElevatorSpecsEngineType {
  Electric = 'ELECTRIC',
  Hydraulic = 'HYDRAULIC',
  MrlHydraulic = 'MRL_HYDRAULIC',
  MrlTraction = 'MRL_TRACTION',
  Other = 'OTHER'
}

/** The type of GSM gateway used */
export enum ElevatorSpecsGsmGateway {
  Gen_2G = 'GEN_2G',
  Gen_3G = 'GEN_3G',
  Gen_4G = 'GEN_4G',
  Lan = 'LAN',
  NoGateway = 'NO_GATEWAY',
  Unknown = 'UNKNOWN'
}

/** The type of traction used for the elevator */
export enum ElevatorSpecsTractionType {
  Belts = 'BELTS',
  Chains = 'CHAINS',
  NotApplicable = 'NOT_APPLICABLE',
  Ropes = 'ROPES',
  RopesAndBelts = 'ROPES_AND_BELTS'
}

/** The measurement unit of the elevator speed */
export enum ElevatorSpeedMeasurementUnit {
  MeterPerSecond = 'METER_PER_SECOND'
}

/**
 * The status of the elevator for metrics
 *   WORKING: The elevator is working fin and have no issues opened
 *   HAS_ISSUES: The elevator is working but still have issues opened
 *   STOPPED: The elevator is stopped
 */
export enum ElevatorStatus {
  HasIssues = 'HAS_ISSUES',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Stopped = 'STOPPED',
  Working = 'WORKING'
}

export type ElevatorStatusCount = {
  __typename?: 'ElevatorStatusCount';
  /** The number of elevator in this status */
  count: Scalars['Float']['output'];
  /** The status of the elevators */
  status: ElevatorStatus;
};

/** Sub Type of elevator */
export enum ElevatorSubType {
  Elevator = 'ELEVATOR',
  FreightElevator = 'FREIGHT_ELEVATOR',
  PlatformLift = 'PLATFORM_LIFT'
}

/** Type of elevator (eg: platform lift, freight elevator, elevator) */
export enum ElevatorType {
  Elevator = 'ELEVATOR',
  FreightElevator = 'FREIGHT_ELEVATOR',
  PlatformLift = 'PLATFORM_LIFT'
}

/** Expected input to update an elevator */
export type ElevatorUpdateInput = {
  alarmSystemId?: InputMaybe<Scalars['Float']['input']>;
  brandId?: InputMaybe<Scalars['Float']['input']>;
  capacity?: InputMaybe<Scalars['Float']['input']>;
  engineType?: InputMaybe<ElevatorEngineType>;
  noOfFloor?: InputMaybe<Scalars['Float']['input']>;
  phoneLine?: InputMaybe<Scalars['String']['input']>;
  speed?: InputMaybe<Scalars['Float']['input']>;
  wingName?: InputMaybe<Scalars['String']['input']>;
};

export type ElevatorsAccessibleDeviceDeviceGraphqlConnection = {
  __typename?: 'ElevatorsAccessibleDeviceDeviceGraphqlConnection';
  edges: Array<ElevatorsAccessibleDeviceDeviceGraphqlEdge>;
  pageInfo: ElevatorsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ElevatorsAccessibleDeviceDeviceGraphqlEdge = {
  __typename?: 'ElevatorsAccessibleDeviceDeviceGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  /** Does the customer have access to this device */
  hasAccess: Scalars['Boolean']['output'];
  node: Device;
};

export type ElevatorsConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ElevatorsDeviceGraphqlConnection = {
  __typename?: 'ElevatorsDeviceGraphqlConnection';
  edges: Array<ElevatorsDeviceGraphqlEdge>;
  pageInfo: ElevatorsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ElevatorsDeviceGraphqlEdge = {
  __typename?: 'ElevatorsDeviceGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Device;
};

export type ElevatorsDeviceOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: DeviceOrmEntitySortableFields;
};

export type ElevatorsElevatorGraphqlConnection = {
  __typename?: 'ElevatorsElevatorGraphqlConnection';
  edges: Array<ElevatorsElevatorGraphqlEdge>;
  pageInfo: ElevatorsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type ElevatorsElevatorGraphqlEdge = {
  __typename?: 'ElevatorsElevatorGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Elevator;
};

/** Set of filters to apply to the elevators */
export type ElevatorsFilters = {
  /** Get only elevators belonging to the specified buildings */
  buildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Get only elevators belonging to specified customers */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only devices matching these identifiers */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only elevators matching these identifiers */
  elevatorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Get only elevators matching these GSM gateway types */
  gsmGateways?: InputMaybe<Array<ElevatorSpecsGsmGateway>>;
  /** Filter elevators based on their iot equipment */
  hasIot?: InputMaybe<Scalars['Boolean']['input']>;
  /** used to filter by wing name or elevator number */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Get only elevators with required status
   * @deprecated Use statuses instead
   */
  status?: InputMaybe<ElevatorStatus>;
  /** Get only elevators the required statuses */
  statuses?: InputMaybe<Array<ElevatorStatus>>;
  /** Get only elevators which are currently into service (or not) */
  stopped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only elevators located in a specific territory. Only takes ISO 2 country codes for now (eg: FR, GB, SG...) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only elevators that have an active contract or that do not */
  withActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only elevators which are working properly (or not) */
  working?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ElevatorsPageInfo = {
  __typename?: 'ElevatorsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type EndDeviceStatusMembers = {
  __typename?: 'EndDeviceStatusMembers';
  answer?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
};

export type EndDeviceStatusOrderByInput = {
  answer?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
};

export type EndDeviceStatusWhereInput = {
  AND?: InputMaybe<Array<EndDeviceStatusWhereInput>>;
  OR?: InputMaybe<Array<EndDeviceStatusWhereInput>>;
  answer?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
};

export type EnergyConsumptionMembers = {
  __typename?: 'EnergyConsumptionMembers';
  accountIds?: Maybe<Scalars['String']['output']>;
  avg?: Maybe<Scalars['Float']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  consumed_Wh?: Maybe<Scalars['Float']['output']>;
  consumed_kWh?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<TimeDimension>;
  day?: Maybe<Scalars['Float']['output']>;
  dayOfWeek?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceLocation?: Maybe<Scalars['String']['output']>;
  deviceNumber?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  hour?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type EnergyConsumptionOrderByInput = {
  accountIds?: InputMaybe<OrderBy>;
  avg?: InputMaybe<OrderBy>;
  buildingId?: InputMaybe<OrderBy>;
  consumed_Wh?: InputMaybe<OrderBy>;
  consumed_kWh?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  countryCode?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  deviceLocation?: InputMaybe<OrderBy>;
  deviceNumber?: InputMaybe<OrderBy>;
  deviceType?: InputMaybe<OrderBy>;
  hour?: InputMaybe<OrderBy>;
  month?: InputMaybe<OrderBy>;
  sum?: InputMaybe<OrderBy>;
  year?: InputMaybe<OrderBy>;
};

export type EnergyConsumptionWhereInput = {
  AND?: InputMaybe<Array<EnergyConsumptionWhereInput>>;
  OR?: InputMaybe<Array<EnergyConsumptionWhereInput>>;
  accountIds?: InputMaybe<StringFilter>;
  avg?: InputMaybe<FloatFilter>;
  buildingId?: InputMaybe<StringFilter>;
  consumed_Wh?: InputMaybe<FloatFilter>;
  consumed_kWh?: InputMaybe<FloatFilter>;
  count?: InputMaybe<FloatFilter>;
  countryCode?: InputMaybe<StringFilter>;
  customerId?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateTimeFilter>;
  day?: InputMaybe<FloatFilter>;
  dayOfWeek?: InputMaybe<FloatFilter>;
  deviceId?: InputMaybe<StringFilter>;
  deviceLocation?: InputMaybe<StringFilter>;
  deviceNumber?: InputMaybe<StringFilter>;
  deviceType?: InputMaybe<StringFilter>;
  hour?: InputMaybe<FloatFilter>;
  month?: InputMaybe<FloatFilter>;
  sum?: InputMaybe<FloatFilter>;
  year?: InputMaybe<FloatFilter>;
};

/** App team an enrolment request asks to join */
export enum EnrolMechanicTeam {
  RepairSupport = 'REPAIR_SUPPORT',
  TechSupport = 'TECH_SUPPORT'
}

/** A person outside @wemaintain.com who signed in to the internal Clerk app and asks for access to one app */
export type EnrolmentRequest = {
  __typename?: 'EnrolmentRequest';
  /** Company an App requester works for */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Country an App requester works in */
  countryCode?: Maybe<Scalars['String']['output']>;
  decidedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** User id of the admin who decided */
  decidedBy?: Maybe<Scalars['Int']['output']>;
  /** Verified email of the Clerk user */
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone of an App requester */
  phone?: Maybe<Scalars['String']['output']>;
  requestedAccess: EnrolmentRequestedAccess;
  requestedAt: Scalars['DateTimeISO']['output'];
  status: EnrolmentRequestStatus;
  /** App teams the requester joins */
  teams?: Maybe<Array<EnrolMechanicTeam>>;
};

/** Where an enrolment request stands: pending until an admin decides, then final */
export enum EnrolmentRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Access an enrolment request asks for: the Admin, or the App (mechanic) */
export enum EnrolmentRequestedAccess {
  Admin = 'ADMIN',
  Mechanic = 'MECHANIC'
}

export type EnsureAuditReportLineCommandInput = {
  /** The reference under which the report is known to the audit office which issued it */
  auditOfficeRef: Scalars['String']['input'];
  /** The content of the audit report line */
  content: Scalars['String']['input'];
  /** DefectType:The defect type of the line */
  defectType: DefectType;
  /** The device ID to ensure the audit report line for */
  deviceId: Scalars['String']['input'];
  /** The date the defect of that device was discovered at */
  discoveredAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** The emitted at timestamp */
  emittedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** The external ID to ensure the audit report line for */
  externalId: Scalars['String']['input'];
  /** The emitted at timestamp */
  receivedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** The remote path of the report */
  remoteReportPath?: InputMaybe<Scalars['String']['input']>;
  /** The date the device should be done before */
  toBeDoneBefore?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type Escalator = Device & {
  __typename?: 'Escalator';
  /**
   * The audit offices possess an internal id refering to this specific Device
   *       that was registered during the ingest of an Audit Report.
   */
  auditOfficeIdentities: Array<Maybe<AuditOfficeIdentity>>;
  /** Returns the expected configuration for the audit-report types for the Device */
  auditReportConfig: AuditReportConfigObject;
  /** The audit reports lines of the device */
  auditReportLines: AuditReportAuditReportLineConnection;
  /** Audit reports associated with this building */
  auditReports: Array<AuditReport>;
  /** Availability rate of the device */
  availabilityRate?: Maybe<AvailabilityRate>;
  /** Brand of the device */
  brand?: Maybe<ElevatorBrand>;
  /** Date at which the elevator stopped working, usually as reported by call centers. This is different from the "stoppedSince" field. */
  brokenSince?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Building of the elevator */
  building: Building;
  /** Contracts of this device */
  contracts: ContractsContractDeviceContractConnection;
  /**
   * Determine if defects of the device have been handled:
   * - ON_TIME: All applicable defects were fixed on time
   * - LATE: One defect was fixed after toBeDoneBefore or toBeDoneBefore is passed
   * - NON_APPLICABLE: No defects were applicable
   */
  defectHandlingStatus: DefectHandlingStatus;
  /** Device defects progress counts */
  defectsProgress: DefectsProgress;
  /** Public identifier of a device */
  deviceNumber?: Maybe<Scalars['String']['output']>;
  /** Retrieve the status of the device: WORKING, STOPPED or HAS_ISSUES (working but with issues) */
  deviceStatus: DeviceStatuses;
  /** This device's dilap window state at the given instant — defaults to now; NO_WINDOW when no dilap period is configured or the device has no active contract line */
  dilapStatus: DilapStatus;
  /** This device's dilap window — the dilapidation coverage period; null when no dilap period is configured or the device has no active contract line */
  dilapWindow?: Maybe<DilapWindow>;
  /** List of events for a given device (currently only implements IOT) */
  events: IotEventConnection;
  /** Return whether or not the device is equipped with IOT */
  hasIot: Scalars['Boolean']['output'];
  /** Verify if there exists at least one AuditReportLine with a quote to send in this report */
  hasLineWithQuoteStatusToSend: Scalars['Boolean']['output'];
  /** The icon for the device */
  icon: Icon;
  id: Scalars['ID']['output'];
  /** Live status of the device */
  liveStatus?: Maybe<LiveDeviceStatus>;
  /** form to display a mechanic to update this device */
  mechanicIdentifyForm: DeviceSpecsForm;
  /** Missions that have at least one task on this device */
  missions: MissionsMissionConnection;
  /** Details about the device location inside the building */
  name?: Maybe<Scalars['String']['output']>;
  /** onboarding form of an onboarding */
  onboardingForm?: Maybe<OnboardingDeviceForm>;
  /** Ops responsible of managing this device in this contract */
  opsReferent?: Maybe<Admin>;
  /** Indicates if the device is in a paused state */
  paused?: Maybe<Scalars['Boolean']['output']>;
  /** The Schedule of Rates in force for this device: its active contract's annex, or WeMaintain's standard list for its country and device type when the contract carries none; null = no price list either way */
  priceList?: Maybe<PriceList>;
  /** Retrieve the list of repair requests linked to this device */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  /** Technical specs relative to an escalator (ie: speed, motorRoom...) */
  specs: EscalatorSpecs;
  state?: Maybe<StateSnapshot>;
  /** Get the list of state for a device between a range of date */
  stateSnapshots: DeviceStateStateSnapshotConnection;
  /**
   * If the elevator is ONLINE or OFFLINE
   * @deprecated **DO NOT USE** Should use Device.deviceStatus instead.
   */
  status: DeviceStatuses;
  stoppedReason?: Maybe<Scalars['String']['output']>;
  /** Date at which the device was stopped, denoting that an engineer purposely put it offline for safety reason. This is usually a few hours after the device broke down. */
  stoppedSince?: Maybe<Scalars['DateTime']['output']>;
  /** Subtype of the escalator */
  subtype: EscalatorSubType;
  /** Tasks of this device */
  tasks: MissionsTaskConnection;
  /**
   * The WM serial number of the IoT-device currently attached to the device
   * @deprecated A device can now have mulitple things. Use the `things` field
   */
  thingName?: Maybe<Scalars['String']['output']>;
  /** The things attached to this device */
  things: Array<Maybe<Thing>>;
  /** Media associated with the device from visits */
  visitMedia: VisitsAnswerPhotoConnection;
};


export type EscalatorAuditReportLinesArgs = {
  filters?: InputMaybe<AuditReportLineDeviceFilters>;
  order?: InputMaybe<Array<AuditReportAuditReportLineOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};


export type EscalatorAvailabilityRateArgs = {
  filters: AvailabilityRateFilters;
};


export type EscalatorContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ContractDeviceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EscalatorDilapStatusArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type EscalatorEventsArgs = {
  pagination?: InputMaybe<IotConnectionArgs>;
};


export type EscalatorIconArgs = {
  size: AvailableIconSizes;
};


export type EscalatorMechanicIdentifyFormArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type EscalatorMissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EscalatorPausedArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type EscalatorRepairRequestsArgs = {
  filters?: InputMaybe<RepairRequestForDeviceInputFilters>;
  order?: InputMaybe<Array<WorkOrdersRepairRequestOrmEntityOrderOptions>>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type EscalatorStateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type EscalatorStateSnapshotsArgs = {
  filters?: InputMaybe<StateSnapshotInput>;
  pagination?: InputMaybe<DeviceStateConnectionArgs>;
};


export type EscalatorStoppedReasonArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type EscalatorTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deviceTaskFilters?: InputMaybe<DeviceTaskFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MissionsTaskOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


export type EscalatorVisitMediaArgs = {
  filters?: InputMaybe<FindManyDevicePhotosInput>;
  order?: InputMaybe<Array<VisitsAnswerPhotoOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

/** Escalator Thing Module FaultMode setup */
export type EscalatorModuleFaultMode = {
  __typename?: 'EscalatorModuleFaultMode';
  defaultState: DefaultPinState;
  pinNumber: PinNumber;
};

/** Desired FautMode setup for the Escalator Module */
export type EscalatorModuleFaultModeInput = {
  defaultState: DefaultPinState;
  pinNumber: PinNumber;
};

/** Setup for the Escalator Module */
export type EscalatorModuleSetup = {
  __typename?: 'EscalatorModuleSetup';
  /** The fault mode setup for the escalator module. Will be deprecated soon. */
  faultMode: EscalatorModuleFaultMode;
  /** The list of inputs for this thing installation */
  inputs?: Maybe<Array<InputSetup>>;
};

/** Desired setup for the Escalator Module */
export type EscalatorModuleSetupInput = {
  /** The fault mode setup for the escalator module. Will be deprecated soon. */
  faultMode: EscalatorModuleFaultModeInput;
  /** The list of inputs for this thing installation */
  inputs?: InputMaybe<Array<InputSetupInput>>;
};

/** Escalator Module Thing. Provide fault mode, direction, speed,... data for escalator */
export type EscalatorModuleThing = Thing & {
  __typename?: 'EscalatorModuleThing';
  /** Building where this thing is installed */
  building: Building;
  /** List of devices this thing is installed on */
  devices: Array<Maybe<Device>>;
  /** The Thing uuid */
  id: Scalars['String']['output'];
  installationDate: Scalars['DateTime']['output'];
  /** The Thing Model */
  model: ThingModel;
  /** The URL were the thing can be monitored (online/offline,...) */
  monitoringUrl?: Maybe<Scalars['Boolean']['output']>;
  /** The Thing name, used by MQTT for example. (eg: TYXXXX) */
  name: Scalars['String']['output'];
  setup: EscalatorModuleSetup;
  type: ThingType;
};

/** Contains all technical specifications of an escalator */
export type EscalatorSpecs = {
  __typename?: 'EscalatorSpecs';
  /** Description for identifying the escalator (eg: duplex gauche) */
  description?: Maybe<Scalars['String']['output']>;
  /** Total length of the handrail (in meters) */
  handrailLength?: Maybe<Scalars['Float']['output']>;
  /** Type of the handrail */
  handrailType?: Maybe<HandRailType>;
  /** How much is the inclination of the escalator (in degrees) */
  inclination?: Maybe<Scalars['Float']['output']>;
  /** The year of installation */
  installationYear?: Maybe<Scalars['String']['output']>;
  /** Model of the device (specificy the model of the brand) */
  model?: Maybe<Scalars['String']['output']>;
  /** If the escalator has a motor room or not */
  motorRoom?: Maybe<Scalars['Boolean']['output']>;
  /** Number of steps the escalator has */
  noSteps?: Maybe<Scalars['Float']['output']>;
  /** the serial number of the device */
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** serialNo */
  speed?: Maybe<Scalars['Float']['output']>;
  /** Defines the vertical meter difference between upper and lower landing */
  verticalRise?: Maybe<Scalars['Float']['output']>;
  /** Width of the steps, useful for spare parts */
  widthSteps?: Maybe<Scalars['Int']['output']>;
};

/** Sub Type of escalator */
export enum EscalatorSubType {
  Escalator = 'ESCALATOR',
  MovingWalk = 'MOVING_WALK'
}

/** The evaluation status of the downtime */
export enum EvaluationStatus {
  Evaluated = 'EVALUATED',
  Evaluating = 'EVALUATING'
}

export type Event = {
  __typename?: 'Event';
  date: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  type: EventType;
};

/** The provider of a given Event (this is the author of said event) */
export enum EventProvider {
  Defect = 'DEFECT',
  Elevator = 'ELEVATOR',
  Integration = 'INTEGRATION',
  Iot = 'IOT',
  Mission = 'MISSION',
  State = 'STATE',
  Ticket = 'TICKET',
  Visit = 'VISIT'
}

/** Type of device event */
export enum EventType {
  Doors = 'DOORS',
  Message = 'MESSAGE',
  Trips = 'TRIPS'
}

export type ExternalPartRequestItem = RequestItem & {
  __typename?: 'ExternalPartRequestItem';
  /** If this requested item needs to be invoiced to the customer */
  chargeable?: Maybe<Scalars['Boolean']['output']>;
  /** Short text describing the external part */
  description: Scalars['String']['output'];
  /** Date when the request item should be delivered from our supplier */
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The human identifier for a request (at the moment it is the id within airtable)
   * @deprecated Airtable is not used anymore. This field is deprecated and will be removed in the future.
   */
  humanId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** If the item is withdrawable by the engineer */
  isWithdrawable: Scalars['Boolean']['output'];
  /**
   * Comment of the ops about the requested item
   * @deprecated Comments are not found on individual parts anymore but on the request as a whole. Use RepairRequest.enginerComment or RepairRequest.internalComment
   */
  opsComment?: Maybe<Scalars['String']['output']>;
  /** Order progression data synced from Netsuite for this request item */
  orderProgression?: Maybe<RequestItemOrderProgression>;
  /** The catalog part requested */
  part?: Maybe<Part>;
  partId?: Maybe<Scalars['ID']['output']>;
  /** Display the external part requested item photos */
  photos: Array<Scalars['String']['output']>;
  /** Cost of the item (what we pay). This represents the company's cost for the item. Use sellPrice for the margin/sell price. Can be null if not set yet. */
  price?: Maybe<Scalars['Float']['output']>;
  /** Number of external parts requested */
  quantity: Scalars['Int']['output'];
  /** The quote line this item backs — a partition: an item belongs to at most one line (PRENG-7500) */
  quoteLine?: Maybe<QuoteLine>;
  repairRequestId: Scalars['ID']['output'];
  /**
   * Sell price of the item (separate from cost). Used for items that need to track separate cost and margin, such as Installation items. Can be null if not set.
   * @deprecated What the customer pays lives on QuoteLine.sellPrice (PRENG-7500); this is never written anymore
   */
  sellPrice?: Maybe<Scalars['Float']['output']>;
  /** RFQ send history for this non-catalog part */
  sourcingInfo?: Maybe<SourcingInfo>;
  /** Represent the state of the request item (should be used in place of status). Based on the type of the itemand its current data it return a state representing the next action to be done on a business point of view. */
  state?: Maybe<RequestItemState>;
  /**
   * Represent the status of the item in the repair flow
   * @deprecated Status is representing the status of the item in our legacy flow. Please use state instead, that represent
   */
  status: RepairRequestStatus;
  /** Url from the supplier of the external part */
  supplierLink: Scalars['String']['output'];
  /** Optional URL towards a quote from one of our supplier for this part that we've used for pricing */
  supplierQuoteLink?: Maybe<Scalars['String']['output']>;
  /** Information about the withdrawal of the item by the engineer */
  withdrawal?: Maybe<Withdrawal>;
};

/** Payload to add an external part item (outside of the catalog Wemaintain) to a repair request */
export type ExternalPartRequestItemInput = {
  /** Short text describing the external part item */
  description: Scalars['String']['input'];
  /** Photos/screenshots of the external part item */
  photos?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Number of part requested */
  quantity: Scalars['Float']['input'];
  /** Url from the supplier of the external part item */
  supplierLink: Scalars['String']['input'];
};

/**  FaultMode setup for iot thing */
export type FaultMode = {
  __typename?: 'FaultMode';
  defaultState: DefaultPinState;
  pinNumber: PinNumber;
};

/** Desired FaultMode setup for iot thing */
export type FaultModeInput = {
  defaultState: DefaultPinState;
  pinNumber: PinNumber;
};

export type Feed = {
  __typename?: 'Feed';
  activities: FeedActivityGqlConnection;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type FeedActivitiesArgs = {
  filters?: InputMaybe<FindActivitiesOfFeedInput>;
  order?: InputMaybe<Array<FeedActivityOrmEntityOrderOptions>>;
  pagination?: InputMaybe<FeedConnectionArgs>;
};

export type FeedActivityGqlConnection = {
  __typename?: 'FeedActivityGQLConnection';
  edges: Array<FeedActivityGqlEdge>;
  pageInfo: FeedPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type FeedActivityGqlEdge = {
  __typename?: 'FeedActivityGQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Activity;
};

export type FeedActivityOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: ActivityOrmEntitySortableFields;
};

export type FeedComment = Activity & {
  __typename?: 'FeedComment';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type FeedCommentDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type FeedCommentTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FeedConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FeedFeedGqlConnection = {
  __typename?: 'FeedFeedGQLConnection';
  edges: Array<FeedFeedGqlEdge>;
  pageInfo: FeedPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type FeedFeedGqlEdge = {
  __typename?: 'FeedFeedGQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Feed;
};

export type FeedPageInfo = {
  __typename?: 'FeedPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Payload to fetch a repair request with a forced refresh on the item progression */
export type FetchRepairRequestInput = {
  /** The id of the repair request to fetch */
  repairRequestId: Scalars['ID']['input'];
};

export type FilterSuggestions = {
  __typename?: 'FilterSuggestions';
  suggestions?: Maybe<Array<Scalars['String']['output']>>;
};

export type FilterSuggestionsQueryInput = {
  dashboardType: Scalars['String']['input'];
  /** DashboardFilter: Represents a dashboard filter */
  filters?: InputMaybe<Array<DashboardFilter>>;
  id: Scalars['String']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};

export type FindActivitiesOfFeedInput = {
  /** Date range to updated at */
  updatedAt?: InputMaybe<FindActivitiesOfFeedInput_UpdatedAt>;
};

export type FindActivitiesOfFeedInput_UpdatedAt = {
  after?: InputMaybe<Scalars['DateTimeISO']['input']>;
  before?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FindDowntimesQueryInput = {
  buildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** DeviceTypeEnum:The available device types */
  deviceTypes?: InputMaybe<Array<DeviceTypeEnum>>;
  /** Date range to filter by end date */
  end?: InputMaybe<FindDowntimesQueryInput_Start>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter downtime still ongoing (meaning no end date) or not (with end date) */
  isOngoing?: InputMaybe<Scalars['Boolean']['input']>;
  /** DowntimeSourceType:Type of source reporting this downtime */
  sourceTypes?: InputMaybe<Array<DowntimeSourceType>>;
  /** Date range to filter by start date */
  start?: InputMaybe<FindDowntimesQueryInput_Start>;
};

export type FindDowntimesQueryInput_Start = {
  after?: InputMaybe<Scalars['DateTimeISO']['input']>;
  before?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

/** Input to find many media attached to an answer */
export type FindManyAnswerMediaInput = {
  mediaKind: Array<MediaKind>;
  /** Get only media whose answer was given for questions described by these human keys */
  questionHumanKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input to filter media associated with a device */
export type FindManyDevicePhotosInput = {
  /** Get only media of these kinds (photo, video) */
  mediaKind?: InputMaybe<Array<MediaKind>>;
  /** Get only media whose answer was given for questions described by these human keys */
  questionHumanKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindManyOvertimePaginatedQueryInput = {
  /** OvertimeApproval */
  approvals?: InputMaybe<Array<OvertimeApproval>>;
  buildingIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  declareDate?: InputMaybe<FindManyOvertimePaginatedQueryInput_DeclareDate>;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mechanicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  missionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  month?: InputMaybe<Scalars['DateTimeISO']['input']>;
  noPreApprovalReason?: InputMaybe<Array<Scalars['String']['input']>>;
  overtimeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preApproverIds?: InputMaybe<Array<Scalars['String']['input']>>;
  referentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindManyOvertimePaginatedQueryInput_DeclareDate = {
  after?: InputMaybe<Scalars['DateTimeISO']['input']>;
  before?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FindManyPaginatedActivityQueryInput = {
  feeds: Array<InputMaybe<Scalars['String']['input']>>;
  /** Date range to updated at */
  updatedAt?: InputMaybe<FindActivitiesOfFeedInput_UpdatedAt>;
};

export type FindManyPaginatedFeedsQueryInput = {
  /** Restrict the page to these feed names */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FindManyPaginatedPriceListsInput = {
  /** Lists this contract is or was priced on, via the historical junction */
  contractId?: InputMaybe<Scalars['String']['input']>;
  /** true = only versions in force right now; false = only versions not in force */
  inForce?: InputMaybe<Scalars['Boolean']['input']>;
  /** All versions of this stable reference — "INLI_BPU_LOT4" */
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type FindNotificationsQueryInput = {
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  buildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NotificationSourceType:The source of the notification. It can be a StrongSignal or a Downtime */
  sourceTypes?: Array<NotificationSourceType>;
};

export type FindOneFeedQueryInput = {
  name: Scalars['String']['input'];
};

export type FindOneOvertimeInput = {
  overtimeId: Scalars['String']['input'];
};

export type FindOnePriceListInput = {
  priceListId: Scalars['String']['input'];
};

export type FindOneProblemQueryInput = {
  problemId: Scalars['String']['input'];
};

export type FindProblemsQueryInput = {
  cancelledAt?: InputMaybe<Scalars['Boolean']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dilap?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  stateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FireAlarm = Device & {
  __typename?: 'FireAlarm';
  /**
   * The audit offices possess an internal id refering to this specific Device
   *       that was registered during the ingest of an Audit Report.
   */
  auditOfficeIdentities: Array<Maybe<AuditOfficeIdentity>>;
  /** Returns the expected configuration for the audit-report types for the Device */
  auditReportConfig: AuditReportConfigObject;
  /** The audit reports lines of the device */
  auditReportLines: AuditReportAuditReportLineConnection;
  /** Audit reports associated with this building */
  auditReports: Array<AuditReport>;
  /** Availability rate of the device */
  availabilityRate?: Maybe<AvailabilityRate>;
  /** Brand of the device */
  brand?: Maybe<ElevatorBrand>;
  /** Date at which the elevator stopped working, usually as reported by call centers. This is different from the "stoppedSince" field. */
  brokenSince?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Building of the elevator */
  building: Building;
  /** Contracts of this device */
  contracts: ContractsContractDeviceContractConnection;
  /**
   * Determine if defects of the device have been handled:
   * - ON_TIME: All applicable defects were fixed on time
   * - LATE: One defect was fixed after toBeDoneBefore or toBeDoneBefore is passed
   * - NON_APPLICABLE: No defects were applicable
   */
  defectHandlingStatus: DefectHandlingStatus;
  /** Device defects progress counts */
  defectsProgress: DefectsProgress;
  /** Public identifier of a device */
  deviceNumber?: Maybe<Scalars['String']['output']>;
  /** Retrieve the status of the device: WORKING, STOPPED or HAS_ISSUES (working but with issues) */
  deviceStatus: DeviceStatuses;
  /** This device's dilap window state at the given instant — defaults to now; NO_WINDOW when no dilap period is configured or the device has no active contract line */
  dilapStatus: DilapStatus;
  /** This device's dilap window — the dilapidation coverage period; null when no dilap period is configured or the device has no active contract line */
  dilapWindow?: Maybe<DilapWindow>;
  /** List of events for a given device (currently only implements IOT) */
  events: IotEventConnection;
  /** Return whether or not the device is equipped with IOT */
  hasIot: Scalars['Boolean']['output'];
  /** Verify if there exists at least one AuditReportLine with a quote to send in this report */
  hasLineWithQuoteStatusToSend: Scalars['Boolean']['output'];
  /** The icon for the device */
  icon: Icon;
  id: Scalars['ID']['output'];
  /** Live status of the device */
  liveStatus?: Maybe<LiveDeviceStatus>;
  /** form to display a mechanic to update this device */
  mechanicIdentifyForm: DeviceSpecsForm;
  /** Missions that have at least one task on this device */
  missions: MissionsMissionConnection;
  /** Details about the device location inside the building */
  name?: Maybe<Scalars['String']['output']>;
  /** onboarding form of an onboarding */
  onboardingForm?: Maybe<OnboardingDeviceForm>;
  /** Ops responsible of managing this device in this contract */
  opsReferent?: Maybe<Admin>;
  /** Indicates if the device is in a paused state */
  paused?: Maybe<Scalars['Boolean']['output']>;
  /** The Schedule of Rates in force for this device: its active contract's annex, or WeMaintain's standard list for its country and device type when the contract carries none; null = no price list either way */
  priceList?: Maybe<PriceList>;
  /** Retrieve the list of repair requests linked to this device */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  /** Technical specs relative to a fire alarm (ie: cmsi, fireDoor...) */
  specs: FireAlarmSpecs;
  state?: Maybe<StateSnapshot>;
  /** Get the list of state for a device between a range of date */
  stateSnapshots: DeviceStateStateSnapshotConnection;
  /**
   * If the elevator is ONLINE or OFFLINE
   * @deprecated **DO NOT USE** Should use Device.deviceStatus instead.
   */
  status: DeviceStatuses;
  stoppedReason?: Maybe<Scalars['String']['output']>;
  /** Date at which the device was stopped, denoting that an engineer purposely put it offline for safety reason. This is usually a few hours after the device broke down. */
  stoppedSince?: Maybe<Scalars['DateTime']['output']>;
  /** Subtype of the fire alarm */
  subtype: FireAlarmSubType;
  /** Tasks of this device */
  tasks: MissionsTaskConnection;
  /**
   * The WM serial number of the IoT-device currently attached to the device
   * @deprecated A device can now have mulitple things. Use the `things` field
   */
  thingName?: Maybe<Scalars['String']['output']>;
  /** The things attached to this device */
  things: Array<Maybe<Thing>>;
  /** Media associated with the device from visits */
  visitMedia: VisitsAnswerPhotoConnection;
};


export type FireAlarmAuditReportLinesArgs = {
  filters?: InputMaybe<AuditReportLineDeviceFilters>;
  order?: InputMaybe<Array<AuditReportAuditReportLineOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};


export type FireAlarmAvailabilityRateArgs = {
  filters: AvailabilityRateFilters;
};


export type FireAlarmContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ContractDeviceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FireAlarmDilapStatusArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type FireAlarmEventsArgs = {
  pagination?: InputMaybe<IotConnectionArgs>;
};


export type FireAlarmIconArgs = {
  size: AvailableIconSizes;
};


export type FireAlarmMechanicIdentifyFormArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type FireAlarmMissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FireAlarmPausedArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type FireAlarmRepairRequestsArgs = {
  filters?: InputMaybe<RepairRequestForDeviceInputFilters>;
  order?: InputMaybe<Array<WorkOrdersRepairRequestOrmEntityOrderOptions>>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type FireAlarmStateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type FireAlarmStateSnapshotsArgs = {
  filters?: InputMaybe<StateSnapshotInput>;
  pagination?: InputMaybe<DeviceStateConnectionArgs>;
};


export type FireAlarmStoppedReasonArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type FireAlarmTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deviceTaskFilters?: InputMaybe<DeviceTaskFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MissionsTaskOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


export type FireAlarmVisitMediaArgs = {
  filters?: InputMaybe<FindManyDevicePhotosInput>;
  order?: InputMaybe<Array<VisitsAnswerPhotoOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

/** Type of fire alarm */
export enum FireAlarmClassification {
  Aov = 'AOV',
  Ieag = 'IEAG',
  L1 = 'L1',
  L2 = 'L2',
  M = 'M',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4',
  P5 = 'P5',
  SmokeExtractionCentral = 'SMOKE_EXTRACTION_CENTRAL',
  Type_1 = 'TYPE_1',
  Type_2A = 'TYPE_2A',
  Type_2B = 'TYPE_2B',
  Type_3 = 'TYPE_3',
  Type_4 = 'TYPE_4'
}

/** Contains all technical specifications of a fire alarm */
export type FireAlarmSpecs = {
  __typename?: 'FireAlarmSpecs';
  /** Number of air opening vents */
  airOpeningVents?: Maybe<Scalars['Int']['output']>;
  /** Number of alarm zones */
  alarmZones?: Maybe<Scalars['Int']['output']>;
  /** Number of AOV panels */
  aovPanels?: Maybe<Scalars['Int']['output']>;
  /** Number of aspirating smoke detectors */
  aspiratingSmokeDetectors?: Maybe<Scalars['Int']['output']>;
  /** Number of automatic opening vents */
  automaticOpeningVents?: Maybe<Scalars['Int']['output']>;
  /** Number of battery packups */
  batteryBackups?: Maybe<Scalars['Int']['output']>;
  /** Number of beam smoke detectors */
  beamSmokeDetectors?: Maybe<Scalars['Int']['output']>;
  /** Know the type of building (hotel,, offices...) to know which regulation applies */
  buildingType?: Maybe<Scalars['String']['output']>;
  /** Number of other function */
  cmsiFunctions?: Maybe<Scalars['Int']['output']>;
  /** Model of the main control panel */
  controlPanelModel?: Maybe<Scalars['String']['output']>;
  /** Numer of detection zones */
  detectionZones?: Maybe<Scalars['Int']['output']>;
  /** Number of release magnets */
  doorReleaseMagnets?: Maybe<Scalars['Int']['output']>;
  /** Type of fire alarm */
  fireAlarmClassification?: Maybe<FireAlarmClassification>;
  /** Number of control panels */
  fireAlarmControlPanels?: Maybe<Scalars['Int']['output']>;
  /** Number of fire / smoke dampers */
  fireDampers?: Maybe<Scalars['Int']['output']>;
  /** Number of fire doors */
  fireDoors?: Maybe<Scalars['Int']['output']>;
  /** Number of fire safety control panels */
  fireSafetyControlPanels?: Maybe<Scalars['Int']['output']>;
  /** Number of green MCPs */
  greenMCPs?: Maybe<Scalars['Int']['output']>;
  /** Number of heat detectors */
  heatDetectors?: Maybe<Scalars['Int']['output']>;
  /** Number of I/O modules */
  ioModules?: Maybe<Scalars['Int']['output']>;
  /** Number of linear heat detectors */
  linearHeatDetectors?: Maybe<Scalars['Int']['output']>;
  /** Numberof manual call points */
  manualCallPoints?: Maybe<Scalars['Int']['output']>;
  /** Number of mnnual closing winches */
  manualClosingWinches?: Maybe<Scalars['Int']['output']>;
  /** Number of optical smoke detectors */
  opticalSmokeDetectors?: Maybe<Scalars['Int']['output']>;
  /** Number of pipe detectors */
  pipeDetectors?: Maybe<Scalars['Int']['output']>;
  /** Number of pneumatic AOV panels */
  pneumaticAOVPanels?: Maybe<Scalars['Int']['output']>;
  /** Number of pneumatic AOV systems */
  pneumaticAOVSystems?: Maybe<Scalars['Int']['output']>;
  /** Number of public annoucement voice alarms */
  publicAannouncementVoiceAlarms?: Maybe<Scalars['Int']['output']>;
  /** Number of remote indicators */
  remoteIndicators?: Maybe<Scalars['Int']['output']>;
  /** Number of repeater panels */
  repeaterPanels?: Maybe<Scalars['Int']['output']>;
  /** the serial number of the device */
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** Number of smoke extract fans */
  smokeExtractionMotors?: Maybe<Scalars['Int']['output']>;
  /** Number of sounders and beacons */
  soundersAndBeacons?: Maybe<Scalars['Int']['output']>;
  /** Number of special detectors */
  specialDetectors?: Maybe<Scalars['Int']['output']>;
  /** Brand of the main control panel */
  systemBrand?: Maybe<SystemBrand>;
  /** Number of third party security systems */
  thirdPartySecuritySystems?: Maybe<Scalars['Int']['output']>;
  /** Number of volt-free relays */
  voltFreeRelays?: Maybe<Scalars['Int']['output']>;
  /** Number of wireless MCPs */
  wirelessMcps?: Maybe<Scalars['Int']['output']>;
  /** Number of wireless optical smoke detectors */
  wirelessOpticalSmokeDetectors?: Maybe<Scalars['Int']['output']>;
  /** Number of wireless remote indicators */
  wirelessRemoteIndicators?: Maybe<Scalars['Int']['output']>;
  /** Number of wireless transponders */
  wirelessTransponders?: Maybe<Scalars['Int']['output']>;
};

/** Sub Type of fire alarm */
export enum FireAlarmSubType {
  FireAlarm = 'FIRE_ALARM',
  FireSafety = 'FIRE_SAFETY'
}

/** The parser's name for message processing */
export enum FireSafetyCloudParser {
  None = 'NONE'
}

/** Fire and safety controller iot setup */
export type FireSafetyControllerModuleSetup = {
  __typename?: 'FireSafetyControllerModuleSetup';
  /**
   * Describe the analog setup of the fire and safety device. JSON Payload.
   * 'The analog setup map the state of the analog inputs to a message that the iot can emit over the rs232 mqtt topic
   */
  analogSetup: Scalars['String']['output'];
  /** The parser to use for parsing the message from the controller */
  parser?: Maybe<FireSafetyCloudParser>;
  /**
   * Describe the RS232 Configuration of the fire and safety device. JSON Payload
   * Configuration of the RS232 bus to correctly receive the messages
   */
  rs232Configuration: Scalars['String']['output'];
  /** Setup the RS232 parser to convert raw rs232 messages into message payload. JSON Payload */
  rs232Parser: Scalars['String']['output'];
};

/** Input for the Fire and safety controller iot setup */
export type FireSafetyControllerModuleSetupInput = {
  /**
   * Describe the analog setup of the fire and safety device. JSON Payload.
   * 'The analog setup map the state of the analog inputs to a message that the iot can emit over the rs232 mqtt topic
   */
  analogSetup: Scalars['String']['input'];
  /** The parser to use for parsing the message from the controller */
  parser?: InputMaybe<FireSafetyCloudParser>;
  /**
   * Describe the RS232 Configuration of the fire and safety device. JSON Payload
   * Configuration of the RS232 bus to correctly receive the messages
   */
  rs232Configuration: Scalars['String']['input'];
  /** Setup the RS232 parser to convert raw rs232 messages into message payload. JSON Payload */
  rs232Parser: Scalars['String']['input'];
};

/** Fire and safety controller Module Thing. Provide parser and other information for the fire and safety controller */
export type FireSafetyControllerModuleThing = Thing & {
  __typename?: 'FireSafetyControllerModuleThing';
  /** Building where this thing is installed */
  building: Building;
  /** List of devices this thing is installed on */
  devices: Array<Maybe<Device>>;
  /** The Thing uuid */
  id: Scalars['String']['output'];
  installationDate: Scalars['DateTime']['output'];
  /** The Thing Model */
  model: ThingModel;
  /** The URL were the thing can be monitored (online/offline,...) */
  monitoringUrl?: Maybe<Scalars['Boolean']['output']>;
  /** The Thing name, used by MQTT for example. (eg: TYXXXX) */
  name: Scalars['String']['output'];
  setup: FireSafetyControllerModuleSetup;
  type: ThingType;
};

/** An admin (CSM) recorded that the audit report line was fixed. The work itself was done by the fixedByMechanic. */
export type FixRecord = {
  __typename?: 'FixRecord';
  /** The admin who recorded the fix */
  admin: Admin;
  note?: Maybe<Scalars['String']['output']>;
  /** The task the fix was done in, which gave the fixedByMechanic and the fixedAt */
  task?: Maybe<Task>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  notEquals?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The plan of a floor */
export type FloorPlan = {
  __typename?: 'FloorPlan';
  id: Scalars['Int']['output'];
  level: Scalars['String']['output'];
  planUrl: Scalars['String']['output'];
};

/** The additional answer for this choice */
export type FollowUp = {
  __typename?: 'FollowUp';
  /** Value of the follow up */
  value?: Maybe<Scalars['String']['output']>;
};

/** The additional answer for this choice */
export type FollowUpInput = {
  /** Value of the follow up */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A group contains a set of inputs */
export type FormGroup = FormThing & {
  __typename?: 'FormGroup';
  /** The inputs that belong inside this group */
  inputs: Array<FormInput>;
  title: Scalars['String']['output'];
};

/** Represents a single input in a form */
export type FormInput = {
  /** If set, means that changing this field would update 1<->1 to the corresponding key in the entity */
  entityKey?: Maybe<Scalars['String']['output']>;
  /** The identifier of this input, to be sent back to the backend */
  key?: Maybe<Scalars['String']['output']>;
  /** configuration for the display/validation of this input */
  settings: IInputSettings;
  title: Scalars['String']['output'];
  /** Current value associated to the input */
  value?: Maybe<Scalars['ValueOfInput']['output']>;
};

/** Represents a static value that should be returned when submiting the form */
export type FormTarget = {
  __typename?: 'FormTarget';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Represents a type of form */
export type FormThing = {
  title: Scalars['String']['output'];
};

/** Thing with unknown setup data */
export type GenericThing = Thing & {
  __typename?: 'GenericThing';
  /** Building where this thing is installed */
  building: Building;
  /** List of devices this thing is installed on */
  devices: Array<Maybe<Device>>;
  /** The Thing uuid */
  id: Scalars['String']['output'];
  installationDate: Scalars['DateTime']['output'];
  /** The Thing Model */
  model: ThingModel;
  /** The URL were the thing can be monitored (online/offline,...) */
  monitoringUrl?: Maybe<Scalars['Boolean']['output']>;
  /** The Thing name, used by MQTT for example. (eg: TYXXXX) */
  name: Scalars['String']['output'];
  type: ThingType;
};

export type GeographicPosition = {
  /** The latitude of the position */
  lat: Scalars['Float']['input'];
  /** The longitude of the position */
  lon: Scalars['Float']['input'];
};

export type GetDashboardQueryInput = {
  type: Scalars['String']['input'];
};

/** A dynamic GraphQL form */
export type GraphQlForm = {
  /** The inputs that belong inside this form */
  inputs: Array<FormThing>;
  targets: Array<FormTarget>;
};

/** Contains all technical specifications of HVAC */
export type HvacSpecs = {
  __typename?: 'HVACSpecs';
  /** The criticality the system must ensure in emergency ventilation in case of fire and in case of loss of primary ventilation functions */
  criticality?: Maybe<Criticality>;
  /** The number of indoor units included in the stystem */
  numberOfIndoorUnits?: Maybe<Scalars['Int']['output']>;
  /** The type of refrigerant which is a chemical that produces a cooling effect while expanding or vaporizing. */
  refrigerant?: Maybe<Scalars['String']['output']>;
  /** the serial number of the device */
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/** Sub Type of a HVAC */
export enum HvacSubType {
  Hvac = 'HVAC'
}

export type HandOverRepairRequestActionInput = {
  /** The open action to hand over, handed over already or not */
  actionId: Scalars['String']['input'];
  /** Why, required. Trimmed, at most 500 characters. */
  note: Scalars['String']['input'];
  /** The work order the action is on */
  repairRequestId: Scalars['String']['input'];
  /** Who acts on it from now, @-mentioned on the work order feed. Not the giver it was handed over by (take it back instead), nor whoever acts on it already. */
  toUserId: Scalars['String']['input'];
};

/** Type of the handrail (eg: Otis Slim, Kone Standard...) */
export enum HandRailType {
  KoneSlim = 'KONE_SLIM',
  KoneSlimVType = 'KONE_SLIM_V_TYPE',
  KoneStandard = 'KONE_STANDARD',
  KoneStandardVType = 'KONE_STANDARD_V_TYPE',
  OtisSlim = 'OTIS_SLIM',
  OtisSlimVType = 'OTIS_SLIM_V_TYPE',
  OtisStandard = 'OTIS_STANDARD',
  OtisStandardVType = 'OTIS_STANDARD_V_TYPE',
  SchindlerEco = 'SCHINDLER_ECO',
  SchindlerSlim = 'SCHINDLER_SLIM',
  SchindlerSlimVType = 'SCHINDLER_SLIM_V_TYPE',
  SchindlerStandard = 'SCHINDLER_STANDARD',
  ThyssenSlim = 'THYSSEN_SLIM',
  ThyssenSlimVType = 'THYSSEN_SLIM_V_TYPE',
  ThyssenStandard = 'THYSSEN_STANDARD',
  ThyssenStandardVType = 'THYSSEN_STANDARD_V_TYPE'
}

/** A toggleable signal. */
export type HandrailsSpeedAnomaly = StrongSignal & {
  __typename?: 'HandrailsSpeedAnomaly';
  /** An acknowledgement if the signal was acknowledged. */
  acknowledgement?: Maybe<Acknowledgement>;
  /** The date and time when the signal was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time when the signal was last updated. This attribute has to be sent when acknowledging a signal. */
  date: Scalars['DateTime']['output'];
  /** Details about this signal */
  details: Array<StrongSignalDetail>;
  /** The device associated with the signal */
  device?: Maybe<Device>;
  /** A dismissal if the signal was dismissed. */
  dismissal?: Maybe<Dismissal>;
  /** Technical description of the signal meant for the engineer */
  engineerDescription: Scalars['String']['output'];
  /** The state of the strong signal. */
  engineerSorting: StrongSignalStateEnum;
  /** Human understandable explanation detailing this signal, trying to make it legible even by non technical users */
  explanation: Scalars['String']['output'];
  /** The handrail 1 value. */
  handrail1: Scalars['Float']['output'];
  /** The handrail 2 value. */
  handrail2: Scalars['Float']['output'];
  /** The ID of the signal in the backend. */
  id: Scalars['ID']['output'];
  /** The relevancy feedback of the signal. */
  relevancyFeedback?: Maybe<SignalRelevancyFeedback>;
  /** Human readable sub title detailing this signal */
  subtitle: Scalars['String']['output'];
  /** The thing associated with the signal */
  thing?: Maybe<Thing>;
  /** The thing name that emitted the signal. */
  thingName: Scalars['String']['output'];
  /** Human readable title for this signal */
  title: Scalars['String']['output'];
};


/** A toggleable signal. */
export type HandrailsSpeedAnomalyDetailsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A toggleable signal. */
export type HandrailsSpeedAnomalyEngineerDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A toggleable signal. */
export type HandrailsSpeedAnomalyExplanationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A toggleable signal. */
export type HandrailsSpeedAnomalySubtitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A toggleable signal. */
export type HandrailsSpeedAnomalyTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Hvac = Device & {
  __typename?: 'Hvac';
  /**
   * The audit offices possess an internal id refering to this specific Device
   *       that was registered during the ingest of an Audit Report.
   */
  auditOfficeIdentities: Array<Maybe<AuditOfficeIdentity>>;
  /** Returns the expected configuration for the audit-report types for the Device */
  auditReportConfig: AuditReportConfigObject;
  /** The audit reports lines of the device */
  auditReportLines: AuditReportAuditReportLineConnection;
  /** Audit reports associated with this building */
  auditReports: Array<AuditReport>;
  /** Availability rate of the device */
  availabilityRate?: Maybe<AvailabilityRate>;
  /** Brand of the device */
  brand?: Maybe<ElevatorBrand>;
  /** Date at which the elevator stopped working, usually as reported by call centers. This is different from the "stoppedSince" field. */
  brokenSince?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Building of the elevator */
  building: Building;
  /** Contracts of this device */
  contracts: ContractsContractDeviceContractConnection;
  /**
   * Determine if defects of the device have been handled:
   * - ON_TIME: All applicable defects were fixed on time
   * - LATE: One defect was fixed after toBeDoneBefore or toBeDoneBefore is passed
   * - NON_APPLICABLE: No defects were applicable
   */
  defectHandlingStatus: DefectHandlingStatus;
  /** Device defects progress counts */
  defectsProgress: DefectsProgress;
  /** Public identifier of a device */
  deviceNumber?: Maybe<Scalars['String']['output']>;
  /** Retrieve the status of the device: WORKING, STOPPED or HAS_ISSUES (working but with issues) */
  deviceStatus: DeviceStatuses;
  /** This device's dilap window state at the given instant — defaults to now; NO_WINDOW when no dilap period is configured or the device has no active contract line */
  dilapStatus: DilapStatus;
  /** This device's dilap window — the dilapidation coverage period; null when no dilap period is configured or the device has no active contract line */
  dilapWindow?: Maybe<DilapWindow>;
  /** List of events for a given device (currently only implements IOT) */
  events: IotEventConnection;
  /** Return whether or not the device is equipped with IOT */
  hasIot: Scalars['Boolean']['output'];
  /** Verify if there exists at least one AuditReportLine with a quote to send in this report */
  hasLineWithQuoteStatusToSend: Scalars['Boolean']['output'];
  /** The icon for the device */
  icon: Icon;
  id: Scalars['ID']['output'];
  /** Live status of the device */
  liveStatus?: Maybe<LiveDeviceStatus>;
  /** form to display a mechanic to update this device */
  mechanicIdentifyForm: DeviceSpecsForm;
  /** Missions that have at least one task on this device */
  missions: MissionsMissionConnection;
  /** Details about the device location inside the building */
  name?: Maybe<Scalars['String']['output']>;
  /** onboarding form of an onboarding */
  onboardingForm?: Maybe<OnboardingDeviceForm>;
  /** Ops responsible of managing this device in this contract */
  opsReferent?: Maybe<Admin>;
  /** Indicates if the device is in a paused state */
  paused?: Maybe<Scalars['Boolean']['output']>;
  /** The Schedule of Rates in force for this device: its active contract's annex, or WeMaintain's standard list for its country and device type when the contract carries none; null = no price list either way */
  priceList?: Maybe<PriceList>;
  /** Retrieve the list of repair requests linked to this device */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  /** Technical specs relative to HVAC */
  specs: HvacSpecs;
  state?: Maybe<StateSnapshot>;
  /** Get the list of state for a device between a range of date */
  stateSnapshots: DeviceStateStateSnapshotConnection;
  /**
   * If the elevator is ONLINE or OFFLINE
   * @deprecated **DO NOT USE** Should use Device.deviceStatus instead.
   */
  status: DeviceStatuses;
  stoppedReason?: Maybe<Scalars['String']['output']>;
  /** Date at which the device was stopped, denoting that an engineer purposely put it offline for safety reason. This is usually a few hours after the device broke down. */
  stoppedSince?: Maybe<Scalars['DateTime']['output']>;
  /** Subtype of the HVAC */
  subtype: HvacSubType;
  /** Tasks of this device */
  tasks: MissionsTaskConnection;
  /**
   * The WM serial number of the IoT-device currently attached to the device
   * @deprecated A device can now have mulitple things. Use the `things` field
   */
  thingName?: Maybe<Scalars['String']['output']>;
  /** The things attached to this device */
  things: Array<Maybe<Thing>>;
  /** Media associated with the device from visits */
  visitMedia: VisitsAnswerPhotoConnection;
};


export type HvacAuditReportLinesArgs = {
  filters?: InputMaybe<AuditReportLineDeviceFilters>;
  order?: InputMaybe<Array<AuditReportAuditReportLineOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};


export type HvacAvailabilityRateArgs = {
  filters: AvailabilityRateFilters;
};


export type HvacContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ContractDeviceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HvacDilapStatusArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type HvacEventsArgs = {
  pagination?: InputMaybe<IotConnectionArgs>;
};


export type HvacIconArgs = {
  size: AvailableIconSizes;
};


export type HvacMechanicIdentifyFormArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type HvacMissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HvacPausedArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type HvacRepairRequestsArgs = {
  filters?: InputMaybe<RepairRequestForDeviceInputFilters>;
  order?: InputMaybe<Array<WorkOrdersRepairRequestOrmEntityOrderOptions>>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type HvacStateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type HvacStateSnapshotsArgs = {
  filters?: InputMaybe<StateSnapshotInput>;
  pagination?: InputMaybe<DeviceStateConnectionArgs>;
};


export type HvacStoppedReasonArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type HvacTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deviceTaskFilters?: InputMaybe<DeviceTaskFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MissionsTaskOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


export type HvacVisitMediaArgs = {
  filters?: InputMaybe<FindManyDevicePhotosInput>;
  order?: InputMaybe<Array<VisitsAnswerPhotoOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

/** One of the selected choice for one question */
export type IAnswerChoice = {
  /** Template for this answer, containing its translation, what it impacts and all other information */
  answerTemplate: IAnswerTemplate;
  /**
   * Answer template which contains the actual text of the answer
   * @deprecated Use answerTemplate.id instead
   */
  answerTemplateId: Scalars['String']['output'];
  /** Key to group the answers by. */
  displayGroup?: Maybe<Scalars['String']['output']>;
  /** Contains information on how to display the answer template in the front-end side */
  displayOptions: AnswerDisplayOption;
  /** The additional answer for this choice */
  followUp: FollowUp;
  /** Does the answer ask for followup */
  hasFollowUp: Scalars['Boolean']['output'];
  /** Answer ID used to match mulitple question between them, provided by the author. */
  humanKey: Scalars['String']['output'];
  /** A problemKey is always associated with a stateKey and describes what's wrong. A basic example would be the problemKey 'BROKEN' on the stateKey 'car.lighting'. */
  problemKey?: Maybe<Scalars['String']['output']>;
  /** Part of the device this questions is about. A stateKey is a representation of component and subcomponent of a device. For example 'car' or 'car.lighting' */
  stateKey?: Maybe<Scalars['String']['output']>;
  stateKeyTranslation?: Maybe<AnswerTemplateAvailableStateKey>;
  /** The text of the answer which will be displayed to the mechanic */
  title: Scalars['String']['output'];
};


/** One of the selected choice for one question */
export type IAnswerChoiceDisplayGroupArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** One of the selected choice for one question */
export type IAnswerChoiceStateKeyTranslationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** One of the selected choice for one question */
export type IAnswerChoiceTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Possible answer to a question asked to a mechanic */
export type IAnswerTemplate = {
  /** Key to group the answers by. */
  displayGroup?: Maybe<Scalars['String']['output']>;
  /** Contains information on how to display the answer template in the front-end side */
  displayOptions: AnswerDisplayOption;
  /** Does the answer ask for followup */
  hasFollowUp: Scalars['Boolean']['output'];
  /** Answer ID used to match mulitple question between them, provided by the author. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** A problemKey is always associated with a stateKey and describes what's wrong. A basic example would be the problemKey 'BROKEN' on the stateKey 'car.lighting'. */
  problemKey?: Maybe<Scalars['String']['output']>;
  /** Part of the device this questions is about. A stateKey is a representation of component and subcomponent of a device. For example 'car' or 'car.lighting' */
  stateKey?: Maybe<Scalars['String']['output']>;
  stateKeyTranslation?: Maybe<AnswerTemplateAvailableStateKey>;
  /** The text of the answer which will be displayed to the mechanic */
  title: Scalars['String']['output'];
};


/** Possible answer to a question asked to a mechanic */
export type IAnswerTemplateDisplayGroupArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Possible answer to a question asked to a mechanic */
export type IAnswerTemplateStateKeyTranslationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Possible answer to a question asked to a mechanic */
export type IAnswerTemplateTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IInputSettings = {
  /** If true, this input should not be editable */
  disabled: Scalars['Boolean']['output'];
  /** If true, this input should be considered required */
  required: Scalars['Boolean']['output'];
};

/** Represents a choice available for a question, which can be selected by the user */
export type IQuestionChoice = {
  /** Template for this choice, containing its translation, what it impacts and all other information */
  answerTemplate: IAnswerTemplate;
  /**
   * Answer template which contains the actual text of the answer
   * @deprecated Use answerTemplate.id instead
   */
  answerTemplateId: Scalars['String']['output'];
  /** Key to group the answers by. */
  displayGroup?: Maybe<Scalars['String']['output']>;
  /** Contains information on how to display the answer template in the front-end side */
  displayOptions: AnswerDisplayOption;
  /** Does the answer ask for followup */
  hasFollowUp: Scalars['Boolean']['output'];
  /** Answer ID used to match mulitple question between them, provided by the author. */
  humanKey: Scalars['String']['output'];
  /** A problemKey is always associated with a stateKey and describes what's wrong. A basic example would be the problemKey 'BROKEN' on the stateKey 'car.lighting'. */
  problemKey?: Maybe<Scalars['String']['output']>;
  /** Part of the device this questions is about. A stateKey is a representation of component and subcomponent of a device. For example 'car' or 'car.lighting' */
  stateKey?: Maybe<Scalars['String']['output']>;
  stateKeyTranslation?: Maybe<AnswerTemplateAvailableStateKey>;
  /** The text of the answer which will be displayed to the mechanic */
  title: Scalars['String']['output'];
};


/** Represents a choice available for a question, which can be selected by the user */
export type IQuestionChoiceDisplayGroupArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a choice available for a question, which can be selected by the user */
export type IQuestionChoiceStateKeyTranslationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a choice available for a question, which can be selected by the user */
export type IQuestionChoiceTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IQuestionCondition = {
  outcome: QuestionConditionOutcome;
  type: QuestionConditionType;
};

/** The icon representing a given device */
export type Icon = {
  __typename?: 'Icon';
  /** The CDN URL for the icon */
  url?: Maybe<Scalars['String']['output']>;
};

/** The available actions to identify a device */
export type IdentifyDeviceAction = {
  /** Expected input to identify a door */
  identifyDoorInput?: InputMaybe<IdentifyDoorInput>;
  /** Expected input to identify an elevator */
  identifyElevatorInput?: InputMaybe<IdentifyElevatorInput>;
  /** Expected input to identify an escalator */
  identifyEscalatorInput?: InputMaybe<IdentifyEscalatorInput>;
  /** Expected input to identify a fire alarm */
  identifyFireAlarmInput?: InputMaybe<IdentifyFireAlarmInput>;
  /** Expected input to identify a HVAC */
  identifyHVACInput?: InputMaybe<IdentifyHvacInput>;
};

/** Expected input to identify a door */
export type IdentifyDoorInput = {
  /** Id of the door to update */
  deviceId: Scalars['String']['input'];
  /** The payload to update the door */
  update: IdentifyDoorUpdateInput;
};

/** Expected input to identify the specs of a door */
export type IdentifyDoorSpecsInput = {
  /** Type of sensor used for the external presence detection to activate the door opening */
  externalActivationType?: InputMaybe<ActivationType>;
  /** Type of sensor used for the internal presence detection to activate the door opening */
  internalActivationType?: InputMaybe<ActivationType>;
  /** The model of the door */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Type of motor used to open the door */
  motorType?: InputMaybe<MotorType>;
  /** The maximum opening width of the door */
  openingWidth?: InputMaybe<Scalars['Float']['input']>;
  /** Type of safety device */
  physicalSafety?: InputMaybe<PhysicalSafety>;
  /** Type of radar used to detect presence */
  radarType?: InputMaybe<RadarType>;
  /** The safety risk of this door depending on who uses it (children, elderly...) */
  risk?: InputMaybe<Risk>;
  /** the serial number of the device */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Props that can be updated to identify a door */
export type IdentifyDoorUpdateInput = {
  /** The id of the brand attached to the device (otis, sodimas...) */
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** The WM device number */
  deviceNo?: InputMaybe<Scalars['String']['input']>;
  /** Details about the door location inside the building */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The technical specs of the device */
  specs?: InputMaybe<IdentifyDoorSpecsInput>;
  /** Subtype of the door */
  subtype?: InputMaybe<DoorSubType>;
};

/** Expected input to identify an elevator */
export type IdentifyElevatorInput = {
  /** Id of the elevator to update */
  deviceId: Scalars['String']['input'];
  /** The payload to update the elevator */
  update: IdentifyElevatorUpdateInput;
};

/** Expected input to identify the specs of an elevator */
export type IdentifyElevatorSpecsInput = {
  /** What is the alarm system used for the elevator */
  alarmSystemId?: InputMaybe<Scalars['ID']['input']>;
  /** What kind of lighting is used in the lift cabin */
  cabinLightingType?: InputMaybe<ElevatorCabinLightingSpecsType>;
  /** What kind of friction is used to move the lift up and down */
  cabinMotionType?: InputMaybe<ElevatorCabinMotionSpecsType>;
  /** Indicates how many cables are used to draw the lift */
  cableNumber?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Reference (ie the brand but it could also be the model number)
   * of the cables used to draw the lift
   */
  cableReference?: InputMaybe<Scalars['String']['input']>;
  /** Diameter of the cables used to draw the lift */
  cableThickness?: InputMaybe<Scalars['Float']['input']>;
  /** How much weight can the elevator hold */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** What kind of doors opening does the car use */
  carDoorsOpeningType?: InputMaybe<ElevatorDoorsOpeningType>;
  /** Since when has the controller been running */
  controllerYear?: InputMaybe<Scalars['String']['input']>;
  /** Does the Elevator support the eco-mode */
  ecoMode?: InputMaybe<ElevatorEcoMode>;
  /** What kind of emergency services the lift is adapted for */
  emergencyServices?: InputMaybe<ElevatorEmergencyServices>;
  /**
   * Since every engines are in fact electrical machines,
   * this field indicates more precisly what is running underneath the engine
   */
  engineSubType?: InputMaybe<ElevatorEngineSpecsSubType>;
  /** What is the engine used inside the elevator */
  engineType?: InputMaybe<ElevatorSpecsEngineType>;
  /** Mechanism used to adjust the engine speed */
  frequencyVariator?: InputMaybe<ElevatorFrequencySpecsVariator>;
  /** Type of Gateway for the alarm system */
  gsmGateway?: InputMaybe<ElevatorSpecsGsmGateway>;
  /** Is the elevator part of a group (multiplex) */
  isPartOfGroup?: InputMaybe<YesNoType>;
  /** Is the lift a through car (2 entrances) */
  isThroughCar?: InputMaybe<YesNoType>;
  /** The location of the landing indicators */
  landingIndicatorsLocation?: InputMaybe<ElevatorLandingIndicatorsLocation>;
  /** When was the lift installed */
  liftInstallationYear?: InputMaybe<Scalars['String']['input']>;
  /** Soft reference to the device_model selected for this elevator (no FK, no validation) */
  modelId?: InputMaybe<Scalars['ID']['input']>;
  /** The location of the motor room */
  motorRoomLocation?: InputMaybe<ElevatorMotorRoomLocation>;
  /** Since when has the motor been running */
  motorYear?: InputMaybe<Scalars['String']['input']>;
  /** How many floors are deserved by the elevator */
  noOfFloor?: InputMaybe<Scalars['Float']['input']>;
  /** The phoneline of the elevator */
  phoneLine?: InputMaybe<Scalars['String']['input']>;
  /** The PROM number of the alarm system */
  promNumber?: InputMaybe<Scalars['String']['input']>;
  /** The serial number of the elevator */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** What kind of doors opening does the shaft use */
  shaftDoorsOpeningType?: InputMaybe<ElevatorDoorsOpeningType>;
  /** What kind of lighting is used in the lift shaft */
  shaftLightingType?: InputMaybe<ElevatorShaftLightingSpecsType>;
  /** How fast does the elevator go */
  speed?: InputMaybe<Scalars['Float']['input']>;
  /** What kind of traction (belt, cable,ect) is used to pull the elevator up and down */
  tractionType?: InputMaybe<ElevatorSpecsTractionType>;
};

/** Props tha can be updated to identify en elevator */
export type IdentifyElevatorUpdateInput = {
  /** What is the brand of the identified device (ie otis) */
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** The WM device number */
  deviceNo?: InputMaybe<Scalars['String']['input']>;
  /** Details about the elevator location inside the building */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Contains all the technical specs relative to the elevator */
  specs?: InputMaybe<IdentifyElevatorSpecsInput>;
  /** Subtype of the elevator */
  subtype?: InputMaybe<ElevatorSubType>;
};

/** Expected input to identify an escalator */
export type IdentifyEscalatorInput = {
  /** Id of the escalator to update */
  deviceId: Scalars['String']['input'];
  /** The payload to update the escalator */
  update: IdentifyEscalatorUpdateInput;
};

/** Expected input to identify the specs of an escalator */
export type IdentifyEscalatorSpecsInput = {
  /** A field to add additional information about the escalator */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If the escalator supports eco-mode */
  ecoMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** Total length of the handrail (in meters) */
  handrailLength?: InputMaybe<Scalars['Float']['input']>;
  /** Type of the handrail (eg:Otis Slim, Kone Standard...) */
  handrailType?: InputMaybe<HandRailType>;
  /** How much is the inclination of the escalator (in degrees) */
  inclination?: InputMaybe<Scalars['Float']['input']>;
  /** The year of installation */
  installationYear?: InputMaybe<Scalars['String']['input']>;
  /** Model of the escalator */
  model?: InputMaybe<Scalars['String']['input']>;
  /** If the escalator has a motor room or not */
  motorRoom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of steps the escalator has */
  noSteps?: InputMaybe<Scalars['Float']['input']>;
  /** the serial number of the escalator */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** How fast does the escalator go */
  speed?: InputMaybe<Scalars['Float']['input']>;
  /** Defines the vertical meter difference between upper and lower landing */
  verticalRise?: InputMaybe<Scalars['Float']['input']>;
  /** Width of the steps, useful for spare parts */
  widthSteps?: InputMaybe<Scalars['Int']['input']>;
};

/** Props tha can be updated to identify an escalator */
export type IdentifyEscalatorUpdateInput = {
  /** The id of the brand attached to the device (otis, sodimas...) */
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** The WM device number */
  deviceNo?: InputMaybe<Scalars['String']['input']>;
  /** Details about the elevator location inside the building */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The technical specs of the devices */
  specs?: InputMaybe<IdentifyEscalatorSpecsInput>;
  /** Subtype of the escalator */
  subtype?: InputMaybe<EscalatorSubType>;
};

/** Expected input to identify a fire alarm */
export type IdentifyFireAlarmInput = {
  /** Id of the fire alarm to update */
  deviceId: Scalars['String']['input'];
  /** The payload to update the fire alarm */
  update: IdentifyFireAlarmUpdateInput;
};

/** Expected input to identify the specs of a fire alarm */
export type IdentifyFireAlarmSpecsInput = {
  /** Number of air opening vents */
  airOpeningVents?: InputMaybe<Scalars['Int']['input']>;
  /** Number of alarm zones */
  alarmZones?: InputMaybe<Scalars['Int']['input']>;
  /** Number of AOV panels */
  aovPanels?: InputMaybe<Scalars['Int']['input']>;
  /** Number of aspirating smoke detectors */
  aspiratingSmokeDetectors?: InputMaybe<Scalars['Int']['input']>;
  /** Number of automatic opening vents */
  automaticOpeningVents?: InputMaybe<Scalars['Int']['input']>;
  /** Number of battery packups */
  batteryBackups?: InputMaybe<Scalars['Int']['input']>;
  /** Number of beam smoke detectors */
  beamSmokeDetectors?: InputMaybe<Scalars['Int']['input']>;
  /** Know the type of building (hotel,, offices...) to know which regulation applies */
  buildingType?: InputMaybe<Scalars['String']['input']>;
  /** Number of other function */
  cmsiFunctions?: InputMaybe<Scalars['Int']['input']>;
  /** Model of the main control panel */
  controlPanelModel?: InputMaybe<Scalars['String']['input']>;
  /** Numer of detection zones */
  detectionZones?: InputMaybe<Scalars['Int']['input']>;
  /** Number of release magnets */
  doorReleaseMagnets?: InputMaybe<Scalars['Int']['input']>;
  /** Type of fire alarm */
  fireAlarmClassification?: InputMaybe<FireAlarmClassification>;
  /** Number of control panels */
  fireAlarmControlPanels?: InputMaybe<Scalars['Int']['input']>;
  /** Number of fire / smoke dampers */
  fireDampers?: InputMaybe<Scalars['Int']['input']>;
  /** Number of fire doors */
  fireDoors?: InputMaybe<Scalars['Int']['input']>;
  /** Number of fire safety control panels */
  fireSafetyControlPanels?: InputMaybe<Scalars['Int']['input']>;
  /** Number of green MCPs */
  greenMCPs?: InputMaybe<Scalars['Int']['input']>;
  /** Number of heat detectors */
  heatDetectors?: InputMaybe<Scalars['Int']['input']>;
  /** Number of I/O modules */
  ioModules?: InputMaybe<Scalars['Int']['input']>;
  /** Number of linear heat detectors */
  linearHeatDetectors?: InputMaybe<Scalars['Int']['input']>;
  /** Numberof manual call points */
  manualCallPoints?: InputMaybe<Scalars['Int']['input']>;
  /** Number of manual closing winches */
  manualClosingWinches?: InputMaybe<Scalars['Int']['input']>;
  /** Number of optical smoke detectors */
  opticalSmokeDetectors?: InputMaybe<Scalars['Int']['input']>;
  /** Number of pipe detectors */
  pipeDetectors?: InputMaybe<Scalars['Int']['input']>;
  /** Number of pneumatic AOV systems */
  pneumaticAOVPanels?: InputMaybe<Scalars['Int']['input']>;
  /** Number of pneumatic AOV systems */
  pneumaticAOVSystems?: InputMaybe<Scalars['Int']['input']>;
  /** Number of public annoucement voice alarms */
  publicAannouncementVoiceAlarms?: InputMaybe<Scalars['Int']['input']>;
  /** Number of remote indicators */
  remoteIndicators?: InputMaybe<Scalars['Int']['input']>;
  /** Number of repeater panels */
  repeaterPanels?: InputMaybe<Scalars['Int']['input']>;
  /** the serial number of the device */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Number of smoke extract fans */
  smokeExtractionMotors?: InputMaybe<Scalars['Int']['input']>;
  /** Number of sounders and beacons */
  soundersAndBeacons?: InputMaybe<Scalars['Int']['input']>;
  /** Number of special detectors */
  specialDetectors?: InputMaybe<Scalars['Int']['input']>;
  /** Brand of the main control panel */
  systemBrand?: InputMaybe<SystemBrand>;
  /** Number of third party security systems */
  thirdPartySecuritySystems?: InputMaybe<Scalars['Int']['input']>;
  /** Number of volt-free relays */
  voltFreeRelays?: InputMaybe<Scalars['Int']['input']>;
  /** Number of wireless MCPs */
  wirelessMcps?: InputMaybe<Scalars['Int']['input']>;
  /** Number of wireless optical smoke detectors */
  wirelessOpticalSmokeDetectors?: InputMaybe<Scalars['Int']['input']>;
  /** Number of wireless remote indicators */
  wirelessRemoteIndicators?: InputMaybe<Scalars['Int']['input']>;
  /** Number of wireless transponders */
  wirelessTransponders?: InputMaybe<Scalars['Int']['input']>;
};

/** Props that can be updated to identify a fire alarm */
export type IdentifyFireAlarmUpdateInput = {
  /** The id of the brand attached to the device (otis, sodimas...) */
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** The WM device number */
  deviceNo?: InputMaybe<Scalars['String']['input']>;
  /** Details about the fire alarm location inside the building */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The technical specs of the device */
  specs?: InputMaybe<IdentifyFireAlarmSpecsInput>;
  /** Subtype of the fire alarm */
  subtype?: InputMaybe<FireAlarmSubType>;
};

/** Expected input to identify a HVAC */
export type IdentifyHvacInput = {
  /** Id of the HVAC to update */
  deviceId: Scalars['String']['input'];
  /** The payload to update the HVAC */
  update: IdentifyHvacUpdateInput;
};

/** Expected input to identify the specs of a HVAC */
export type IdentifyHvacSpecsInput = {
  /** The criticality the system must ensure in emergency ventilation in case of fire and in case of loss of primary ventilation functions */
  criticality?: InputMaybe<Criticality>;
  /** The number of indoor units included in the stystem */
  numberOfIndoorUnits?: InputMaybe<Scalars['Int']['input']>;
  /** The type of refrigerant which is a chemical that produces a cooling effect while expanding or vaporizing. */
  refrigerant?: InputMaybe<Scalars['String']['input']>;
  /** the serial number of the device */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Props that can be updated to identify a hvac */
export type IdentifyHvacUpdateInput = {
  /** The id of the brand attached to the device (samsung...) */
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** The WM device number */
  deviceNo?: InputMaybe<Scalars['String']['input']>;
  /** Details about the HVAC location inside the building */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The technical specs of the device */
  specs?: InputMaybe<IdentifyHvacSpecsInput>;
  /** Subtype of the HVAC */
  subtype?: InputMaybe<HvacSubType>;
};

/** A user an admin may impersonate off production */
export type ImpersonationCandidate = {
  __typename?: 'ImpersonationCandidate';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** Has an admin profile */
  hasAdmin: Scalars['Boolean']['output'];
  /** Has an active mechanic; always true, as only engineers are listed */
  hasApp: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Signs the caller in once, through Clerk, as another internal user */
export type ImpersonationToken = {
  __typename?: 'ImpersonationToken';
  /** Clerk actor token */
  token: Scalars['String']['output'];
  /** Clerk-hosted sign-in URL carrying the token */
  url?: Maybe<Scalars['String']['output']>;
};

export type ImportQuestionGroupsResponse = {
  __typename?: 'ImportQuestionGroupsResponse';
  success: Scalars['Boolean']['output'];
};

/**
 * The payload for adding a new report.
 * It includes all the info corresponding to the auditReport
 * and the device matchings filled by the ops
 */
export type ImportReportPayload = {
  /** Name of the audit office / OTHER */
  auditOffice: AuditOffice;
  /** Reference under which the audit report is known to the audit office which issued it */
  auditOfficeRef?: InputMaybe<Scalars['String']['input']>;
  /** Type of the audit check */
  auditReportType: AuditReportType;
  /** Building that the report refers to */
  buildingId: Scalars['ID']['input'];
  /** Device ids that the report is about */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Date at which the report was emitted */
  emittedAt: Scalars['DateTime']['input'];
  /** Info of the file to upload. Check https://github.com/jaydenseric/graphql-upload#type-fileupload */
  file: Scalars['Upload']['input'];
  /** The matching between wm reference and auditOffice reference for each device */
  matchings: Array<DeviceRefMatching>;
  /** Date at which the report was received */
  receivedAt: Scalars['DateTime']['input'];
};

export type Inference = {
  __typename?: 'Inference';
  id: Scalars['ID']['output'];
  stream: Scalars['InferenceStream']['output'];
  /** The base URL every inference endpoint hangs off, trailing slash included. Combine with `streamToken` to call an endpoint other than `stream`, such as `inference/batch`. */
  streamBaseUrl: Scalars['String']['output'];
  /** The signed token authorising this inference, on its own. Same token as the one embedded in `stream`, exposed separately so a batch request can carry several of them. */
  streamToken: Scalars['String']['output'];
};

export type InputOption = FormThing & {
  __typename?: 'InputOption';
  /** Parent-field values this option is valid for, evaluated as an OR (cascading dropdown) */
  dependsOnValue?: Maybe<Array<Scalars['ValueOfInput']['output']>>;
  title: Scalars['String']['output'];
  /** The value of the option in the select input */
  value: Scalars['ValueOfInput']['output'];
};

/**
 * The status of a given AuditReportLine in the internal WM process
 * before or after validation by ops, extented with the following:
 *  - 'NO_QUOTE': filter on report lines with no related quote.
 */
export enum InputQuoteStatus {
  NoQuote = 'NO_QUOTE',
  Rejected = 'REJECTED',
  Sent = 'SENT',
  ToSend = 'TO_SEND',
  Validated = 'VALIDATED'
}

export type InputSettings = IInputSettings & {
  __typename?: 'InputSettings';
  /** If true, this input should not be editable */
  disabled: Scalars['Boolean']['output'];
  /** If true, this input should be considered required */
  required: Scalars['Boolean']['output'];
};

/** Setup for the inputs of the IoT thing */
export type InputSetup = {
  __typename?: 'InputSetup';
  defaultState: DefaultPinState;
  kind: PinKind;
  pinNumber: PinNumber;
};

/** Desired setup for the inputs of the IoT thing */
export type InputSetupInput = {
  defaultState: DefaultPinState;
  kind: PinKind;
  pinNumber: PinNumber;
};

export type InstallationRequestItem = RequestItem & {
  __typename?: 'InstallationRequestItem';
  /** If this requested item needs to be invoiced to the customer */
  chargeable?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the request item should be delivered from our supplier */
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The human identifier for a request (at the moment it is the id within airtable)
   * @deprecated Airtable is not used anymore. This field is deprecated and will be removed in the future.
   */
  humanId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** If the item is withdrawable by the engineer */
  isWithdrawable: Scalars['Boolean']['output'];
  /**
   * Comment of the ops about the requested item
   * @deprecated Comments are not found on individual parts anymore but on the request as a whole. Use RepairRequest.enginerComment or RepairRequest.internalComment
   */
  opsComment?: Maybe<Scalars['String']['output']>;
  /** Order progression data synced from Netsuite for this request item */
  orderProgression?: Maybe<RequestItemOrderProgression>;
  /** Cost of the item (what we pay). This represents the company's cost for the item. Use sellPrice for the margin/sell price. Can be null if not set yet. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The quote line this item backs — a partition: an item belongs to at most one line (PRENG-7500) */
  quoteLine?: Maybe<QuoteLine>;
  repairRequestId: Scalars['ID']['output'];
  /**
   * Sell price of the item (separate from cost). Used for items that need to track separate cost and margin, such as Installation items. Can be null if not set.
   * @deprecated What the customer pays lives on QuoteLine.sellPrice (PRENG-7500); this is never written anymore
   */
  sellPrice?: Maybe<Scalars['Float']['output']>;
  /** Represent the state of the request item (should be used in place of status). Based on the type of the itemand its current data it return a state representing the next action to be done on a business point of view. */
  state?: Maybe<RequestItemState>;
  /**
   * Represent the status of the item in the repair flow
   * @deprecated Status is representing the status of the item in our legacy flow. Please use state instead, that represent
   */
  status: RepairRequestStatus;
  /** Optional URL towards a quote from one of our supplier for this part that we've used for pricing */
  supplierQuoteLink?: Maybe<Scalars['String']['output']>;
  /** Information about the withdrawal of the item by the engineer */
  withdrawal?: Maybe<Withdrawal>;
};

/** A intervention timeline marker in a timeline */
export type InterventionTimelineMarker = TimelineMarker & {
  __typename?: 'InterventionTimelineMarker';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  type: TimelineMarkerType;
};

/**
 * Represente the invoice for a mechanic.
 * This invoice is used for the generation of the PDF invoice.
 * An invoice have one or more InvoiceItem (each line for the invoice)
 */
export type Invoice = {
  __typename?: 'Invoice';
  /** The amount this invoice represents */
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  /** The currency iso code used in this invoice (ex: EUR for france, GBP for uk...) */
  currencyIsoCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The invoice tasks the mechanics has done included in this invoice */
  invoiceItems: InvoicesInvoiceItemConnection;
  /** Mechanic this invoice belongs to */
  mechanic: Mechanic;
  /** If this invoice was paid to the mechanic */
  paid: Scalars['Boolean']['output'];
  /** signed URL to a invoice report, can be null if no report exists */
  reportUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Date for which we're invoicing.
   *      We could for example be invocing in march the twelfth due in february.
   *      *Can be different than createdAt.*
   */
  targetDate?: Maybe<Scalars['DateTimeISO']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


/**
 * Represente the invoice for a mechanic.
 * This invoice is used for the generation of the PDF invoice.
 * An invoice have one or more InvoiceItem (each line for the invoice)
 */
export type InvoiceInvoiceItemsArgs = {
  order?: InputMaybe<Array<InvoicesInvoiceItemOrderOptions>>;
  pagination?: InputMaybe<InvoicesConnectionArgs>;
};

/** Set of filters to apply to the Invoices query */
export type InvoiceFilters = {
  /** Filter items by their invoice ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Represent a line invoicable of an invoice.
 * We have one invoice item for each 1/12 of each contract,
 * invoice items for each repaire/trapped_passenger/breackdown,
 * and previsits.
 */
export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  /** If an ops approved the invoice item */
  accepted?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use buildingOfContract.building instead to access the building link to the contract of this invoice item */
  building: Building;
  buildingOfContract?: Maybe<ContractBuilding>;
  /** @deprecated Use buildingOfContract.contract instead to access the contract link this invoice item */
  contract?: Maybe<Contract>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Temporary fix for InvoiceItems with no mission. To be removed in August */
  legacyReportUrl?: Maybe<Scalars['String']['output']>;
  mechanic: Mechanic;
  /** Mission that we're invoicing */
  mission?: Maybe<Mission>;
  /** The quantity of this item we've done */
  quantity: Scalars['Float']['output'];
  /** The rate we'll pay per quantity */
  rate: Scalars['Float']['output'];
  sfQuoteLink?: Maybe<Scalars['String']['output']>;
  /** If this item has already been pre-sorted or not */
  sorted: Scalars['Boolean']['output'];
  /**
   * Date for which we're invoicing.
   *      We could for example be invocing in march the twelfth due in february.
   *      *Can be different than createdAt.*
   */
  targetDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /**
   * The type the the invoice Item' +
   *     CONTRACT = This type invoice item occurs once by mounth, represent 1/12 of the related contractCharge',
   *     PREVISIT = Invoice Item for the pre visit, once per building
   *     TASK = Invoice Item for a breakdown, trapped_passenger or repair taks
   */
  type: InvoiceItemType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Set of filters to apply to the InvoiceItems query */
export type InvoiceItemFilters = {
  /** Items that are accepted */
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter invoice items by buildings belonging to the specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter invoice items by building ids */
  buildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter invoice items by buildings belonging to the specified accounts
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter items by their invoice ids */
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get items that have already been invoiced (linked to an invoice) */
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter invoice items by the manager of the ops referent user on the building's contract. Given a list of user IDs, invoice items whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter invoice items by users that manage the current contract for the invoice item */
  referentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search on linked adresses */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Items that have already/not yet been sorted */
  sorted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter invoice items by the location of the building (iso 3166-1 alpha-2 format: FR, EN) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Items that have been sorted but have yet to be accepted */
  toAccept?: InputMaybe<Scalars['Boolean']['input']>;
  /** Types of invoice item we want to fetch */
  types?: InputMaybe<Array<InvoiceItemType>>;
};

export enum InvoiceItemSortableFields {
  Accepted = 'accepted',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Quantity = 'quantity',
  Rate = 'rate',
  Sorted = 'sorted',
  TargetDate = 'targetDate',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

/** type of invoice item (if this is related to paying a contract, a previsit, a task ...) */
export enum InvoiceItemType {
  Contract = 'CONTRACT',
  Previsit = 'PREVISIT',
  Task = 'TASK'
}

export type InvoiceItemUpdate = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sorted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InvoiceSortableFields {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Id = 'id',
  Paid = 'paid',
  TargetDate = 'targetDate',
  UpdatedAt = 'updatedAt'
}

export type InvoicesConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoicesInvoiceConnection = {
  __typename?: 'InvoicesInvoiceConnection';
  edges: Array<InvoicesInvoiceEdge>;
  pageInfo: InvoicesPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type InvoicesInvoiceEdge = {
  __typename?: 'InvoicesInvoiceEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Invoice;
};

export type InvoicesInvoiceItemConnection = {
  __typename?: 'InvoicesInvoiceItemConnection';
  edges: Array<InvoicesInvoiceItemEdge>;
  pageInfo: InvoicesPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type InvoicesInvoiceItemEdge = {
  __typename?: 'InvoicesInvoiceItemEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: InvoiceItem;
};

export type InvoicesInvoiceItemOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: InvoiceItemSortableFields;
};

export type InvoicesInvoiceOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: InvoiceSortableFields;
};

export type InvoicesPageInfo = {
  __typename?: 'InvoicesPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Input param to generate the netsuite csv */
export type InvoicingCsvForNetsuiteInput = {
  /** Generate the export using the targetDate, default is current month */
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IotConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IotEventConnection = {
  __typename?: 'IotEventConnection';
  edges: Array<IotEventEdge>;
  pageInfo: IotPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type IotEventEdge = {
  __typename?: 'IotEventEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Event;
};

export type IotPageInfo = {
  __typename?: 'IotPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type IotSignalOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: SignalOrmEntitySortableFields;
};

export type IotStrongSignalGraphQlConnection = {
  __typename?: 'IotStrongSignalGraphQLConnection';
  edges: Array<IotStrongSignalGraphQlEdge>;
  pageInfo: IotPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type IotStrongSignalGraphQlEdge = {
  __typename?: 'IotStrongSignalGraphQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: StrongSignal;
};

export type IotThingGraphqlConnection = {
  __typename?: 'IotThingGraphqlConnection';
  edges: Array<IotThingGraphqlEdge>;
  pageInfo: IotPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type IotThingGraphqlEdge = {
  __typename?: 'IotThingGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Thing;
};

export type IotThingMembers = {
  __typename?: 'IotThingMembers';
  count?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type IotThingOrderByInput = {
  count?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

export type IotThingWhereInput = {
  AND?: InputMaybe<Array<IotThingWhereInput>>;
  OR?: InputMaybe<Array<IotThingWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  deviceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
};

export type IssueMembers = {
  __typename?: 'IssueMembers';
  closed?: Maybe<Scalars['String']['output']>;
  closedat?: Maybe<TimeDimension>;
  count?: Maybe<Scalars['Float']['output']>;
  createdat?: Maybe<TimeDimension>;
  criticity?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<TimeDimension>;
  deviceid?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Scalars['String']['output']>;
  issueId?: Maybe<Scalars['String']['output']>;
  issueid?: Maybe<Scalars['String']['output']>;
  problemId?: Maybe<Scalars['String']['output']>;
  problemkey?: Maybe<Scalars['String']['output']>;
  statekey?: Maybe<Scalars['String']['output']>;
};

export type IssueOrderByInput = {
  closed?: InputMaybe<OrderBy>;
  closedat?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  createdat?: InputMaybe<OrderBy>;
  criticity?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deviceid?: InputMaybe<OrderBy>;
  events?: InputMaybe<OrderBy>;
  issueId?: InputMaybe<OrderBy>;
  issueid?: InputMaybe<OrderBy>;
  problemId?: InputMaybe<OrderBy>;
  problemkey?: InputMaybe<OrderBy>;
  statekey?: InputMaybe<OrderBy>;
};

export type IssueQuestion = Question & {
  __typename?: 'IssueQuestion';
  /** Different answers that can be chosen for this question */
  answerTemplates: Array<IAnswerTemplate>;
  conditions: Array<IQuestionCondition>;
  /** The category the question refers to (car, ...) */
  displayCategory?: Maybe<Scalars['String']['output']>;
  /** The sub-category the question refers to, used to group questions in the same category */
  displaySubCategory?: Maybe<QuestionSubCategory>;
  /**
   * Defines the presence & requiredness of choices, photos and comments.
   *     By default, they are all present and optional
   */
  features: QuestionTemplateFeature;
  /** Hint to help the user answer the question */
  hint?: Maybe<Scalars['String']['output']>;
  /** A manual question ID, set in the question spreadsheet. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Issue that triggered the creation of this question */
  issue: IssueSnapshot;
  /** QuestionTemplate that was used to create that question */
  questionTemplate: QuestionTemplate;
  /** The part of the elevator the question is about */
  stateKey?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** Work order linked to that question */
  workOrder?: Maybe<RepairRequest>;
};


export type IssueQuestionHintArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type IssueQuestionTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IssueSnapshot = {
  __typename?: 'IssueSnapshot';
  /** The date this issue has been closed */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Retrieve the source that closed the issue */
  closingReason?: Maybe<SourceUnion>;
  /** Level of the criticity of an issue, ranging from 0 to 100 */
  criticity: Scalars['Float']['output'];
  /** Date of the last update of this issue */
  date: Scalars['DateTime']['output'];
  /** Device linked to this issue */
  device: Device;
  /** The snapshot ID */
  id: Scalars['ID']['output'];
  /** The issue ID */
  issueId: Scalars['ID']['output'];
  /** Human readable problem message, when it's ongoing */
  ongoingProblemI18n?: Maybe<Scalars['String']['output']>;
  /** The key of the problem this issue relates to */
  problemKey?: Maybe<Scalars['String']['output']>;
  /** Providers that reported this issue */
  providers: Array<EventProvider>;
  /** All the repair requests linked to this issue. Request are ordered from most recent to oldest. */
  repairRequests: WorkOrdersRepairRequestIssueGraphqlRepairRequestGraphqlConnection;
  /** Human readable problem message, when it's solved */
  solvedProblemI18n?: Maybe<Scalars['String']['output']>;
  sources: Array<SourceUnion>;
  /** The key of the part of the elevator this issue relates to */
  stateKey: Scalars['String']['output'];
  /** Human readable state key, translated in the given language */
  stateKeyI18n?: Maybe<Scalars['String']['output']>;
};


export type IssueSnapshotOngoingProblemI18nArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type IssueSnapshotRepairRequestsArgs = {
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type IssueSnapshotSolvedProblemI18nArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type IssueSnapshotSourcesArgs = {
  filters?: InputMaybe<IssueSourceFilters>;
};


export type IssueSnapshotStateKeyI18nArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input filters to return issues of a device */
export type IssueSnapshotInput = {
  /** Default behavior is false, and will return the last snapshot of all issueId */
  currentlyOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Return snapshot only for this device
   * @deprecated Use deviceIds instead
   */
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Return snapshot only for given devices */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Fetch only issues with given issueIds */
  issueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Fetch only issues of a specific problem type */
  problemKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Fetch only issues opened by one of these providers */
  providers?: InputMaybe<Array<EventProvider>>;
  /** Fetch only issues on a specific part of devices */
  stateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IssueSnapshotMembers = {
  __typename?: 'IssueSnapshotMembers';
  closed?: Maybe<Scalars['String']['output']>;
  closedat?: Maybe<TimeDimension>;
  count?: Maybe<Scalars['Float']['output']>;
  createdat?: Maybe<TimeDimension>;
  criticity?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<TimeDimension>;
  deviceid?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Scalars['String']['output']>;
  issueid?: Maybe<Scalars['String']['output']>;
  problemId?: Maybe<Scalars['String']['output']>;
  problemkey?: Maybe<Scalars['String']['output']>;
  statekey?: Maybe<Scalars['String']['output']>;
};

export type IssueSnapshotOrderByInput = {
  closed?: InputMaybe<OrderBy>;
  closedat?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  createdat?: InputMaybe<OrderBy>;
  criticity?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deviceid?: InputMaybe<OrderBy>;
  events?: InputMaybe<OrderBy>;
  issueid?: InputMaybe<OrderBy>;
  problemId?: InputMaybe<OrderBy>;
  problemkey?: InputMaybe<OrderBy>;
  statekey?: InputMaybe<OrderBy>;
};

export enum IssueSnapshotSortableFields {
  ClosedAt = 'closedAt',
  Criticity = 'criticity',
  Date = 'date',
  Id = 'id',
  IssueId = 'issueId',
  ProblemKey = 'problemKey',
  StateKey = 'stateKey'
}

export type IssueSnapshotWhereInput = {
  AND?: InputMaybe<Array<IssueSnapshotWhereInput>>;
  OR?: InputMaybe<Array<IssueSnapshotWhereInput>>;
  closed?: InputMaybe<StringFilter>;
  closedat?: InputMaybe<DateTimeFilter>;
  count?: InputMaybe<FloatFilter>;
  createdat?: InputMaybe<DateTimeFilter>;
  criticity?: InputMaybe<FloatFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deviceid?: InputMaybe<StringFilter>;
  events?: InputMaybe<StringFilter>;
  issueid?: InputMaybe<StringFilter>;
  problemId?: InputMaybe<StringFilter>;
  problemkey?: InputMaybe<StringFilter>;
  statekey?: InputMaybe<StringFilter>;
};

/** Filters sources of an issue */
export type IssueSourceFilters = {
  /** By default only sources that are currently open are returned, set to true to return everything */
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IssueWhereInput = {
  AND?: InputMaybe<Array<IssueWhereInput>>;
  OR?: InputMaybe<Array<IssueWhereInput>>;
  closed?: InputMaybe<StringFilter>;
  closedat?: InputMaybe<DateTimeFilter>;
  count?: InputMaybe<FloatFilter>;
  createdat?: InputMaybe<DateTimeFilter>;
  criticity?: InputMaybe<FloatFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deviceid?: InputMaybe<StringFilter>;
  events?: InputMaybe<StringFilter>;
  issueId?: InputMaybe<StringFilter>;
  issueid?: InputMaybe<StringFilter>;
  problemId?: InputMaybe<StringFilter>;
  problemkey?: InputMaybe<StringFilter>;
  statekey?: InputMaybe<StringFilter>;
};

export type LabourLine = PriceListLine & {
  __typename?: 'LabourLine';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includesTravel?: Maybe<Scalars['Boolean']['output']>;
  kind: PriceListLineKind;
  label: Scalars['String']['output'];
  priceListId: Scalars['String']['output'];
  rawRow?: Maybe<Scalars['JSON']['output']>;
  reference: Scalars['String']['output'];
  /** The labour/price tier this row belongs to; null = one price for the line */
  tier?: Maybe<PriceListTier>;
  tierId?: Maybe<Scalars['String']['output']>;
  /** The rate family in force alongside this row — every tier the contract prices this reference at, this line included, ordered by tier ordinal. One element when the reference is priced once regardless of the time of day, and never a tier that has since been retired */
  tierVariants: Array<PriceListLine>;
  validFrom: Scalars['DateTimeISO']['output'];
  validTo?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type LegacyVisualization = QueryResult & {
  __typename?: 'LegacyVisualization';
  cellHtml?: Maybe<Array<Visualization_CellHtml>>;
  color?: Maybe<Array<Scalars['String']['output']>>;
  /** ConditionalVisualFormat */
  conditionalVisualFormat?: Maybe<Array<ConditionalVisualFormat>>;
  /** Dataset */
  dataset?: Maybe<Dataset>;
  drillFields?: Maybe<Array<Visualization_DrillFields>>;
  labelValueFormat?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Visualization_Links>>;
  /** Note */
  note?: Maybe<Note>;
  series?: Maybe<Array<Visualization_Series>>;
  /** Sort */
  sort?: Maybe<Sort>;
  title?: Maybe<Scalars['String']['output']>;
  /** ValueFormat */
  valueFormat?: Maybe<Array<ValueFormat>>;
  /** VisualMap */
  visualMap?: Maybe<Array<VisualMap>>;
  xAxis?: Maybe<Visualization_XAxis>;
  yAxes?: Maybe<Array<Visualization_YAxes>>;
  yAxis?: Maybe<Visualization_YAxis>;
};

/** A leveling anomaly strong signal. */
export type LevelingAnomaly = StrongSignal & {
  __typename?: 'LevelingAnomaly';
  /** An acknowledgement if the signal was acknowledged. */
  acknowledgement?: Maybe<Acknowledgement>;
  /** The closest level delta. */
  closestLevelDelta?: Maybe<Scalars['Float']['output']>;
  /** The closest level height. */
  closestLevelHeight?: Maybe<Scalars['Float']['output']>;
  /** The closest level label. */
  closestLevelLabel?: Maybe<Scalars['String']['output']>;
  /** The date and time when the signal was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time when the signal was last updated. This attribute has to be sent when acknowledging a signal. */
  date: Scalars['DateTime']['output'];
  /** Details about this signal */
  details: Array<StrongSignalDetail>;
  /** The device associated with the signal */
  device?: Maybe<Device>;
  /** A dismissal if the signal was dismissed. */
  dismissal?: Maybe<Dismissal>;
  /** Technical description of the signal meant for the engineer */
  engineerDescription: Scalars['String']['output'];
  /** The state of the strong signal. */
  engineerSorting: StrongSignalStateEnum;
  /** Human understandable explanation detailing this signal, trying to make it legible even by non technical users */
  explanation: Scalars['String']['output'];
  /** The ID of the signal in the backend. */
  id: Scalars['ID']['output'];
  /** The relevancy feedback of the signal. */
  relevancyFeedback?: Maybe<SignalRelevancyFeedback>;
  /** The reported height. */
  reportedHeight?: Maybe<Scalars['Float']['output']>;
  /** Human readable sub title detailing this signal */
  subtitle: Scalars['String']['output'];
  /** The thing associated with the signal */
  thing?: Maybe<Thing>;
  /** The thing name that emitted the signal. */
  thingName: Scalars['String']['output'];
  /** Human readable title for this signal */
  title: Scalars['String']['output'];
};


/** A leveling anomaly strong signal. */
export type LevelingAnomalyDetailsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A leveling anomaly strong signal. */
export type LevelingAnomalyEngineerDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A leveling anomaly strong signal. */
export type LevelingAnomalyExplanationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A leveling anomaly strong signal. */
export type LevelingAnomalySubtitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A leveling anomaly strong signal. */
export type LevelingAnomalyTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Link: */
export type Link = {
  __typename?: 'Link';
  /** An optional icon to be displayed before the label */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** How the link should be named in the UI */
  label?: Maybe<Scalars['String']['output']>;
  /** URL to navigate to */
  url?: Maybe<Scalars['String']['output']>;
};

/** The input for linking a SKU to a specific request item in a repair request */
export type LinkSkuToRequestItemInput = {
  /** The id of the part to link to the request item */
  partId: Scalars['String']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
  /** The id of the request item */
  requestItemId: Scalars['String']['input'];
};

/** Input to link tasks to a specific repair request */
export type LinkTasksToRepairRequestInput = {
  /** The id of the repair request where we want to link to tasks */
  repairRequestId: Scalars['ID']['input'];
  /** The ids of the tasks we want to link */
  taskIds: Array<Scalars['ID']['input']>;
};

/** ListenToDashboardFilter: Represents a filter on a dashboard level that this query listens to */
export type ListenToDashboardFilter = {
  __typename?: 'ListenToDashboardFilter';
  /** The dashboard filter ID to listen to */
  filterId: Scalars['String']['output'];
  /** Property to filter by on this query when given filter changes */
  queryField: Scalars['String']['output'];
};

/** The live status of the device, for example WORKING, STOPPED... */
export enum LiveDeviceStatus {
  CurrentlyEvaluating = 'CURRENTLY_EVALUATING',
  Stopped = 'STOPPED',
  Working = 'WORKING'
}

/**
 * The precise location of the building.
 * Contain the address, longitude / latitude points, the zipcode and the city
 */
export type Location = {
  __typename?: 'Location';
  /** The city where the building is */
  city: City;
  /** The Alpha2 code of the building (FR, GB) */
  countryCode: Scalars['String']['output'];
  /** The latitude (**Should be not optional in the future**) */
  latitude: Scalars['Float']['output'];
  /** The longitude (**Should be not optional in the future**) */
  longitude: Scalars['Float']['output'];
  /** The street address (eg: 96 rue de l'ascensoriste */
  streetAddress: Scalars['String']['output'];
  /** The zip code of the building location */
  zipcode: Scalars['String']['output'];
};

/** What a man-hour item is. The man-hour item of a repair request is an on-site item and the travel item attached to it, costed at the on-site item's hourly cost */
export enum ManHourKind {
  /** The time spent at the building working on the device */
  OnSite = 'ON_SITE',
  /** All the travel the job needs, outbound and return */
  Travel = 'TRAVEL'
}

export type ManHourRequestItem = RequestItem & {
  __typename?: 'ManHourRequestItem';
  /** If this requested item needs to be invoiced to the customer */
  chargeable?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the request item should be delivered from our supplier */
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The human identifier for a request (at the moment it is the id within airtable)
   * @deprecated Airtable is not used anymore. This field is deprecated and will be removed in the future.
   */
  humanId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** If the item is withdrawable by the engineer */
  isWithdrawable: Scalars['Boolean']['output'];
  kind: ManHourKind;
  /** The hours of this item alone */
  noOfHours: Scalars['Int']['output'];
  /** The on-site hours of the man-hour item */
  onSiteHours: Scalars['Int']['output'];
  /**
   * Comment of the ops about the requested item
   * @deprecated Comments are not found on individual parts anymore but on the request as a whole. Use RepairRequest.enginerComment or RepairRequest.internalComment
   */
  opsComment?: Maybe<Scalars['String']['output']>;
  /** Order progression data synced from Netsuite for this request item */
  orderProgression?: Maybe<RequestItemOrderProgression>;
  /** The on-site item of a travel item; null on an on-site item */
  parent?: Maybe<ManHourRequestItem>;
  /** The on-site item a travel item belongs to; null on an on-site item */
  parentRequestItemId?: Maybe<Scalars['ID']['output']>;
  /** Cost of the item (what we pay). This represents the company's cost for the item. Use sellPrice for the margin/sell price. Can be null if not set yet. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The quote line this item backs — a partition: an item belongs to at most one line (PRENG-7500) */
  quoteLine?: Maybe<QuoteLine>;
  repairRequestId: Scalars['ID']['output'];
  /**
   * Sell price of the item (separate from cost). Used for items that need to track separate cost and margin, such as Installation items. Can be null if not set.
   * @deprecated What the customer pays lives on QuoteLine.sellPrice (PRENG-7500); this is never written anymore
   */
  sellPrice?: Maybe<Scalars['Float']['output']>;
  /** Represent the state of the request item (should be used in place of status). Based on the type of the itemand its current data it return a state representing the next action to be done on a business point of view. */
  state?: Maybe<RequestItemState>;
  /**
   * Represent the status of the item in the repair flow
   * @deprecated Status is representing the status of the item in our legacy flow. Please use state instead, that represent
   */
  status: RepairRequestStatus;
  /** Optional URL towards a quote from one of our supplier for this part that we've used for pricing */
  supplierQuoteLink?: Maybe<Scalars['String']['output']>;
  /** On-site + travel hours: what the repair request shows, at the hourly cost */
  totalHours: Scalars['Int']['output'];
  /** The travel item of an on-site item; null on a travel item */
  travel?: Maybe<ManHourRequestItem>;
  /** The travel hours of the man-hour item; 0 on an item without travel, until its split is set */
  travelHours: Scalars['Int']['output'];
  /** Information about the withdrawal of the item by the engineer */
  withdrawal?: Maybe<Withdrawal>;
};

/** Payload to add a man hour item to a repair request */
export type ManHourRequestItemInput = {
  /** Number of on-site hours requested */
  noOfHours: Scalars['Float']['input'];
  /** The travel hours, at least 1. The device market's default travel hours when not given */
  travelHours?: InputMaybe<Scalars['Int']['input']>;
};

export type MapboxFeatureRepresentation = {
  __typename?: 'MapboxFeatureRepresentation';
  /** The tile id representing the building in mapbox */
  id: Scalars['Float']['output'];
};

/** Represents a mechanic and his informations */
export type Mechanic = User & {
  __typename?: 'Mechanic';
  CreateDashboardPdfQuery: Scalars['String']['output'];
  GetDashboardQuery: Dashboard;
  RunDashboardQuery: QueryResult;
  RunDrilldownQuery: QueryResult;
  accessibleBuildingsCount?: Maybe<Scalars['Float']['output']>;
  /** List of all buildings the mechanic can see */
  allVisibleBuildings: BuildingsBuildingConnection;
  /**
   * List of all missions the mechanic can see
   * @deprecated Use missions instead
   */
  allVisibleMissions: MissionsMissionConnection;
  /** Bank IBAN number */
  bankIban?: Maybe<Scalars['String']['output']>;
  /** List of buildings, for which the mechanic owns a contracts */
  buildings: BuildingsBuildingConnection;
  /** The company informations of the mechanic */
  company?: Maybe<MechanicCompany>;
  /** Name of the mechanic company */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Siret number of the mechanic company */
  companySiretNo?: Maybe<Scalars['String']['output']>;
  /** Type of company */
  companyType?: Maybe<CompanyType>;
  /**
   * Contracts of this mechanic
   * @deprecated Please use mechanic.buildings instead and access the edge for contract information
   */
  contracts: ContractsContractConnection;
  /** Country code is an ISO 3166-1 alpha-2 code that represents where the mechanic currently operates */
  countryCode: Scalars['String']['output'];
  /** Date the mech accepted our business conditions */
  dateBusinessConditionAccepted?: Maybe<Scalars['DateTime']['output']>;
  /** Date the mech accepted our general conditions */
  dateGeneralConditionAccepted?: Maybe<Scalars['DateTime']['output']>;
  /** Date the mech profile was approved */
  dateProfileApproved?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Renamed, use email instead */
  emailId: Scalars['String']['output'];
  /** Years of exeperience the mech has */
  experience?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasMaximize?: Maybe<Scalars['Boolean']['output']>;
  /** If the mech has a professional insurance cover */
  hasPrfsnInsuranceCover?: Maybe<Scalars['Boolean']['output']>;
  /** The Mechanic ID */
  id: Scalars['ID']['output'];
  intercomHashId: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** Set when this user is an alias merged into another user: the id of that user */
  mergedIntoUserId?: Maybe<Scalars['Int']['output']>;
  /** List of all missions the mechanic can see */
  missions: MissionsMissionConnection;
  mobileNo?: Maybe<Scalars['String']['output']>;
  /** Name of the bank where mechanic has account */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Name of the mech personal insurance */
  personalInsuranceName?: Maybe<Scalars['String']['output']>;
  /** Date from which the mec personal insurance starts */
  personalInsuranceStartFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Number of the insurance policy of the mech */
  personalPolicyNumber?: Maybe<Scalars['String']['output']>;
  /** Resolves the signed S3 URL to the picture of the Mechanic */
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** List of repair request, for which the mechanic owns a contract or is the requester */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  /** Name of the mech insurance for spare parts */
  sparePartsInsuranceName?: Maybe<Scalars['String']['output']>;
  /** Date from which the mec insurance for spares starts */
  sparePartsInsuranceStartFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Number of the insurance policy of the mech for spare parts */
  sparePartsPolicyNumber?: Maybe<Scalars['String']['output']>;
  subscriptionInfo: SubscriptionInfo;
  /** Teams in which the mechanic is a member, mechanics are not always part of a team. */
  teams?: Maybe<Array<MechanicTeam>>;
  /** Geographical zoning of the mechanic operations, */
  territory: Territory;
  /** Type of mechanic, default to REGULAR */
  type?: Maybe<MechanicType>;
  /**
   * User associated with the mechanic
   * @deprecated All user information are now embed in the Mechanic object
   */
  user: Mechanic;
  /** ID of the user associated with the mech */
  userId?: Maybe<Scalars['Float']['output']>;
};


/** Represents a mechanic and his informations */
export type MechanicCreateDashboardPdfQueryArgs = {
  query: CreateDashboardPdfForUserInput;
};


/** Represents a mechanic and his informations */
export type MechanicGetDashboardQueryArgs = {
  query: GetDashboardQueryInput;
};


/** Represents a mechanic and his informations */
export type MechanicRunDashboardQueryArgs = {
  query: RunDashboardQueryForUserInput;
};


/** Represents a mechanic and his informations */
export type MechanicRunDrilldownQueryArgs = {
  query: RunDrilldownQueryForUserInput;
};


/** Represents a mechanic and his informations */
export type MechanicAllVisibleBuildingsArgs = {
  filters?: InputMaybe<AllVisibleBuildingsForMechanicFilter>;
  pagination?: InputMaybe<BuildingsConnectionArgs>;
};


/** Represents a mechanic and his informations */
export type MechanicAllVisibleMissionsArgs = {
  filters?: InputMaybe<VisibleMissionsFilters>;
  order?: InputMaybe<Array<MissionsMissionOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


/** Represents a mechanic and his informations */
export type MechanicBuildingsArgs = {
  pagination?: InputMaybe<BuildingsConnectionArgs>;
};


/** Represents a mechanic and his informations */
export type MechanicContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a mechanic and his informations */
export type MechanicMissionsArgs = {
  filters?: InputMaybe<MechanicMissionsFilters>;
  order?: InputMaybe<Array<MissionsMissionOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


/** Represents a mechanic and his informations */
export type MechanicRepairRequestsArgs = {
  filters?: InputMaybe<RepairRequestForMechanicInputFilters>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};

/** Set of filters to apply to MechanicAvailabilities */
export type MechanicAvailabilitiesFilters = {
  /** Get only availabilities before suplied date (as availabilities are by day, we include the same day as supplied date) */
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Get only availabilities after suplied date (as availabilities are by day, we include the same day as supplied date) */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Get only MechanicAvailabilities belonging to a specific mechanic */
  mechanicId?: InputMaybe<Scalars['Int']['input']>;
};

export type MechanicAvailability = {
  __typename?: 'MechanicAvailability';
  /** If this special availability has been approved by WeMaintain or not */
  approved: Scalars['Boolean']['output'];
  /** Day on which the special availability is happening */
  date: Scalars['String']['output'];
  /** Mechanic linked to this special availability */
  mechanic: Mechanic;
  /**
   * Type of availability the mechanic can have :
   *     - FULL: The mechanic is working the whole day
   *     - MORNING: The mechanic will only work the first half of the day
   *     - AFTERNOON: The mechanic will only work the second half of the day
   *     - NONE: The mechanic is not available for regular tasks on this day
   *     - HOLIDAY: The mechanic is not available **at all** on this day
   */
  type: MechanicAvailabilityType;
};

/**
 * Describes a special availability of mechanic on a given day. This means the mechanic or WeMaintain
 * has decided that he will be on holiday/unavailable for the whole day, or only available for haf the day (see type for details)
 */
export enum MechanicAvailabilityType {
  Afternoon = 'AFTERNOON',
  Full = 'FULL',
  Holiday = 'HOLIDAY',
  Morning = 'MORNING',
  None = 'NONE'
}

/** Company details of a mechanic */
export type MechanicCompany = {
  __typename?: 'MechanicCompany';
  /** The unique identifier of the mechanic company */
  id: Scalars['ID']['output'];
};

/** Filters to apply when fetching mechanics */
export type MechanicFilters = {
  /** Filter mechanic by ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Include inactive mechanics */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not implemented yet. Filter mechanic that are in these teams (at least one team of the list) */
  teams?: InputMaybe<Array<MechanicTeam>>;
  /** Filter mechanic for given territories */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MechanicMembers = {
  __typename?: 'MechanicMembers';
  count?: Maybe<Scalars['Float']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
};

/** Filters to apply for mechanic.missions */
export type MechanicMissionsFilters = {
  /** Get only missions from the buildings of the specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions belonging to these buildings */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions that where completed between the a period */
  completedAt?: InputMaybe<RequiredDateFilter>;
  /** Get only missions from the buildings of the specified accounts */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by their deviceIds as long as the task is not completed */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by the status of its devices (as long as the task is not completed) */
  deviceStatuses?: InputMaybe<Array<DeviceStateStatus>>;
  /** If we want missions which were already done or not */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only missions where a task was done by one of the specified mechanics */
  doneByMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Fetch mission that are late (ie: they were done late or they are not done and their deadline has expired) */
  isLate?: InputMaybe<Scalars['Boolean']['input']>;
  /** If we want only missions which are urgent. */
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only missions belonging to one or many mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by the manager of the ops referent user on the building's contract. Given a list of user IDs, missions whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by referent user linked to the mission's building's contract */
  referentUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** used to filter by address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Get only the missions matching the given mission types */
  types?: InputMaybe<Array<TaskType>>;
  /** Order missions to show the Urgent one on top */
  urgentFirst?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MechanicOrderByInput = {
  count?: InputMaybe<OrderBy>;
  firstname?: InputMaybe<OrderBy>;
  lastname?: InputMaybe<OrderBy>;
};

/** The teams a mechanic can be in, for example Repair support (repairer team). */
export enum MechanicTeam {
  RepairSupport = 'REPAIR_SUPPORT',
  TechSupport = 'TECH_SUPPORT'
}

/** The type of the mechanic, default REGULAR */
export enum MechanicType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
  Regular = 'REGULAR'
}

export type MechanicWhereInput = {
  AND?: InputMaybe<Array<MechanicWhereInput>>;
  OR?: InputMaybe<Array<MechanicWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  firstname?: InputMaybe<StringFilter>;
  lastname?: InputMaybe<StringFilter>;
};

export type MechanicsConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MechanicsMechanicAvailabilityConnection = {
  __typename?: 'MechanicsMechanicAvailabilityConnection';
  edges: Array<MechanicsMechanicAvailabilityEdge>;
  pageInfo: MechanicsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type MechanicsMechanicAvailabilityEdge = {
  __typename?: 'MechanicsMechanicAvailabilityEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: MechanicAvailability;
};

export type MechanicsMechanicConnection = {
  __typename?: 'MechanicsMechanicConnection';
  edges: Array<MechanicsMechanicEdge>;
  pageInfo: MechanicsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type MechanicsMechanicEdge = {
  __typename?: 'MechanicsMechanicEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Mechanic;
};

export type MechanicsPageInfo = {
  __typename?: 'MechanicsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Kind of media stored (photo, video) */
export enum MediaKind {
  Photo = 'PHOTO',
  Video = 'VIDEO'
}

/** Mention: */
export type Mention = {
  __typename?: 'Mention';
  /** The id of the mentioned entity */
  entityId: Scalars['String']['output'];
  /** The type of the mentioned entity, e.g. "user" or "repair request", ..." */
  entityType: Scalars['String']['output'];
  /** The length of the mention in the text */
  length: Scalars['Int']['output'];
  /** The offset in the text where the mention starts, including the @ symbol */
  offset: Scalars['Int']['output'];
};

export type MentionInput = {
  /** The id of the mentioned entity */
  entityId: Scalars['String']['input'];
  /** The type of the mentioned entity, e.g. "user" or "repair request", ..." */
  entityType: Scalars['String']['input'];
  /** The length of the mention in the text */
  length: Scalars['Int']['input'];
  /** The offset in the text where the mention starts, including the @ symbol */
  offset: Scalars['Int']['input'];
};

/** Used when contextual informations have to be added on the input (ie the unit m/s) */
export type MetricInput = FormInput & FormThing & {
  __typename?: 'MetricInput';
  /** If set, means that changing this field would update 1<->1 to the corresponding key in the entity */
  entityKey?: Maybe<Scalars['String']['output']>;
  /** The identifier of this input, to be sent back to the backend */
  key?: Maybe<Scalars['String']['output']>;
  settings: MetricInputSettings;
  title: Scalars['String']['output'];
  /** Current value associated to the input */
  value?: Maybe<Scalars['ValueOfInput']['output']>;
};

/** Settings for validating and displaying a metric input field */
export type MetricInputSettings = IInputSettings & {
  __typename?: 'MetricInputSettings';
  /** If true, this input should not be editable */
  disabled: Scalars['Boolean']['output'];
  /** If true, only integers should be allowed */
  integer: Scalars['Boolean']['output'];
  /** If set, the value cannot be greater than this property */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** If set, the value cannot be lower than this property */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** If true, this input should be considered required */
  required: Scalars['Boolean']['output'];
  /** If true, only numbers > 0 should be allowed */
  strictlyPositive: Scalars['Boolean']['output'];
  /** Unit of measurement such as distance, volume, mass, time ect */
  unit: MetricUnits;
};

/** The measurement units we use on our devices */
export enum MetricUnits {
  Degree = 'DEGREE',
  Kilograms = 'KILOGRAMS',
  Meter = 'METER',
  MeterPerSecond = 'METER_PER_SECOND',
  Millimeter = 'MILLIMETER'
}

/** A mission represents a set of goals we want the mechanic to perform on a building before (or at) a specific time */
export type Mission = {
  __typename?: 'Mission';
  /** Building where the mission will take place */
  building: Building;
  /**
   * Indicates if a specific mechanic can start this mission or not
   * @deprecated Not used anymore post multi-engineers visits
   */
  canBeStartedByMechanic: Scalars['Boolean']['output'];
  /** Get related chunks for a mission. Omit the missionIds array filter. */
  chunks: MissionsChunkConnection;
  /** The completion date of the last completed task of the mission (equal to the completedAt of the last task of this mission) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Get the contract related to the mission */
  contract?: Maybe<Contract>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Delayed time in seconds for a mission:
   *      - For interventions: time between the mission has been started the
   *      first time and the contract deadline.
   *      - For maintainance:
   *        - When done: time between mission completion and the contract deadline.
   *        - Otherwise: time between the current date and the contract deadline.
   *
   *      Note: Is a positive number when the mission has been started/completed
   *      before or there is still time before the contract deadline, a negative
   *      number otherwise
   */
  delayedTime?: Maybe<Scalars['Float']['output']>;
  /** Date at which the mission was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A description of the mission, currently used for communication between the ops and the engineer */
  description?: Maybe<Scalars['String']['output']>;
  /** The device type of the devices targeted by this mission */
  deviceTypes: Array<DeviceTypeEnum>;
  /** If this mission is considered as done */
  done: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isLate?: Maybe<Scalars['Boolean']['output']>;
  /** An urgent mission will be displayed at the top of all missions, and must be done before all else during a visit */
  isUrgent: Scalars['Boolean']['output'];
  /** The issue that might have been the reason of this mission */
  issue?: Maybe<IssueSnapshot>;
  /** The mechanic responsible for this mission */
  mechanic: Mechanic;
  reportSentAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * signed URL to a report for the given mission, can be null if no report exists
   * Notes: This link expires after 7 days
   */
  reportUrl?: Maybe<Scalars['String']['output']>;
  /** Date at which the intervention was requested */
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Response time in seconds for a mission:
   *      - For interventions: time between the request has been made & the
   *      related mission has been started the first time.
   *      - For maintainance:
   *        - When done: time between mission creation & completion.
   *        - Otherwise: time between mission creation & the current date.
   */
  responseTime?: Maybe<Scalars['Float']['output']>;
  /** Time at which the mission was started (equal to the startedAt of the first visit involving this mission) */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Task we want performed during this mission. They are the objective of the mission */
  tasks: Array<Task>;
  /** @deprecated please use chunks instead */
  toBeDoneAt?: Maybe<Scalars['DateTime']['output']>;
  /** This mission needs to be done BEFORE this time */
  toBeDoneBefore: Scalars['DateTime']['output'];
  /** tasks have types to easily tell the mechanic in broad lines what he will be doing */
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Visits relating to this mission */
  visits: VisitsVisitConnection;
};


/** A mission represents a set of goals we want the mechanic to perform on a building before (or at) a specific time */
export type MissionCanBeStartedByMechanicArgs = {
  mechanicId: Scalars['Int']['input'];
};


/** A mission represents a set of goals we want the mechanic to perform on a building before (or at) a specific time */
export type MissionChunksArgs = {
  filters?: InputMaybe<ChunksFilters>;
  order?: InputMaybe<Array<MissionsChunkOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


/** A mission represents a set of goals we want the mechanic to perform on a building before (or at) a specific time */
export type MissionVisitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VisitsVisitOrmEntityOrderOptions>>;
};

/** Payload required for the creation of a mission */
export type MissionCreatePayload = {
  /** Building in which the mission will take place */
  buildingId: Scalars['Int']['input'];
  /** A description of the mission, currently used for communication between the ops and the engineer */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Devices concerned by the mission */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Elevators concerned by the mission
   * @deprecated Use deviceIds instead
   */
  elevatorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Mechanic who will do the mission */
  mechanicId: Scalars['Int']['input'];
  /** Date before which the mission must be done */
  toBeDoneBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Type of mission */
  type: TaskType;
};

/** Payload required for the soft deletion of a mission */
export type MissionDeletePayload = {
  /** Id of the mission to be soft deleted */
  id: Scalars['ID']['input'];
};

export type MissionMembers = {
  __typename?: 'MissionMembers';
  count?: Maybe<Scalars['Float']['output']>;
  startedAt?: Maybe<TimeDimension>;
};

export type MissionOrderByInput = {
  count?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
};

/** Payload for retieving a matching mission or creating one. Used only if no missionId. */
export type MissionPayload = {
  buildingId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Use deviceIds instead */
  elevatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mechanicId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export enum MissionSortableFields {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Done = 'done',
  Id = 'id',
  ReportSentAt = 'reportSentAt',
  RequestedAt = 'requestedAt',
  StartedAt = 'startedAt',
  ToBeDoneBefore = 'toBeDoneBefore',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type MissionWhereInput = {
  AND?: InputMaybe<Array<MissionWhereInput>>;
  OR?: InputMaybe<Array<MissionWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  startedAt?: InputMaybe<DateTimeFilter>;
};

export type MissionsChunkConnection = {
  __typename?: 'MissionsChunkConnection';
  edges: Array<MissionsChunkEdge>;
  pageInfo: MissionsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type MissionsChunkEdge = {
  __typename?: 'MissionsChunkEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Chunk;
};

export type MissionsChunkOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: ChunkSortableFields;
};

export type MissionsConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Set of filters to apply to the missions */
export type MissionsFilters = {
  /** Get only missions from the buildings of the specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions belonging to these buildings */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Return only missions that can be started by given mechanic ids */
  canBeStartedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions that where completed between the a period */
  completedAt?: InputMaybe<RequiredDateFilter>;
  /**
   * Get only missions from the buildings of the specified accounts
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by their deviceIds as long as the task is not completed */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by the status of its devices (as long as the task is not completed) */
  deviceStatuses?: InputMaybe<Array<DeviceStateStatus>>;
  /** If we want missions which were already done or not */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only missions where a task was done by one of the specified mechanics */
  doneByMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Fetch mission that are late (ie: they were done late or they are not done and their deadline has expired) */
  isLate?: InputMaybe<Scalars['Boolean']['input']>;
  /** If we want only missions which are urgent. */
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Get only missions belonging to a specific mechanic
   * @deprecated Use mechanicIds instead
   */
  mechanicId?: InputMaybe<Scalars['Int']['input']>;
  /** Get only missions belonging to one or many mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by the manager of the ops referent user on the building's contract. Given a list of user IDs, missions whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by referent user linked to the mission's building's contract */
  referentUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** used to filter by address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter missions by the location of the building (iso 3166-1 alpha-2 format: FR, EN) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only the missions matching the given mission types */
  types?: InputMaybe<Array<TaskType>>;
  /** Order missions to show the Urgent one on top */
  urgentFirst?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MissionsMissionConnection = {
  __typename?: 'MissionsMissionConnection';
  edges: Array<MissionsMissionEdge>;
  pageInfo: MissionsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type MissionsMissionEdge = {
  __typename?: 'MissionsMissionEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Mission;
};

export type MissionsMissionOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: MissionSortableFields;
};

export type MissionsPageInfo = {
  __typename?: 'MissionsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type MissionsTaskConnection = {
  __typename?: 'MissionsTaskConnection';
  edges: Array<MissionsTaskEdge>;
  pageInfo: MissionsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type MissionsTaskEdge = {
  __typename?: 'MissionsTaskEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Task;
};

export type MissionsTaskOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: TaskSortableFields;
};

export type MonitoringConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MonitoringNotificationConnection = {
  __typename?: 'MonitoringNotificationConnection';
  edges: Array<MonitoringNotificationEdge>;
  pageInfo: MonitoringPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type MonitoringNotificationEdge = {
  __typename?: 'MonitoringNotificationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type MonitoringNotificationGqlConnection = {
  __typename?: 'MonitoringNotificationGQLConnection';
  edges: Array<MonitoringNotificationGqlEdge>;
  pageInfo: MonitoringPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type MonitoringNotificationGqlEdge = {
  __typename?: 'MonitoringNotificationGQLEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type MonitoringNotificationOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: NotificationOrmEntitySortableFields;
};

export type MonitoringPageInfo = {
  __typename?: 'MonitoringPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type MonthlyDeviceCostsMembers = {
  __typename?: 'MonthlyDeviceCostsMembers';
  accountIds?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  costSum?: Maybe<Scalars['Float']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<TimeDimension>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type MonthlyDeviceCostsOrderByInput = {
  accountIds?: InputMaybe<OrderBy>;
  amount?: InputMaybe<OrderBy>;
  buildingId?: InputMaybe<OrderBy>;
  costSum?: InputMaybe<OrderBy>;
  countryCode?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  deviceType?: InputMaybe<OrderBy>;
  month?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  year?: InputMaybe<OrderBy>;
};

export type MonthlyDeviceCostsWhereInput = {
  AND?: InputMaybe<Array<MonthlyDeviceCostsWhereInput>>;
  OR?: InputMaybe<Array<MonthlyDeviceCostsWhereInput>>;
  accountIds?: InputMaybe<StringFilter>;
  amount?: InputMaybe<FloatFilter>;
  buildingId?: InputMaybe<StringFilter>;
  costSum?: InputMaybe<FloatFilter>;
  countryCode?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  customerId?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deviceId?: InputMaybe<StringFilter>;
  deviceType?: InputMaybe<StringFilter>;
  month?: InputMaybe<FloatFilter>;
  type?: InputMaybe<StringFilter>;
  year?: InputMaybe<FloatFilter>;
};

/** Type of motor used to open the door */
export enum MotorType {
  Ate_16Record = 'ATE_16_RECORD',
  Ate_20_200Record = 'ATE_20_200_RECORD',
  Ate_20Record = 'ATE_20_RECORD',
  Ate_21Record = 'ATE_21_RECORD',
  BftLuxB = 'BFT_LUX_B',
  BftLuxR = 'BFT_LUX_R',
  BftUx_2B = 'BFT_UX_2B',
  BrushlessOptima_100Softica = 'BRUSHLESS_OPTIMA_100_SOFTICA',
  BrushlessOptima_150Softica = 'BRUSHLESS_OPTIMA_150_SOFTICA',
  CameAti = 'CAME_ATI',
  SlaGilgen = 'SLA_GILGEN',
  SlmGilgen = 'SLM_GILGEN',
  SlxMoget_2Gilgen = 'SLX_MOGET_2_GILGEN',
  Sl_35Gilgen = 'SL_35_GILGEN',
  SoftipowerLightGalinoSoftica = 'SOFTIPOWER_LIGHT_GALINO_SOFTICA',
  SoftipowerOptima_100Softica = 'SOFTIPOWER_OPTIMA_100_SOFTICA',
  SoftipowerOptima_150Softica = 'SOFTIPOWER_OPTIMA_150_SOFTICA'
}

/** Move a set of sources to a problem input */
export type MoveSourcesInput = {
  /** The source external ids of the sources to move */
  sourceExternalIds: Array<Scalars['ID']['input']>;
  /** The id of the problem to move the sources to */
  targetProblemId: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeSignal: StrongSignal;
  /** Add a note to the building */
  addBuildingNote: BuildingNote;
  /** Add an external part item to a repair request */
  addExternalPartItem: RequestItem;
  /** Add an installation item to a repair request (quantity is always 1) */
  addInstallationItem: RequestItem;
  /** Add man hours to a repair request */
  addManHours: RequestItem;
  /** Add a part item to a repair request */
  addPartItem: RequestItem;
  /**
   * Mark as fixed the insurance items of a problem (validated and qualified as included or not
   * included in contract), on behalf of a mechanic. Not applicable items are skipped.
   * Refused when an item of the problem is already fixed.
   * When linked to the task the items were fixed in, the mechanic and the fixed-on date are the task's
   * done-by mechanic and completion date. The task must be done, on the problem's device, of a type with
   * work on site, and completed after every item was discovered.
   */
  adminFixProblemAuditReportLines: Array<AuditReportLine>;
  annotateState: Annotation;
  /**
   * Submit one or several answers while on a visit.
   * When an answer is modified, the new answer should have a answeredAt more recent than the older,
   * Else the answer will be ignored
   * Each updated choices of photos, older choices and photos will be replace by the new ones.
   */
  answerTasks: Array<Answer>;
  /** Price to target (S6): applies the proposal of `Quote.priceToTargetPreview`. Send the preview's quoteVersion and no price: the backend recomputes the proposal at that version and writes its new unit prices as ordinary line updates, recording who applied it and when. Prices stay editable. Rejected with QuoteVersionMovedError when the quote changed since the preview, QuoteNotADraftError past DRAFT, and PriceToTargetNothingToApplyError when no price would change. */
  applyPriceToTarget: Quote;
  /** Approve an enrolment request: the identity gets the access it asked for */
  approveEnrolmentRequest: EnrolmentRequest;
  /** Creates a Zip archive of all the reports of the provided missions/tasks */
  archiveReports: Scalars['String']['output'];
  /** Set an AuditOfficeIdentity for a device */
  assignAuditOfficeIdentityForDevice: AuditOfficeIdentity;
  /** Assign the mechanic of a mission */
  assignMechanicToMission: Scalars['Boolean']['output'];
  /** Assigns mechanics to missions from spreadsheet. You need to open the spreadsheet to "anyone with the link", name the sheet "ASSIGNATIONS" and have two columns representing the mission id and the mechanic id named Mission and Mechanic */
  assignMechanicsToMissionsFromSheet: Scalars['Boolean']['output'];
  /** Assign an existing photo to an answer */
  assignMediaToAnswer: AnswerPhoto;
  batchCollectParts: Array<RepairRequest>;
  /** Cancel issues */
  cancelIssues: CancelIssuesResult;
  /** Cancels a repair request */
  cancelRepairRequest: Scalars['Boolean']['output'];
  /** Change the chargeable status of a repair request */
  changeRepairRequestChargeableStatus: Scalars['Boolean']['output'];
  /** Change the delivery address of a repair request */
  changeRepairRequestDeliveryOption: Scalars['Boolean']['output'];
  /** Change the receiver of a repair request */
  changeRepairRequestReceiver: RepairRequest;
  /**
   * Change the price of a request item
   * @deprecated Use setRequestItemPricing instead to set both cost and sell price
   */
  changeRequestItemPrice: Scalars['Boolean']['output'];
  /** Change the quantity of a request item */
  changeRequestItemQuantity: Scalars['Boolean']['output'];
  /** Change the receiver of a repair request */
  changeUrgencyLevel: RepairRequest;
  /** Chase an open action, late or not, whoever holds it: @-mention someone on the work order feed with the comment (or a default line), and set when to look again. The step is not late before then, and shows in Chased me for whoever was asked. It never changes who acts. Throws ActionNotOpenError when it is no longer open, CannotFindActionError when the request has no such action, ChasedUserRequiredError without toUserId on a step that does not wait on the customer or a supplier, ChaseDeadlineNotInFutureError on a deadline that has passed, ValidationDomainError on an input the schema refuses (a comment too long), and FeatureDisabled when the action center is off for the caller. */
  chaseRepairRequestAction: RepairRequestAction;
  commentActivity: Comment;
  commentOnFeed: Activity;
  /** Adds or modifies a comment on a repair request */
  commentRepairRequest: Scalars['Boolean']['output'];
  /** Mark one or more task as having been completed during the current active visit */
  completeTasks: Array<CompletedTask>;
  /** Adds a new report line to a report and saves it */
  createAuditReportLine: AuditReportLine;
  /** Create a new chunk for a given mission */
  createChunk: Chunk;
  /** Add a new contact for a building */
  createContact: Contact;
  /** Create a mission. */
  createMission: Mission;
  createQuestion: QuestionTemplate;
  /** Mints a local draft quote attached to the given work orders (PRENG-7500). Create-only (no find-or-create — read the existing quote through the graph first). Author lines with setQuoteLines, push with syncQuoteToSalesforce. */
  createQuote: Quote;
  /** Create a quote for a repair request */
  createQuoteForWorkOrder: RepairRequest;
  /** Create a repair request without request items */
  createRepairRequest: RepairRequest;
  /** Create a Sales order for the repair request */
  createSalesOrder: Scalars['Boolean']['output'];
  /**
   * Delete the given AuditReport,
   * When the report is in a deletable status,
   * And the associated lines are in a deletable status
   */
  deleteAuditReport: Scalars['Boolean']['output'];
  /**
   * Delete a report line from a report:
   *     - As a transcriber, only report lines which are ready for validation.
   *     - As an admin, all except for fixed report lines.
   */
  deleteAuditReportLine: Scalars['String']['output'];
  /** Delete a note from the building */
  deleteBuildingNote: Scalars['Boolean']['output'];
  /** Delete the chunk with the given id and the associated mission if need be */
  deleteChunk?: Maybe<Chunk>;
  /** Deletes the given contact */
  deleteContact: Scalars['Int']['output'];
  /** Soft delete all invoice items matching filter */
  deleteInvoiceItems: Scalars['Boolean']['output'];
  /** Soft delete a given mission and its related tasks/chunks. */
  deleteMission: Mission;
  /**
   * Soft delete a given task and its related mission when no other task remains.
   *     In the case of all remaining tasks being finished, we mark the related mission as completed.
   */
  deleteTask: Task;
  /** Discard an open action, whoever holds it: it doesn't need doing. It stays closed while the request still calls for that step. Throws ActionNotOpenError when it is no longer open, CannotFindActionError when the request has no such action, ValidationDomainError on an input the schema refuses (a reason too long), and FeatureDisabled when the action center is off for the caller. */
  discardRepairRequestAction: RepairRequestAction;
  dismissSignal: StrongSignal;
  ensureAuditReportLineOnDummyReport: AuditReportLine;
  /** Force complete a repair request */
  forceRepairRequestCompletion: Scalars['Boolean']['output'];
  /** Send a notification with an unique token to update password */
  forgotPassword: Scalars['Boolean']['output'];
  /** Generate a Client Activity Report for the building, returning the link to download it */
  generateClientActivityReport: Scalars['String']['output'];
  /** Generate a report Defect Certificate for a specific audit report */
  generateDefectReportCertificate: Scalars['String']['output'];
  /** Generate a device car.parachute component certificate for a specific device (only works for car.parachute due to front limitation for now) */
  generateDeviceComponentCertificate: Scalars['String']['output'];
  /** Generate the invoicing csv file for netsuite invoicing of external engineers */
  generateInvoicingCsvForNetsuite: Scalars['String']['output'];
  generateQuote: InvoiceItem;
  /** Hand an open action over to another user, with a note: it leaves the caller's Mine to move and lands in the receiver's, whatever the unit, and the receiver is @-mentioned on the work order feed. The caller becomes the giver: it's in their Waiting on others, and they can take it back. The receiver can hand it on, becoming the giver. Its normal duration counts from the hand-over, and a hold on it ends. Throws CannotHandBackToGiverError when handed back to the giver, ActionAlreadyHandedToUserError when handed to whoever has it, ActionNotOpenError when it is no longer open, CannotFindActionError when the request has no such action, ValidationDomainError on an input the schema refuses (a blank or too long note), and FeatureDisabled when the action center is off for the caller. */
  handOverRepairRequestAction: RepairRequestAction;
  /** Identify device by calling an action */
  identifyDevice: Device;
  /** Off production: sign in as an internal user (admin or mechanic), creating it in the internal Clerk app if needed. Null in production. */
  impersonateUser?: Maybe<ImpersonationToken>;
  /**
   * Updates the elevator matchings,
   *     uploads the reportPdf,
   *     and saves the new AuditReport to the db
   */
  importAuditReport: AuditReport;
  /** Admin operation to re-hydrate the questionGroups asked to the mechanics */
  importQuestionGroups: ImportQuestionGroupsResponse;
  /** Install a thing on a device, and provide the Setup information. Multiple thing can be installed on the same device. If the given thing name is already installed on another device it will be moved to the requested device, with the new setup information */
  installThing: Thing;
  /** Register last activity sent from the mechanic during his visit */
  keepVisitAlive: Scalars['Boolean']['output'];
  /** Allows changing the sku of a given request item to another one */
  linkSKUToRequestItem: Scalars['Boolean']['output'];
  /** Link tasks to repair request, tasks where work about the repair took place. */
  linkTasksToRepairRequest: Scalars['Boolean']['output'];
  login: AccessTokenResponse;
  loginAsUser: AccessTokenResponse;
  /** Mark an open action done, whoever holds it. It stays closed while the request still calls for that step. Throws ActionNotOpenError when it is no longer open, CannotFindActionError when the request has no such action, ValidationDomainError on an input the schema refuses (a reason too long), and FeatureDisabled when the action center is off for the caller. */
  markRepairRequestActionDone: RepairRequestAction;
  /** Move a set of sources to a problem. */
  moveSourcesToProblem: Problem;
  notifyTicketEvent: Scalars['Boolean']['output'];
  /**
   * Pause the device (if not already paused), a paused device does not count in availability rate.
   *     Optional: a date can be provided to pause a device at a specific time.
   */
  pauseDevice: Scalars['Boolean']['output'];
  /** Pick up a part request item */
  pickUpRequestItem: RequestItem;
  prepareUpload: Scalars['String']['output'];
  /**
   * Propagate fixed status to ongoing audit report lines in a problem that has fixed lines.
   * It will use the first found fixed audit report line as reference to mark as fixed all other ongoing audit report lines
   * in the same problem.
   */
  propagateFixedStatusToProblemAuditReportLines: Scalars['Boolean']['output'];
  /** Put an open action on hold until a date, with a note, whoever holds it. It stays its holder's, in their Waiting on others, and is neither late nor To chase before the date. It comes back to Mine to move on the date, on releaseRepairRequestActionFromHold, or when someone changes the work order. Putting it on hold again replaces the date and the note, and records nothing when both are unchanged. Throws ActionNotOpenError when it is no longer open, CannotFindActionError when the request has no such action, HoldUntilNotInFutureError on a date that has passed, HoldUntilTooLateError on a date past holdLatestUntil, ValidationDomainError on an input the schema refuses (a blank or too long note), and FeatureDisabled when the action center is off for the caller. */
  putRepairRequestActionOnHold: RepairRequestAction;
  /** Refresh an Access Token using your userId and the Refresh Token you got during login. */
  refreshToken: AccessTokenResponse;
  /** Refuse a proposed quote */
  refuseQuote: Scalars['String']['output'];
  /** Regenerate PDF reports */
  regenReport: RegenedReport;
  /** Register the deviceToken linked to the device of a user for push notification purpose */
  registerPushNotificationToken: Scalars['Boolean']['output'];
  /** Reject an enrolment request, for good */
  rejectEnrolmentRequest: EnrolmentRequest;
  /** Release an action on hold before its date: it is back from hold now, in Mine to move, due after its normal duration from now. Throws ActionNotOnHoldError when it is not on hold (its date passed, or a change to the work order ended it), ActionNotOpenError when it is no longer open, CannotFindActionError when the request has no such action, and FeatureDisabled when the action center is off for the caller. */
  releaseRepairRequestActionFromHold: RepairRequestAction;
  /** Off production: remove from the internal Clerk dev instance a user that impersonation created. False when there was none. */
  removeImpersonationTarget: Scalars['Boolean']['output'];
  /** Remove an item from the request */
  removeRequestItem: Scalars['Boolean']['output'];
  /** Remove a thing from a device. And returns the thing id */
  removeThing: Scalars['ID']['output'];
  /** Assign an expert (mechanic) to a repair request support request item (tech / repair support) */
  repairRequestAssignExpertToSupportItem: Scalars['Boolean']['output'];
  /** Assigns a given quote to a given repair request */
  repairRequestAssignQuote: RepairRequest;
  /** Change the fact that the repair request will be done by subcontractors or internally */
  repairRequestChangeSubcontractedStatus: Scalars['Boolean']['output'];
  /** Delete subcontractor reports from a repair request */
  repairRequestDeleteSubcontractorReports: Scalars['Boolean']['output'];
  /** Marked the repair request for a new follow up visit. The engineer has already do at least one visit and state that the repair was done but we need more details or to go on site again. */
  repairRequestRedoFieldExecution: Scalars['Boolean']['output'];
  /** Link or unlink a subcontractor netsuite purchase order link to the repair request. The request needs to be subcontracted to be able to add a PO. */
  repairRequestUpdateSubcontractorPurchaseOrderLink: Scalars['Boolean']['output'];
  /** Upload subcontractor reports about the repair work that has been done */
  repairRequestUploadSubcontractorReports: Scalars['Boolean']['output'];
  /** Request some support for a repair request. It means you will need the help of the repair support team or the tech support team to acheive this repair */
  requestSupportForRepairRequest: Scalars['Boolean']['output'];
  /** The review of an overtime request by an ops to approve or reject it or override some of its properties. */
  reviewOvertime: Overtime;
  /** Submits a score (feedback) for an LLM response. */
  scoreLlmResponse: Scalars['Boolean']['output'];
  /** Send a title/body to all the devices of a given user through push notification. Only works for mobile users currently */
  sendPushNotification: PushNotificationStatus;
  /** Set the on-site and travel hours of a man-hour item, in one operation. An item without travel gets its travel item when travel hours are given */
  setManHourSplit: ManHourRequestItem;
  /** Sets the discount on the total of a draft quote, a ratio: 0 ≤ discountRate < 1 (0.2, not 20), 0 clears it. Send the Quote.version it was set on. The margin readout and Price to target then work on the value after it; Salesforce still receives the prices before it. Rejected with QuoteVersionMovedError when the quote changed since quoteVersion, QuoteNotADraftError past DRAFT and InvalidQuoteDiscountError out of range. */
  setQuoteDiscount: Quote;
  /** Wholesale replace of a draft quote's authored composition: lines AND deliberately not-quoted items — each array is the whole truth: a line omitted is deleted, an exclusion omitted is revoked. Also authors the wording: optional titleLabel and description are sent to Salesforce on push. The draft comes from createQuote; refused once the quote status left DRAFT. */
  setQuoteLines: Quote;
  /** Set both cost and sell price of a request item */
  setRequestItemPricing: Scalars['Boolean']['output'];
  /** Soft delete a given visit and its related visit tasks */
  softDeleteVisit: Scalars['Boolean']['output'];
  /** Send vendor email for request items */
  sourceItemVendorEmail: Scalars['Boolean']['output'];
  /**
   * Start one or more missions for a visit.
   * A mechanic can have only one visit simultaneously.
   */
  startMissions: StartedMissions;
  /**
   * Makes the current mechanic leaves its current visit if it has any.
   * When the mechanic is the principal of the visit, it will be marked as completed
   */
  stopMission: Scalars['Boolean']['output'];
  summarizeShutdown: Inference;
  /** Switch the work-order type of a repair request */
  switchWorkOrderType: RepairRequest;
  /** Pushes a locally-authored draft to Salesforce: the quote's lines are the entire payload (PRENG-7500). Re-runnable while the Salesforce quote is still a draft, re-syncing the lines onto the same quote; past draft it rejects. */
  syncQuoteToSalesforce: Quote;
  /** Take a hand-over back: the action's rule holder acts on it again, due as it was before the hand-over, so it can be late at once. A hold the receiver put on it ends. Throws ActionNotHandedOverError when it is not handed over (taken back already, or the step moved on), ActionNotOpenError when it is no longer open, CannotFindActionError when the request has no such action, and FeatureDisabled when the action center is off for the caller. */
  takeBackRepairRequestAction: RepairRequestAction;
  /** Unlink a source from a problem. */
  unlinkSourceFromProblem: Problem;
  /** Unlink wrongly tasks that have been linked to the repair request. */
  unlinkTasksFromRepairRequest: Scalars['Boolean']['output'];
  /**
   * Unpause the device (if it's paused), a paused device does not count in availability rate.
   *     Optional: a date can be provided to unpause a device at a specific time.
   */
  unpauseDevice: Scalars['Boolean']['output'];
  /** Unregister the deviceToken linked to the device of a user for push notification purpose */
  unregisterPushNotificationToken: Scalars['Boolean']['output'];
  /** Updates the auditReport status */
  updateAuditReport: AuditReport;
  /**
   * Updates a report line.
   *     Admins can modify any of the properties in the payload.
   *     Transcribers can only modify content, deviceId and discoveredAt
   * @deprecated Use `updateAuditReportLines` mutation for more flexibility
   */
  updateAuditReportLine: AuditReportLine;
  /**
   * Updates multiple report line.
   *     Admins can modify any of the properties in the payload.
   *     Transcribers can only modify content, deviceId and discoveredAt
   */
  updateAuditReportLines: UpdateAuditReportLinesResponse;
  /**
   * Update the buildign infos.
   *
   * **NOT IMPLEMENTED**
   * * Should have differents permissions between CUSTOMER / MECHANIC / ADMIN (currently, this mutation is only for a mechanic)
   */
  updateBuilding: Building;
  /** Update an existing contact */
  updateContact: Contact;
  /** Update one elevator */
  updateElevator: Elevator;
  updateInvoiceItem: InvoiceItem;
  /** Updates the user password if the old password is given */
  updatePassword: Scalars['Boolean']['output'];
  /** Updates user's password if a good token provided. Throws otherwise. */
  updatePasswordWithToken: Scalars['Boolean']['output'];
  updatePlan: BuildingPlan;
  /** Update the list of issues linked to a repair request. This will automatically link new issues and unlink removed ones. */
  updateRepairRequestIssues: Scalars['Boolean']['output'];
  /** Update the title of a repair request */
  updateRepairRequestTitle: RepairRequest;
  /** Update the given thing setup information. */
  updateThingSetup: Thing;
  /**
   * Update the blocklist of buildings and/or devices for a user.
   * Use BlocklistAction.ADD to block access and BlocklistAction.REMOVE to restore it.
   */
  updateUserBlocklist: UpdateUserBlocklistResponse;
  /**
   * Update the blocklist of buildings and/or devices for a user.
   * Use BlocklistAction.ADD to block access and BlocklistAction.REMOVE to restore it.
   * @deprecated Use updateUserBlocklist instead, which can update both building and device blocklists in a single request
   */
  updateUserBuildingBlocklistAssociation: UpdateUserBlocklistResponse;
  /**
   * Upload a photo linked to a given Task and QuestionTemplate
   * @deprecated Use prepareUpload in combination with assignPhotoToAnswer after uploading the photo to S3 directly
   */
  uploadPhoto: AnswerPhoto;
  /** Upload a signed quote document to SF */
  uploadSignedQuote: Scalars['String']['output'];
  /** Attach and/or detach repair requests to/from an existing Salesforce quote. Returns all affected repair requests. */
  upsertQuoteWorkOrders: Array<RepairRequest>;
  /** Validate that the repair request work has been done on the field by the engineer. */
  validateRepairRequestFieldExecution: Scalars['Boolean']['output'];
  /**
   * Creates a Zip archive of all the reports of all the missions provided as input
   * @deprecated DEPRECATED: Use archiveReports(reports: { missionIds }) instead
   */
  zipReportOfMissions: Scalars['String']['output'];
  /**
   * Creates a Zip archive of all the reports of all the tasks provided as input
   * @deprecated DEPRECATED: Use archiveReports(reports: { taskIds }) instead
   */
  zipReportOfTasks: Scalars['String']['output'];
};


export type MutationAcknowledgeSignalArgs = {
  input: AcknowledgeSignalInput;
};


export type MutationAddBuildingNoteArgs = {
  payload: BuildingNoteCreateInput;
};


export type MutationAddExternalPartItemArgs = {
  input: AddExternalPartItemInput;
};


export type MutationAddInstallationItemArgs = {
  input: AddInstallationItemInput;
};


export type MutationAddManHoursArgs = {
  input: AddManHourItemInput;
};


export type MutationAddPartItemArgs = {
  input: AddPartItemInput;
};


export type MutationAdminFixProblemAuditReportLinesArgs = {
  args: AdminFixProblemAuditReportLinesInput;
};


export type MutationAnnotateStateArgs = {
  payload: AnnotationInput;
};


export type MutationAnswerTasksArgs = {
  answers: Array<AnswerTaskInput>;
};


export type MutationApplyPriceToTargetArgs = {
  input: ApplyPriceToTargetInput;
};


export type MutationApproveEnrolmentRequestArgs = {
  id: Scalars['ID']['input'];
  sfAccountId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveReportsArgs = {
  reports: ArchiveReportsInput;
};


export type MutationAssignAuditOfficeIdentityForDeviceArgs = {
  deviceId: Scalars['ID']['input'];
  office: AuditOffice;
  vendorId: Scalars['String']['input'];
};


export type MutationAssignMechanicToMissionArgs = {
  mechanicId: Scalars['ID']['input'];
  missionId: Scalars['ID']['input'];
};


export type MutationAssignMechanicsToMissionsFromSheetArgs = {
  spreadsheetId: Scalars['ID']['input'];
};


export type MutationAssignMediaToAnswerArgs = {
  payload: AssignMediaToAnswerInput;
};


export type MutationBatchCollectPartsArgs = {
  input: BatchCollectPartsInput;
};


export type MutationCancelIssuesArgs = {
  filters: CancelIssuesInput;
};


export type MutationCancelRepairRequestArgs = {
  repairRequestId: Scalars['String']['input'];
};


export type MutationChangeRepairRequestChargeableStatusArgs = {
  payload: ChangeRepairRequestChargeableStatusInput;
};


export type MutationChangeRepairRequestDeliveryOptionArgs = {
  payload: ChangeRepairRequestDeliveryOptionInput;
};


export type MutationChangeRepairRequestReceiverArgs = {
  receiverId: Scalars['String']['input'];
  repairRequestId: Scalars['String']['input'];
};


export type MutationChangeRequestItemPriceArgs = {
  payload: ChangeRequestItemPriceInput;
};


export type MutationChangeRequestItemQuantityArgs = {
  payload: ChangeRequestItemQuantityInput;
};


export type MutationChangeUrgencyLevelArgs = {
  payload: ChangeRepairRequestUrgencyLevelInput;
};


export type MutationChaseRepairRequestActionArgs = {
  input: ChaseRepairRequestActionInput;
};


export type MutationCommentActivityArgs = {
  input: CommentActivityInput;
};


export type MutationCommentOnFeedArgs = {
  input: CommentOnFeedInput;
};


export type MutationCommentRepairRequestArgs = {
  payload: CommentRepairRequestInput;
};


export type MutationCompleteTasksArgs = {
  completedTasks: Array<CompletedTaskInput>;
};


export type MutationCreateAuditReportLineArgs = {
  payload: CreateAuditReportLinePayload;
};


export type MutationCreateChunkArgs = {
  missionId?: InputMaybe<Scalars['String']['input']>;
  missionPayload?: InputMaybe<MissionPayload>;
  payload: ChunkInput;
};


export type MutationCreateContactArgs = {
  buildingId: Scalars['Int']['input'];
  payload: ContactInput;
};


export type MutationCreateMissionArgs = {
  payload: MissionCreatePayload;
};


export type MutationCreateQuestionArgs = {
  question: CreateQuestionInput;
};


export type MutationCreateQuoteArgs = {
  workOrderIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateQuoteForWorkOrderArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type MutationCreateRepairRequestArgs = {
  payload: CreateRepairRequestInput;
};


export type MutationCreateSalesOrderArgs = {
  repairRequestId: Scalars['String']['input'];
};


export type MutationDeleteAuditReportArgs = {
  auditReportId: Scalars['String']['input'];
};


export type MutationDeleteAuditReportLineArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBuildingNoteArgs = {
  payload: BuildingNoteDeleteInput;
};


export type MutationDeleteChunkArgs = {
  chunkId: Scalars['String']['input'];
};


export type MutationDeleteContactArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvoiceItemsArgs = {
  filters: DeleteInvoiceItemsFilters;
};


export type MutationDeleteMissionArgs = {
  payload: MissionDeletePayload;
};


export type MutationDeleteTaskArgs = {
  payload: TaskDeletePayload;
};


export type MutationDiscardRepairRequestActionArgs = {
  input: CloseRepairRequestActionInput;
};


export type MutationDismissSignalArgs = {
  input: DismissSignalInput;
};


export type MutationEnsureAuditReportLineOnDummyReportArgs = {
  payload: EnsureAuditReportLineCommandInput;
};


export type MutationForceRepairRequestCompletionArgs = {
  repairRequestId: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateClientActivityReportArgs = {
  buildingId: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  overrideGenerationUrl?: InputMaybe<Scalars['String']['input']>;
  period: ClientActivityReportPeriod;
};


export type MutationGenerateDefectReportCertificateArgs = {
  auditReportId: Scalars['ID']['input'];
};


export type MutationGenerateDeviceComponentCertificateArgs = {
  payload: DeviceComponentCertificateInputPayload;
};


export type MutationGenerateInvoicingCsvForNetsuiteArgs = {
  payload: InvoicingCsvForNetsuiteInput;
};


export type MutationGenerateQuoteArgs = {
  invoiceItemId: Scalars['Int']['input'];
};


export type MutationHandOverRepairRequestActionArgs = {
  input: HandOverRepairRequestActionInput;
};


export type MutationIdentifyDeviceArgs = {
  action: IdentifyDeviceAction;
};


export type MutationImpersonateUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationImportAuditReportArgs = {
  payload: ImportReportPayload;
};


export type MutationImportQuestionGroupsArgs = {
  groupNames: Array<Scalars['String']['input']>;
};


export type MutationInstallThingArgs = {
  deviceId: Scalars['String']['input'];
  setup: ThingsSetupInput;
  thingName: Scalars['String']['input'];
};


export type MutationKeepVisitAliveArgs = {
  lastActivity: Scalars['DateTime']['input'];
};


export type MutationLinkSkuToRequestItemArgs = {
  payload: LinkSkuToRequestItemInput;
};


export type MutationLinkTasksToRepairRequestArgs = {
  payload: LinkTasksToRepairRequestInput;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginAsUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationMarkRepairRequestActionDoneArgs = {
  input: CloseRepairRequestActionInput;
};


export type MutationMoveSourcesToProblemArgs = {
  args: MoveSourcesInput;
};


export type MutationNotifyTicketEventArgs = {
  ticket: NotifyTicketEventInput;
};


export type MutationPauseDeviceArgs = {
  payload: DevicePauseInput;
};


export type MutationPickUpRequestItemArgs = {
  input: PickUpRequestItemInput;
};


export type MutationPrepareUploadArgs = {
  payload: PrepareUploadInput;
};


export type MutationPropagateFixedStatusToProblemAuditReportLinesArgs = {
  args: PropagateFixedStatusToProblemLinesInput;
};


export type MutationPutRepairRequestActionOnHoldArgs = {
  input: PutRepairRequestActionOnHoldInput;
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRefuseQuoteArgs = {
  quoteId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRegenReportArgs = {
  payload: RegenReportPayload;
};


export type MutationRegisterPushNotificationTokenArgs = {
  payload: RegisterPushNotificationTokenPayload;
};


export type MutationRejectEnrolmentRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReleaseRepairRequestActionFromHoldArgs = {
  input: ReleaseRepairRequestActionFromHoldInput;
};


export type MutationRemoveImpersonationTargetArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRemoveRequestItemArgs = {
  payload: RemoveItemInput;
};


export type MutationRemoveThingArgs = {
  thing: RemoveThingInput;
};


export type MutationRepairRequestAssignExpertToSupportItemArgs = {
  payload: RepairRequestAssignExpertToSupportItemInput;
};


export type MutationRepairRequestAssignQuoteArgs = {
  input: AssignQuoteOnRepairRequestInput;
};


export type MutationRepairRequestChangeSubcontractedStatusArgs = {
  payload: ChangeRepairRequestSubcontractedStatusInput;
};


export type MutationRepairRequestDeleteSubcontractorReportsArgs = {
  payload: RepairRequestDeleteSubcontractorReportsInput;
};


export type MutationRepairRequestRedoFieldExecutionArgs = {
  repairRequestId: Scalars['ID']['input'];
};


export type MutationRepairRequestUpdateSubcontractorPurchaseOrderLinkArgs = {
  payload: RepairRequestUpdateSubcontractorPurchaseOrderLinkInput;
};


export type MutationRepairRequestUploadSubcontractorReportsArgs = {
  payload: RepairRequestUploadSubcontractorReportsInput;
};


export type MutationRequestSupportForRepairRequestArgs = {
  input: RepairRequestRequestSupportInput;
};


export type MutationReviewOvertimeArgs = {
  args: ReviewOvertimeInput;
};


export type MutationScoreLlmResponseArgs = {
  input: ScoreLlmResponseInput;
};


export type MutationSendPushNotificationArgs = {
  notification: SendPushNotificationInput;
};


export type MutationSetManHourSplitArgs = {
  input: SetManHourSplitInput;
};


export type MutationSetQuoteDiscountArgs = {
  input: SetQuoteDiscountInput;
};


export type MutationSetQuoteLinesArgs = {
  input: SetQuoteLinesInput;
};


export type MutationSetRequestItemPricingArgs = {
  payload: SetRequestItemPricingInput;
};


export type MutationSoftDeleteVisitArgs = {
  payload: DeleteVisitPayload;
};


export type MutationSourceItemVendorEmailArgs = {
  input: SourceItemVendorEmailInput;
};


export type MutationStartMissionsArgs = {
  missionIds: Array<Scalars['ID']['input']>;
  position?: InputMaybe<GeographicPosition>;
};


export type MutationStopMissionArgs = {
  args?: InputMaybe<StopMissionArgs>;
};


export type MutationSummarizeShutdownArgs = {
  deviceId: Scalars['ID']['input'];
};


export type MutationSwitchWorkOrderTypeArgs = {
  payload: SwitchWorkOrderTypeInput;
};


export type MutationSyncQuoteToSalesforceArgs = {
  quoteId: Scalars['ID']['input'];
};


export type MutationTakeBackRepairRequestActionArgs = {
  input: TakeBackRepairRequestActionInput;
};


export type MutationUnlinkSourceFromProblemArgs = {
  args: UnlinkSourceInput;
};


export type MutationUnlinkTasksFromRepairRequestArgs = {
  payload: UnlinkTasksToRepairRequestInput;
};


export type MutationUnpauseDeviceArgs = {
  payload: DeviceUnpauseInput;
};


export type MutationUnregisterPushNotificationTokenArgs = {
  payload: UnregisterPushNotificationTokenPayload;
};


export type MutationUpdateAuditReportArgs = {
  payload: UpdateReportPayload;
};


export type MutationUpdateAuditReportLineArgs = {
  payload: UpdateReportLinePayload;
};


export type MutationUpdateAuditReportLinesArgs = {
  payload: Array<UpdateReportLinePayload>;
};


export type MutationUpdateBuildingArgs = {
  buildingId: Scalars['Int']['input'];
  payload: BuildingUpdateInput;
};


export type MutationUpdateContactArgs = {
  contactId: Scalars['Int']['input'];
  payload: ContactInput;
};


export type MutationUpdateElevatorArgs = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  elevatorId?: InputMaybe<Scalars['Int']['input']>;
  payload: ElevatorUpdateInput;
};


export type MutationUpdateInvoiceItemArgs = {
  invoiceItemId: Scalars['Int']['input'];
  payload: InvoiceItemUpdate;
};


export type MutationUpdatePasswordArgs = {
  oldPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationUpdatePasswordWithTokenArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdatePlanArgs = {
  buildingId: Scalars['ID']['input'];
  items: Array<UpdatePlanItemPayload>;
};


export type MutationUpdateRepairRequestIssuesArgs = {
  payload: UpdateRepairRequestIssuesInput;
};


export type MutationUpdateRepairRequestTitleArgs = {
  payload: UpdateRepairRequestTitleInput;
};


export type MutationUpdateThingSetupArgs = {
  setup: ThingsSetupInput;
  thingId: Scalars['String']['input'];
};


export type MutationUpdateUserBlocklistArgs = {
  payload: UpdateUserBlocklistInput;
};


export type MutationUpdateUserBuildingBlocklistAssociationArgs = {
  payload: UpdateUserBlocklistInput;
};


export type MutationUploadPhotoArgs = {
  photo: AnswerPhotoUpload;
};


export type MutationUploadSignedQuoteArgs = {
  document: UploadSignedQuoteCommandInput;
};


export type MutationUpsertQuoteWorkOrdersArgs = {
  input: UpsertQuoteWorkOrdersInput;
};


export type MutationValidateRepairRequestFieldExecutionArgs = {
  repairRequestId: Scalars['ID']['input'];
};


export type MutationZipReportOfMissionsArgs = {
  payload: ReportZipUrlInput;
};


export type MutationZipReportOfTasksArgs = {
  payload: ReportZipUrlTaskInput;
};

/** Note */
export type Note = {
  __typename?: 'Note';
  display: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  accountId?: Maybe<Scalars['String']['output']>;
  configurationTaskId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  device: Device;
  /** NotificationDispatch: */
  dispatches?: Maybe<Array<NotificationDispatch>>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  source?: Maybe<NotificationSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** NotificationSourceType:The source of the notification. It can be a StrongSignal, Downtime or GenericAnomaly */
  sourceType: NotificationSourceType;
  version: Scalars['Float']['output'];
};

/** NotificationDispatch: */
export type NotificationDispatch = {
  __typename?: 'NotificationDispatch';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  notificationTargetId: Scalars['String']['output'];
  /** DispatchStatus */
  status: DispatchStatus;
};

export enum NotificationOrmEntitySortableFields {
  CreatedAt = 'createdAt'
}

export type NotificationSource = Downtime | SignalSource;

/** The source of the notification. It can be a StrongSignal or a Downtime */
export enum NotificationSourceType {
  Downtime = 'Downtime',
  GenericAnomaly = 'GenericAnomaly',
  StrongSignal = 'StrongSignal'
}

export type NotifyTicketEventInput = {
  /** The device identifier we share with your system */
  deviceId: Scalars['ID']['input'];
  /** The reference of the job in the customer's system */
  externalJobId?: InputMaybe<Scalars['String']['input']>;
  /** The date of when the event happened in your system */
  logDate: Scalars['DateTime']['input'];
  /** A description or notes of the action taken related to this ticket */
  notificationNotes: Scalars['String']['input'];
  /** Specify the type of entry for this notification */
  notificationType: WmTicketHistoryType;
  /** Extra data describing the ticket case, such as the caller name and phone number */
  ticketExtraInfo?: InputMaybe<NotifyTicketEventTicketInfoInput>;
  /** Specify how the device is impacted (Breakdown, trapped passenger, ...) */
  ticketType: WmTicketType;
  /** The reference of the ticket inside your system */
  vendorId: Scalars['ID']['input'];
};

/** Additionnal informations linked to the ticket case */
export type NotifyTicketEventTicketInfoInput = {
  /** The name of the engineer that was assigned to the case by the call center */
  assignedEngineerName?: InputMaybe<Scalars['String']['input']>;
  /** The name of the person that has raised the case */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the person that has raised the case */
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** When sorting a nullable field, possible values on how to sort those null values */
export enum NullsOrdering {
  First = 'FIRST',
  Last = 'LAST'
}

export type NumberInput = FormInput & FormThing & {
  __typename?: 'NumberInput';
  /** If set, means that changing this field would update 1<->1 to the corresponding key in the entity */
  entityKey?: Maybe<Scalars['String']['output']>;
  /** The identifier of this input, to be sent back to the backend */
  key?: Maybe<Scalars['String']['output']>;
  /** Settings for this input */
  settings: NumberInputSettings;
  title: Scalars['String']['output'];
  /** Current value associated to the input */
  value?: Maybe<Scalars['ValueOfInput']['output']>;
};

export type NumberInputSettings = IInputSettings & {
  __typename?: 'NumberInputSettings';
  /** If true, this input should not be editable */
  disabled: Scalars['Boolean']['output'];
  /** If true, only integers should be allowed */
  integer: Scalars['Boolean']['output'];
  /** If set, the value cannot be greater than this property */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** If set, the value cannot be lower than this property */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** If true, this input should be considered required */
  required: Scalars['Boolean']['output'];
  /** If true, only numbers > 0 should be allowed */
  strictlyPositive: Scalars['Boolean']['output'];
};

export type OnboardingConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represent the steps of an onboarding for a device */
export type OnboardingDeviceForm = {
  __typename?: 'OnboardingDeviceForm';
  /** Link of the device contract on the external CRM */
  contractLink: Scalars['String']['output'];
  /** Device of the onboarding */
  device: Device;
  /** ID of the onboarding */
  id: Scalars['ID']['output'];
  inputs: Array<FormThing>;
};

export enum OnboardingDeviceOrmEntitySortableFields {
  ContractStartDate = 'contractStartDate',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export type OnboardingOnboardingDeviceFormConnection = {
  __typename?: 'OnboardingOnboardingDeviceFormConnection';
  edges: Array<OnboardingOnboardingDeviceFormEdge>;
  pageInfo: OnboardingPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type OnboardingOnboardingDeviceFormEdge = {
  __typename?: 'OnboardingOnboardingDeviceFormEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: OnboardingDeviceForm;
};

export type OnboardingOnboardingDeviceOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: OnboardingDeviceOrmEntitySortableFields;
};

export type OnboardingPageInfo = {
  __typename?: 'OnboardingPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type OnboardingsFilters = {
  /** Get only onboardings on buildings belonging to the specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by whether a mechanic has been assigned */
  assignedMechanic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether an operations referent has been assigned */
  assignedOpsReferent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether the autodialer has been reprogrammed */
  autodialerReprogrammed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only onboardings belonging to the specified buildings */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter onboarding that have a contract start date on or after this date */
  contractStartDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter onboarding that have a contract start date on or before this date */
  contractStartDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Get only onboardings matching these identifiers */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by whether the first maintenance has been completed */
  firstMaintenanceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether a handover has been completed */
  handoverCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether the log card has been installed */
  logCardInstalled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only onboardings belonging to the specified referent users. */
  referentUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by whether a security audit has been completed */
  securityAuditCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether a sticker has been installed */
  stickerInstalled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only onboardings located in a specific territory. Only takes ISO 2 country codes for now (eg: FR, GB, SG...) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OperationLine = PriceListLine & {
  __typename?: 'OperationLine';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: PriceListLineKind;
  label: Scalars['String']['output'];
  priceListId: Scalars['String']['output'];
  rawRow?: Maybe<Scalars['JSON']['output']>;
  reference: Scalars['String']['output'];
  /** The labour/price tier this row belongs to; null = one price for the line */
  tier?: Maybe<PriceListTier>;
  tierId?: Maybe<Scalars['String']['output']>;
  /** The rate family in force alongside this row — every tier the contract prices this reference at, this line included, ordered by tier ordinal. One element when the reference is priced once regardless of the time of day, and never a tier that has since been retired */
  tierVariants: Array<PriceListLine>;
  validFrom: Scalars['DateTimeISO']['output'];
  validTo?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum OrderBy {
  Asc = 'asc',
  Desc = 'desc'
}

/** Direction when sorting a column (defaults to ASC) */
export enum OrderingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Orientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export type Overtime = {
  __typename?: 'Overtime';
  /** OvertimeApproval */
  approval: OvertimeApproval;
  /** Date after which this overtime would have been attributed to the following payroll month */
  cutOffDate: Scalars['DateTimeISO']['output'];
  declareComment?: Maybe<Scalars['String']['output']>;
  declareDate: Scalars['DateTimeISO']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastReviewedByEmail?: Maybe<Scalars['String']['output']>;
  linkedWorkOrderIds?: Maybe<Array<Scalars['String']['output']>>;
  mechanic: Mechanic;
  mission: Mission;
  /** Payroll month we want this overtime to be recognized in */
  month: Scalars['DateTimeISO']['output'];
  /** OvertimeOrigin */
  origin: OvertimeOrigin;
  preApprover?: Maybe<PreApprover>;
  /** List of repair requests linked to an overtime */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  reviewComment?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  visit: Visit;
};


export type OvertimeRepairRequestsArgs = {
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};

export enum OvertimeApproval {
  Accepted = 'Accepted',
  Denied = 'Denied',
  Pending = 'Pending'
}

export type OvertimeInput = {
  approver?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Duration in HOURS for the overtime */
  duration?: InputMaybe<Scalars['Int']['input']>;
  linkedWorkOrderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** WorkOrderUnlinkableReason:The reason why a work orders are not linkable at some point */
  workOrderUnlinkableReason?: InputMaybe<WorkOrderUnlinkableReason>;
};

export enum OvertimeOrigin {
  BankHolidays = 'BankHolidays',
  OutOfHours = 'OutOfHours',
  Sunday = 'Sunday'
}

export enum OvertimeOrmEntitySortableFields {
  DeclareDate = 'declareDate'
}

/** Part from the catalog WeMaintain (Netsuite) */
export type Part = {
  __typename?: 'Part';
  /** Brand of the part in Netsuite */
  brand?: Maybe<Scalars['String']['output']>;
  /**
   * Category/Classification (family) of the part on Netsuite
   * @deprecated This field is deprecated, use family instead.
   */
  category?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<PartCost>;
  /** Is the part deprecated? If true, it should not be used in new work orders */
  deprecated: Scalars['Boolean']['output'];
  /** Family (Category/Classification) of the part on Netsuite */
  family?: Maybe<PartCategory>;
  id: Scalars['ID']['output'];
  /** Manufacturer of the part in Netsuite */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /**
   * The Manufacturer Part Number (MPN) is a unique code from the Original Equipment Manufacturer (OEM) for a specific component.
   * Even if a part comes from a third-party supplier, it will still refer to the OEM's Part Number to confirm compatibility.
   */
  mpn?: Maybe<Scalars['String']['output']>;
  /** Name of the part in Netsuite */
  name: Scalars['String']['output'];
  /** Photos of the part */
  photos?: Maybe<Array<Scalars['String']['output']>>;
  /** Identifier of the part in the WM stock */
  sku: Scalars['ID']['output'];
  /**
   * SubCategory Classification (sub family) of the part on Netsuite, ex: Category: "Cable", SubCategory: "Door cable"
   * @deprecated This field is deprecated, use subFamily instead.
   */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** SubFamily (SubCategory Classification) of the part on Netsuite, ex: Category: "Cable", SubCategory: "Door cable" */
  subFamily?: Maybe<PartCategory>;
  /** In which countries catalog the part is available */
  territories?: Maybe<Array<PartTerritory>>;
};


/** Part from the catalog WeMaintain (Netsuite) */
export type PartCategoryArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Part from the catalog WeMaintain (Netsuite) */
export type PartCostArgs = {
  isoCurrency: Scalars['String']['input'];
};


/** Part from the catalog WeMaintain (Netsuite) */
export type PartNameArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Part from the catalog WeMaintain (Netsuite) */
export type PartSubCategoryArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Brand of a Part */
export type PartBrand = {
  __typename?: 'PartBrand';
  name: Scalars['String']['output'];
};

/** Filter catalog brands */
export type PartBrandInputFilters = {
  /** Filter parts by their territories (in which country catalog the part is available). Mandatory to filter only brands that have part in the designated country */
  territories?: InputMaybe<Array<PartTerritory>>;
};

/** Category of a Part */
export type PartCategory = {
  __typename?: 'PartCategory';
  id: Scalars['ID']['output'];
  /** Name of the category */
  name: Scalars['String']['output'];
};


/** Category of a Part */
export type PartCategoryNameArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filter catalog categories */
export type PartCategoryInputFilters = {
  /** Filter parts by their territories (in which country catalog the part is available). Mandatory to localize the categories */
  territories?: InputMaybe<Array<PartTerritory>>;
};

/** Cost statistics for a part in a given currency */
export type PartCost = {
  __typename?: 'PartCost';
  avg?: Maybe<Scalars['Float']['output']>;
  /** A score from 0 to 100 indicating the confidence in the cost data. */
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Filter catalog parts */
export type PartInputFilters = {
  /** Filter parts by their brands, the filter is case insensitive (Otis will return otis / OTIS / Otis...) */
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter parts by their categories, the filter is case insensitive (cable will return Cable / CABLE...)
   * @deprecated Use familyIds filter instead.
   */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter parts by their families (categories) */
  familyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter parts by their ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search parts by their names */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter parts by their skus */
  skus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter parts by their sub families (sub categories) */
  subFamilyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter parts by their territories (in which country catalog the part is available) */
  territories?: InputMaybe<Array<PartTerritory>>;
};

export type PartLine = PriceListLine & {
  __typename?: 'PartLine';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: PriceListLineKind;
  label: Scalars['String']['output'];
  priceListId: Scalars['String']['output'];
  rawRow?: Maybe<Scalars['JSON']['output']>;
  reference: Scalars['String']['output'];
  /** The labour/price tier this row belongs to; null = one price for the line */
  tier?: Maybe<PriceListTier>;
  tierId?: Maybe<Scalars['String']['output']>;
  /** The rate family in force alongside this row — every tier the contract prices this reference at, this line included, ordered by tier ordinal. One element when the reference is priced once regardless of the time of day, and never a tier that has since been retired */
  tierVariants: Array<PriceListLine>;
  validFrom: Scalars['DateTimeISO']['output'];
  validTo?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PartRequestItem = RequestItem & {
  __typename?: 'PartRequestItem';
  /** If this requested item needs to be invoiced to the customer */
  chargeable?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the request item should be delivered from our supplier */
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The human identifier for a request (at the moment it is the id within airtable)
   * @deprecated Airtable is not used anymore. This field is deprecated and will be removed in the future.
   */
  humanId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** If the item is withdrawable by the engineer */
  isWithdrawable: Scalars['Boolean']['output'];
  /**
   * Comment of the ops about the requested item
   * @deprecated Comments are not found on individual parts anymore but on the request as a whole. Use RepairRequest.enginerComment or RepairRequest.internalComment
   */
  opsComment?: Maybe<Scalars['String']['output']>;
  /** Order progression data synced from Netsuite for this request item */
  orderProgression?: Maybe<RequestItemOrderProgression>;
  /** The catalog part requested */
  part?: Maybe<Part>;
  partId?: Maybe<Scalars['ID']['output']>;
  /** Cost of the item (what we pay). This represents the company's cost for the item. Use sellPrice for the margin/sell price. Can be null if not set yet. */
  price?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  /** The quote line this item backs — a partition: an item belongs to at most one line (PRENG-7500) */
  quoteLine?: Maybe<QuoteLine>;
  repairRequestId: Scalars['ID']['output'];
  /**
   * Sell price of the item (separate from cost). Used for items that need to track separate cost and margin, such as Installation items. Can be null if not set.
   * @deprecated What the customer pays lives on QuoteLine.sellPrice (PRENG-7500); this is never written anymore
   */
  sellPrice?: Maybe<Scalars['Float']['output']>;
  /** Represent the state of the request item (should be used in place of status). Based on the type of the itemand its current data it return a state representing the next action to be done on a business point of view. */
  state?: Maybe<RequestItemState>;
  /**
   * Represent the status of the item in the repair flow
   * @deprecated Status is representing the status of the item in our legacy flow. Please use state instead, that represent
   */
  status: RepairRequestStatus;
  /** Optional URL towards a quote from one of our supplier for this part that we've used for pricing */
  supplierQuoteLink?: Maybe<Scalars['String']['output']>;
  /** Information about the withdrawal of the item by the engineer */
  withdrawal?: Maybe<Withdrawal>;
};

/** Payload to add a part item from the WM catalog to a repair request */
export type PartRequestItemInput = {
  /** The currency in which the part */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The WM id of the catalog part */
  id: Scalars['ID']['input'];
  /** Number of part requested */
  quantity: Scalars['Int']['input'];
};

/** In which countries catalog a part is available */
export enum PartTerritory {
  Fr = 'FR',
  Gb = 'GB',
  Hk = 'HK',
  Pt = 'PT',
  Sg = 'SG'
}

/** A password token is generated in the case a user wants to change his password. It is meant to be used by only one user, one time only. */
export type PasswordToken = {
  __typename?: 'PasswordToken';
  /** if the token has expired */
  expired: Scalars['Boolean']['output'];
  /** when the token expires */
  expiresAt: Scalars['DateTimeISO']['output'];
  /** ip from which the request to change the pwd came */
  ip: Scalars['Float']['output'];
  /** actual token */
  token: Scalars['String']['output'];
  /** ID of the user the token is for */
  userId: Scalars['Float']['output'];
};

/** Type of safety device */
export enum PhysicalSafety {
  FixedGlassScreen = 'FIXED_GLASS_SCREEN',
  FlushGlazedScreen = 'FLUSH_GLAZED_SCREEN',
  FrameMountedBarrier = 'FRAME_MOUNTED_BARRIER',
  PocketDoor = 'POCKET_DOOR'
}

/** Input to pick up a request item part */
export type PickUpRequestItemInput = {
  /** The id of the repair request */
  repairRequestId: Scalars['ID']['input'];
  /** The id of the request item */
  requestItemId: Scalars['ID']['input'];
};

/** A translation of a picked problem key for an answer choice */
export type PickedProblemkeyTranslation = {
  __typename?: 'PickedProblemkeyTranslation';
  /** The translated problem key in unsolved state */
  ongoing: Scalars['String']['output'];
  /** The root state key translation */
  rootStateKeyTranslation: Scalars['String']['output'];
  /** The translated problem key in solved state */
  solved: Scalars['String']['output'];
};

export type PieChart = QueryResult & {
  __typename?: 'PieChart';
  cellHtml?: Maybe<Array<Visualization_CellHtml>>;
  color?: Maybe<Array<Scalars['String']['output']>>;
  /** ConditionalVisualFormat */
  conditionalVisualFormat?: Maybe<Array<ConditionalVisualFormat>>;
  /** Dataset */
  dataset?: Maybe<Dataset>;
  /** PieChartDisplay */
  display: PieChartDisplay;
  drillFields?: Maybe<Array<Visualization_DrillFields>>;
  labelValueFormat?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Visualization_Links>>;
  /** Note */
  note?: Maybe<Note>;
  series?: Maybe<Array<Visualization_Series>>;
  /** Sort */
  sort?: Maybe<Sort>;
  title?: Maybe<Scalars['String']['output']>;
  /** ValueFormat */
  valueFormat?: Maybe<Array<ValueFormat>>;
  /** In the pie chart case the name of the label can be modified by looker. This expose this mapping */
  valuesLabel?: Maybe<Scalars['JSON']['output']>;
  /** VisualMap */
  visualMap?: Maybe<Array<VisualMap>>;
  xAxis?: Maybe<Visualization_XAxis>;
  yAxes?: Maybe<Array<Visualization_YAxes>>;
  yAxis?: Maybe<Visualization_YAxis>;
};

/** PieChartDisplay */
export type PieChartDisplay = {
  __typename?: 'PieChartDisplay';
  innerRadius?: Maybe<Scalars['Float']['output']>;
  series: Array<PieChartDisplay_Series>;
  /** ValueLabelsDisplay */
  valueLabelsDisplay: ValueLabelsDisplay;
};

export type PieChartDisplay_Series = {
  __typename?: 'PieChartDisplay_Series';
  /** Litpie */
  type: Scalars['String']['output'];
};

/** Kind that will be mapped to a given pin */
export enum PinKind {
  AlarmBell = 'alarmBell',
  Direction = 'direction',
  FaultMode = 'faultMode'
}

/** The Pin number of the associated data field */
export enum PinNumber {
  In1 = 'in1',
  In2 = 'in2',
  In3 = 'in3',
  In4 = 'in4'
}

/** Interactive item placed on a plan */
export type PlanItem = {
  __typename?: 'PlanItem';
  id: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  level: Scalars['String']['output'];
  posx: Scalars['Float']['output'];
  posy: Scalars['Float']['output'];
};

export type PreApprover = {
  __typename?: 'PreApprover';
  reasonNotPicked?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Admin>;
};

/** Prepare upload input payload */
export type PrepareUploadInput = {
  /** The mime type of the file to upload */
  contentType: Scalars['String']['input'];
  /** The file name to upload */
  key: Scalars['String']['input'];
};

export type PriceList = {
  __typename?: 'PriceList';
  /** ISO 3166-1 alpha-2. Set on one of WeMaintain's standard lists, null on a contractual one */
  country?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  /** The device type this list prices. Set on one of WeMaintain's standard lists, null on a contractual one */
  deviceType?: Maybe<PriceListDeviceType>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  sourceDocumentUrl?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<PriceListTier>>;
  validFrom: Scalars['DateTimeISO']['output'];
  validTo?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum PriceListDeviceType {
  Door = 'DOOR',
  Elevator = 'ELEVATOR',
  Escalator = 'ESCALATOR',
  FireAlarm = 'FIRE_ALARM',
  Hvac = 'HVAC'
}

export type PriceListLine = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Discriminates unit-priced kinds from the cost-based COEFFICIENT kind */
  kind: PriceListLineKind;
  label: Scalars['String']['output'];
  priceListId: Scalars['String']['output'];
  rawRow?: Maybe<Scalars['JSON']['output']>;
  reference: Scalars['String']['output'];
  /** The labour/price tier this row belongs to; null = one price for the line */
  tier?: Maybe<PriceListTier>;
  tierId?: Maybe<Scalars['String']['output']>;
  /** The rate family in force alongside this row — every tier the contract prices this reference at, this line included, ordered by tier ordinal. One element when the reference is priced once regardless of the time of day, and never a tier that has since been retired */
  tierVariants: Array<PriceListLine>;
  validFrom: Scalars['DateTimeISO']['output'];
  validTo?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum PriceListLineKind {
  Coefficient = 'COEFFICIENT',
  Labour = 'LABOUR',
  Operation = 'OPERATION',
  Part = 'PART'
}

export type PriceListTier = {
  __typename?: 'PriceListTier';
  /** PriceListTierRule: */
  applicability?: Maybe<Array<PriceListTierRule>>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
  priceListId: Scalars['String']['output'];
};

export type PriceListTierRule = {
  __typename?: 'PriceListTierRule';
  days?: Maybe<Array<Scalars['Int']['output']>>;
  hourEnd?: Maybe<Scalars['Int']['output']>;
  hourStart?: Maybe<Scalars['Int']['output']>;
  publicHolidays?: Maybe<Scalars['Boolean']['output']>;
};

export type PriceToTargetLineChange = {
  __typename?: 'PriceToTargetLineChange';
  /** Null on a line with no sell price */
  currentUnitPrice?: Maybe<Scalars['Float']['output']>;
  lineId: Scalars['ID']['output'];
  /** Rounded up to the next whole currency unit */
  newUnitPrice: Scalars['Float']['output'];
};

/** Which strategy Price to target used. It does not say whether the target is reached: read targetReached for that */
export enum PriceToTargetMode {
  /** The lines at their own target cannot cover the shortfall and the uniform raise is off, or no line can be raised. Never reaches the target; lines below their own target may still go to it, and blockingRateLineIds lists the rate lines holding it down */
  CannotReach = 'CANNOT_REACH',
  /** Every line without a rate is at or above its own target and so is the quote, or the quote has no target */
  NotNeeded = 'NOT_NEEDED',
  /** Each line without a rate below its own target price goes to it, even when the quote then ends above its target. Always reaches the target */
  RaiseBelowTargetLines = 'RAISE_BELOW_TARGET_LINES',
  /** Rate lines below target leave a shortfall once the other lines are at their own target: every line without a rate goes up by the same percentage, past its own target, capped per line. The cap may leave the target unreached */
  UniformRaise = 'UNIFORM_RAISE'
}

/** What Price to target would do to the quote (S6). Read only: nothing changes until the proposal is applied at its quoteVersion */
export type PriceToTargetPreview = {
  __typename?: 'PriceToTargetPreview';
  /** Lines with a rate, below their own target price, that keep the quote below target: removing the rate lets them be priced differently. Empty once the target is reached */
  blockingRateLineIds: Array<Scalars['ID']['output']>;
  /** Only the lines whose price changes. Lines with a rate, at no charge, or with neither a cost nor a price never do; a line with a price but no cost only in the uniform raise */
  changes: Array<PriceToTargetLineChange>;
  /** The margin once the changes are applied */
  marginAfter?: Maybe<Scalars['Float']['output']>;
  mode: PriceToTargetMode;
  /** The version of the quote this proposal was computed on. Applying it is refused once the quote has moved on; apply recomputes the proposal at that version */
  quoteVersion: Scalars['Int']['output'];
  statusAfter?: Maybe<QuoteMarginStatus>;
  /** Whether the quote reaches its target after the change; null with no target */
  targetReached?: Maybe<Scalars['Boolean']['output']>;
  /** The quote's price after its discount once the changes are applied */
  valueAfter: Scalars['Float']['output'];
};

export type Problem = {
  __typename?: 'Problem';
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  closedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  critical: Scalars['Boolean']['output'];
  date: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  device: Device;
  dilap: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  openedAt: Scalars['DateTimeISO']['output'];
  /** ProblemOrigin:Underlaying origin of the issue that caused the problem. Ie: why did something go wrong */
  origin?: Maybe<BreakdownOrigin>;
  /** Source: */
  sources: Array<ProblemSource>;
  stateKey: Scalars['String']['output'];
  /** Human readable label for this state key, translated in the given language */
  stateKeyLabel?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};


export type ProblemDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ProblemSourcesArgs = {
  filters?: InputMaybe<ProblemSourceFilterInput>;
};


export type ProblemStateKeyLabelArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ProblemOrmEntitySortableFields {
  CancelledAt = 'cancelledAt',
  ClosedAt = 'closedAt',
  Date = 'date',
  OpenedAt = 'openedAt'
}

export type ProblemSource = {
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  critical: Scalars['Boolean']['output'];
  declaredAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  dilap: Scalars['Boolean']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manuallyReassigned?: Maybe<Source_ManuallyReassigned>;
  problemKey?: Maybe<Scalars['String']['output']>;
  /** SourceProvider:The provider of a given Source (this is the author of said source) */
  provider: EventProvider;
  resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  stateKey?: Maybe<Scalars['String']['output']>;
};

export type ProblemSourceDefect = ProblemSource & {
  __typename?: 'ProblemSourceDefect';
  /** Line in the AuditReport that created this defect */
  auditReportLine: AuditReportLine;
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  critical: Scalars['Boolean']['output'];
  declaredAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  dilap: Scalars['Boolean']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manuallyReassigned?: Maybe<Source_ManuallyReassigned>;
  problemKey?: Maybe<Scalars['String']['output']>;
  /** SourceProvider:The provider of a given Source (this is the author of said source) */
  provider: EventProvider;
  resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  stateKey?: Maybe<Scalars['String']['output']>;
};

export type ProblemSourceFilterInput = {
  /** The type of events in the issue */
  providers?: InputMaybe<Array<EventProvider>>;
};

export type ProblemSourceIntegration = ProblemSource & {
  __typename?: 'ProblemSourceIntegration';
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  critical: Scalars['Boolean']['output'];
  declaredAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  dilap: Scalars['Boolean']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manuallyReassigned?: Maybe<Source_ManuallyReassigned>;
  problemKey?: Maybe<Scalars['String']['output']>;
  /** SourceProvider:The provider of a given Source (this is the author of said source) */
  provider: EventProvider;
  resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  stateKey?: Maybe<Scalars['String']['output']>;
};

export type ProblemSourceTicket = ProblemSource & {
  __typename?: 'ProblemSourceTicket';
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  critical: Scalars['Boolean']['output'];
  declaredAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  dilap: Scalars['Boolean']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manuallyReassigned?: Maybe<Source_ManuallyReassigned>;
  problemKey?: Maybe<Scalars['String']['output']>;
  /** SourceProvider:The provider of a given Source (this is the author of said source) */
  provider: EventProvider;
  resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  stateKey?: Maybe<Scalars['String']['output']>;
};

export type ProblemSourceVisit = ProblemSource & {
  __typename?: 'ProblemSourceVisit';
  /** The answer that declared this problem */
  answer: Answer;
  cancelledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  critical: Scalars['Boolean']['output'];
  declaredAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  dilap: Scalars['Boolean']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manuallyReassigned?: Maybe<Source_ManuallyReassigned>;
  problemKey?: Maybe<Scalars['String']['output']>;
  /** SourceProvider:The provider of a given Source (this is the author of said source) */
  provider: EventProvider;
  resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  stateKey?: Maybe<Scalars['String']['output']>;
};

export type PropagateFixedStatusToProblemLinesInput = {
  problemId: Scalars['ID']['input'];
};

export type PushNotificationStatus = {
  __typename?: 'PushNotificationStatus';
  error?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type PutRepairRequestActionOnHoldInput = {
  /** The open action to put on hold, on hold already or not */
  actionId: Scalars['String']['input'];
  /** Why, required. Trimmed, at most 500 characters. */
  note: Scalars['String']['input'];
  /** The work order the action is on */
  repairRequestId: Scalars['String']['input'];
  /** When it comes back, in the future and no later than RepairRequestAction.holdLatestUntil. It is not due before then. */
  until: Scalars['DateTimeISO']['input'];
};

/** The status of the quote relating to the customer contract. */
export enum Qualification {
  IncludedInContract = 'INCLUDED_IN_CONTRACT',
  NotApplicable = 'NOT_APPLICABLE',
  NotIncludedInContract = 'NOT_INCLUDED_IN_CONTRACT'
}

export type Query = {
  __typename?: 'Query';
  FilterSuggestionsQuery: FilterSuggestions;
  FindDowntimesQuery: DevicesState2DowntimeConnection;
  FindNotificationsQuery: MonitoringNotificationConnection;
  GetDashboardPdf: DashboardPdf;
  GetDashboardQuery: Dashboard;
  activities: FeedActivityGqlConnection;
  /** Returns every alarm system */
  alarmSystems: Array<AlarmSystem>;
  /** Fetch answers for a device or a question */
  answers: VisitsAnswerConnection;
  /** Exposes the available report types per country */
  auditReportConfig: AuditReportConfigDetailsObject;
  /** Every items reported in an AuditReport that we ingested */
  auditReportLines: AuditReportAuditReportLineConnection;
  /** Queries the Audit Reports */
  auditReports: AuditReportAuditReportConnection;
  /** List of available width steps */
  authorizedWidthSteps?: Maybe<Array<Scalars['Int']['output']>>;
  /** Get a building by id */
  building: Building;
  /**
   * List all buildings with a pagination.
   * By default, every buildings are returned.
   *
   * **NOT IMPLEMENTED**
   * * Should only return buildings w/ contract or bid (for mechanics)
   * * Should actually filter by mechanicId
   */
  buildings: BuildingsBuildingConnection;
  /** Get chunks filtred by a list of mission ids / machanic id or dates */
  chunks: MissionsChunkConnection;
  /** Get a contact by id */
  contact: Contact;
  /** Get a contract by id */
  contract: Contract;
  /** Queries the contracts */
  contracts: ContractsContractConnection;
  cube: Array<Result>;
  currentVisit?: Maybe<StartedMissions>;
  /** Get a customer by id */
  customer: Customer;
  /** List all customers with a pagination */
  customers: UsersCustomerConnection;
  /** Query one device by its id */
  device: Device;
  /** Get metrics for supplied devices */
  deviceMetrics: DeviceMetrics;
  /** Returns all available spec filter options grouped by device type. Omit deviceType to get options for all device types at once. */
  deviceSpecsFilterOptions: Array<DeviceTypeSpecFilterOptions>;
  /** Query a list of devices */
  devices: ElevatorsDeviceGraphqlConnection;
  /** Query one elevator by its id */
  elevator: Elevator;
  /** Returns every elevator brand */
  elevatorBrands: Array<ElevatorBrand>;
  /**
   * Get metrics for supplied elevators
   * @deprecated Use DeviceMetrics in place of ElevatorMetrics to access all kind of devices
   */
  elevatorMetrics: ElevatorMetrics;
  /** Query a list of elevators */
  elevators: ElevatorsElevatorGraphqlConnection;
  /** Enrolment requests to the internal Clerk app, newest first */
  enrolmentRequests: Array<EnrolmentRequest>;
  feed: Feed;
  feeds: FeedFeedGqlConnection;
  /** Query the list of Things */
  fetchStrongSignals: IotStrongSignalGraphQlConnection;
  /** Return the current question dedicated to this task, beware that some questions can be mechanic dependent and will not be returned here */
  getCurrentQuestionsForTask: Array<QuestionGroup>;
  /** Off production: engineers (users with App access) an admin may impersonate. Empty in production. */
  impersonationCandidates: Array<ImpersonationCandidate>;
  /** Query a list of elevators */
  invoiceItems: InvoicesInvoiceItemConnection;
  /** Query a list of invoices */
  invoices: InvoicesInvoiceConnection;
  /** Return the list of issues for the given device */
  issueSnapshots: DeviceStateIssueSnapshotConnection;
  /** Returns currently logged in user */
  me: User;
  /** List days with special availabilities for all our mechanics. */
  mechanicAvailabilities: MechanicsMechanicAvailabilityConnection;
  /**
   * List all approved mechanics with a pagination for admins.
   * By default, every mechanics are returned.
   */
  mechanics: MechanicsMechanicConnection;
  /** Fetch a mission by id */
  mission: Mission;
  missions: MissionsMissionConnection;
  /**
   * List available onboardings with a pagination.
   * By default, onboardings are ordered by descending updatedAt
   */
  onboardings: OnboardingOnboardingDeviceFormConnection;
  overtime: Overtime;
  overtimes: CostControlOvertimeGqlConnection;
  /** Query one part by its id */
  part: Part;
  /** Retrieve the list of WM catalog part brands. Note: territories filters will be ignored. */
  partBrands: WorkOrdersPartBrandGraphqlConnection;
  /** Retrieve the list of WM catalog part categories. Note: territories filters will be ignored. */
  partCategories: WorkOrdersPartCategoryGraphqlConnection;
  /** Retrieve the list of WM catalog part sub categories. */
  partSubCategories: WorkOrdersPartCategoryGraphqlConnection;
  /** Retrieve the list of WM catalog parts, inactive parts are not returned by this query. Note: territories filters will be ignored */
  parts: WorkOrdersPartGraphqlConnection;
  priceList: PriceList;
  priceListLines: ContractsPriceListLineGqlConnection;
  priceLists: ContractsPriceListGqlConnection;
  problem: Problem;
  problems: DeviceStateProblemGqlConnection;
  /** Get a question by id */
  question?: Maybe<Question>;
  questionGroupTemplate: QuestionGroupTemplate;
  /** QuestionGroupTemplates currently active */
  questionGroupTemplates: QuestionsQuestionGroupTemplateConnection;
  /** Query a list of questionTemplates */
  questionTemplates: Array<QuestionTemplate>;
  /** Queries the quotes of the customers */
  quotes: WorkOrdersQuoteGraphqlConnection;
  /** Return a paginated list of any users managing at least one contract */
  referentUsers: UsersIUserConnection;
  /** Retrieve a repair request by its id */
  repairRequest: RepairRequest;
  /** Retrieve repair request actions, filtered and paged: at most 100 a page, the default. By default, actions on a shutdown come first, then on urgent work orders, then the earliest due (dueAt), the ones with no due date last; an explicit order leads, and the default order breaks its ties. Pass first to page forwards: without it, hasNextPage is always false. Throws a FeatureDisabled error when the action center is off for the caller. */
  repairRequestActions: WorkOrdersRepairRequestActionGraphqlConnection;
  /** Retrieve the list of repair requests delivery options */
  repairRequestPartDeliveryOptions: WorkOrdersRepairRequestDeliveryOptionGraphqlConnection;
  /** Retrieve the list of unique problem state keys */
  repairRequestProblemStateKeys: WorkOrdersProblemStateKeyGraphqlConnection;
  /** Retrieve the list of WM supply manager */
  repairRequestSupplyManagers: WorkOrdersRepairRequestSupplyManagerGrapqhlConnection;
  /**
   * Retrieve the list of repair requests,
   *     repair requests are by default ordered by created date descendant
   */
  repairRequests: WorkOrdersRepairRequestGraphqlConnection;
  /** Get the state component certificates document */
  stateComponentCertificates: DocumentsStateComponentCertificateGraphqlConnection;
  /** Query one task by its id. When withDeleted is true, soft-deleted tasks are included. */
  task: Task;
  tasks: MissionsTaskConnection;
  /** Query the list of Things */
  things: IotThingGraphqlConnection;
  /**
   * Returns a list of users with a specific role
   * @deprecated Use usersv2 query instead
   */
  users: Array<User>;
  /** List all customers with a pagination */
  usersv2: UsersIUserConnection;
  /** Retrieve vendors paginated for a specific territory */
  vendors: WorkOrdersVendorGraphqlConnection;
  /** Fetch a visit by id */
  visit: Visit;
};


export type QueryFilterSuggestionsQueryArgs = {
  query: FilterSuggestionsQueryInput;
};


export type QueryFindDowntimesQueryArgs = {
  filters?: InputMaybe<FindDowntimesQueryInput>;
  order?: InputMaybe<Array<DevicesState2DowntimeOrmEntityOrderOptions>>;
  pagination?: InputMaybe<DevicesState2ConnectionArgs>;
};


export type QueryFindNotificationsQueryArgs = {
  filters?: InputMaybe<FindNotificationsQueryInput>;
  order?: InputMaybe<Array<MonitoringNotificationOrmEntityOrderOptions>>;
  pagination?: InputMaybe<MonitoringConnectionArgs>;
};


export type QueryGetDashboardPdfArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryGetDashboardQueryArgs = {
  query: GetDashboardQueryInput;
};


export type QueryActivitiesArgs = {
  filters?: InputMaybe<FindManyPaginatedActivityQueryInput>;
  order?: InputMaybe<Array<FeedActivityOrmEntityOrderOptions>>;
  pagination?: InputMaybe<FeedConnectionArgs>;
};


export type QueryAlarmSystemsArgs = {
  filters?: InputMaybe<AlarmSystemsFilters>;
};


export type QueryAnswersArgs = {
  filters?: InputMaybe<AnswersFilters>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};


export type QueryAuditReportConfigArgs = {
  filters: AuditReportConfigDetailsFilters;
};


export type QueryAuditReportLinesArgs = {
  filters?: InputMaybe<AuditReportLineFilters>;
  order?: InputMaybe<Array<AuditReportAuditReportLineOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};


export type QueryAuditReportsArgs = {
  filters?: InputMaybe<AuditReportFilters>;
  order?: InputMaybe<Array<AuditReportAuditReportOrderOptions>>;
  pagination?: InputMaybe<AuditReportConnectionArgs>;
};


export type QueryBuildingArgs = {
  buildingId: Scalars['Int']['input'];
};


export type QueryBuildingsArgs = {
  filters?: InputMaybe<BuildingsFilters>;
  pagination?: InputMaybe<BuildingsConnectionArgs>;
};


export type QueryChunksArgs = {
  filters?: InputMaybe<ChunksFilters>;
  order?: InputMaybe<Array<MissionsChunkOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


export type QueryContactArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryContractArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryContractsArgs = {
  filters?: InputMaybe<ContractFilters>;
  order?: InputMaybe<Array<ContractsContractOrderOptions>>;
  pagination?: InputMaybe<ContractsConnectionArgs>;
};


export type QueryCubeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RootOrderByInput>;
  renewQuery?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<RootWhereInput>;
};


export type QueryCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomersArgs = {
  filters?: InputMaybe<CustomersFilters>;
  order?: InputMaybe<Array<UsersAccountOrmEntityOrderOptions>>;
  pagination?: InputMaybe<UsersConnectionArgs>;
};


export type QueryDeviceArgs = {
  deviceId: Scalars['ID']['input'];
};


export type QueryDeviceMetricsArgs = {
  filters?: InputMaybe<DeviceMetricsInput>;
};


export type QueryDeviceSpecsFilterOptionsArgs = {
  deviceType?: InputMaybe<DeviceType>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDevicesArgs = {
  filters?: InputMaybe<DevicesFilters>;
  order?: InputMaybe<Array<ElevatorsDeviceOrmEntityOrderOptions>>;
  pagination?: InputMaybe<ElevatorsConnectionArgs>;
};


export type QueryElevatorArgs = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  elevatorId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryElevatorMetricsArgs = {
  filters: ElevatorMetricsInput;
};


export type QueryElevatorsArgs = {
  filters?: InputMaybe<ElevatorsFilters>;
  pagination?: InputMaybe<ElevatorsConnectionArgs>;
};


export type QueryEnrolmentRequestsArgs = {
  access?: InputMaybe<EnrolmentRequestedAccess>;
  status?: InputMaybe<EnrolmentRequestStatus>;
};


export type QueryFeedArgs = {
  query: FindOneFeedQueryInput;
};


export type QueryFeedsArgs = {
  filters?: InputMaybe<FindManyPaginatedFeedsQueryInput>;
  pagination?: InputMaybe<FeedConnectionArgs>;
};


export type QueryFetchStrongSignalsArgs = {
  filters?: InputMaybe<StrongSignalsInputFilters>;
  order?: InputMaybe<Array<IotSignalOrmEntityOrderOptions>>;
  pagination?: InputMaybe<IotConnectionArgs>;
};


export type QueryGetCurrentQuestionsForTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryImpersonationCandidatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceItemsArgs = {
  filters?: InputMaybe<InvoiceItemFilters>;
  order?: InputMaybe<Array<InvoicesInvoiceItemOrderOptions>>;
  pagination?: InputMaybe<InvoicesConnectionArgs>;
};


export type QueryInvoicesArgs = {
  filters?: InputMaybe<InvoiceFilters>;
  order?: InputMaybe<Array<InvoicesInvoiceOrderOptions>>;
  pagination?: InputMaybe<InvoicesConnectionArgs>;
};


export type QueryIssueSnapshotsArgs = {
  filters: IssueSnapshotInput;
  pagination?: InputMaybe<DeviceStateConnectionArgs>;
};


export type QueryMechanicAvailabilitiesArgs = {
  filters?: InputMaybe<MechanicAvailabilitiesFilters>;
  pagination?: InputMaybe<MechanicsConnectionArgs>;
};


export type QueryMechanicsArgs = {
  filters?: InputMaybe<MechanicFilters>;
  pagination?: InputMaybe<MechanicsConnectionArgs>;
};


export type QueryMissionArgs = {
  missionId: Scalars['String']['input'];
};


export type QueryMissionsArgs = {
  filters?: InputMaybe<MissionsFilters>;
  order?: InputMaybe<Array<MissionsMissionOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


export type QueryOnboardingsArgs = {
  filters?: InputMaybe<OnboardingsFilters>;
  order?: InputMaybe<Array<OnboardingOnboardingDeviceOrmEntityOrderOptions>>;
  pagination?: InputMaybe<OnboardingConnectionArgs>;
};


export type QueryOvertimeArgs = {
  query: FindOneOvertimeInput;
};


export type QueryOvertimesArgs = {
  filters?: InputMaybe<FindManyOvertimePaginatedQueryInput>;
  order?: InputMaybe<Array<CostControlOvertimeOrmEntityOrderOptions>>;
  pagination?: InputMaybe<CostControlConnectionArgs>;
};


export type QueryPartArgs = {
  partId: Scalars['ID']['input'];
};


export type QueryPartBrandsArgs = {
  filters?: InputMaybe<PartBrandInputFilters>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryPartCategoriesArgs = {
  filters?: InputMaybe<PartCategoryInputFilters>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryPartSubCategoriesArgs = {
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryPartsArgs = {
  filters?: InputMaybe<PartInputFilters>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryPriceListArgs = {
  query: FindOnePriceListInput;
};


export type QueryPriceListLinesArgs = {
  filters?: InputMaybe<SearchPriceListLinesInput>;
  pagination?: InputMaybe<ContractsConnectionArgs>;
};


export type QueryPriceListsArgs = {
  filters?: InputMaybe<FindManyPaginatedPriceListsInput>;
  pagination?: InputMaybe<ContractsConnectionArgs>;
};


export type QueryProblemArgs = {
  query: FindOneProblemQueryInput;
};


export type QueryProblemsArgs = {
  filters?: InputMaybe<FindProblemsQueryInput>;
  order?: InputMaybe<Array<DeviceStateProblemOrmEntityOrderOptions>>;
  pagination?: InputMaybe<DeviceStateConnectionArgs>;
};


export type QueryQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionGroupTemplateArgs = {
  groupTemplateId: Scalars['ID']['input'];
};


export type QueryQuestionGroupTemplatesArgs = {
  filters?: InputMaybe<QuestionGroupTemplatesFilters>;
  pagination?: InputMaybe<QuestionsConnectionArgs>;
};


export type QueryQuestionTemplatesArgs = {
  filters?: InputMaybe<QuestionTemplateFilter>;
};


export type QueryQuotesArgs = {
  filters?: InputMaybe<QuotesInputFilters>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryReferentUsersArgs = {
  filters?: InputMaybe<ReferentUsersFilter>;
  pagination?: InputMaybe<UsersConnectionArgs>;
};


export type QueryRepairRequestArgs = {
  input: FetchRepairRequestInput;
};


export type QueryRepairRequestActionsArgs = {
  filters?: InputMaybe<RepairRequestActionFilters>;
  order?: InputMaybe<Array<WorkOrdersRepairRequestActionOrmEntityOrderOptions>>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryRepairRequestPartDeliveryOptionsArgs = {
  filters?: InputMaybe<RepairRequestDeliveryOptionInputFilters>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryRepairRequestProblemStateKeysArgs = {
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryRepairRequestSupplyManagersArgs = {
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryRepairRequestsArgs = {
  filters?: InputMaybe<RepairRequestInputFilters>;
  order?: InputMaybe<Array<WorkOrdersRepairRequestOrmEntityOrderOptions>>;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryStateComponentCertificatesArgs = {
  filters?: InputMaybe<StateComponentCertificateInputFilters>;
  order?: InputMaybe<Array<DocumentsStateComponentCertificateGraphqlOrderOptions>>;
  pagination?: InputMaybe<DocumentsConnectionArgs>;
};


export type QueryTaskArgs = {
  taskId: Scalars['String']['input'];
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTasksArgs = {
  filters?: InputMaybe<TaskFilters>;
  order?: InputMaybe<Array<MissionsTaskOrderOptions>>;
  pagination?: InputMaybe<MissionsConnectionArgs>;
};


export type QueryThingsArgs = {
  filters?: InputMaybe<ThingsFilters>;
  pagination?: InputMaybe<IotConnectionArgs>;
};


export type QueryUsersArgs = {
  filters: UsersFilters;
};


export type QueryUsersv2Args = {
  filters: UsersV2Filters;
  pagination?: InputMaybe<UsersConnectionArgs>;
};


export type QueryVendorsArgs = {
  filters: VendorInputFilters;
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


export type QueryVisitArgs = {
  visitId: Scalars['ID']['input'];
};

/** Current status of the device */
export enum QueryDeviceStatus {
  HasIssues = 'HAS_ISSUES',
  Stopped = 'STOPPED',
  Working = 'WORKING'
}

export type QueryResult = {
  cellHtml?: Maybe<Array<Visualization_CellHtml>>;
  color?: Maybe<Array<Scalars['String']['output']>>;
  /** ConditionalVisualFormat */
  conditionalVisualFormat?: Maybe<Array<ConditionalVisualFormat>>;
  /** Dataset */
  dataset?: Maybe<Dataset>;
  drillFields?: Maybe<Array<Visualization_DrillFields>>;
  labelValueFormat?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Visualization_Links>>;
  /** Note */
  note?: Maybe<Note>;
  series?: Maybe<Array<Visualization_Series>>;
  /** Sort */
  sort?: Maybe<Sort>;
  title?: Maybe<Scalars['String']['output']>;
  /** ValueFormat */
  valueFormat?: Maybe<Array<ValueFormat>>;
  /** VisualMap */
  visualMap?: Maybe<Array<VisualMap>>;
  xAxis?: Maybe<Visualization_XAxis>;
  yAxes?: Maybe<Array<Visualization_YAxes>>;
  yAxis?: Maybe<Visualization_YAxis>;
};

/** Represents all the base attributes that a Question will always have, regardless of what kind it is */
export type Question = {
  /** Different answers that can be chosen for this question */
  answerTemplates: Array<IAnswerTemplate>;
  conditions: Array<IQuestionCondition>;
  /** The category the question refers to (car, ...) */
  displayCategory?: Maybe<Scalars['String']['output']>;
  /** The sub-category the question refers to, used to group questions in the same category */
  displaySubCategory?: Maybe<QuestionSubCategory>;
  /**
   * Defines the presence & requiredness of choices, photos and comments.
   *     By default, they are all present and optional
   */
  features: QuestionTemplateFeature;
  /** Hint to help the user answer the question */
  hint?: Maybe<Scalars['String']['output']>;
  /** A manual question ID, set in the question spreadsheet. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** QuestionTemplate that was used to create that question */
  questionTemplate: QuestionTemplate;
  /** The part of the elevator the question is about */
  stateKey?: Maybe<Scalars['String']['output']>;
  /** The text of the question to be asked to the mechanic */
  title: Scalars['String']['output'];
  /** Work order linked to that question */
  workOrder?: Maybe<RepairRequest>;
};


/** Represents all the base attributes that a Question will always have, regardless of what kind it is */
export type QuestionHintArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents all the base attributes that a Question will always have, regardless of what kind it is */
export type QuestionTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A QuestionChoice represents a choice available for a question, which can be selected by the user */
export type QuestionChoice = IQuestionChoice & {
  __typename?: 'QuestionChoice';
  /** Template for this choice, containing its translation, what it impacts and all other information */
  answerTemplate: IAnswerTemplate;
  /**
   * Answer template which contains the actual text of the answer
   * @deprecated Use answerTemplate.id instead
   */
  answerTemplateId: Scalars['String']['output'];
  /** Key to group the answers by. */
  displayGroup?: Maybe<Scalars['String']['output']>;
  /** Contains information on how to display the answer template in the front-end side */
  displayOptions: AnswerDisplayOption;
  /** Does the answer ask for followup */
  hasFollowUp: Scalars['Boolean']['output'];
  /** Answer ID used to match mulitple question between them, provided by the author. */
  humanKey: Scalars['String']['output'];
  /** A problemKey is always associated with a stateKey and describes what's wrong. A basic example would be the problemKey 'BROKEN' on the stateKey 'car.lighting'. */
  problemKey?: Maybe<Scalars['String']['output']>;
  /** Part of the device this questions is about. A stateKey is a representation of component and subcomponent of a device. For example 'car' or 'car.lighting' */
  stateKey?: Maybe<Scalars['String']['output']>;
  stateKeyTranslation?: Maybe<AnswerTemplateAvailableStateKey>;
  /** The text of the answer which will be displayed to the mechanic */
  title: Scalars['String']['output'];
};


/** A QuestionChoice represents a choice available for a question, which can be selected by the user */
export type QuestionChoiceDisplayGroupArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A QuestionChoice represents a choice available for a question, which can be selected by the user */
export type QuestionChoiceStateKeyTranslationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A QuestionChoice represents a choice available for a question, which can be selected by the user */
export type QuestionChoiceTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Condition that applies to this Question. That will modify its behavior.Such as requirements, or displaybility */
export type QuestionCondition = IQuestionCondition & {
  __typename?: 'QuestionCondition';
  outcome: QuestionConditionOutcome;
  type: QuestionConditionType;
};

/**
 * A question feature specifies for each possible feature of the question if it exists and if it's required.
 *   A task can not be completed without answers to all the required features.
 */
export type QuestionConditionOutcome = {
  __typename?: 'QuestionConditionOutcome';
  /** Defines the existence of choices for a question and whether it is required to select at least one choice */
  choices?: Maybe<QuestionFeatureMode>;
  /** Defines the possibility to add a comment and whether it is required to write something in that comment */
  comments?: Maybe<QuestionFeatureMode>;
  /** Hint to help the user answer the question */
  hint?: Maybe<Scalars['String']['output']>;
  /** Hide the question when the question criteria are matching */
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Defines the existence of photos for a question and whether it is required to select at least one photo */
  photos?: Maybe<QuestionFeatureMode>;
  /** Defines the possibility to add a work order form and whether it is required to fill it (not implemented yet) */
  workOrderForm?: Maybe<QuestionFeatureMode>;
};


/**
 * A question feature specifies for each possible feature of the question if it exists and if it's required.
 *   A task can not be completed without answers to all the required features.
 */
export type QuestionConditionOutcomeHintArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The type of conditions that will need to be computed */
export enum QuestionConditionType {
  AnswerCondition = 'AnswerCondition',
  SpecsCondition = 'SpecsCondition'
}

/**
 * NONE = the feature is not present
 *   OPTIONAL = the feature is present, but an answer is not required
 *   REQUIRED = the feature is present and it's required to provide an answer
 */
export enum QuestionFeatureMode {
  None = 'NONE',
  Optional = 'OPTIONAL',
  Remove = 'REMOVE',
  Required = 'REQUIRED'
}

/**
 * A group of questions to be asked to the mechanic during a visit.
 *   Groups are created dynamically based on the type of mission, the specs of a device and/or current circumstances
 *
 *   For example:
 *   When starting a visit for a task of type REGULAR, we'll add a question group with the questions that needs to be asked on REGULAR frequency.
 *   But we might also add a questiongroup about onboarding that elevator if it's the first time we see it since it's under contract
 *   Or, a device that has issues might contain QuestionGroups to ask questions pertaining to those issues.
 */
export type QuestionGroup = {
  __typename?: 'QuestionGroup';
  id: Scalars['ID']['output'];
  questions: Array<Question>;
};

/** Template of a group of question to be asked to the mechanic */
export type QuestionGroupTemplate = {
  __typename?: 'QuestionGroupTemplate';
  createdAt: Scalars['DateTimeISO']['output'];
  deviceType: DeviceType;
  /** @deprecated Use taskType instead */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Templates of question in this template group */
  questions: QuestionsQuestionTemplateConnection;
  /**
   * A "special" group is a group that does not belong to the simple logic of "display in [taskType] for [deviceType] in [countryCode]"
   * but rather has complex display logic. Examples include displaying group only if IOT is on device, or if device has defects.
   */
  special: Scalars['Boolean']['output'];
  /** type of task that we want this group on */
  taskType: Scalars['String']['output'];
  territory: Scalars['String']['output'];
};


/** Template of a group of question to be asked to the mechanic */
export type QuestionGroupTemplateQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Input filters to query questionGroupTemplates */
export type QuestionGroupTemplatesFilters = {
  /** Get only groups that would be displayed for the supplied types of devices. Wildcard NOT supported */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /** unique identifiers of the group to search (ie: REGULAR, BREAKDOWN ...) */
  humanKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get "special" groups that might have complex logic to be displayed */
  specials?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only groups that would be displayed in the supplied tasks. Wildcard NOT supported */
  taskTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by only selected territories (ISO 3166-1 alpha-2). Wildcard NOT supported */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QuestionSubCategory = {
  __typename?: 'QuestionSubCategory';
  /** The key of the sub-category, used for identifying clearly the sub-category in the code and in the question */
  key: Scalars['String']['output'];
  /** The title of the sub-category, used for grouping questions in the UI */
  title: Scalars['String']['output'];
};


export type QuestionSubCategoryTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * QuestionTemplate is a template that was hard-set by a human and can be
 *     instanciated to create a Question that can be asked to a mechanic during a visit.
 */
export type QuestionTemplate = {
  __typename?: 'QuestionTemplate';
  answerTemplates: Array<IAnswerTemplate>;
  conditions: Array<IQuestionCondition>;
  /** The category the question refers to (car, ...) */
  displayCategory?: Maybe<Scalars['String']['output']>;
  /**
   * Defines the presence & requiredness of choices, photos and comments.
   *     By default, they are all present and optional
   */
  features: QuestionTemplateFeature;
  /** A manual question ID, set in the question spreadsheet. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The part of the elevator the question is about */
  stateKey?: Maybe<Scalars['String']['output']>;
  /** The text of the question to be asked to the mechanic */
  title: Scalars['String']['output'];
};


/**
 * QuestionTemplate is a template that was hard-set by a human and can be
 *     instanciated to create a Question that can be asked to a mechanic during a visit.
 */
export type QuestionTemplateTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * A question feature specifies for each possible feature of the question if it exists and if it's required.
 *   A task can not be completed without answers to all the required features.
 */
export type QuestionTemplateFeature = {
  __typename?: 'QuestionTemplateFeature';
  /** Defines the existence of choices for a question and whether it is required to select at least one choice */
  choices: QuestionFeatureMode;
  /** Defines the possibility to add a comment and whether it is required to write something in that comment */
  comments: QuestionFeatureMode;
  /** Visibility of the question */
  isVisible: Scalars['Boolean']['output'];
  /** Defines the possibility to attach photos and whether it is required to attach at least one photo */
  photos: QuestionFeatureMode;
  /**
   * Defines the possibility to fill out a work order form and whether it is required to complete it
   * @deprecated Use workOrderFormFeature.mode instead
   */
  workOrderForm: QuestionFeatureMode;
  /** The work order form feature including its mode and optional settings (e.g. canPickExisting, workOrder type) */
  workOrderFormFeature: WorkOrderFormFeature;
};

export type QuestionTemplateFeatureInput = {
  choices: QuestionFeatureMode;
  comments: QuestionFeatureMode;
  isVisible: Scalars['Boolean']['input'];
  photos: QuestionFeatureMode;
};

/** Set of filters to apply to the elevators */
export type QuestionTemplateFilter = {
  /** Get only questions templates belonging to those group templates */
  questionGroupTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Reference to a specific question and optionally its corresponding answer, if one has been provided */
export type QuestionWithAnswerReference = {
  __typename?: 'QuestionWithAnswerReference';
  /** The ID of the answer provided for the question, if any */
  answerId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the question associated with this task */
  questionId: Scalars['ID']['output'];
};

export type QuestionsConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionsPageInfo = {
  __typename?: 'QuestionsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type QuestionsQuestionGroupTemplateConnection = {
  __typename?: 'QuestionsQuestionGroupTemplateConnection';
  edges: Array<QuestionsQuestionGroupTemplateEdge>;
  pageInfo: QuestionsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type QuestionsQuestionGroupTemplateEdge = {
  __typename?: 'QuestionsQuestionGroupTemplateEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: QuestionGroupTemplate;
};

export type QuestionsQuestionTemplateConnection = {
  __typename?: 'QuestionsQuestionTemplateConnection';
  edges: Array<QuestionsQuestionTemplateEdge>;
  pageInfo: QuestionsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type QuestionsQuestionTemplateEdge = {
  __typename?: 'QuestionsQuestionTemplateEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: QuestionTemplate;
};

/** Quote emitted by WeMaintain to a customer */
export type Quote = {
  __typename?: 'Quote';
  /** Operator-authored description of a locally-composed quote: the value the next push sends, where description is the read-only Salesforce mirror. Null on legacy-served quotes and on never-authored drafts (the push then falls back to the first repair request's description). */
  authoredDescription?: Maybe<Scalars['String']['output']>;
  /** Currency used for the amounts (EUR, GBP, SGD, ...) */
  currencyISOCode?: Maybe<Scalars['String']['output']>;
  /** Details regarding the quote (description of each element of the quote) */
  description?: Maybe<Scalars['String']['output']>;
  /** Discount on the total of a locally-composed quote, a ratio (0.2, not 20; 0 = none). The margin readout is judged after it; Salesforce receives the prices before it. Null on legacy-served quotes. */
  discountRate?: Maybe<Scalars['Float']['output']>;
  /** Permanent url to download the latest version of the quote */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Date a which the quote was sent to the customer (by email for example) */
  emittedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Request items deliberately left out of this quote (PRENG-7515) — internal authoring state, admin-only. With the lines, makes every item derivably quoted / excluded / undecided. Empty on legacy Salesforce quotes. */
  excludedRequestItems: Array<QuoteRequestItemExclusion>;
  /** Total amount of the quote (incl. shipping, ...) */
  grandTotal?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** The customer-facing lines of the quote (PRENG-7500). Empty on quotes whose payload still comes from the legacy request-item mapping. */
  lines: Array<QuoteLine>;
  /** Live margin readout (S6): value, direct costs by type, Admin & Ops fee, profit, margin and markup, computed from the lines and the request items behind them; the market's target and the status against it. Internal, admin-only. Null on legacy Salesforce quotes. */
  marginReadout?: Maybe<QuoteMarginReadout>;
  /** Number of the quote */
  number?: Maybe<Scalars['String']['output']>;
  /** Price to target (S6): the prices that would bring each line, then the quote, to its market target, computed live and never written. Internal, admin-only. Null on legacy Salesforce quotes. */
  priceToTargetPreview?: Maybe<PriceToTargetPreview>;
  /** Reference of the quote */
  reference?: Maybe<Scalars['String']['output']>;
  /** Salesforce id of the quote; null = a local draft not yet pushed */
  sfId?: Maybe<Scalars['ID']['output']>;
  /** The status of the quote: TO_SIGN if the quote need the customer review, SIGNED if the customerhas review and validated the quote, REFUSED if customer refuse it. */
  status: WorkOrdersQuoteStatus;
  /** Operator-authored title label of a locally-composed quote. On push, Salesforce names the quote "Q{QuoteNumber} - {label}" (readable back through reference). Null on legacy-served quotes and on never-authored drafts. */
  titleLabel?: Maybe<Scalars['String']['output']>;
  /** Aggregate version of a locally-composed quote: send it with setQuoteDiscount. Null on legacy-served quotes. */
  version?: Maybe<Scalars['Int']['output']>;
};

/** Direct costs of a quote by type, in the quote currency */
export type QuoteDirectCosts = {
  __typename?: 'QuoteDirectCosts';
  /** Every on-site man-hour item of the quote work orders, on a charged line or not */
  labour: Scalars['Float']['output'];
  /** Every other request item type */
  other: Scalars['Float']['output'];
  /** Every part item, external parts included */
  parts: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  /** Every travel man-hour item of the quote work orders, at its on-site item's hourly cost, on a charged line or not */
  travel: Scalars['Float']['output'];
};

export type QuoteLine = {
  __typename?: 'QuoteLine';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  priceListLine?: Maybe<PriceListLine>;
  quantity: Scalars['Int']['output'];
  /** The request items backing this line — a partition: an item belongs to at most one line */
  requestItems: Array<RequestItem>;
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

/** A quote line's cost (S6); its suggested price is in Quote.priceToTargetPreview */
export type QuoteLineMargin = {
  __typename?: 'QuoteLineMargin';
  /**
   * Whether the line is in Quote.priceToTargetPreview.changes or blockingRateLineIds; null with no target
   * @deprecated Read Quote.priceToTargetPreview.changes and Quote.priceToTargetPreview.blockingRateLineIds
   */
  belowTarget?: Maybe<Scalars['Boolean']['output']>;
  /** Σ item cost × quantity behind the line; null when no cost is recorded for it */
  cost?: Maybe<Scalars['Float']['output']>;
  lineId: Scalars['ID']['output'];
  /**
   * The line's newUnitPrice in Quote.priceToTargetPreview.changes; null when Price to target does not change it
   * @deprecated Read the line in Quote.priceToTargetPreview.changes
   */
  targetUnitPrice?: Maybe<Scalars['Float']['output']>;
};

/** Live margin readout of a quote (S6), computed from its lines and the request items behind them. Money values are in the quote currency; margin and markup are ratios (0.4, not 40) */
export type QuoteMarginReadout = {
  __typename?: 'QuoteMarginReadout';
  /** Admin & Ops fee: adminAndOpsFeeRate of the direct costs, an operating cost the price has to cover. The discount does not move it */
  adminAndOpsFee: Scalars['Float']['output'];
  /** The market's Admin & Ops fee rate, a ratio of the direct costs (0.03 when none is configured) */
  adminAndOpsFeeRate: Scalars['Float']['output'];
  /** Request items of the quote's work orders with no recorded cost: the direct costs, and so the margin, miss their cost */
  costlessRequestItemIds: Array<Scalars['ID']['output']>;
  directCosts: QuoteDirectCosts;
  /** Quote.discountRate of valueBeforeDiscount */
  discountAmount: Scalars['Float']['output'];
  /**
   * Lines with a request item whose cost is not recorded: their price counts, not that cost
   * @deprecated Every item cost counts, on a line or not: use costlessRequestItemIds
   */
  excludedLineCount: Scalars['Int']['output'];
  /** margin − target, in points: −9 reads "9 points below target". Null whenever status is */
  gapToTargetPoints?: Maybe<Scalars['Float']['output']>;
  /** Every line of the quote, in the order of Quote.lines */
  lines: Array<QuoteLineMargin>;
  /** profit / value. Null when the value is zero */
  margin?: Maybe<Scalars['Float']['output']>;
  /** profit / (direct costs + fee), for information only: margin is the measure. Null when the value is zero */
  markup?: Maybe<Scalars['Float']['output']>;
  /** value − direct costs − fee */
  profit: Scalars['Float']['output'];
  /** The margin against the target. Null with no target or no margin */
  status?: Maybe<QuoteMarginStatus>;
  /** The market's target margin, a ratio. Null when the market has none */
  targetMargin?: Maybe<Scalars['Float']['output']>;
  /** The value after the discount, valueBeforeDiscount − discountAmount: margin, markup and status are judged on it */
  value: Scalars['Float']['output'];
  /** Σ line sell price × quantity over every line */
  valueBeforeDiscount: Scalars['Float']['output'];
};

/** How a quote's margin stands against its market's target, judged on margin only */
export enum QuoteMarginStatus {
  /** Below the target by less than the Average band */
  Average = 'AVERAGE',
  /** At or above the target */
  Good = 'GOOD',
  /** Below the target by the Average band or more */
  Low = 'LOW'
}

export type QuoteRequestItemExclusion = {
  __typename?: 'QuoteRequestItemExclusion';
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requestItemId: Scalars['String']['output'];
};

/** The status of the quote relating to this report line, if it exists. */
export enum QuoteStatus {
  Rejected = 'REJECTED',
  Sent = 'SENT',
  ToSend = 'TO_SEND',
  Validated = 'VALIDATED'
}

/** Filter quotes */
export type QuotesInputFilters = {
  /** Filter quotes that are owned by the specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter quotes by building */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter quotes that are owned by the specified accounts
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter quotes by device */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter quotes by their ids */
  quoteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter quotes by their statuses */
  quoteStatus?: InputMaybe<Array<WorkOrdersQuoteStatus>>;
};

/** Type of radar used to detect presence */
export enum RadarType {
  BeaBeagle_1Softica = 'BEA_BEAGLE_1_SOFTICA',
  BeaEagleArtek = 'BEA_EAGLE_ARTEK',
  BeaIxioDo = 'BEA_IXIO_DO',
  BeaIxioDp_1 = 'BEA_IXIO_DP_1',
  BeaIxioDt_1 = 'BEA_IXIO_DT_1',
  BeaIxioSt = 'BEA_IXIO_ST',
  BiTech_3Hir_14Softica = 'BI_TECH_3_HIR_14_SOFTICA',
  BiTechIxioDt1Softica = 'BI_TECH_IXIO_DT1_SOFTICA',
  BiTechSsr_3 = 'BI_TECH_SSR_3',
  CombiscanAppliqueGilgen = 'COMBISCAN_APPLIQUE_GILGEN',
  CombiscanEncastreGilgen = 'COMBISCAN_ENCASTRE_GILGEN',
  EagleArtekGilgen = 'EAGLE_ARTEK_GILGEN',
  Hr_100CtBl = 'HR_100_CT_BL',
  IxioDp_1Gilgen = 'IXIO_DP_1_GILGEN',
  IxioDt_1Gilgen = 'IXIO_DT_1_GILGEN',
  IxioStGilgen = 'IXIO_ST_GILGEN',
  Rad_290AcRecord = 'RAD_290_AC_RECORD',
  Rad_290ArRecord = 'RAD_290_AR_RECORD',
  Ric_290AcRecord = 'RIC_290_AC_RECORD'
}

export type RadioInput = FormInput & FormThing & {
  __typename?: 'RadioInput';
  /** If set, means that changing this field would update 1<->1 to the corresponding key in the entity */
  entityKey?: Maybe<Scalars['String']['output']>;
  /** The identifier of this input, to be sent back to the backend */
  key?: Maybe<Scalars['String']['output']>;
  options: Array<InputOption>;
  /** configuration for the display/validation of this input */
  settings: IInputSettings;
  title: Scalars['String']['output'];
  /** Current value associated to the input */
  value?: Maybe<Scalars['ValueOfInput']['output']>;
};

export type RailwaySpecificPeriodsMembers = {
  __typename?: 'RailwaySpecificPeriodsMembers';
  endOfPeriod?: Maybe<TimeDimension>;
  financialYear?: Maybe<Scalars['String']['output']>;
  periodNumber?: Maybe<Scalars['Float']['output']>;
  startOfPeriod?: Maybe<TimeDimension>;
};

export type RailwaySpecificPeriodsOrderByInput = {
  endOfPeriod?: InputMaybe<OrderBy>;
  financialYear?: InputMaybe<OrderBy>;
  periodNumber?: InputMaybe<OrderBy>;
  startOfPeriod?: InputMaybe<OrderBy>;
};

export type RailwaySpecificPeriodsWhereInput = {
  AND?: InputMaybe<Array<RailwaySpecificPeriodsWhereInput>>;
  OR?: InputMaybe<Array<RailwaySpecificPeriodsWhereInput>>;
  endOfPeriod?: InputMaybe<DateTimeFilter>;
  financialYear?: InputMaybe<StringFilter>;
  periodNumber?: InputMaybe<FloatFilter>;
  startOfPeriod?: InputMaybe<DateTimeFilter>;
};

/** ReferenceLine */
export type ReferenceLine = {
  __typename?: 'ReferenceLine';
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

/** Filters to apply when fetching the users that managed at least one contract */
export type ReferentUsersFilter = {
  /**
   * Filter the users by the territory of the customers
   * @deprecated Use territories instead
   */
  customerTerritories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter admin users by their own territory (ISO country code) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Refresh report of supplied tasks/missions */
export type RegenReportPayload = {
  /** missions to regen (will regen both mission reports and reports of all the tasks in the mission) */
  missionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** tasks to regen (will regen both the task report and its mission report if applicable) */
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RegenedReport = {
  __typename?: 'RegenedReport';
  missionIds?: Maybe<Array<Scalars['ID']['output']>>;
  succesfullySentRegenResquests: Scalars['Boolean']['output'];
  taskIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Payload to send a device token linked to a user */
export type RegisterPushNotificationTokenPayload = {
  /** token linked to the device/phone of the user */
  deviceToken: Scalars['String']['input'];
};

export type ReleaseRepairRequestActionFromHoldInput = {
  /** The action on hold to bring back now */
  actionId: Scalars['String']['input'];
  /** The work order the action is on */
  repairRequestId: Scalars['String']['input'];
};

/** Input to remove an item from a request */
export type RemoveItemInput = {
  /** The id of the repair request where we want the request item to be removed from */
  repairRequestId: Scalars['String']['input'];
  /** The id of the request item to be removed */
  requestItemId: Scalars['String']['input'];
};

/** GraphQL Input Payload to remove a thing.At least one of `thingId` or `thingName` must be provided. */
export type RemoveThingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The date when the thing was actually removed. If null we will assume it just been removed */
  removalDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Repair request made by an engineer to correct an issue on a specific device */
export type RepairRequest = {
  __typename?: 'RepairRequest';
  /** What's needed on the request, and by whom: the open actions, or every occurrence with includeClosed, oldest first. Null when the action center is off for the caller. */
  actions?: Maybe<Array<RepairRequestAction>>;
  aiSummary: Inference;
  /**
   * Estimated date when all the parts that requiring to be delivered will be available
   * @deprecated Use estimatedPartsDeliveryDate instead
   */
  allPartDeliveredEstimatedDate?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Other repair requests sharing the same Salesforce quote id. Returns an empty connection when no quote is linked. */
  bundledRepairRequests: WorkOrdersRepairRequestBundledRepairRequestGraphqlRepairRequestGraphqlConnection;
  /** If this repair request needs to be invoiced to the customer */
  chargeable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Short text describing the repair request purpose
   * @deprecated Moved to engineerComment & internalComment
   */
  comment?: Maybe<Scalars['String']['output']>;
  /** The creator of the repair request */
  createdBy?: Maybe<RepairRequestContextualUserInfo>;
  /** Date at which the repair request was made */
  createdDate: Scalars['DateTime']['output'];
  /** Selected delivery option, how the part of this repair request will be delivered to the mechanic */
  deliveryOption?: Maybe<RepairRequestDeliveryOption>;
  /** Short text describing the repair request purpose */
  description: Scalars['String']['output'];
  /** Device this repair request is for */
  device: Device;
  /** Engineer's description of the repair request */
  engineerComment?: Maybe<Scalars['String']['output']>;
  /** Date at which all the parts of the request are estimated to be delivered from our supplier. Is the max of the ETA of all parts */
  estimatedPartsDeliveryDate?: Maybe<Scalars['Date']['output']>;
  /** Generate an AI digest from a work order for external communication */
  externalCommunicationDigest: Inference;
  /** Generate an AI-authored email from a work order digest context */
  externalCommunicationEmail: Inference;
  /** Represent all the informations regarding the field execution of this repair request */
  fieldExecution?: Maybe<RepairRequestFieldExecution>;
  /**
   * Represent the status of the repair request regarding field execution. If the work can be done by an engineer or if the works has been done but needs to be validated by an ops or if everything is done and validated on site.Note that the status is null until the quote is validated or if no quote the parts if any have been ordered
   * @deprecated Use fieldExecution.status instead
   */
  fieldExecutionStatus?: Maybe<RepairRequestFieldExecutionStatus>;
  id: Scalars['ID']['output'];
  /** Internal comment of this repair request, used mainly by ops */
  internalComment?: Maybe<Scalars['String']['output']>;
  /** Generate an AI digest from a work order */
  internalDigest: Inference;
  /** Indicates whether this repair request is part of an automated policy workflow (such as auto create, part auto added or quote auto generated) */
  isAutomatedWorkflow: Scalars['Boolean']['output'];
  /** Indicates whether at least one request item is withdrawable by the engineer */
  isWithdrawable: Scalars['Boolean']['output'];
  /** All the issues we want to fix with this repair request */
  issues: WorkOrdersRepairRequestIssueGraphqlIssueSnapshotConnection;
  /** The sales order ID */
  netsuiteSalesOrderId?: Maybe<Scalars['String']['output']>;
  /** Link to the Netsuite Sales Order */
  netsuiteSalesOrderLink?: Maybe<Scalars['String']['output']>;
  /** Display the requested items photos */
  photos: Array<Scalars['String']['output']>;
  /**
   * The problem linked to this repair request, if any
   * @deprecated Use problems instead
   */
  problem?: Maybe<Problem>;
  /** The problems linked to this repair request, if any */
  problems: Array<Problem>;
  /** Attached quote */
  quote?: Maybe<Quote>;
  /** Represent the status of a quote from a business point of view in the repair request domain. This state is repair request related and front oriented, this is not the same as the quote.status. */
  quoteState?: Maybe<WorkOrdersRepairRequestQuoteState>;
  /** The autogenerated unique number of a repair request (in a readable format). The format is R{last-digit-of-the-year}-{number-of-the-rr-in-the-year} (R24-00001) */
  repairRequestNumber?: Maybe<Scalars['String']['output']>;
  /** item requested in the repair request */
  requestItems?: Maybe<Array<RequestItem>>;
  /** The user who asked for this repair request */
  requester?: Maybe<User>;
  /** The Id of the quote linked to a repair request on Salesforce */
  sfQuoteId?: Maybe<Scalars['String']['output']>;
  /** Link to Salesforce quote */
  sfQuoteLink?: Maybe<Scalars['String']['output']>;
  /** Represent the state of the repair request. Based on the request info and its items states return a simple and understandable state from a business point of view of the actions to be carried out next */
  state?: Maybe<RepairRequestState>;
  /**
   * Represent the status of the request (the less advanced status of all the requested items)
   * @deprecated Legacy status used in previous airtable flow, please use state instead.
   */
  status: RepairRequestStatus;
  /** The email of the supply chain manager handling the repair request - might be deprecated soon to have a User resource instead */
  supplyChainManagerEmail?: Maybe<Scalars['String']['output']>;
  /** The status of the support requested to diagnose/repair this Repair Request (if any) */
  supportRequest: RepairRequestSupportGraphql;
  /** Work-order types this repair request can be switched to. Empty array means no switch is possible. */
  switchableWorkOrderTypes: Array<WorkOrderType>;
  /**
   * All the tasks where works related to the repair request took place
   * @deprecated Use fieldExecution.tasks instead
   */
  tasks: WorkOrdersRepairRequestTaskGraphqlTaskConnection;
  /** Title of the repair request */
  title: Scalars['String']['output'];
  /** Date at which the repair request was made */
  updatedDate: Scalars['DateTime']['output'];
  /** A repair request can have a deadline which means that, depending on the level, the request has to be treated as soon as possible (urgent) or at a later date (ie for this week) */
  urgencyLevel: UrgencyLevel;
  /** Type of work order */
  workOrderType: WorkOrderType;
};


/** Repair request made by an engineer to correct an issue on a specific device */
export type RepairRequestActionsArgs = {
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Repair request made by an engineer to correct an issue on a specific device */
export type RepairRequestAiSummaryArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Repair request made by an engineer to correct an issue on a specific device */
export type RepairRequestBundledRepairRequestsArgs = {
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


/** Repair request made by an engineer to correct an issue on a specific device */
export type RepairRequestExternalCommunicationDigestArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Repair request made by an engineer to correct an issue on a specific device */
export type RepairRequestExternalCommunicationEmailArgs = {
  audience: Scalars['String']['input'];
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  length: Scalars['String']['input'];
  tone: Scalars['String']['input'];
};


/** Repair request made by an engineer to correct an issue on a specific device */
export type RepairRequestInternalDigestArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Repair request made by an engineer to correct an issue on a specific device */
export type RepairRequestIssuesArgs = {
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};


/** Repair request made by an engineer to correct an issue on a specific device */
export type RepairRequestTasksArgs = {
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};

/** One occurrence of an action on a repair request: one step, held by one holder, from when it opened until the step left. Derived from the request, not typed by people. */
export type RepairRequestAction = {
  __typename?: 'RepairRequestAction';
  /** Who the latest chase asked: the step is in their Chased me while it's open. Null when it was never chased, or chased off-platform naming no one (the customer, a supplier). */
  chasedUser?: Maybe<User>;
  /** The latest chase's: when to look again, the step not late before then. Null when it was never chased, or chased with no deadline and no normal duration. */
  checkAt?: Maybe<Scalars['DateTime']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who closed it, null when the closing event has no user (Salesforce, NetSuite, system) */
  closedBy?: Maybe<User>;
  closedReason?: Maybe<Scalars['String']['output']>;
  /** When it is due, the instant it becomes late: the date someone outside gave, or its normal duration after the step became the holder's. For a part, NetSuite's due day is over: 00:00 UTC the day after it, so show "Expected by" as the day before. Null when the step has neither: it is then never late. */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** The latest hand-over's note */
  handOverNote?: Maybe<Scalars['String']['output']>;
  /** When it was last handed over: the receiver's normal duration counts from then. Null when it is not handed over, or was taken back. */
  handedOverAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who handed it over last, the giver: in their Waiting on others, they can take it back. Null when it is not handed over, was taken back, or the system handed it over. */
  handedOverBy?: Maybe<User>;
  /** Who it was handed over to: they act on it, in their Mine to move whatever the unit. Null when it is not handed over, or was taken back. It stays on a closed action. */
  handedOverTo?: Maybe<User>;
  /** When it was last put on hold */
  heldAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who put it on hold last, null when it was never put on hold or the system did */
  heldBy?: Maybe<User>;
  /** The latest date it can be put on hold until now, from the work order's type and chargeability: the date picker's limit */
  holdLatestUntil: Scalars['DateTime']['output'];
  /** The latest hold's note */
  holdNote?: Maybe<Scalars['String']['output']>;
  /** The latest hold's: on hold before then, back from hold after it ("Back from hold" once passed). A release, or someone changing the work order, brings it forward to that day. Null when it was never put on hold. */
  holdUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Who must act on it: the receiver once handed over (see handedOverTo); else the CSM of the unit, the mechanic the request was raised for, or the support engineer's user. Null for the other roles, and for a CSM action that waits on the customer. */
  holder?: Maybe<User>;
  holderRole: ActionHolderRole;
  id: Scalars['ID']['output'];
  /** The step: the type, or type:scope (e.g. DO_SUPPORT_VISIT:<supportItemId>) */
  key: Scalars['String']['output'];
  /** When it was last chased */
  lastChasedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who chased it last, null when it was never chased or the system did */
  lastChasedBy?: Maybe<User>;
  /** Open, whether it is past its due date now; closed, whether it closed after it */
  late: Scalars['Boolean']['output'];
  /** Open and on hold now: in its holder's Waiting on others, neither late nor To chase */
  onHold: Scalars['Boolean']['output'];
  openedAt: Scalars['DateTime']['output'];
  repairRequest: RepairRequest;
  /** The catalogue rule that produced it */
  ruleId: Scalars['String']['output'];
  /** When the step became the holder's */
  since: Scalars['DateTime']['output'];
  status: RepairRequestActionStatus;
  type: RepairRequestActionType;
  waitingOn: ActionWaitingOn;
};

/** Filter repair request actions. Filters combine with AND; anyOf adds groups combined with OR. A CSM's lists, with me their user id: Yours = { heldByUserIds: [me], statuses: [OPEN], anyOf: [{ onHold: false }, { repairRequest: { workOrderTypes: [SHUTDOWN] } }] }: held by me AND open AND (not on hold OR on a shutdown work order). Stuck = Yours + { late: true }. To chase = { statuses: [OPEN], late: true, excludeHeldByUserIds: [me], repairRequest: { opsReferentUserIds: [me] } }. Chased me = { chasedUserIds: [me], statuses: [OPEN] }. All = { anyOf: [Yours, To chase, Chased me] }. Waiting on others = { statuses: [OPEN], anyOf: [{ late: false, excludeHeldByUserIds: [me], repairRequest: { opsReferentUserIds: [me] } }, { heldByUserIds: [me], onHold: true, repairRequest: { workOrderTypes: [CALLOUT, REPAIR] } }, { handedOverByUserIds: [me] }] }: with my own actions on hold, but not those on a shutdown, still in Yours, and what I handed over, whatever the unit; narrowed with waitingOn (Held by). Done = { statuses: [DONE, DISCARDED, MOVED_ON], closedAt: [{ after: <start of the viewer's day> }], involvingUserIds: [me] }, ordered by closedAt descending. */
export type RepairRequestActionFilters = {
  /** Filter sets any of which the actions must pass (OR), on top of the other filters here (AND). An empty list filters nothing. */
  anyOf?: InputMaybe<Array<RepairRequestActionFilters>>;
  /** The open actions whose latest chase asked one of these people (see RepairRequestAction.chasedUser). An action leaves it when it closes, when the step moves on, or when a later chase asks someone else. */
  chasedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Narrows on when the action closed, leaving out the open ones */
  closedAt?: InputMaybe<Array<DateFilter>>;
  /** Narrows on when the action is due, leaving out the ones with no due date */
  dueAt?: InputMaybe<Array<DateFilter>>;
  /** Leaves out the actions these people must act on now, as heldByUserIds finds them. Keeps the actions someone else must act on, and the ones no one must act on yet, like a CSM action that waits on the customer. */
  excludeHeldByUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The actions these people handed over last, the givers (see RepairRequestAction.handedOverBy), whatever the unit: the giver's Waiting on others. An action leaves it when it is taken back or handed on, and with its occurrence when the step moves on. */
  handedOverByUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The people who must act on them now, whatever their role and unit: the receiver of an action handed over, else its rule's holder. So far the rule resolves the CSM of the unit, for the CSM actions that do not wait on the customer. */
  heldByUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  holderRoles?: InputMaybe<Array<ActionHolderRole>>;
  /** The actions these people hold, as heldByUserIds finds them, open or however they closed; the ones they handed over last; and the ones they closed with Done or Discard, whoever held them. */
  involvingUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether they are late (see RepairRequestAction.late): open and past their due date, or closed after it. An action with no due date is never late. */
  late?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether they are on hold now (see RepairRequestAction.onHold): open, with a holdUntil still to come */
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  /** The request filters, on each action's work order, as on the request list */
  repairRequest?: InputMaybe<RepairRequestInputFilters>;
  /** Narrows on when the step became the holder's */
  since?: InputMaybe<Array<DateFilter>>;
  statuses?: InputMaybe<Array<RepairRequestActionStatus>>;
  /** Who the request waits on for them (see RepairRequestAction.waitingOn): the Held by filter on Waiting on others */
  waitingOn?: InputMaybe<Array<ActionWaitingOn>>;
};

export enum RepairRequestActionOrmEntitySortableFields {
  ClosedAt = 'closedAt',
  OpenedAt = 'openedAt',
  Since = 'since'
}

/** Where an action stands. MOVED_ON: the request left the step, or the step passed to another holder, before anyone marked it done or discarded it */
export enum RepairRequestActionStatus {
  Discarded = 'DISCARDED',
  Done = 'DONE',
  MovedOn = 'MOVED_ON',
  Open = 'OPEN'
}

/** What has to be done on a repair request */
export enum RepairRequestActionType {
  AssignRepairSupportEngineer = 'ASSIGN_REPAIR_SUPPORT_ENGINEER',
  AssignTechSupportEngineer = 'ASSIGN_TECH_SUPPORT_ENGINEER',
  ChaseQuote = 'CHASE_QUOTE',
  CollectPart = 'COLLECT_PART',
  ConfirmSubcontractorDate = 'CONFIRM_SUBCONTRACTOR_DATE',
  DoSupportVisit = 'DO_SUPPORT_VISIT',
  DoVisit = 'DO_VISIT',
  IdentifyPart = 'IDENTIFY_PART',
  PricePart = 'PRICE_PART',
  ReceivePart = 'RECEIVE_PART',
  RequoteOrClose = 'REQUOTE_OR_CLOSE',
  SendQuote = 'SEND_QUOTE',
  SendSupplierPo = 'SEND_SUPPLIER_PO',
  SendToNetsuite = 'SEND_TO_NETSUITE',
  VerifyAndClose = 'VERIFY_AND_CLOSE',
  VerifyPo = 'VERIFY_PO'
}

/** Input to assign an expert (a mechanic) to a request item of type support (tech / repair) */
export type RepairRequestAssignExpertToSupportItemInput = {
  /** The mechanic expert id that will be assigned to the support request */
  mechanicId: Scalars['ID']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['ID']['input'];
  /** The id of the request item to assign the expert */
  requestItemId: Scalars['ID']['input'];
};

/** Contextual user info of a repair request */
export type RepairRequestContextualUserInfo = {
  __typename?: 'RepairRequestContextualUserInfo';
  /** The email of the user */
  email: Scalars['String']['output'];
  /** The full name of the user */
  name: Scalars['String']['output'];
  /** The id of the user */
  userId?: Maybe<Scalars['String']['output']>;
};

/** Input to delete subcontractor reports from a repair request */
export type RepairRequestDeleteSubcontractorReportsInput = {
  /** The id of the repair request we want to delete the subcontractor reports */
  repairRequestId: Scalars['ID']['input'];
  /** reports ids we want to delete */
  reportIds: Array<Scalars['ID']['input']>;
};

/** Delivery option when a part is ordered with its value and its title */
export type RepairRequestDeliveryOption = {
  __typename?: 'RepairRequestDeliveryOption';
  /** The country code where this delivery option applies */
  countryCode: Scalars['String']['output'];
  /** Unique identifier representing the delivery option */
  id: Scalars['ID']['output'];
  /** Text describing the delivery option */
  title: Scalars['String']['output'];
};

/** Filter repair requests delivery options */
export type RepairRequestDeliveryOptionInputFilters = {
  /** Filter delivery option by country code */
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RepairRequestExecutionQuestion = Question & {
  __typename?: 'RepairRequestExecutionQuestion';
  /** Different answers that can be chosen for this question */
  answerTemplates: Array<IAnswerTemplate>;
  /** Conditions in which this question should appears */
  conditions: Array<IQuestionCondition>;
  /** The category the question refers to (car, ...) */
  displayCategory?: Maybe<Scalars['String']['output']>;
  /** The sub-category the question refers to, used to group questions in the same category */
  displaySubCategory?: Maybe<QuestionSubCategory>;
  /**
   * Defines the presence & requiredness of choices, photos and comments.
   *     By default, they are all present and optional
   */
  features: QuestionTemplateFeature;
  /** Hint to help the user answer the question */
  hint?: Maybe<Scalars['String']['output']>;
  /** A manual question ID, set in the question spreadsheet. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** QuestionTemplate that was used to create that question */
  questionTemplate: QuestionTemplate;
  /** Resolve the id of the repair request linked to the question for federation */
  repairRequest: RepairRequest;
  /** The part of the elevator the question is about */
  stateKey?: Maybe<Scalars['String']['output']>;
  /** The text of the question to be asked to the mechanic */
  title: Scalars['String']['output'];
  /** Work order linked to that question */
  workOrder?: Maybe<RepairRequest>;
};


export type RepairRequestExecutionQuestionHintArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RepairRequestExecutionQuestionTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Info regarding the field execution of a repair request, like it's status, if it's subcontractedor the tasks link... */
export type RepairRequestFieldExecution = {
  __typename?: 'RepairRequestFieldExecution';
  /** If this repair request field execution is subcontracted or not */
  isSubcontracted?: Maybe<Scalars['Boolean']['output']>;
  /** Represent the status of the repair request regarding field execution. If the work can be done by an engineer or if the works has been done but needs to be validated by an ops or if everything is done and validated on site.Note that the status is null until the quote is validated or if no quote the parts if any have been ordered */
  status?: Maybe<RepairRequestFieldExecutionStatus>;
  /** The link to the netsuite purchase order of the subcontractor if the repair is subcontracted */
  subcontractorPurchaseOrderLink?: Maybe<Scalars['String']['output']>;
  /** All subcontractor reports link to this repair request */
  subcontractorReports: Array<RepairRequestSubcontractorReportGraphql>;
  /** All the tasks where works related to the repair request took place */
  tasks: WorkOrdersRepairRequestTaskGraphqlTaskConnection;
};


/** Info regarding the field execution of a repair request, like it's status, if it's subcontractedor the tasks link... */
export type RepairRequestFieldExecutionTasksArgs = {
  pagination?: InputMaybe<WorkOrdersConnectionArgs>;
};

/** Repair request status about the field execution, if the work can be done during a visit, has been done and need validation by an ops or is done */
export enum RepairRequestFieldExecutionStatus {
  Done = 'DONE',
  WorkToDo = 'WORK_TO_DO',
  WorkToVerify = 'WORK_TO_VERIFY'
}

/** Filter repair requests linked to the building */
export type RepairRequestForBuildingInputFilters = {
  /** If the request is related to a paused device */
  devicePaused?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the request is related to a stopped device */
  deviceStopped?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the request is related to a working device */
  deviceWorking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests based on if they are subcontracted or not. When requesting for non subcontracted it will also return repairs where we don't have the info yet */
  fieldExecutionIsSubcontracted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by their field execution status (regarding works on site) */
  fieldExecutionStatuses?: InputMaybe<Array<RepairRequestFieldExecutionStatus>>;
  /** Filter repair requests by their ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If the request is chargeable or not. If not provided, the filter will not be applied. */
  isChargeable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by the type of the item within it (PART/EXTERNAL_PART/MAN_HOUR/TECH_SUPPORT/REPAIR_SUPPORT). Be aware that this filter will also exclude the item of type not requested from the data returned. */
  itemTypes?: InputMaybe<Array<RequestItemTypeEnum>>;
  /** Filter repair requests by  the mechanics that have issued it */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search by partial or entire repair request number */
  repairRequestNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filter repair requests by the requester */
  requesterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search for repair request description matching */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter repair requests by their states */
  states?: InputMaybe<Array<RepairRequestState>>;
  /** Filter repair requests by supply manager emails */
  supplyManagerEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter repair requests by urgency levels */
  urgencyLevels?: InputMaybe<Array<UrgencyLevel>>;
};

/** Filter repair requests for a device */
export type RepairRequestForDeviceInputFilters = {
  /** If the request is related to a paused device */
  devicePaused?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the request is related to a stopped device */
  deviceStopped?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the request is related to a working device */
  deviceWorking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests based on if they are subcontracted or not. When requesting for non subcontracted it will also return repairs where we don't have the info yet */
  fieldExecutionIsSubcontracted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by their field execution status (regarding works on site) */
  fieldExecutionStatuses?: InputMaybe<Array<RepairRequestFieldExecutionStatus>>;
  /** Filter repair requests by their ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If the request is chargeable or not. If not provided, the filter will not be applied. */
  isChargeable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Convenient filter to retrieve repair request that are still in progress if set to true, meaning that the repair request is not DONE / CANCELLED nor DENIED. If set to false it will return all repair request DONE / CANCELLED or DENIED. */
  isOngoing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by the type of the item within it (PART/EXTERNAL_PART/MAN_HOUR/TECH_SUPPORT/REPAIR_SUPPORT). Be aware that this filter will also exclude the item of type not requested from the data returned. */
  itemTypes?: InputMaybe<Array<RequestItemTypeEnum>>;
  /** Filter repair requests if they are linked to an issue */
  linkedToIssues?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by  the mechanics that have issued it */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search by partial or entire repair request number */
  repairRequestNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filter repair requests by the requester */
  requesterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search for repair request description matching */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter repair requests by their states */
  states?: InputMaybe<Array<RepairRequestState>>;
  /** Filter repair requests by supply manager emails */
  supplyManagerEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter repair requests by urgency levels */
  urgencyLevels?: InputMaybe<Array<UrgencyLevel>>;
  /** Filter repair requests by work order type (REPAIR or CALLOUT) */
  workOrderTypes?: InputMaybe<Array<WorkOrderType>>;
};

/** Filters to apply when fetching visible repair requests for a mechanic */
export type RepairRequestForMechanicInputFilters = {
  /** Filter repair requests by buildings where the device of the request is located */
  buildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter repair requests by devices */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of device statuses ("working", "paused", "stopped") to filter repair requests by. */
  deviceStatuses?: InputMaybe<Array<DeviceStateStatus>>;
  /** Filter repair requests by the type of the device of the request */
  deviceTypes?: InputMaybe<Array<DeviceTypeEnum>>;
  /** Filter repair requests by their ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If the request is chargeable or not. If not provided, the filter will not be applied. */
  isChargeable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Convenient filter to retrieve repair request that are still in progress if set to true, meaning that the repair request is not DONE / CANCELLED nor DENIED. If set to false it will return all repair request DONE / CANCELLED or DENIED. */
  isOngoing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by the type of the item within it (PART/EXTERNAL_PART/MAN_HOUR/TECH_SUPPORT/REPAIR_SUPPORT). Be aware that this filter will also exclude the item of type not requested from the data returned. */
  itemTypes?: InputMaybe<Array<RequestItemTypeEnum>>;
  /** Search for repair request description matching */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter repair requests by their states */
  states?: InputMaybe<Array<RepairRequestState>>;
  /** Filter repair requests by urgency levels */
  urgencyLevels?: InputMaybe<Array<UrgencyLevel>>;
  /** Filter repair requests by work order type (REPAIR or CALLOUT) */
  workOrderTypes?: InputMaybe<Array<WorkOrderType>>;
};

/** Filter repair requests */
export type RepairRequestInputFilters = {
  /** Filter repair requests by the account on the contract */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter repair requests by buildings where the device of the request is located */
  buildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter repair requests by its creation date */
  createdAt?: InputMaybe<Array<DateFilter>>;
  /** Filter repair requests by devices */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If the request is related to a paused device */
  devicePaused?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of device statuses ("working", "paused", "stopped") to filter repair requests by. */
  deviceStatuses?: InputMaybe<Array<DeviceStateStatus>>;
  /** If the request is related to a stopped device */
  deviceStopped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by the type of the device of the request */
  deviceTypes?: InputMaybe<Array<DeviceTypeEnum>>;
  /** If the request is related to a working device */
  deviceWorking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests based on if they are subcontracted or not. When requesting for non subcontracted it will also return repairs where we don't have the info yet */
  fieldExecutionIsSubcontracted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by their field execution status (regarding works on site) */
  fieldExecutionStatuses?: InputMaybe<Array<RepairRequestFieldExecutionStatus>>;
  /** Filter repair requests that have one item of type repair support requested if set to true.If set to false it will return only the repair request with no repair support item.This is a convenient filter to retrieve repair requests with or without item type: REPAIR_SUPPORT. */
  hasRepairSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, filter repair request with repair a support item and an expert assigned. If set to false, it will also filter repair request with a repair support item but expert still need to be assigned. To summarize, this filter works only on repair request with repair support item (REPAIR_SUPPORT) when used. */
  hasRepairSupportExpertAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests that have at least one item of type tech/repair support requested if set to true.If set to false it will return only the repair request with no support item at all.This is a convenient filter to retrieve repair requests with or without item type: TECH_SUPPORT or REPAIR_SUPPORT. */
  hasSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, filter repair request with repair or tech a support item and an expert assigned. If set to false, it will also filter repair request with a tech or repair support item but expert still need to be assigned. To summarize, this filter works only on repair request with support item (REPAIR_SUPPORT / TECH_SUPPORT) when used. */
  hasSupportExpertAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests that have one item of type tech support requested if set to true.If set to false it will return only the repair request with no tech support item.This is a convenient filter to retrieve repair requests with or without item type: TECH_SUPPORT. */
  hasTechSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, filter repair request with tech a support item and an expert assigned. If set to false, it will also filter repair request with a tech support item but expert still need to be assigned. To summarize, this filter works only on repair request with tech support item (TECH_SUPPORT) when used. */
  hasTechSupportExpertAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by their ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If set to true, filter repair requests that were created automatically (have an automation context). If set to false, filter repair requests that were created manually (no automation context). */
  isAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the request is chargeable or not. If not provided, the filter will not be applied. */
  isChargeable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Convenient filter to retrieve repair request that are still in progress if set to true, meaning that the repair request is not DONE / CANCELLED nor DENIED. If set to false it will return all repair request DONE / CANCELLED or DENIED. */
  isOngoing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by the type of the item within it (PART/EXTERNAL_PART/MAN_HOUR/TECH_SUPPORT/REPAIR_SUPPORT). Be aware that this filter will also exclude the item of type not requested from the data returned. */
  itemTypes?: InputMaybe<Array<RequestItemTypeEnum>>;
  /** Filter repair requests if they are linked to an issue */
  linkedToIssues?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by  the mechanics that have issued it */
  mechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter repair requests by the manager of the ops referent user on the contract. Given a list of user IDs, repair requests whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter repair requests by the ops that are the referent of the device on the contract */
  opsReferentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter repair requests by whether their linked problem has the dilap flag */
  problemDilap?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter repair requests by linked problem state keys */
  problemStateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search by partial or entire repair request number */
  repairRequestNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filter repair requests by the mechanic assigned to repair support items. */
  repairSupportAssignedMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter repair requests by the requester */
  requesterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search for repair request description matching */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter repair requests by their Salesforce quote ids */
  sfQuoteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter repair requests by their states */
  states?: InputMaybe<Array<RepairRequestState>>;
  /** Filter repair requests by supply manager emails */
  supplyManagerEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter repair requests by the mechanic assigned to repair or tech support items. */
  supportAssignedMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter repair requests by field-execution task ids */
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter repair requests by the mechanic assigned to tech support items. */
  techSupportAssignedMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter repair requests by the territory of the contract */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter repair requests by urgency levels */
  urgencyLevels?: InputMaybe<Array<UrgencyLevel>>;
  /** Filter repair requests by work order type (REPAIR or CALLOUT) */
  workOrderTypes?: InputMaybe<Array<WorkOrderType>>;
};

export enum RepairRequestOrmEntitySortableFields {
  CreatedAt = 'createdAt',
  DeviceBrokenSince = 'deviceBrokenSince'
}

/** Unique problem state key referenced by repair requests */
export type RepairRequestProblemStateKey = {
  __typename?: 'RepairRequestProblemStateKey';
  /** Human readable label for this state key, translated in the given language */
  label?: Maybe<Scalars['String']['output']>;
  stateKey: Scalars['String']['output'];
};


/** Unique problem state key referenced by repair requests */
export type RepairRequestProblemStateKeyLabelArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input to add a part item to a repair request */
export type RepairRequestRequestSupportInput = {
  /** Engineer comment regarding the purpose of the support request */
  comment: Scalars['String']['input'];
  /** Photos/screenshots adding context to the support request */
  photos?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
  /** The type of support requested, for example the repair team help or technical help. */
  supportType: RequestSupportTypeEnum;
};

/** State of a repair request, defined from a business point of view the state of the request */
export enum RepairRequestState {
  Cancelled = 'CANCELLED',
  Denied = 'DENIED',
  Done = 'DONE',
  PartToEstimate = 'PART_TO_ESTIMATE',
  PartToIdentify = 'PART_TO_IDENTIFY',
  PartToInstall = 'PART_TO_INSTALL',
  PartToOrder = 'PART_TO_ORDER',
  PartToPurchase = 'PART_TO_PURCHASE',
  PartToReceive = 'PART_TO_RECEIVE',
  PartToWithdraw = 'PART_TO_WITHDRAW',
  QuoteToSend = 'QUOTE_TO_SEND',
  QuoteToSignByCustomer = 'QUOTE_TO_SIGN_BY_CUSTOMER',
  QuoteToVerifyPo = 'QUOTE_TO_VERIFY_PO',
  WorkToDo = 'WORK_TO_DO',
  WorkToVerify = 'WORK_TO_VERIFY'
}

/** Status of a repair request including the type of status and its title */
export type RepairRequestStatus = {
  __typename?: 'RepairRequestStatus';
  /** The text representing the status of the repair request */
  title: Scalars['String']['output'];
  /** Unique value representing the status */
  value: RepairRequestStatusEnum;
};


/** Status of a repair request including the type of status and its title */
export type RepairRequestStatusTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The status of the repair request, is it SENT, VALIDATED... represent the progress of the request */
export enum RepairRequestStatusEnum {
  Canceled = 'CANCELED',
  Done = 'DONE',
  InTreatment = 'IN_TREATMENT',
  PartAvailable = 'PART_AVAILABLE',
  PartOrdered = 'PART_ORDERED',
  QuoteAccepted = 'QUOTE_ACCEPTED',
  QuoteSent = 'QUOTE_SENT',
  Sent = 'SENT'
}

/** Report of a subcontractor */
export type RepairRequestSubcontractorReportGraphql = {
  __typename?: 'RepairRequestSubcontractorReportGraphql';
  /** The report filename */
  filename: Scalars['String']['output'];
  /** The unique identifier of the subcontractor report */
  id: Scalars['ID']['output'];
  /** The url to download the report */
  reportUrl: Scalars['String']['output'];
  /** Date at which the report was uploaded */
  uploadedDate: Scalars['DateTime']['output'];
};

/** Supply manager handling the repair request */
export type RepairRequestSupplyManager = {
  __typename?: 'RepairRequestSupplyManager';
  email: Scalars['String']['output'];
};

/** Tracks the requests for support that an engineer might have made in order to advance with the repair request */
export type RepairRequestSupportGraphql = {
  __typename?: 'RepairRequestSupportGraphql';
  /** Repair support is for when a help is required to actually perform the repair */
  repairSupport: RepairRequestSupportItemGraphql;
  /** Tech support is for when a diagnostic help is required */
  techSupport: RepairRequestSupportItemGraphql;
};

/** Support request item for a repair request, A support request is when an engineer needs help to fully solve a Repair Request, either through diagnostic or actual repair on the field */
export type RepairRequestSupportItemGraphql = {
  __typename?: 'RepairRequestSupportItemGraphql';
  /** The mechanic assigned to this support request, if any */
  assignedMechanic?: Maybe<Mechanic>;
  /** Indicates if the support request was requested */
  required: Scalars['Boolean']['output'];
};

/** Input to link a netsuite purchase order to a repair request, if purchaseOrderLink is null then it will unlink the purchase order */
export type RepairRequestUpdateSubcontractorPurchaseOrderLinkInput = {
  /** The netsuite url to the purchase order or null to remove the link */
  purchaseOrderLink?: InputMaybe<Scalars['String']['input']>;
  /** The id of the repair request we want to update */
  repairRequestId: Scalars['ID']['input'];
};

/** Input to upload subcontractor reports to a repair request */
export type RepairRequestUploadSubcontractorReportsInput = {
  /** The id of the repair request we want to upload subcontractor reports */
  repairRequestId: Scalars['ID']['input'];
  /** Subcontractor reports to upload */
  reports: Array<Scalars['Upload']['input']>;
};

export type RepairSupportRequestItem = RequestItem & {
  __typename?: 'RepairSupportRequestItem';
  /** The repair support expert (mechanic) assigned on this support request */
  assignedMechanic?: Maybe<Mechanic>;
  /** If this requested item needs to be invoiced to the customer */
  chargeable?: Maybe<Scalars['Boolean']['output']>;
  /** Short text describing the purpose of the repair support */
  comment: Scalars['String']['output'];
  /** Date when the request item should be delivered from our supplier */
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The human identifier for a request (at the moment it is the id within airtable)
   * @deprecated Airtable is not used anymore. This field is deprecated and will be removed in the future.
   */
  humanId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** If the item is withdrawable by the engineer */
  isWithdrawable: Scalars['Boolean']['output'];
  /**
   * Comment of the ops about the requested item
   * @deprecated Comments are not found on individual parts anymore but on the request as a whole. Use RepairRequest.enginerComment or RepairRequest.internalComment
   */
  opsComment?: Maybe<Scalars['String']['output']>;
  /** Order progression data synced from Netsuite for this request item */
  orderProgression?: Maybe<RequestItemOrderProgression>;
  /** Display the repair support requested item photos */
  photos: Array<Scalars['String']['output']>;
  /** Cost of the item (what we pay). This represents the company's cost for the item. Use sellPrice for the margin/sell price. Can be null if not set yet. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The quote line this item backs — a partition: an item belongs to at most one line (PRENG-7500) */
  quoteLine?: Maybe<QuoteLine>;
  repairRequestId: Scalars['ID']['output'];
  /**
   * Sell price of the item (separate from cost). Used for items that need to track separate cost and margin, such as Installation items. Can be null if not set.
   * @deprecated What the customer pays lives on QuoteLine.sellPrice (PRENG-7500); this is never written anymore
   */
  sellPrice?: Maybe<Scalars['Float']['output']>;
  /** Represent the state of the request item (should be used in place of status). Based on the type of the itemand its current data it return a state representing the next action to be done on a business point of view. */
  state?: Maybe<RequestItemState>;
  /**
   * Represent the status of the item in the repair flow
   * @deprecated Status is representing the status of the item in our legacy flow. Please use state instead, that represent
   */
  status: RepairRequestStatus;
  /** Optional URL towards a quote from one of our supplier for this part that we've used for pricing */
  supplierQuoteLink?: Maybe<Scalars['String']['output']>;
  /** Information about the withdrawal of the item by the engineer */
  withdrawal?: Maybe<Withdrawal>;
};

/** Payload to add a repair support request item to an engineer request */
export type RepairSupportRequestItemInput = {
  /** Engineer comment regarding the purpose of the repair support request */
  comment: Scalars['String']['input'];
  /** Photos/screenshots adding context to the repair support request */
  photos?: InputMaybe<Array<Scalars['Upload']['input']>>;
};

/** Input type for retrieving a .zip archive of report PDF files for a set of missions */
export type ReportZipUrlInput = {
  missionIds: Array<Scalars['String']['input']>;
};

/** Input type for retrieving a .zip archive of report PDF files for a set of tasks */
export type ReportZipUrlTaskInput = {
  taskIds: Array<Scalars['String']['input']>;
};

export type RequestItem = {
  /** If this requested item needs to be invoiced to the customer */
  chargeable?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the request item should be delivered from our supplier */
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The human identifier for a request (at the moment it is the id within airtable)
   * @deprecated Airtable is not used anymore. This field is deprecated and will be removed in the future.
   */
  humanId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** If the item is withdrawable by the engineer */
  isWithdrawable: Scalars['Boolean']['output'];
  /**
   * Comment of the ops about the requested item
   * @deprecated Comments are not found on individual parts anymore but on the request as a whole. Use RepairRequest.enginerComment or RepairRequest.internalComment
   */
  opsComment?: Maybe<Scalars['String']['output']>;
  /** Order progression data synced from Netsuite for this request item */
  orderProgression?: Maybe<RequestItemOrderProgression>;
  /** Cost of the item (what we pay). This represents the company's cost for the item. Use sellPrice for the margin/sell price. Can be null if not set yet. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The quote line this item backs — a partition: an item belongs to at most one line (PRENG-7500) */
  quoteLine?: Maybe<QuoteLine>;
  repairRequestId: Scalars['ID']['output'];
  /**
   * Sell price of the item (separate from cost). Used for items that need to track separate cost and margin, such as Installation items. Can be null if not set.
   * @deprecated What the customer pays lives on QuoteLine.sellPrice (PRENG-7500); this is never written anymore
   */
  sellPrice?: Maybe<Scalars['Float']['output']>;
  /** Represent the state of the request item (should be used in place of status). Based on the type of the itemand its current data it return a state representing the next action to be done on a business point of view. */
  state?: Maybe<RequestItemState>;
  /**
   * Represent the status of the item in the repair flow
   * @deprecated Status is representing the status of the item in our legacy flow. Please use state instead, that represent
   */
  status: RepairRequestStatus;
  /** Optional URL towards a quote from one of our supplier for this part that we've used for pricing */
  supplierQuoteLink?: Maybe<Scalars['String']['output']>;
  /** Information about the withdrawal of the item by the engineer */
  withdrawal?: Maybe<Withdrawal>;
};

/** Order progression of a request item, representing the different stages of the order process for this item in Netsuite */
export type RequestItemOrderProgression = {
  __typename?: 'RequestItemOrderProgression';
  /** How many of this item have been received, handled by the warehouse and put on a shelf */
  committed: Scalars['Int']['output'];
  /** Date at which the purchase order for this item is due to arrive */
  dueDate?: Maybe<Scalars['Date']['output']>;
  /** How many of this item have been picked up or shipped to the engineer */
  fulfilled: Scalars['Int']['output'];
  /** The bin in which the item is stored in the warehouse */
  itemBin?: Maybe<Scalars['String']['output']>;
  /** Netsuite purchase order ID associated to this request item */
  netsuitePurchaseOrderId?: Maybe<Scalars['String']['output']>;
  /** How many of this item are currently ordered in the purchase order */
  ordered: Scalars['Int']['output'];
  /** The type of purchase order (e.g. drop-ship, special order) */
  purchaseOrderType?: Maybe<Scalars['String']['output']>;
  /** How many of this item have been received in the warehouse */
  received: Scalars['Int']['output'];
  /** How many of this item are on the sales order line in Netsuite. Note this value can be null if not provided by netsuite. */
  salesOrderItemQuantity?: Maybe<Scalars['Int']['output']>;
};

/** State of a request item, defined from a business point of view the state of the item */
export enum RequestItemState {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  PartToEstimate = 'PART_TO_ESTIMATE',
  PartToIdentify = 'PART_TO_IDENTIFY',
  PartToInstall = 'PART_TO_INSTALL',
  PartToOrder = 'PART_TO_ORDER',
  PartToPurchase = 'PART_TO_PURCHASE',
  PartToReceive = 'PART_TO_RECEIVE',
  PartToWithdraw = 'PART_TO_WITHDRAW',
  Sent = 'SENT'
}

/** The type of the requested item. Can be PART/EXTERNAL_PART/MAN_HOUR/TECH_SUPPORT/REPAIR_SUPPORT */
export enum RequestItemTypeEnum {
  ExternalPart = 'EXTERNAL_PART',
  Installation = 'INSTALLATION',
  ManHour = 'MAN_HOUR',
  Part = 'PART',
  RepairSupport = 'REPAIR_SUPPORT',
  TechSupport = 'TECH_SUPPORT'
}

/** Payload to add items to a repair request */
export type RequestItemsInput = {
  /** Request a part that is not in the WeMaintain catalog */
  externalPartItems?: InputMaybe<Array<ExternalPartRequestItemInput>>;
  /** Request man hour for a repair */
  manHourItems?: InputMaybe<Array<ManHourRequestItemInput>>;
  /** Request a part from the WeMaintain catalog */
  partItems?: InputMaybe<Array<PartRequestItemInput>>;
  /** Request the help of the repair support team */
  repairSupportItems?: InputMaybe<Array<RepairSupportRequestItemInput>>;
  /** Request the help of the tech support team */
  techSupportItems?: InputMaybe<Array<TechSupportRequestItemInput>>;
};

/** The type of support needed TECH_SUPPORT - REPAIR_SUPPORT */
export enum RequestSupportTypeEnum {
  RepairSupport = 'REPAIR_SUPPORT',
  TechSupport = 'TECH_SUPPORT'
}

export type RequiredDateFilter = {
  /** End of the period */
  end: Scalars['DateTime']['input'];
  /** Start of the period */
  start: Scalars['DateTime']['input'];
};

export type Result = {
  __typename?: 'Result';
  auditReportLine: AuditReportLineMembers;
  availabilityRate: AvailabilityRateMembers;
  availabilityRates: AvailabilityRatesMembers;
  breakdown: BreakdownMembers;
  breakdownSnapshot: BreakdownSnapshotMembers;
  building: BuildingMembers;
  comment: CommentMembers;
  contract: ContractMembers;
  contractBuilding: ContractBuildingMembers;
  contractDevice: ContractDeviceMembers;
  contractMonths: ContractMonthsMembers;
  customer: CustomerMembers;
  defectLocation: DefectLocationMembers;
  defectOrigin: DefectOriginMembers;
  device: DeviceMembers;
  devicePause: DevicePauseMembers;
  devicePausePeriod: DevicePausePeriodMembers;
  endDeviceStatus: EndDeviceStatusMembers;
  energyConsumption: EnergyConsumptionMembers;
  iotThing: IotThingMembers;
  issue: IssueMembers;
  issueSnapshot: IssueSnapshotMembers;
  mechanic: MechanicMembers;
  mission: MissionMembers;
  monthlyDeviceCosts: MonthlyDeviceCostsMembers;
  railwaySpecificPeriods: RailwaySpecificPeriodsMembers;
  state: StateMembers;
  stateSnapshot: StateSnapshotMembers;
  task: TaskMembers;
  trip: TripMembers;
  unavailability: UnavailabilityMembers;
  unavailability_legacy: Unavailability_LegacyMembers;
  user: UserMembers;
  userAccount: UserAccountMembers;
};


export type ResultAuditReportLineArgs = {
  orderBy?: InputMaybe<AuditReportLineOrderByInput>;
  where?: InputMaybe<AuditReportLineWhereInput>;
};


export type ResultAvailabilityRateArgs = {
  orderBy?: InputMaybe<AvailabilityRateOrderByInput>;
  where?: InputMaybe<AvailabilityRateWhereInput>;
};


export type ResultAvailabilityRatesArgs = {
  orderBy?: InputMaybe<AvailabilityRatesOrderByInput>;
  where?: InputMaybe<AvailabilityRatesWhereInput>;
};


export type ResultBreakdownArgs = {
  orderBy?: InputMaybe<BreakdownOrderByInput>;
  where?: InputMaybe<BreakdownWhereInput>;
};


export type ResultBreakdownSnapshotArgs = {
  orderBy?: InputMaybe<BreakdownSnapshotOrderByInput>;
  where?: InputMaybe<BreakdownSnapshotWhereInput>;
};


export type ResultBuildingArgs = {
  orderBy?: InputMaybe<BuildingOrderByInput>;
  where?: InputMaybe<BuildingWhereInput>;
};


export type ResultCommentArgs = {
  orderBy?: InputMaybe<CommentOrderByInput>;
  where?: InputMaybe<CommentWhereInput>;
};


export type ResultContractArgs = {
  orderBy?: InputMaybe<ContractOrderByInput>;
  where?: InputMaybe<ContractWhereInput>;
};


export type ResultContractBuildingArgs = {
  orderBy?: InputMaybe<ContractBuildingOrderByInput>;
  where?: InputMaybe<ContractBuildingWhereInput>;
};


export type ResultContractDeviceArgs = {
  orderBy?: InputMaybe<ContractDeviceOrderByInput>;
  where?: InputMaybe<ContractDeviceWhereInput>;
};


export type ResultContractMonthsArgs = {
  orderBy?: InputMaybe<ContractMonthsOrderByInput>;
  where?: InputMaybe<ContractMonthsWhereInput>;
};


export type ResultCustomerArgs = {
  orderBy?: InputMaybe<CustomerOrderByInput>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type ResultDefectLocationArgs = {
  orderBy?: InputMaybe<DefectLocationOrderByInput>;
  where?: InputMaybe<DefectLocationWhereInput>;
};


export type ResultDefectOriginArgs = {
  orderBy?: InputMaybe<DefectOriginOrderByInput>;
  where?: InputMaybe<DefectOriginWhereInput>;
};


export type ResultDeviceArgs = {
  orderBy?: InputMaybe<DeviceOrderByInput>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type ResultDevicePauseArgs = {
  orderBy?: InputMaybe<DevicePauseOrderByInput>;
  where?: InputMaybe<DevicePauseWhereInput>;
};


export type ResultDevicePausePeriodArgs = {
  orderBy?: InputMaybe<DevicePausePeriodOrderByInput>;
  where?: InputMaybe<DevicePausePeriodWhereInput>;
};


export type ResultEndDeviceStatusArgs = {
  orderBy?: InputMaybe<EndDeviceStatusOrderByInput>;
  where?: InputMaybe<EndDeviceStatusWhereInput>;
};


export type ResultEnergyConsumptionArgs = {
  orderBy?: InputMaybe<EnergyConsumptionOrderByInput>;
  where?: InputMaybe<EnergyConsumptionWhereInput>;
};


export type ResultIotThingArgs = {
  orderBy?: InputMaybe<IotThingOrderByInput>;
  where?: InputMaybe<IotThingWhereInput>;
};


export type ResultIssueArgs = {
  orderBy?: InputMaybe<IssueOrderByInput>;
  where?: InputMaybe<IssueWhereInput>;
};


export type ResultIssueSnapshotArgs = {
  orderBy?: InputMaybe<IssueSnapshotOrderByInput>;
  where?: InputMaybe<IssueSnapshotWhereInput>;
};


export type ResultMechanicArgs = {
  orderBy?: InputMaybe<MechanicOrderByInput>;
  where?: InputMaybe<MechanicWhereInput>;
};


export type ResultMissionArgs = {
  orderBy?: InputMaybe<MissionOrderByInput>;
  where?: InputMaybe<MissionWhereInput>;
};


export type ResultMonthlyDeviceCostsArgs = {
  orderBy?: InputMaybe<MonthlyDeviceCostsOrderByInput>;
  where?: InputMaybe<MonthlyDeviceCostsWhereInput>;
};


export type ResultRailwaySpecificPeriodsArgs = {
  orderBy?: InputMaybe<RailwaySpecificPeriodsOrderByInput>;
  where?: InputMaybe<RailwaySpecificPeriodsWhereInput>;
};


export type ResultStateArgs = {
  orderBy?: InputMaybe<StateOrderByInput>;
  where?: InputMaybe<StateWhereInput>;
};


export type ResultStateSnapshotArgs = {
  orderBy?: InputMaybe<StateSnapshotOrderByInput>;
  where?: InputMaybe<StateSnapshotWhereInput>;
};


export type ResultTaskArgs = {
  orderBy?: InputMaybe<TaskOrderByInput>;
  where?: InputMaybe<TaskWhereInput>;
};


export type ResultTripArgs = {
  orderBy?: InputMaybe<TripOrderByInput>;
  where?: InputMaybe<TripWhereInput>;
};


export type ResultUnavailabilityArgs = {
  orderBy?: InputMaybe<UnavailabilityOrderByInput>;
  where?: InputMaybe<UnavailabilityWhereInput>;
};


export type ResultUnavailability_LegacyArgs = {
  orderBy?: InputMaybe<Unavailability_LegacyOrderByInput>;
  where?: InputMaybe<Unavailability_LegacyWhereInput>;
};


export type ResultUserArgs = {
  orderBy?: InputMaybe<UserOrderByInput>;
  where?: InputMaybe<UserWhereInput>;
};


export type ResultUserAccountArgs = {
  orderBy?: InputMaybe<UserAccountOrderByInput>;
  where?: InputMaybe<UserAccountWhereInput>;
};

export type ReviewOvertimeInput = {
  approval?: InputMaybe<OvertimeApproval>;
  comment?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['DateTimeISO']['input']>;
  origin?: InputMaybe<OvertimeOrigin>;
  overtimeId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

/** The safety risk of this door depending on who uses it (children, elderly...) */
export enum Risk {
  High = 'HIGH',
  Low = 'LOW'
}

/** Role of the mechanic in the visit. A principal being the main mechanic while collaborator are secondary mechanics that can help with the visit. */
export enum RoleInVisit {
  Collaborator = 'COLLABORATOR',
  Principal = 'PRINCIPAL'
}

export type RootOrderByInput = {
  auditReportLine?: InputMaybe<AuditReportLineOrderByInput>;
  availabilityRate?: InputMaybe<AvailabilityRateOrderByInput>;
  availabilityRates?: InputMaybe<AvailabilityRatesOrderByInput>;
  breakdown?: InputMaybe<BreakdownOrderByInput>;
  breakdownSnapshot?: InputMaybe<BreakdownSnapshotOrderByInput>;
  building?: InputMaybe<BuildingOrderByInput>;
  comment?: InputMaybe<CommentOrderByInput>;
  contract?: InputMaybe<ContractOrderByInput>;
  contractBuilding?: InputMaybe<ContractBuildingOrderByInput>;
  contractDevice?: InputMaybe<ContractDeviceOrderByInput>;
  contractMonths?: InputMaybe<ContractMonthsOrderByInput>;
  customer?: InputMaybe<CustomerOrderByInput>;
  defectLocation?: InputMaybe<DefectLocationOrderByInput>;
  defectOrigin?: InputMaybe<DefectOriginOrderByInput>;
  device?: InputMaybe<DeviceOrderByInput>;
  devicePause?: InputMaybe<DevicePauseOrderByInput>;
  devicePausePeriod?: InputMaybe<DevicePausePeriodOrderByInput>;
  endDeviceStatus?: InputMaybe<EndDeviceStatusOrderByInput>;
  energyConsumption?: InputMaybe<EnergyConsumptionOrderByInput>;
  iotThing?: InputMaybe<IotThingOrderByInput>;
  issue?: InputMaybe<IssueOrderByInput>;
  issueSnapshot?: InputMaybe<IssueSnapshotOrderByInput>;
  mechanic?: InputMaybe<MechanicOrderByInput>;
  mission?: InputMaybe<MissionOrderByInput>;
  monthlyDeviceCosts?: InputMaybe<MonthlyDeviceCostsOrderByInput>;
  railwaySpecificPeriods?: InputMaybe<RailwaySpecificPeriodsOrderByInput>;
  state?: InputMaybe<StateOrderByInput>;
  stateSnapshot?: InputMaybe<StateSnapshotOrderByInput>;
  task?: InputMaybe<TaskOrderByInput>;
  trip?: InputMaybe<TripOrderByInput>;
  unavailability?: InputMaybe<UnavailabilityOrderByInput>;
  unavailability_legacy?: InputMaybe<Unavailability_LegacyOrderByInput>;
  user?: InputMaybe<UserOrderByInput>;
  userAccount?: InputMaybe<UserAccountOrderByInput>;
};

export type RootWhereInput = {
  AND?: InputMaybe<Array<RootWhereInput>>;
  OR?: InputMaybe<Array<RootWhereInput>>;
  auditReportLine?: InputMaybe<AuditReportLineWhereInput>;
  availabilityRate?: InputMaybe<AvailabilityRateWhereInput>;
  availabilityRates?: InputMaybe<AvailabilityRatesWhereInput>;
  breakdown?: InputMaybe<BreakdownWhereInput>;
  breakdownSnapshot?: InputMaybe<BreakdownSnapshotWhereInput>;
  building?: InputMaybe<BuildingWhereInput>;
  comment?: InputMaybe<CommentWhereInput>;
  contract?: InputMaybe<ContractWhereInput>;
  contractBuilding?: InputMaybe<ContractBuildingWhereInput>;
  contractDevice?: InputMaybe<ContractDeviceWhereInput>;
  contractMonths?: InputMaybe<ContractMonthsWhereInput>;
  customer?: InputMaybe<CustomerWhereInput>;
  defectLocation?: InputMaybe<DefectLocationWhereInput>;
  defectOrigin?: InputMaybe<DefectOriginWhereInput>;
  device?: InputMaybe<DeviceWhereInput>;
  devicePause?: InputMaybe<DevicePauseWhereInput>;
  devicePausePeriod?: InputMaybe<DevicePausePeriodWhereInput>;
  endDeviceStatus?: InputMaybe<EndDeviceStatusWhereInput>;
  energyConsumption?: InputMaybe<EnergyConsumptionWhereInput>;
  iotThing?: InputMaybe<IotThingWhereInput>;
  issue?: InputMaybe<IssueWhereInput>;
  issueSnapshot?: InputMaybe<IssueSnapshotWhereInput>;
  mechanic?: InputMaybe<MechanicWhereInput>;
  mission?: InputMaybe<MissionWhereInput>;
  monthlyDeviceCosts?: InputMaybe<MonthlyDeviceCostsWhereInput>;
  railwaySpecificPeriods?: InputMaybe<RailwaySpecificPeriodsWhereInput>;
  state?: InputMaybe<StateWhereInput>;
  stateSnapshot?: InputMaybe<StateSnapshotWhereInput>;
  task?: InputMaybe<TaskWhereInput>;
  trip?: InputMaybe<TripWhereInput>;
  unavailability?: InputMaybe<UnavailabilityWhereInput>;
  unavailability_legacy?: InputMaybe<Unavailability_LegacyWhereInput>;
  user?: InputMaybe<UserWhereInput>;
  userAccount?: InputMaybe<UserAccountWhereInput>;
};

export type RunDashboardQueryForUserInput = {
  dashboardType: Scalars['String']['input'];
  /** DashboardFilter: Represents a dashboard filter */
  filters?: InputMaybe<Array<DashboardFilter>>;
  id: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type RunDrilldownQueryForUserInput = {
  dashboardType: Scalars['String']['input'];
  dimensionName: Scalars['String']['input'];
  /** DashboardFilter: Represents a dashboard filter */
  filters?: InputMaybe<Array<DashboardFilter>>;
  id: Scalars['String']['input'];
  /** For merged queries: the name of the source query to drilldown on. When provided, left joinning on it */
  sourceQueryName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Input payload for scoring an LLM response (feedback). */
export type ScoreLlmResponseInput = {
  /** Optional text comment providing context or reasons for the score. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The internal identifier of the resource being scored. */
  resourceId: Scalars['String']['input'];
  /** The unique identifier of the span associated with the LLM execution. */
  spanId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the trace associated with the LLM execution. */
  traceId: Scalars['String']['input'];
  /** The numerical score value, normalized between 0 and 1. */
  value: Scalars['Float']['input'];
};

export type SearchPriceListLinesInput = {
  /** Search the rates in force at that instant instead of now — what a rate cost at the date an old quote was priced */
  at?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Return one row per (price list, reference) instead of one per tier — totalCount then counts rate families. The other tiers of a row are on PriceListLine.tierVariants */
  collapseTiers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search the in-force price list of this contract */
  contractId?: InputMaybe<Scalars['String']['input']>;
  /** Search the in-force price list of this device — its active contract's annex, or WeMaintain's standard list for its country and device type when the contract carries none */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** Only lines of these kinds */
  kinds?: InputMaybe<Array<PriceListLineKind>>;
  /** Ranking hint, never a filter: lines of these kinds come first, the other kinds still come back below them (a man-hour item ranks LABOUR and OPERATION first) */
  preferredKinds?: InputMaybe<Array<PriceListLineKind>>;
  /** Which tier represents a collapsed family; defaults to the list's lowest-ordinal tier. Only meaningful with collapseTiers */
  preferredTierId?: InputMaybe<Scalars['String']['input']>;
  /** Search this exact price list version */
  priceListId?: InputMaybe<Scalars['String']['input']>;
  /** Full-text + fuzzy match on line label, reference and description */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SelectInput = FormInput & FormThing & {
  __typename?: 'SelectInput';
  /** entityKey of the sibling input whose value drives this select options (cascading dropdown) */
  dependsOn?: Maybe<Scalars['String']['output']>;
  /** If set, means that changing this field would update 1<->1 to the corresponding key in the entity */
  entityKey?: Maybe<Scalars['String']['output']>;
  /** The identifier of this input, to be sent back to the backend */
  key?: Maybe<Scalars['String']['output']>;
  options: Array<InputOption>;
  /** configuration for the display/validation of this input */
  settings: IInputSettings;
  title: Scalars['String']['output'];
  /** Current value associated to the input */
  value?: Maybe<Scalars['ValueOfInput']['output']>;
};

export type SendPushNotificationInput = {
  /** Body of the notification to send */
  body: Scalars['String']['input'];
  /** Deeplink to open in app when tapping the notification */
  deepLink?: InputMaybe<Scalars['String']['input']>;
  /** Title of the notification to send */
  title: Scalars['String']['input'];
  /** Send the notification to the given users */
  userIds: Array<Scalars['ID']['input']>;
};

/** Serie */
export type Serie = {
  __typename?: 'Serie';
  dimension: Scalars['Int']['output'];
  stack?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** Input to set how a man-hour item splits into on-site and travel hours */
export type SetManHourSplitInput = {
  /** The on-site hours, at least 1 */
  onSiteHours: Scalars['Int']['input'];
  /** The id of the repair request */
  repairRequestId: Scalars['ID']['input'];
  /** The id of the on-site man-hour item */
  requestItemId: Scalars['ID']['input'];
  /** The travel hours, at least 1. Left as they are when not given: an item without travel then keeps none */
  travelHours?: InputMaybe<Scalars['Int']['input']>;
};

export type SetQuoteDiscountInput = {
  discountRate: Scalars['Float']['input'];
  quoteId: Scalars['String']['input'];
  quoteVersion: Scalars['Int']['input'];
};

export type SetQuoteLinesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  excludedRequestItems?: Array<SetQuoteLinesInput_ExcludedRequestItems>;
  lines: Array<SetQuoteLinesInput_Lines>;
  quoteId: Scalars['String']['input'];
  titleLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SetQuoteLinesInput_ExcludedRequestItems = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestItemId: Scalars['String']['input'];
};

export type SetQuoteLinesInput_Lines = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  priceListLineId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  requestItemIds?: Array<Scalars['String']['input']>;
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
};

/** Input to set both cost and sell price of a request item */
export type SetRequestItemPricingInput = {
  /** The cost of the request item (what we pay) */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** The sell price of the request item (what we charge) */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
  /** The id of the request item */
  requestItemId: Scalars['String']['input'];
};

/** The reason why the signal was dismissed */
export enum SignalDismissalReason {
  KnownAsDefective = 'KnownAsDefective',
  KnownAsFalsePositive = 'KnownAsFalsePositive',
  KnownIoTDeviceIssue = 'KnownIoTDeviceIssue',
  KnownSensorIssues = 'KnownSensorIssues',
  Other = 'Other',
  ShutdownUnit = 'ShutdownUnit',
  TriggeredWhileWorkingOnIt = 'TriggeredWhileWorkingOnIt'
}

export type SignalFeedbackUserInfo = {
  __typename?: 'SignalFeedbackUserInfo';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum SignalOrmEntitySortableFields {
  CreatedAt = 'createdAt',
  Date = 'date'
}

/** The relevancy of the signal */
export enum SignalRelevancy {
  /** The signal was relevant and has been flagged as such */
  Relevant = 'relevant',
  /** The signal was irrelevant and has been flagged as such */
  Unrelevant = 'unrelevant'
}

export type SignalRelevancyFeedback = {
  __typename?: 'SignalRelevancyFeedback';
  /** The feedback given by the user */
  feedback?: Maybe<Scalars['String']['output']>;
  /** The relevancy of the signal */
  relevancy: SignalRelevancy;
  /** The user who gave the feedback */
  userInfo?: Maybe<SignalFeedbackUserInfo>;
};

export type SignalSource = {
  __typename?: 'SignalSource';
  signal: StrongSignal;
};

/** A signal timeline marker */
export type SignalTimelineMarker = TimelineMarker & {
  __typename?: 'SignalTimelineMarker';
  date: Scalars['DateTime']['output'];
  hasAlert: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The signal of the marker */
  signal: StrongSignal;
  type: TimelineMarkerType;
};

export type SingleValue = QueryResult & {
  __typename?: 'SingleValue';
  cellHtml?: Maybe<Array<Visualization_CellHtml>>;
  color?: Maybe<Array<Scalars['String']['output']>>;
  /** ConditionalVisualFormat */
  conditionalVisualFormat?: Maybe<Array<ConditionalVisualFormat>>;
  /** Dataset */
  dataset?: Maybe<Dataset>;
  drillFields?: Maybe<Array<Visualization_DrillFields>>;
  labelValueFormat?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Visualization_Links>>;
  /** Note */
  note?: Maybe<Note>;
  series?: Maybe<Array<Visualization_Series>>;
  /** Sort */
  sort?: Maybe<Sort>;
  title?: Maybe<Scalars['String']['output']>;
  /** ValueFormat */
  valueFormat?: Maybe<Array<ValueFormat>>;
  /** VisualMap */
  visualMap?: Maybe<Array<VisualMap>>;
  xAxis?: Maybe<Visualization_XAxis>;
  yAxes?: Maybe<Array<Visualization_YAxes>>;
  yAxis?: Maybe<Visualization_YAxis>;
};

/** Sort */
export type Sort = {
  __typename?: 'Sort';
  dimension: Scalars['Float']['output'];
  order: Scalars['String']['output'];
};

/** Configuration of the sos feature */
export type SosFeature = {
  __typename?: 'SosFeature';
  /** Max delay given to the engineer to send a keep alive before we trigger the emergency plan */
  maxSosDelay: Scalars['Float']['output'];
};

export type Source = {
  /** Date at which the source was considered close by device state */
  closedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Date at which the source was ingested in device-state */
  createdAt: Scalars['DateTimeISO']['output'];
  externalId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  provider: EventProvider;
};

export type SourceAnswer = Source & {
  __typename?: 'SourceAnswer';
  /** The answer given by the technician to the task created by this issue */
  answer: Answer;
  /** Date at which the source was considered close by device state */
  closedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Date at which the source was ingested in device-state */
  createdAt: Scalars['DateTimeISO']['output'];
  externalId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  provider: EventProvider;
};

export type SourceDefect = Source & {
  __typename?: 'SourceDefect';
  /** Line in the AuditReport that created this defect */
  auditReportLine: AuditReportLine;
  /** Date at which the source was considered close by device state */
  closedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Date at which the source was ingested in device-state */
  createdAt: Scalars['DateTimeISO']['output'];
  externalId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  provider: EventProvider;
};

export type SourceIntegration = Source & {
  __typename?: 'SourceIntegration';
  /** Date at which the source was considered close by device state */
  closedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Date at which the source was ingested in device-state */
  createdAt: Scalars['DateTimeISO']['output'];
  externalId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  provider: EventProvider;
};

/** Input to send vendor email for request items */
export type SourceItemVendorEmailInput = {
  /** The email body */
  body: Scalars['String']['input'];
  /** The email addresses to send to */
  emailList: Array<Scalars['String']['input']>;
  /** The ids of the request items */
  requestItems: Array<Scalars['ID']['input']>;
  /** The email subject */
  subject: Scalars['String']['input'];
  /** The vendor ids to link to the communication */
  vendors: Array<Scalars['ID']['input']>;
  /** The id of the work order (repair request) */
  workOrderId: Scalars['ID']['input'];
};

export type SourceMission = Source & {
  __typename?: 'SourceMission';
  /** Date at which the source was considered close by device state */
  closedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Date at which the source was ingested in device-state */
  createdAt: Scalars['DateTimeISO']['output'];
  externalId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The mission this event refers to */
  mission: Mission;
  provider: EventProvider;
};

export type SourceTicket = Source & {
  __typename?: 'SourceTicket';
  /** Date at which the source was considered close by device state */
  closedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Date at which the source was ingested in device-state */
  createdAt: Scalars['DateTimeISO']['output'];
  externalId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  provider: EventProvider;
  /** el ticketos */
  ticket: WmTicket;
};

/**
 * A source is a reason why an issue exists. It comes from exactly one provider.
 *   For example, a "Ticket" can be a Source of an issue, so can the "Answer" from a mechanic during a visit.
 *
 *   If multiple tickets are opened for the exact same problem, you'll have one issue but multiple Sources.
 */
export type SourceUnion = SourceAnswer | SourceDefect | SourceIntegration | SourceMission | SourceTicket;

export type Source_ManuallyReassigned = {
  __typename?: 'Source_ManuallyReassigned';
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<Source_ManuallyReassigned_User>;
};

export type Source_ManuallyReassigned_User = {
  __typename?: 'Source_ManuallyReassigned_User';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

/** Sourcing activity for a non-catalog part */
export type SourcingInfo = {
  __typename?: 'SourcingInfo';
  /** List of vendor emails sent for this part */
  communications: Array<SourcingVendorCommunication>;
};

/** Record of a vendor email sent as part of the sourcing process for a non-catalog part */
export type SourcingVendorCommunication = {
  __typename?: 'SourcingVendorCommunication';
  /** Date at which the RFQ email was sent */
  sentAt: Scalars['DateTime']['output'];
  /** Email address of the user who sent the RFQ */
  sentByEmail: Scalars['String']['output'];
  /** Vendors contacted in this RFQ send */
  vendors: Array<Vendor>;
};

/** A Condition that will depends on the device specifications */
export type SpecsCondition = IQuestionCondition & {
  __typename?: 'SpecsCondition';
  /** The jsonata expression that should be evaluated to true for the condition to apply */
  condition: Scalars['String']['output'];
  outcome: QuestionConditionOutcome;
  type: QuestionConditionType;
};

export type StartedMissions = {
  __typename?: 'StartedMissions';
  /** All answers from previous visit(s) for all missions / tasks ongoing */
  answers: Array<Maybe<Answer>>;
  /**
   * The static content of missions that were started.
   *     The content of the visit, such as questions, is available in other fields of the StartedMissions object.
   */
  missions: Array<Mission>;
  /** Form to fill to declare overtime for this visit */
  overtimeForm: VisitOvertimeForm;
  /**
   * All question groups available for all missions / tasks still ongoing
   * @deprecated Use questions instead
   */
  questionGroups: Array<Maybe<QuestionGroup>>;
  /** All questions available for all missions / tasks still ongoing */
  questions: Array<Maybe<Question>>;
  /** Role that was assigned in this visit */
  role: RoleInVisit;
  /** Sos feature configuration for that specific visit */
  sosFeature?: Maybe<SosFeature>;
  /** All task available and ongoing related of all missions */
  tasks: Array<AvailableTask>;
  /** Current visit that was launched/joined */
  visit: Visit;
};

/** Represent the state of a device component (ex: car.parachute) */
export type StateComponent = {
  __typename?: 'StateComponent';
  /** Date at which this state component refer to */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Device linked to this state component */
  device: Device;
  /** Use device instead, this id is used to uniquely identify the component with federation */
  deviceId: Scalars['ID']['output'];
  /** Indicate if the component has issues */
  hasIssues: Scalars['Boolean']['output'];
  /** If the component is not working (has open issues), returns all unique open sources from those issues — ordered from most recent to oldest — representing what has been reporting problems since the last working date. If the component is working, returns the source of the last close_issue event. Returns an empty array when working with no close event. */
  sources: Array<Maybe<SourceUnion>>;
  /** Reference of the part of the device this state component describe */
  stateKey: Scalars['String']['output'];
  /** Describe if the component is working, return true if device is working, false if not (we have at least one issue breaking the component) and return null if we don't know (we don't have the information yet) */
  working?: Maybe<Scalars['Boolean']['output']>;
};

/** Certify that a job has been done on a given device */
export type StateComponentCertificate = {
  __typename?: 'StateComponentCertificate';
  /** The unique identifier of the StateComponentCertificate */
  id: Scalars['ID']['output'];
  /** The url where to download the StateComponentCertificate report */
  reportUrl: Scalars['String']['output'];
  /** The state component that has been certified */
  stateComponent: StateComponent;
};

export type StateComponentCertificateInputFilters = {
  /** Filter documents that are owned by the specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter documents that are owned by the specified accounts
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum StateComponentOrmEntitySortableFields {
  Date = 'date'
}

/** The filters of the issues */
export type StateIssueFilters = {
  /** The type of events in the issue */
  providers?: InputMaybe<Array<EventProvider>>;
};

export type StateMembers = {
  __typename?: 'StateMembers';
  count?: Maybe<Scalars['Float']['output']>;
  createdat?: Maybe<TimeDimension>;
  date?: Maybe<TimeDimension>;
  deviceid?: Maybe<Scalars['String']['output']>;
  hasIssues?: Maybe<Scalars['String']['output']>;
  issueCount?: Maybe<Scalars['Float']['output']>;
  issuecount?: Maybe<Scalars['Float']['output']>;
  snapshot?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stopped?: Maybe<Scalars['String']['output']>;
  working?: Maybe<Scalars['String']['output']>;
};

export type StateOrderByInput = {
  count?: InputMaybe<OrderBy>;
  createdat?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deviceid?: InputMaybe<OrderBy>;
  hasIssues?: InputMaybe<OrderBy>;
  issueCount?: InputMaybe<OrderBy>;
  issuecount?: InputMaybe<OrderBy>;
  snapshot?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stopped?: InputMaybe<OrderBy>;
  working?: InputMaybe<OrderBy>;
};

export type StateSnapshot = {
  __typename?: 'StateSnapshot';
  /** The annotation linked to the state of the device */
  annotation?: Maybe<Annotation>;
  /** The period of unavailability linked to this state. Only exists when working:false */
  breakdown?: Maybe<Breakdown>;
  /** The device's components state */
  components: Array<Maybe<StateComponent>>;
  /** The date of this state */
  date: Scalars['DateTime']['output'];
  /** Id of the State */
  id: Scalars['ID']['output'];
  /** Issues assigned to this state */
  issues: Array<Maybe<IssueSnapshot>>;
  /** The status of the Elevator during this state */
  status: ElevatorStatus;
  /** The device has been stopped by a mechanic */
  stopped?: Maybe<Scalars['Boolean']['output']>;
  /** The date since the device has been stopped by a mechanic */
  stoppedSince?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Is the device working properly */
  working: Scalars['Boolean']['output'];
};


export type StateSnapshotComponentsArgs = {
  filters?: InputMaybe<ComponentsFilters>;
};


export type StateSnapshotIssuesArgs = {
  filters?: InputMaybe<StateIssueFilters>;
  order?: InputMaybe<Array<DeviceStateIssueSnapshotOrderOptions>>;
};

/** Input to filter by a range of dates */
export type StateSnapshotInput = {
  /** The older date of the return list of states. By default, there is no limit */
  from: Scalars['DateTime']['input'];
  /** The limit date. Filter states before this date. By defualt, the date is setted to NOW. */
  to: Scalars['DateTime']['input'];
};

export type StateSnapshotMembers = {
  __typename?: 'StateSnapshotMembers';
  count?: Maybe<Scalars['Float']['output']>;
  createdat?: Maybe<TimeDimension>;
  date?: Maybe<TimeDimension>;
  deviceid?: Maybe<Scalars['String']['output']>;
  hasIssues?: Maybe<Scalars['String']['output']>;
  issueCount?: Maybe<Scalars['Float']['output']>;
  issuecount?: Maybe<Scalars['Float']['output']>;
  snapshot?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stopped?: Maybe<Scalars['String']['output']>;
  working?: Maybe<Scalars['String']['output']>;
};

export type StateSnapshotOrderByInput = {
  count?: InputMaybe<OrderBy>;
  createdat?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deviceid?: InputMaybe<OrderBy>;
  hasIssues?: InputMaybe<OrderBy>;
  issueCount?: InputMaybe<OrderBy>;
  issuecount?: InputMaybe<OrderBy>;
  snapshot?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stopped?: InputMaybe<OrderBy>;
  working?: InputMaybe<OrderBy>;
};

export type StateSnapshotWhereInput = {
  AND?: InputMaybe<Array<StateSnapshotWhereInput>>;
  OR?: InputMaybe<Array<StateSnapshotWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  createdat?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deviceid?: InputMaybe<StringFilter>;
  hasIssues?: InputMaybe<StringFilter>;
  issueCount?: InputMaybe<FloatFilter>;
  issuecount?: InputMaybe<FloatFilter>;
  snapshot?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  stopped?: InputMaybe<StringFilter>;
  working?: InputMaybe<StringFilter>;
};

export type StateWhereInput = {
  AND?: InputMaybe<Array<StateWhereInput>>;
  OR?: InputMaybe<Array<StateWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  createdat?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deviceid?: InputMaybe<StringFilter>;
  hasIssues?: InputMaybe<StringFilter>;
  issueCount?: InputMaybe<FloatFilter>;
  issuecount?: InputMaybe<FloatFilter>;
  snapshot?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  stopped?: InputMaybe<StringFilter>;
  working?: InputMaybe<StringFilter>;
};

export type StaticQuestion = Question & {
  __typename?: 'StaticQuestion';
  /** Different answers that can be chosen for this question */
  answerTemplates: Array<IAnswerTemplate>;
  conditions: Array<IQuestionCondition>;
  /** The category the question refers to (car, ...) */
  displayCategory?: Maybe<Scalars['String']['output']>;
  /** The sub-category the question refers to, used to group questions in the same category */
  displaySubCategory?: Maybe<QuestionSubCategory>;
  /**
   * Defines the presence & requiredness of choices, photos and comments.
   *     By default, they are all present and optional
   */
  features: QuestionTemplateFeature;
  /** Hint to help the user answer the question */
  hint?: Maybe<Scalars['String']['output']>;
  /** A manual question ID, set in the question spreadsheet. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** QuestionTemplate that was used to create that question */
  questionTemplate: QuestionTemplate;
  /** The part of the elevator the question is about */
  stateKey?: Maybe<Scalars['String']['output']>;
  /** The text of the question to be asked to the mechanic */
  title: Scalars['String']['output'];
  /** Work order linked to that question */
  workOrder?: Maybe<RepairRequest>;
};


export type StaticQuestionHintArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type StaticQuestionTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A statistical anomaly on a feature monitored by IoT. */
export type StatisticalAnomaly = StrongSignal & {
  __typename?: 'StatisticalAnomaly';
  /** An acknowledgement if the signal was acknowledged. */
  acknowledgement?: Maybe<Acknowledgement>;
  /** The date and time when the signal was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time when the signal was last updated. This attribute has to be sent when acknowledging a signal. */
  date: Scalars['DateTime']['output'];
  delta: StatisticalDelta;
  /** Details about this signal */
  details: Array<StrongSignalDetail>;
  /** The device associated with the signal */
  device?: Maybe<Device>;
  /** A dismissal if the signal was dismissed. */
  dismissal?: Maybe<Dismissal>;
  /** Technical description of the signal meant for the engineer */
  engineerDescription: Scalars['String']['output'];
  /** The state of the strong signal. */
  engineerSorting: StrongSignalStateEnum;
  /** Human understandable explanation detailing this signal, trying to make it legible even by non technical users */
  explanation: Scalars['String']['output'];
  /** Name of the feature we deviated from */
  feature: Scalars['String']['output'];
  /** The ID of the signal in the backend. */
  id: Scalars['ID']['output'];
  /** The relevancy feedback of the signal. */
  relevancyFeedback?: Maybe<SignalRelevancyFeedback>;
  /** Date at which the anomaly was first detected. This is usually far from the creation date of the signal since we only trigger anomalies after a few day of bad data */
  startDate: Scalars['Date']['output'];
  /** Human readable sub title detailing this signal */
  subtitle: Scalars['String']['output'];
  /** The thing associated with the signal */
  thing?: Maybe<Thing>;
  /** The thing name that emitted the signal. */
  thingName: Scalars['String']['output'];
  /** Human readable title for this signal */
  title: Scalars['String']['output'];
};


/** A statistical anomaly on a feature monitored by IoT. */
export type StatisticalAnomalyDetailsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A statistical anomaly on a feature monitored by IoT. */
export type StatisticalAnomalyEngineerDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A statistical anomaly on a feature monitored by IoT. */
export type StatisticalAnomalyExplanationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A statistical anomaly on a feature monitored by IoT. */
export type StatisticalAnomalySubtitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A statistical anomaly on a feature monitored by IoT. */
export type StatisticalAnomalyTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents the amount by which we're in an anomaly when we're calculating statistical anomalies from IoT */
export type StatisticalDelta = {
  __typename?: 'StatisticalDelta';
  /** Bound of what was considered correct before the anomaly occured */
  boundBeforeAnomaly: Scalars['Float']['output'];
  /** Unit for value & bound */
  unit: Scalars['String']['output'];
  /** Anomalous value that triggered the anomaly */
  value: Scalars['Float']['output'];
  /** Value that was considered correct before the anomaly occured */
  valueBeforeAnomaly: Scalars['Float']['output'];
};

export type StopMissionArgs = {
  overtime?: InputMaybe<OvertimeInput>;
  position?: InputMaybe<GeographicPosition>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notEquals?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The base class for all strong signals. */
export type StrongSignal = {
  /** An acknowledgement if the signal was acknowledged. */
  acknowledgement?: Maybe<Acknowledgement>;
  /** The date and time when the signal was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time when the signal was last updated. This attribute has to be sent when acknowledging a signal. */
  date: Scalars['DateTime']['output'];
  /** Details about this signal */
  details: Array<StrongSignalDetail>;
  /** The device associated with the signal */
  device?: Maybe<Device>;
  /** A dismissal if the signal was dismissed. */
  dismissal?: Maybe<Dismissal>;
  /** Technical description of the signal meant for the engineer */
  engineerDescription: Scalars['String']['output'];
  /** The state of the strong signal. */
  engineerSorting: StrongSignalStateEnum;
  /** Human understandable explanation detailing this signal, trying to make it legible even by non technical users */
  explanation: Scalars['String']['output'];
  /** The ID of the signal in the backend. */
  id: Scalars['ID']['output'];
  /** The relevancy feedback of the signal. */
  relevancyFeedback?: Maybe<SignalRelevancyFeedback>;
  /** Human readable sub title detailing this signal */
  subtitle: Scalars['String']['output'];
  /** The thing associated with the signal */
  thing?: Maybe<Thing>;
  /** The thing name that emitted the signal. */
  thingName: Scalars['String']['output'];
  /** Human readable title for this signal */
  title: Scalars['String']['output'];
};


/** The base class for all strong signals. */
export type StrongSignalDetailsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The base class for all strong signals. */
export type StrongSignalEngineerDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The base class for all strong signals. */
export type StrongSignalExplanationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The base class for all strong signals. */
export type StrongSignalSubtitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The base class for all strong signals. */
export type StrongSignalTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StrongSignalDetail = {
  __typename?: 'StrongSignalDetail';
  /** name of this property */
  type: Scalars['String']['output'];
  /** Value of the property */
  value: Scalars['String']['output'];
};

export type StrongSignalQuestion = Question & {
  __typename?: 'StrongSignalQuestion';
  /** Different answers that can be chosen for this question */
  answerTemplates: Array<IAnswerTemplate>;
  conditions: Array<IQuestionCondition>;
  /** The category the question refers to (car, ...) */
  displayCategory?: Maybe<Scalars['String']['output']>;
  /** The sub-category the question refers to, used to group questions in the same category */
  displaySubCategory?: Maybe<QuestionSubCategory>;
  /**
   * Defines the presence & requiredness of choices, photos and comments.
   *     By default, they are all present and optional
   */
  features: QuestionTemplateFeature;
  /** Hint to help the user answer the question */
  hint?: Maybe<Scalars['String']['output']>;
  /** A manual question ID, set in the question spreadsheet. */
  humanKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** QuestionTemplate that was used to create that question */
  questionTemplate: QuestionTemplate;
  /** The text of the question to be asked to the mechanic */
  signal: StrongSignal;
  /** The part of the elevator the question is about */
  stateKey?: Maybe<Scalars['String']['output']>;
  /** The text of the question to be asked to the mechanic */
  title: Scalars['String']['output'];
  /** Work order linked to that question */
  workOrder?: Maybe<RepairRequest>;
};


export type StrongSignalQuestionHintArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type StrongSignalQuestionTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The state of the strong signal. */
export enum StrongSignalStateEnum {
  Acknowledged = 'acknowledged',
  Declared = 'declared',
  Dismissed = 'dismissed'
}

export type StrongSignalsInputFilters = {
  /** Filter signals that have been acknowledged but with no relevancy feedback yet */
  areUnanswered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by building IDs */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter signals that were created after this date */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by device IDs */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by signal IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter all signals even those which are not whitelisted */
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by thing names */
  thingNames?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  hmac: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** The countries supported by the audit-report system */
export enum SupportedCountries {
  Fr = 'FR',
  Gb = 'GB',
  Hk = 'HK',
  Pt = 'PT',
  Uk = 'UK'
}

/** Input to switch the work-order type of a repair request */
export type SwitchWorkOrderTypeInput = {
  /** The id of the repair request whose work-order type should be switched */
  repairRequestId: Scalars['ID']['input'];
  /** The new work-order type to assign to the repair request */
  workOrderType: WorkOrderType;
};

/** Brand of the main control panel */
export enum SystemBrand {
  Advanced = 'ADVANCED',
  Advantech = 'ADVANTECH',
  Ampac = 'AMPAC',
  Asd = 'ASD',
  Aviss = 'AVISS',
  BaldwinBoxall = 'BALDWIN_BOXALL',
  Cel = 'CEL',
  Chubb = 'CHUBB',
  CtEc = 'CT_EC',
  Def = 'DEF',
  Desautel = 'DESAUTEL',
  Eaton = 'EATON',
  Edwards = 'EDWARDS',
  ElectroDetectors = 'ELECTRO_DETECTORS',
  Ems = 'EMS',
  Esp = 'ESP',
  Esser = 'ESSER',
  Fike = 'FIKE',
  Fincuseur = 'FINCUSEUR',
  Fireclass = 'FIRECLASS',
  Gent = 'GENT',
  GlobalFireEquipment = 'GLOBAL_FIRE_EQUIPMENT',
  Haes = 'HAES',
  Honeywell = 'HONEYWELL',
  Hyfire = 'HYFIRE',
  Kentec = 'KENTEC',
  Legrand = 'LEGRAND',
  Morley = 'MORLEY',
  Neutronic = 'NEUTRONIC',
  Notifier = 'NOTIFIER',
  Nugelec = 'NUGELEC',
  Other = 'OTHER',
  Protec = 'PROTEC',
  Sefi = 'SEFI',
  Siemens = 'SIEMENS',
  Signaline = 'SIGNALINE',
  Sms = 'SMS',
  StaticSystemsGroup = 'STATIC_SYSTEMS_GROUP',
  Thorn = 'THORN',
  Tyco = 'TYCO',
  Ura = 'URA',
  Zeta = 'ZETA',
  Ziton = 'ZITON'
}

export type TakeBackRepairRequestActionInput = {
  /** The handed-over action to take back */
  actionId: Scalars['String']['input'];
  /** The work order the action is on */
  repairRequestId: Scalars['String']['input'];
};

/** A task is one goal of a mission. It represents the work we want the mechanic to be doing when he gets on site. */
export type Task = {
  __typename?: 'Task';
  /** Answers given for this task during mechanics' visits. Can change if the task is not done */
  answers: VisitsAnswerConnection;
  /** Building this task needs to be performed on */
  building?: Maybe<Building>;
  /** Building assigned to this task */
  buildingId: Scalars['ID']['output'];
  /** The time at which the task was completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date at which the task was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Device this task needs to be performed on */
  device?: Maybe<Device>;
  /** a task is considered done when the mechanic marks it as such. It is then no longer an objective of the mission */
  done: Scalars['Boolean']['output'];
  /** The id of the mechanic who completed the task (can be different of the mechanic id assigned to the task */
  doneByMechanic?: Maybe<Mechanic>;
  /**
   * Elevator this task needs to be performed on
   * @deprecated Use device instead.
   */
  elevator?: Maybe<Device>;
  id: Scalars['ID']['output'];
  isLate?: Maybe<Scalars['Boolean']['output']>;
  isUrgent: Scalars['Boolean']['output'];
  /** The mechanic responsible for this task */
  mechanic: Mechanic;
  /**
   * Mechanic dedicated to this task
   * @deprecated Use mechanic instead.
   */
  mechanicId: Scalars['ID']['output'];
  /** Media currently linked to this task. More precisely, includes all media linked to answers given for this task */
  media: VisitsAnswerPhotoConnection;
  mission: Mission;
  /** If false, the task is late or was done late, if true, it was done in time, if null there is time left to complete the task */
  onTime?: Maybe<Scalars['Boolean']['output']>;
  /** Photos currently linked to this task. More precisely, includes all photos linked to answers given for this task */
  photos: VisitsAnswerPhotoConnection;
  /** The reference of this task, as printed on its worksheet: BDN26-000004, or BDN26-S12345-1 when the task belongs to a shutdown chain. */
  reference?: Maybe<Scalars['String']['output']>;
  /** All the repair requests linked to this task */
  repairRequests: Array<RepairRequest>;
  reportLocationKey?: Maybe<Scalars['String']['output']>;
  /**
   * signed URL to a report for the given task, can be null if no report exists
   * Notes: This link expires after 7 days
   */
  reportUrl?: Maybe<Scalars['String']['output']>;
  /** The time at which the task was started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  taskNumber: Scalars['String']['output'];
  /** @deprecated please use chunks instead */
  toBeDoneAt?: Maybe<Scalars['DateTime']['output']>;
  /** This mission needs to be done BEFORE this time */
  toBeDoneBefore: Scalars['DateTime']['output'];
  /** tasks have types to easily tell the mechanic in broad lines what he will be doing */
  type: TaskType;
  /** Human readable task type, translated in the selected language */
  typeName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** All visits that happened on this task */
  visits: VisitsVisitTaskVisitConnection;
};


/** A task is one goal of a mission. It represents the work we want the mechanic to be doing when he gets on site. */
export type TaskAnswersArgs = {
  order?: InputMaybe<Array<VisitsAnswerOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};


/** A task is one goal of a mission. It represents the work we want the mechanic to be doing when he gets on site. */
export type TaskMediaArgs = {
  filters?: InputMaybe<FindManyAnswerMediaInput>;
  order?: InputMaybe<Array<VisitsAnswerPhotoOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};


/** A task is one goal of a mission. It represents the work we want the mechanic to be doing when he gets on site. */
export type TaskPhotosArgs = {
  order?: InputMaybe<Array<VisitsAnswerPhotoOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};


/** A task is one goal of a mission. It represents the work we want the mechanic to be doing when he gets on site. */
export type TaskTypeNameArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A task is one goal of a mission. It represents the work we want the mechanic to be doing when he gets on site. */
export type TaskVisitsArgs = {
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

/** Payload required for the soft deletion of a task, identified by either its id or its reference */
export type TaskDeletePayload = {
  /** Id of the task to be soft deleted. Exclusive with reference. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Reference of the task to be soft deleted, as printed on its worksheet (e.g. BDN26-000004). Exclusive with id. */
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** Set of filters to apply to the tasks */
export type TaskFilters = {
  /** Get only tasks from the buildings of specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only tasks belonging to specified buildings */
  buildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter task that have been completed on or after this date */
  completedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter task that have been completed on or before this date */
  completedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Get only tasks from the buildings of specified accounts
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Get only tasks belonging to specified Devices */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter tasks by the device subtypes they relate to */
  deviceSubTypes?: InputMaybe<Array<DeviceSubTypeEnum>>;
  /** Filter tasks by the device types they relate to */
  deviceTypes?: InputMaybe<Array<DeviceTypeEnum>>;
  /** Get only tasks done to specified mechanics */
  doneByMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Get only tasks belonging to specified elevators
   * @deprecated Use deviceIds instead
   */
  elevatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter tasks by their IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** true to only get tasks currently in progress (an engineer is currently in an active visit), false to get every tasks but the ongoing ones */
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to only get Tasks which are done, false to get only Tasks which are still to be completed */
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to only get tasks which are late (ie: past their deadline), false to only get tasks currently meeting their deadlines */
  isLate?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to only get tasks that were started (task is done or task is paused/inprogress and one question was answered), false to get only not started ones */
  isStarted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only tasks belonging to specified mechanics */
  mechanicIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter tasks by the manager of the ops referent user on the device's contract. Given a list of user IDs, tasks whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Get only the tasks whose reference contains this text — a whole reference as printed on a worksheet (BDN26-000004, BDN26-S12345-1), or a shutdown number, which returns every sheet of that chain. */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Get only tasks affected to some specific referent users */
  referentUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** used to filter by address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter tasks by the location of the building (iso 3166-1 alpha-2 format: FR, EN) */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get only tasks of certain types */
  types?: InputMaybe<Array<TaskType>>;
  /**
   * DEPRECATED: Use updatedAt.after
   * @deprecated Use updatedAt.after
   */
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter tasks that have been updated between a certain date */
  updatedAt?: InputMaybe<DateFilter>;
  /** Also return tasks that have been soft deleted */
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskMembers = {
  __typename?: 'TaskMembers';
  accountIds?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<TimeDimension>;
  count?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<TimeDimension>;
  customerId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<TimeDimension>;
  deviceId?: Maybe<Scalars['String']['output']>;
  done?: Maybe<Scalars['String']['output']>;
  doneByMechanicId?: Maybe<Scalars['String']['output']>;
  isUrgent?: Maybe<Scalars['String']['output']>;
  mechanicId?: Maybe<Scalars['String']['output']>;
  onTime?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<TimeDimension>;
  toBeDoneBefore?: Maybe<TimeDimension>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<TimeDimension>;
};

export type TaskOrderByInput = {
  accountIds?: InputMaybe<OrderBy>;
  buildingId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  done?: InputMaybe<OrderBy>;
  doneByMechanicId?: InputMaybe<OrderBy>;
  isUrgent?: InputMaybe<OrderBy>;
  mechanicId?: InputMaybe<OrderBy>;
  onTime?: InputMaybe<OrderBy>;
  origin?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  toBeDoneBefore?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

export enum TaskSortableFields {
  BuildingId = 'buildingId',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Done = 'done',
  Id = 'id',
  IsUrgent = 'isUrgent',
  MechanicId = 'mechanicId',
  Reference = 'reference',
  StartedAt = 'startedAt',
  ToBeDoneBefore = 'toBeDoneBefore',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

/** Different types of task */
export enum TaskType {
  Annual = 'ANNUAL',
  Breakdown = 'BREAKDOWN',
  ClientAppointment = 'CLIENT_APPOINTMENT',
  ControlOfficeAppointment = 'CONTROL_OFFICE_APPOINTMENT',
  Handover = 'HANDOVER',
  IotInstallation = 'IOT_INSTALLATION',
  Previsit = 'PREVISIT',
  Quarterly = 'QUARTERLY',
  Regular = 'REGULAR',
  Repair = 'REPAIR',
  SecurityAudit = 'SECURITY_AUDIT',
  Semiannual = 'SEMIANNUAL',
  TrappedPassenger = 'TRAPPED_PASSENGER'
}

export type TaskWhereInput = {
  AND?: InputMaybe<Array<TaskWhereInput>>;
  OR?: InputMaybe<Array<TaskWhereInput>>;
  accountIds?: InputMaybe<StringFilter>;
  buildingId?: InputMaybe<StringFilter>;
  completedAt?: InputMaybe<DateTimeFilter>;
  count?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeFilter>;
  deviceId?: InputMaybe<StringFilter>;
  done?: InputMaybe<StringFilter>;
  doneByMechanicId?: InputMaybe<StringFilter>;
  isUrgent?: InputMaybe<StringFilter>;
  mechanicId?: InputMaybe<StringFilter>;
  onTime?: InputMaybe<StringFilter>;
  origin?: InputMaybe<StringFilter>;
  startedAt?: InputMaybe<DateTimeFilter>;
  toBeDoneBefore?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TechSupportRequestItem = RequestItem & {
  __typename?: 'TechSupportRequestItem';
  /** The tech support expert (mechanic) assigned on this support request */
  assignedMechanic?: Maybe<Mechanic>;
  /** If this requested item needs to be invoiced to the customer */
  chargeable?: Maybe<Scalars['Boolean']['output']>;
  /** Short text describing the purpose of the tech support */
  comment: Scalars['String']['output'];
  /** Date when the request item should be delivered from our supplier */
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The human identifier for a request (at the moment it is the id within airtable)
   * @deprecated Airtable is not used anymore. This field is deprecated and will be removed in the future.
   */
  humanId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** If the item is withdrawable by the engineer */
  isWithdrawable: Scalars['Boolean']['output'];
  /**
   * Comment of the ops about the requested item
   * @deprecated Comments are not found on individual parts anymore but on the request as a whole. Use RepairRequest.enginerComment or RepairRequest.internalComment
   */
  opsComment?: Maybe<Scalars['String']['output']>;
  /** Order progression data synced from Netsuite for this request item */
  orderProgression?: Maybe<RequestItemOrderProgression>;
  /** Display the tech support requested item photos */
  photos: Array<Scalars['String']['output']>;
  /** Cost of the item (what we pay). This represents the company's cost for the item. Use sellPrice for the margin/sell price. Can be null if not set yet. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The quote line this item backs — a partition: an item belongs to at most one line (PRENG-7500) */
  quoteLine?: Maybe<QuoteLine>;
  repairRequestId: Scalars['ID']['output'];
  /**
   * Sell price of the item (separate from cost). Used for items that need to track separate cost and margin, such as Installation items. Can be null if not set.
   * @deprecated What the customer pays lives on QuoteLine.sellPrice (PRENG-7500); this is never written anymore
   */
  sellPrice?: Maybe<Scalars['Float']['output']>;
  /** Represent the state of the request item (should be used in place of status). Based on the type of the itemand its current data it return a state representing the next action to be done on a business point of view. */
  state?: Maybe<RequestItemState>;
  /**
   * Represent the status of the item in the repair flow
   * @deprecated Status is representing the status of the item in our legacy flow. Please use state instead, that represent
   */
  status: RepairRequestStatus;
  /** Optional URL towards a quote from one of our supplier for this part that we've used for pricing */
  supplierQuoteLink?: Maybe<Scalars['String']['output']>;
  /** Information about the withdrawal of the item by the engineer */
  withdrawal?: Maybe<Withdrawal>;
};

/** Payload to add a tech support request item to a repair request */
export type TechSupportRequestItemInput = {
  /** Engineer comment regarding the purpose of the tech support request */
  comment: Scalars['String']['input'];
  /** Photos/screenshots adding context to the tech support request */
  photos?: InputMaybe<Array<Scalars['Upload']['input']>>;
};

/** Geographical zoning of our operations, can be a country, state, city or whatever zoning we need */
export type Territory = {
  __typename?: 'Territory';
  /** Returns a list of buildings filtered by the locale of the mechanic */
  buildings: BuildingsBuildingConnection;
  countryCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


/** Geographical zoning of our operations, can be a country, state, city or whatever zoning we need */
export type TerritoryBuildingsArgs = {
  filters?: InputMaybe<TerritoryBuildingsFilters>;
  pagination?: InputMaybe<BuildingsConnectionArgs>;
};


/** Geographical zoning of our operations, can be a country, state, city or whatever zoning we need */
export type TerritoryNameArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filters to apply when fetching buildings */
export type TerritoryBuildingsFilters = {
  /** Filter buildings with a search on building name, city name, zipcode or address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter buildings which have signed contracts */
  withContract?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextInput = FormInput & FormThing & {
  __typename?: 'TextInput';
  /** If set, means that changing this field would update 1<->1 to the corresponding key in the entity */
  entityKey?: Maybe<Scalars['String']['output']>;
  /** The identifier of this input, to be sent back to the backend */
  key?: Maybe<Scalars['String']['output']>;
  /** configuration for the display/validation of this input */
  settings: IInputSettings;
  title: Scalars['String']['output'];
  /** Current value associated to the input */
  value?: Maybe<Scalars['ValueOfInput']['output']>;
};

/** A Thing (or IOT Device) */
export type Thing = {
  /** Building where this thing is installed */
  building: Building;
  /** List of devices this thing is installed on */
  devices: Array<Maybe<Device>>;
  /** The Thing uuid */
  id: Scalars['String']['output'];
  installationDate: Scalars['DateTime']['output'];
  /** The Thing Model */
  model: ThingModel;
  /** The URL were the thing can be monitored (online/offline,...) */
  monitoringUrl?: Maybe<Scalars['Boolean']['output']>;
  /** The Thing name, used by MQTT for example. (eg: TYXXXX) */
  name: Scalars['String']['output'];
  type: ThingType;
};

/** The thing's model */
export enum ThingModel {
  MxAdvance = 'MxAdvance',
  MxCore = 'MxCore',
  Tyrion = 'Tyrion'
}

/** Define the type of thing module, and the data it will provide */
export enum ThingType {
  ElevatorModule = 'ElevatorModule',
  EscalatorModule = 'EscalatorModule',
  FireSafetyControllerModule = 'FireSafetyControllerModule',
  Unknown = 'Unknown'
}

export type ThingsFilters = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  thingNames?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Payload for the new setup information. Only one of those can be provided at a given time */
export type ThingsSetupInput = {
  /** Update the elevator module information */
  elevatorModule?: InputMaybe<ElevatorModuleSetupInput>;
  /** Update the Esclator Module setup */
  escalatorModule?: InputMaybe<EscalatorModuleSetupInput>;
  /** Update the fire safety controller information */
  fireSafetyControllerModule?: InputMaybe<FireSafetyControllerModuleSetupInput>;
};

/** Providers of ticket outside of WeMaintain that end up aggregated in WmTicket */
export enum TicketVendor {
  Antasis = 'ANTASIS',
  MakeTheRightCall = 'MAKE_THE_RIGHT_CALL',
  Serenite = 'SERENITE',
  Totally247 = 'TOTALLY247'
}

export type TimeDimension = {
  __typename?: 'TimeDimension';
  day: Scalars['DateTime']['output'];
  hour: Scalars['DateTime']['output'];
  minute: Scalars['DateTime']['output'];
  month: Scalars['DateTime']['output'];
  quarter: Scalars['DateTime']['output'];
  second: Scalars['DateTime']['output'];
  value: Scalars['DateTime']['output'];
  week: Scalars['DateTime']['output'];
  year: Scalars['DateTime']['output'];
};

/** A timeline marker in a downtime timeline */
export type TimelineMarker = {
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  type: TimelineMarkerType;
};

/** The type of a timeline marker */
export enum TimelineMarkerType {
  Downtime = 'Downtime',
  Intervention = 'Intervention',
  Signal = 'Signal'
}

export type TimestampOverrideInput = {
  /** Change the end date to the given datetime */
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Change the start date to the given datetime */
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

/** A toggleable signal. */
export type ToggleableSignal = StrongSignal & {
  __typename?: 'ToggleableSignal';
  /** An acknowledgement if the signal was acknowledged. */
  acknowledgement?: Maybe<Acknowledgement>;
  /** The date and time when the signal was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time when the signal was last updated. This attribute has to be sent when acknowledging a signal. */
  date: Scalars['DateTime']['output'];
  /** Details about this signal */
  details: Array<StrongSignalDetail>;
  /** The device associated with the signal */
  device?: Maybe<Device>;
  /** A dismissal if the signal was dismissed. */
  dismissal?: Maybe<Dismissal>;
  /** Technical description of the signal meant for the engineer */
  engineerDescription: Scalars['String']['output'];
  /** The state of the strong signal. */
  engineerSorting: StrongSignalStateEnum;
  /** The type of the toggleable signal. */
  eventName: ToggleableSignalType;
  /** Human understandable explanation detailing this signal, trying to make it legible even by non technical users */
  explanation: Scalars['String']['output'];
  /** The ID of the signal in the backend. */
  id: Scalars['ID']['output'];
  /** The state of the toggleable signal. */
  isActive: Scalars['Boolean']['output'];
  /** The relevancy feedback of the signal. */
  relevancyFeedback?: Maybe<SignalRelevancyFeedback>;
  /** Human readable sub title detailing this signal */
  subtitle: Scalars['String']['output'];
  /** The thing associated with the signal */
  thing?: Maybe<Thing>;
  /** The thing name that emitted the signal. */
  thingName: Scalars['String']['output'];
  /** Human readable title for this signal */
  title: Scalars['String']['output'];
};


/** A toggleable signal. */
export type ToggleableSignalDetailsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A toggleable signal. */
export type ToggleableSignalEngineerDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A toggleable signal. */
export type ToggleableSignalExplanationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A toggleable signal. */
export type ToggleableSignalSubtitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A toggleable signal. */
export type ToggleableSignalTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The type of the toggleable signal. */
export enum ToggleableSignalType {
  AlarmBell = 'AlarmBell',
  FaultMode = 'FaultMode',
  FireAlarm = 'FireAlarm'
}

export type TranslationInput = {
  lang: Scalars['String']['input'];
  translation: Scalars['String']['input'];
};

export type TripMembers = {
  __typename?: 'TripMembers';
  accountIds?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  /** Monthly average number of trips */
  countMonthlyAvg?: Maybe<Scalars['Float']['output']>;
  /** Daily trips count average */
  dailyCountAvg?: Maybe<Scalars['Float']['output']>;
  dayOfWeekStartTime?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceNumber?: Maybe<Scalars['String']['output']>;
  /** Distance between start and end position in mm */
  distance?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  endFloor?: Maybe<Scalars['Float']['output']>;
  endFloorLabel?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<TimeDimension>;
  /** Hourly trips count average */
  hourlyCountAvg?: Maybe<Scalars['Float']['output']>;
  hourlyStartTime?: Maybe<TimeDimension>;
  /** Lane between 2 floors */
  lane?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  /** Number of days included in the date range of the query time filter */
  nbDays?: Maybe<Scalars['Float']['output']>;
  /** Number of hours of the time interval defined by the query time filter */
  nbHours?: Maybe<Scalars['Float']['output']>;
  /** End of the time dimension's, provided by the filter */
  queryEndTime?: Maybe<Scalars['Float']['output']>;
  /** Start of the time dimension's, provided by the filter */
  queryStartTime?: Maybe<Scalars['Float']['output']>;
  startFloor?: Maybe<Scalars['Float']['output']>;
  startFloorLabel?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<TimeDimension>;
  thingName?: Maybe<Scalars['String']['output']>;
  totalDuration?: Maybe<Scalars['Float']['output']>;
};

export type TripOrderByInput = {
  accountIds?: InputMaybe<OrderBy>;
  buildingId?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  countMonthlyAvg?: InputMaybe<OrderBy>;
  dailyCountAvg?: InputMaybe<OrderBy>;
  dayOfWeekStartTime?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  deviceNumber?: InputMaybe<OrderBy>;
  distance?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  endFloor?: InputMaybe<OrderBy>;
  endFloorLabel?: InputMaybe<OrderBy>;
  endTime?: InputMaybe<OrderBy>;
  hourlyCountAvg?: InputMaybe<OrderBy>;
  hourlyStartTime?: InputMaybe<OrderBy>;
  lane?: InputMaybe<OrderBy>;
  location?: InputMaybe<OrderBy>;
  nbDays?: InputMaybe<OrderBy>;
  nbHours?: InputMaybe<OrderBy>;
  queryEndTime?: InputMaybe<OrderBy>;
  queryStartTime?: InputMaybe<OrderBy>;
  startFloor?: InputMaybe<OrderBy>;
  startFloorLabel?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<OrderBy>;
  thingName?: InputMaybe<OrderBy>;
  totalDuration?: InputMaybe<OrderBy>;
};

export type TripWhereInput = {
  AND?: InputMaybe<Array<TripWhereInput>>;
  OR?: InputMaybe<Array<TripWhereInput>>;
  accountIds?: InputMaybe<StringFilter>;
  buildingId?: InputMaybe<StringFilter>;
  count?: InputMaybe<FloatFilter>;
  countMonthlyAvg?: InputMaybe<FloatFilter>;
  dailyCountAvg?: InputMaybe<FloatFilter>;
  dayOfWeekStartTime?: InputMaybe<StringFilter>;
  deviceId?: InputMaybe<StringFilter>;
  deviceNumber?: InputMaybe<StringFilter>;
  distance?: InputMaybe<FloatFilter>;
  duration?: InputMaybe<FloatFilter>;
  endFloor?: InputMaybe<FloatFilter>;
  endFloorLabel?: InputMaybe<StringFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  hourlyCountAvg?: InputMaybe<FloatFilter>;
  hourlyStartTime?: InputMaybe<DateTimeFilter>;
  lane?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringFilter>;
  nbDays?: InputMaybe<FloatFilter>;
  nbHours?: InputMaybe<FloatFilter>;
  queryEndTime?: InputMaybe<FloatFilter>;
  queryStartTime?: InputMaybe<FloatFilter>;
  startFloor?: InputMaybe<FloatFilter>;
  startFloorLabel?: InputMaybe<StringFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  thingName?: InputMaybe<StringFilter>;
  totalDuration?: InputMaybe<FloatFilter>;
};

/** A trips anomaly strong signal. */
export type TripsAnomaly = StrongSignal & {
  __typename?: 'TripsAnomaly';
  /** An acknowledgement if the signal was acknowledged. */
  acknowledgement?: Maybe<Acknowledgement>;
  /** The date and time when the signal was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date and time when the signal was last updated. This attribute has to be sent when acknowledging a signal. */
  date: Scalars['DateTime']['output'];
  /** Details about this signal */
  details: Array<StrongSignalDetail>;
  /** The device associated with the signal */
  device?: Maybe<Device>;
  /** A dismissal if the signal was dismissed. */
  dismissal?: Maybe<Dismissal>;
  /** Technical description of the signal meant for the engineer */
  engineerDescription: Scalars['String']['output'];
  /** The state of the strong signal. */
  engineerSorting: StrongSignalStateEnum;
  /** Human understandable explanation detailing this signal, trying to make it legible even by non technical users */
  explanation: Scalars['String']['output'];
  /** The ID of the signal in the backend. */
  id: Scalars['ID']['output'];
  /** The relevancy feedback of the signal. */
  relevancyFeedback?: Maybe<SignalRelevancyFeedback>;
  /** Human readable sub title detailing this signal */
  subtitle: Scalars['String']['output'];
  /** The thing associated with the signal */
  thing?: Maybe<Thing>;
  /** The thing name that emitted the signal. */
  thingName: Scalars['String']['output'];
  /** The timestamp of the anomaly. */
  timestamp: Scalars['Timestamp']['output'];
  /** Human readable title for this signal */
  title: Scalars['String']['output'];
  /** The type of the trips anomaly. */
  type: TripsAnomalyType;
};


/** A trips anomaly strong signal. */
export type TripsAnomalyDetailsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A trips anomaly strong signal. */
export type TripsAnomalyEngineerDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A trips anomaly strong signal. */
export type TripsAnomalyExplanationArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A trips anomaly strong signal. */
export type TripsAnomalySubtitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A trips anomaly strong signal. */
export type TripsAnomalyTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The type of the trips anomaly. */
export enum TripsAnomalyType {
  Acceleration = 'Acceleration',
  Braking = 'Braking',
  Speed = 'Speed'
}

/** Type of the downtime, either an intervention by an engineer or a breakdown */
export enum Type {
  Breakdown = 'BREAKDOWN',
  Intervention = 'INTERVENTION'
}

export type UnavailabilityMembers = {
  __typename?: 'UnavailabilityMembers';
  count?: Maybe<Scalars['Float']['output']>;
  day?: Maybe<TimeDimension>;
  defectOnlyDowntime?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Scalars['Float']['output']>;
  downtime?: Maybe<Scalars['Float']['output']>;
  endInDay?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  startInDay?: Maybe<Scalars['String']['output']>;
  totalDowntime?: Maybe<Scalars['Float']['output']>;
  totalDowntimeHours?: Maybe<Scalars['Float']['output']>;
};

export type UnavailabilityOrderByInput = {
  count?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  defectOnlyDowntime?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  devices?: InputMaybe<OrderBy>;
  downtime?: InputMaybe<OrderBy>;
  endInDay?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  startInDay?: InputMaybe<OrderBy>;
  totalDowntime?: InputMaybe<OrderBy>;
  totalDowntimeHours?: InputMaybe<OrderBy>;
};

export type UnavailabilityWhereInput = {
  AND?: InputMaybe<Array<UnavailabilityWhereInput>>;
  OR?: InputMaybe<Array<UnavailabilityWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  day?: InputMaybe<DateTimeFilter>;
  defectOnlyDowntime?: InputMaybe<FloatFilter>;
  deviceId?: InputMaybe<StringFilter>;
  devices?: InputMaybe<FloatFilter>;
  downtime?: InputMaybe<FloatFilter>;
  endInDay?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  startInDay?: InputMaybe<StringFilter>;
  totalDowntime?: InputMaybe<FloatFilter>;
  totalDowntimeHours?: InputMaybe<FloatFilter>;
};

export type Unavailability_LegacyMembers = {
  __typename?: 'Unavailability_legacyMembers';
  /** Availability rate during the day */
  availabilityRate?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  day?: Maybe<TimeDimension>;
  deviceId?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Scalars['Float']['output']>;
  durationDuringTheDay?: Maybe<Scalars['Float']['output']>;
  endInDay?: Maybe<Scalars['String']['output']>;
  /** Availability rate during the day */
  rate?: Maybe<Scalars['Float']['output']>;
  startInDay?: Maybe<Scalars['String']['output']>;
};

export type Unavailability_LegacyOrderByInput = {
  availabilityRate?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  day?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  devices?: InputMaybe<OrderBy>;
  durationDuringTheDay?: InputMaybe<OrderBy>;
  endInDay?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  startInDay?: InputMaybe<OrderBy>;
};

export type Unavailability_LegacyWhereInput = {
  AND?: InputMaybe<Array<Unavailability_LegacyWhereInput>>;
  OR?: InputMaybe<Array<Unavailability_LegacyWhereInput>>;
  availabilityRate?: InputMaybe<FloatFilter>;
  count?: InputMaybe<FloatFilter>;
  day?: InputMaybe<DateTimeFilter>;
  deviceId?: InputMaybe<StringFilter>;
  devices?: InputMaybe<FloatFilter>;
  durationDuringTheDay?: InputMaybe<FloatFilter>;
  endInDay?: InputMaybe<StringFilter>;
  rate?: InputMaybe<FloatFilter>;
  startInDay?: InputMaybe<StringFilter>;
};

/** Unlink a source from a problem input */
export type UnlinkSourceInput = {
  /** The device id of the device that has the problem */
  deviceId: Scalars['ID']['input'];
  /** The source id of the source that has the problem */
  sourceId: Scalars['ID']['input'];
};

/** Input to unlink tasks from a specific repair request */
export type UnlinkTasksToRepairRequestInput = {
  /** The id of the repair request where we want to unlink some tasks */
  repairRequestId: Scalars['ID']['input'];
  /** The ids of the tasks we want to unlink */
  taskIds: Array<Scalars['ID']['input']>;
};

/** Payload to unregister a device token linked to a user */
export type UnregisterPushNotificationTokenPayload = {
  /** token linked to the device/phone of the user */
  deviceToken: Scalars['String']['input'];
};

/** Response after updating audit report lines */
export type UpdateAuditReportLinesResponse = {
  __typename?: 'UpdateAuditReportLinesResponse';
  /** Report lines array of updated audit reports lines */
  updatedAuditReportLines: Array<AuditReportLine>;
};

export type UpdatePlanItemPayload = {
  id?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  level: Scalars['String']['input'];
  posx: Scalars['Float']['input'];
  posy: Scalars['Float']['input'];
};

/** Input to update the list of issues linked to a repair request */
export type UpdateRepairRequestIssuesInput = {
  /** The complete list of issue ids that should be linked to this repair request */
  issueIds: Array<Scalars['ID']['input']>;
  /** The id of the repair request to update */
  repairRequestId: Scalars['ID']['input'];
};

/** Input to update the title of a repair request */
export type UpdateRepairRequestTitleInput = {
  /** The id of the repair request */
  repairRequestId: Scalars['String']['input'];
  /** The new title of the repair request */
  title: Scalars['String']['input'];
};

/**
 * The payload for updating an auditReportLine.
 * Some properties can only be updated by admin,
 * others are meant to be updated by transcribers.
 */
export type UpdateReportLinePayload = {
  /**
   * The appliable property will be set to false
   *     if the reported defect is irrelevant and will therefore be ignored.
   *     Can be set only by admin
   * @deprecated Replaced by the qualification field
   */
  applicable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The text describing the defect.
   * Can be selected from the pdf or edited by the transcriber
   */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The type of defect that will be emitted from this report-line, defining behavior for fixing. See DefectType. */
  defectType?: InputMaybe<DefectType>;
  /** The referenced device */
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Date at which the described defect was discovered */
  discoveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date at which the defect has been fixed */
  fixedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The id of the reportLine to update */
  id: Scalars['ID']['input'];
  /**
   * If set to true, then the mechanic must fix it as part of the contract.
   *     Otherwise, the mechanic will send a quote that will be confirmed by the customer.
   *     Can be set only by admin
   * @deprecated Replaced by the qualification field
   */
  includedInContract?: InputMaybe<Scalars['Boolean']['input']>;
  /** The status of the line relating to the customer contract. */
  qualification?: InputMaybe<Qualification>;
  /** The status of the current quote related to the report line */
  quoteStatus?: InputMaybe<QuoteStatus>;
  /**
   * The status of the line.
   * Can be updated only by admin, and never to FIXED
   */
  status?: InputMaybe<AuditReportLineStatus>;
  /** Date before which the report line needs to be done */
  toBeDoneBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Used to filter audit reports by status */
export type UpdateReportPayload = {
  /** Id of the report to update */
  reportId: Scalars['ID']['input'];
  /** New status for the report */
  status: AuditReportStatus;
};

/** Payload to update building and/or device blocklists for a user */
export type UpdateUserBlocklistInput = {
  /** Buildings to add to or remove from the blocklist */
  buildings?: InputMaybe<Array<BuildingBlocklistItem>>;
  /** Devices to add to or remove from the blocklist */
  devices?: InputMaybe<Array<DeviceBlocklistItem>>;
  /** ID of the user whose blocklist should be updated */
  userId: Scalars['Int']['input'];
};

/** Result of updating the blocklist associations for a user */
export type UpdateUserBlocklistResponse = {
  __typename?: 'UpdateUserBlocklistResponse';
  /** Building IDs that have been added to the blocklist (access denied) */
  blockedBuildingIds: Array<Scalars['Int']['output']>;
  /** Device IDs that have been added to the blocklist (access denied) */
  blockedDeviceIds: Array<Scalars['String']['output']>;
  /** Building IDs that have been removed from the blocklist (access restored) */
  buildingIdsAccessible: Array<Scalars['Int']['output']>;
  /** Device IDs that have been removed from the blocklist (access restored) */
  deviceIdsAccessible: Array<Scalars['String']['output']>;
};

export type UploadSignedQuoteCommandInput = {
  key: Scalars['String']['input'];
  quoteId: Scalars['String']['input'];
};

export type UpsertQuoteWorkOrdersInput = {
  sfQuoteId?: InputMaybe<Scalars['String']['input']>;
  workOrderIdsToAttach?: Array<Scalars['ID']['input']>;
  workOrderIdsToDetach?: Array<Scalars['ID']['input']>;
};

/** Urgency level of a repair request */
export enum UrgencyLevel {
  ForTheNextVisit = 'FOR_THE_NEXT_VISIT',
  InTheWeek = 'IN_THE_WEEK',
  Urgent = 'URGENT'
}

export type User = {
  accessibleBuildingsCount?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Renamed, use email instead */
  emailId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  hasMaximize?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  intercomHashId: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** Set when this user is an alias merged into another user: the id of that user */
  mergedIntoUserId?: Maybe<Scalars['Int']['output']>;
  mobileNo?: Maybe<Scalars['String']['output']>;
  subscriptionInfo: SubscriptionInfo;
  /** The user id */
  userId?: Maybe<Scalars['Float']['output']>;
};

export type UserAccountMembers = {
  __typename?: 'UserAccountMembers';
  customerId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type UserAccountOrderByInput = {
  customerId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

export type UserAccountWhereInput = {
  AND?: InputMaybe<Array<UserAccountWhereInput>>;
  OR?: InputMaybe<Array<UserAccountWhereInput>>;
  customerId?: InputMaybe<FloatFilter>;
  userId?: InputMaybe<FloatFilter>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export type UserMembers = {
  __typename?: 'UserMembers';
  count?: Maybe<Scalars['Float']['output']>;
  createddate?: Maybe<TimeDimension>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  hasplatformaccess?: Maybe<Scalars['String']['output']>;
  isactive?: Maybe<Scalars['String']['output']>;
  iscontactbydefault?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  mobileno?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  passwordsaltkey?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type UserOrderByInput = {
  count?: InputMaybe<OrderBy>;
  createddate?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  firstname?: InputMaybe<OrderBy>;
  hasplatformaccess?: InputMaybe<OrderBy>;
  isactive?: InputMaybe<OrderBy>;
  iscontactbydefault?: InputMaybe<OrderBy>;
  lastname?: InputMaybe<OrderBy>;
  mobileno?: InputMaybe<OrderBy>;
  password?: InputMaybe<OrderBy>;
  passwordsaltkey?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
};

/** The user role */
export enum UserRole {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Mechanic = 'MECHANIC'
}

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  count?: InputMaybe<FloatFilter>;
  createddate?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  hasplatformaccess?: InputMaybe<StringFilter>;
  isactive?: InputMaybe<StringFilter>;
  iscontactbydefault?: InputMaybe<StringFilter>;
  lastname?: InputMaybe<StringFilter>;
  mobileno?: InputMaybe<StringFilter>;
  password?: InputMaybe<StringFilter>;
  passwordsaltkey?: InputMaybe<StringFilter>;
  role?: InputMaybe<StringFilter>;
};

export type UsersAccountOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: AccountOrmEntitySortableFields;
};

export type UsersConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersCustomerConnection = {
  __typename?: 'UsersCustomerConnection';
  edges: Array<UsersCustomerEdge>;
  pageInfo: UsersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type UsersCustomerEdge = {
  __typename?: 'UsersCustomerEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Customer;
};

/** Filters to apply when fetching one or more users */
export type UsersFilters = {
  /** Filter users of given roles */
  roles: Array<UserRole>;
  /** Filter users of given territories */
  territories?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter whether users currently have at least one active contract or not
   * Notes: Filtering on withActiveContract will exclude users with role!=ADMIN
   */
  withActiveContract?: Scalars['Boolean']['input'];
};

/** Filters users by group key */
export type UsersGroupKeyFilter = {
  /** The human key describing the group users we want to fetch */
  key: Scalars['String']['input'];
  /** The territory */
  territory?: InputMaybe<Scalars['String']['input']>;
};

export type UsersIUserConnection = {
  __typename?: 'UsersIUserConnection';
  edges: Array<UsersIUserEdge>;
  pageInfo: UsersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type UsersIUserEdge = {
  __typename?: 'UsersIUserEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: User;
};

export type UsersPageInfo = {
  __typename?: 'UsersPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type UsersUserCustomerGraphqlAccountConnection = {
  __typename?: 'UsersUserCustomerGraphqlAccountConnection';
  edges: Array<UsersUserCustomerGraphqlAccountEdge>;
  pageInfo: UsersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type UsersUserCustomerGraphqlAccountEdge = {
  __typename?: 'UsersUserCustomerGraphqlAccountEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  /** if the user has access to the Client platform */
  hasPlatformAccess: Scalars['Boolean']['output'];
  /** if the user is the entry point for every communications with the client */
  isContactByDefault: Scalars['Boolean']['output'];
  node: Account;
};

/** Filters to apply when fetching one or more users */
export type UsersV2Filters = {
  /** Filter contacts by the accounts they have access to */
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter contacts by the building ids */
  buildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter users by their ISO country code (e.g. "FR", "GB") */
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter contacts by the accounts they have access to
   * @deprecated Use accountIds instead
   */
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter contacts by their emails */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter users by group keys (e.g., roles within a territory) */
  groupKeys?: InputMaybe<Array<UsersGroupKeyFilter>>;
  /** Filter users by their UUIDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, only returns users who are referenced as a manager on another user */
  isBranchManager?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, only returns users who are referenced as the CSM referent of at least one mechanic */
  isReferentUserOfMechanic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter contacts by the user owning the contract related to these users */
  referentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter users of given roles */
  roles: Array<UserRole>;
  /** Filter users on firstName|lastName|email|customer.companyName */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** ValueFormat */
export type ValueFormat = {
  __typename?: 'ValueFormat';
  dimension: Scalars['Float']['output'];
  format: Scalars['String']['output'];
};

export enum ValueLabelsDisplay {
  Labels = 'labels',
  Legend = 'legend',
  None = 'none'
}

/** Vendor synchronized from Netsuite */
export type Vendor = {
  __typename?: 'Vendor';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Email for order dunning */
  emailOrderDunning?: Maybe<Scalars['String']['output']>;
  /** Email for quote */
  emailQuote?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Identifier of the vendor in Netsuite */
  netsuiteId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  /** Territories where this vendor can be used */
  territories: Array<PartTerritory>;
};

/** Filter vendors by territory and search text */
export type VendorInputFilters = {
  /** Search vendors by name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter vendors by a territory */
  territory: PartTerritory;
};

/** A device vertical such as ELEVATOR / ESCALATOR / ... */
export type VerticalType = {
  __typename?: 'VerticalType';
  /** The icon for the vertical */
  icon: Icon;
  /** Number of devices from the current vertical present in the building */
  noOfDevices: Scalars['Int']['output'];
  type: DeviceType;
};


/** A device vertical such as ELEVATOR / ESCALATOR / ... */
export type VerticalTypeIconArgs = {
  size: AvailableIconSizes;
};


/** A device vertical such as ELEVATOR / ESCALATOR / ... */
export type VerticalTypeNoOfDevicesArgs = {
  filters?: InputMaybe<BuildingDeviceFilters>;
};

/** Filters to apply for mechanic.allVisibleMissions */
export type VisibleMissionsFilters = {
  /** Get only missions from the buildings of the specified accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions belonging to these buildings */
  buildingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions that where completed between the a period */
  completedAt?: InputMaybe<RequiredDateFilter>;
  /** Get only missions from the buildings of the specified accounts */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by their deviceIds as long as the task is not completed */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by the status of its devices (as long as the task is not completed) */
  deviceStatuses?: InputMaybe<Array<DeviceStateStatus>>;
  /** If we want missions which were already done or not */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** Get only missions where a task was done by one of the specified mechanics */
  doneByMechanicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Fetch mission that are late (ie: they were done late or they are not done and their deadline has expired) */
  isLate?: InputMaybe<Scalars['Boolean']['input']>;
  /** If we want only missions which are urgent. */
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter missions by the manager of the ops referent user on the building's contract. Given a list of user IDs, missions whose contract referent user has one of those IDs as their manager will be returned. For convenience, passing a referent user's own ID also returns contracts they manage directly. */
  opsManagerUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter missions by referent user linked to the mission's building's contract */
  referentUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** used to filter by address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Get only the missions matching the given mission types */
  types?: InputMaybe<Array<TaskType>>;
  /** Order missions to show the Urgent one on top */
  urgentFirst?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A visit is the act of physically going on site for a period of time to do one or more missions.
 *
 * Only during a visit can a mechanic answer questions or complete tasks (ie: do the work.)
 * Everytime a mechanic leaves the site, his visit is then closed, even if missions / tasks are left
 * unfinished.
 *
 * A given mechanic can only have one active (whose completedAt is null) visit at a time.
 */
export type Visit = {
  __typename?: 'Visit';
  /**
   * Date at which the visit was marked as completed.
   *     This equates to the time the mechanic declared "leaving the site" and stopping all work
   */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Date at which the visit was created.
   *     This equates to the time the mechanic declared being "on site" and ready to start working
   */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * The mechanic that **STARTED** this visit
   * @deprecated You should use mechanics instead to get all mechanics involved in the visit
   */
  mechanic: Mechanic;
  mechanicId: Scalars['ID']['output'];
  /** Mechanics that were present during this visit */
  mechanics: VisitsVisitMechanicGqlMechanicConnection;
  /** Missions that were available in this visit */
  missions: VisitsMissionConnection;
  overtimeAnswers?: Maybe<VisitOvertime>;
  /** All the available tasks that could have been done during this visit */
  tasks: VisitsVisitTaskTaskConnection;
};


/**
 * A visit is the act of physically going on site for a period of time to do one or more missions.
 *
 * Only during a visit can a mechanic answer questions or complete tasks (ie: do the work.)
 * Everytime a mechanic leaves the site, his visit is then closed, even if missions / tasks are left
 * unfinished.
 *
 * A given mechanic can only have one active (whose completedAt is null) visit at a time.
 */
export type VisitMechanicsArgs = {
  pagination?: InputMaybe<VisitsConnectionArgs>;
};


/**
 * A visit is the act of physically going on site for a period of time to do one or more missions.
 *
 * Only during a visit can a mechanic answer questions or complete tasks (ie: do the work.)
 * Everytime a mechanic leaves the site, his visit is then closed, even if missions / tasks are left
 * unfinished.
 *
 * A given mechanic can only have one active (whose completedAt is null) visit at a time.
 */
export type VisitMissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A visit is the act of physically going on site for a period of time to do one or more missions.
 *
 * Only during a visit can a mechanic answer questions or complete tasks (ie: do the work.)
 * Everytime a mechanic leaves the site, his visit is then closed, even if missions / tasks are left
 * unfinished.
 *
 * A given mechanic can only have one active (whose completedAt is null) visit at a time.
 */
export type VisitTasksArgs = {
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

export enum VisitOrmEntitySortableFields {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  Id = 'id',
  MechanicId = 'mechanicId'
}

/** Represents the overtime data about a visit. So basically when a visit is done out of "normal" working conditions, we might attach an overtime to it for accounting / billing purposes. */
export type VisitOvertime = {
  __typename?: 'VisitOvertime';
  approver?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  linkedWorkOrderIds?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
  /** WorkOrderUnlinkableReason:The reason why a work orders are not linkable at some point */
  workOrderUnlinkableReason?: Maybe<WorkOrderUnlinkableReason>;
};

export type VisitOvertimeForm = GraphQlForm & {
  __typename?: 'VisitOvertimeForm';
  /** The inputs that belong inside this form */
  inputs: Array<FormThing>;
  targets: Array<FormTarget>;
};

export type VisitTask = {
  __typename?: 'VisitTask';
  /** Answers given for this visit task during mechanics' visits. */
  answers: VisitsAnswerConnection;
  /** Date at which this task was completed **during this visit**. This corresponds to when the mechanic say he's done with the device. */
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Unique human readable id to be used in the report of the visitTask */
  reportNumber?: Maybe<Scalars['String']['output']>;
  /** Report associated to the visit of an engineer on a task for a device.This is used to store intervention bond that are sent to customer when a visit is made. */
  reportUrl?: Maybe<Scalars['String']['output']>;
  /** Date at which this task was started **during this visit**. This corresponds to the first time any change was made to this task during this visit (adding/modyfing an answer or submitting). If you want the date at which the task itself was first started, look at task.startedAt */
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Visit that contains all of the tasks the mechanic could have done */
  visit: Visit;
};


export type VisitTaskAnswersArgs = {
  order?: InputMaybe<Array<VisitsAnswerOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

export type VisitsAnswerConnection = {
  __typename?: 'VisitsAnswerConnection';
  edges: Array<VisitsAnswerEdge>;
  pageInfo: VisitsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type VisitsAnswerEdge = {
  __typename?: 'VisitsAnswerEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Answer;
};

export type VisitsAnswerOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: AnswerSortableFields;
};

export type VisitsAnswerPhotoConnection = {
  __typename?: 'VisitsAnswerPhotoConnection';
  edges: Array<VisitsAnswerPhotoEdge>;
  pageInfo: VisitsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type VisitsAnswerPhotoEdge = {
  __typename?: 'VisitsAnswerPhotoEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: AnswerPhoto;
};

export type VisitsAnswerPhotoOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: AnswerPhotoSortableFields;
};

export type VisitsConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VisitsMissionConnection = {
  __typename?: 'VisitsMissionConnection';
  edges: Array<VisitsMissionEdge>;
  pageInfo: VisitsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type VisitsMissionEdge = {
  __typename?: 'VisitsMissionEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Mission;
};

export type VisitsPageInfo = {
  __typename?: 'VisitsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type VisitsVisitConnection = {
  __typename?: 'VisitsVisitConnection';
  edges: Array<VisitsVisitEdge>;
  pageInfo: VisitsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type VisitsVisitEdge = {
  __typename?: 'VisitsVisitEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Visit;
};

export type VisitsVisitMechanicGqlMechanicConnection = {
  __typename?: 'VisitsVisitMechanicGQLMechanicConnection';
  edges: Array<VisitsVisitMechanicGqlMechanicEdge>;
  pageInfo: VisitsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type VisitsVisitMechanicGqlMechanicEdge = {
  __typename?: 'VisitsVisitMechanicGQLMechanicEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  /** Date at which the mechanic joined the visit */
  joinedAt: Scalars['DateTimeISO']['output'];
  /** Date at which the mechanic left the visit */
  leftAt?: Maybe<Scalars['DateTimeISO']['output']>;
  mechanic: Mechanic;
  node: Mechanic;
  /** RoleInVisit:Role of the mechanic in the visit. A principal being the main mechanic while collaborator are secondary mechanics that can help with the visit. */
  role: RoleInVisit;
};

export type VisitsVisitOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: VisitOrmEntitySortableFields;
};

export type VisitsVisitTaskTaskConnection = {
  __typename?: 'VisitsVisitTaskTaskConnection';
  edges: Array<VisitsVisitTaskTaskEdge>;
  pageInfo: VisitsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type VisitsVisitTaskTaskEdge = {
  __typename?: 'VisitsVisitTaskTaskEdge';
  /** Answers given for this visit task during mechanics' visits. */
  answers: VisitsAnswerConnection;
  /** Date at which this task was completed **during this visit**. This corresponds to when the mechanic say he's done with the device. */
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Task;
  /** Unique human readable id to be used in the report of the visitTask */
  reportNumber?: Maybe<Scalars['String']['output']>;
  /** Report associated to the visit of an engineer on a task for a device.This is used to store intervention bond that are sent to customer when a visit is made. */
  reportUrl?: Maybe<Scalars['String']['output']>;
  /** Date at which this task was started **during this visit**. This corresponds to the first time any change was made to this task during this visit (adding/modyfing an answer or submitting). If you want the date at which the task itself was first started, look at task.startedAt */
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Visit that contains all of the tasks the mechanic could have done */
  visit: Visit;
};


export type VisitsVisitTaskTaskEdgeAnswersArgs = {
  order?: InputMaybe<Array<VisitsAnswerOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

export type VisitsVisitTaskVisitConnection = {
  __typename?: 'VisitsVisitTaskVisitConnection';
  edges: Array<VisitsVisitTaskVisitEdge>;
  pageInfo: VisitsPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type VisitsVisitTaskVisitEdge = {
  __typename?: 'VisitsVisitTaskVisitEdge';
  /** Answers given for this visit task during mechanics' visits. */
  answers: VisitsAnswerConnection;
  /** Date at which this task was completed **during this visit**. This corresponds to when the mechanic say he's done with the device. */
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Visit;
  /** Unique human readable id to be used in the report of the visitTask */
  reportNumber?: Maybe<Scalars['String']['output']>;
  /** Report associated to the visit of an engineer on a task for a device.This is used to store intervention bond that are sent to customer when a visit is made. */
  reportUrl?: Maybe<Scalars['String']['output']>;
  /** Date at which this task was started **during this visit**. This corresponds to the first time any change was made to this task during this visit (adding/modyfing an answer or submitting). If you want the date at which the task itself was first started, look at task.startedAt */
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Visit that contains all of the tasks the mechanic could have done */
  visit: Visit;
};


export type VisitsVisitTaskVisitEdgeAnswersArgs = {
  order?: InputMaybe<Array<VisitsAnswerOrderOptions>>;
  pagination?: InputMaybe<VisitsConnectionArgs>;
};

/** VisualMap */
export type VisualMap = {
  __typename?: 'VisualMap';
  /** The index of the dimension in the dataset */
  dimension: Scalars['Int']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  /** Whether to reverse the color scale */
  reverse: Scalars['Boolean']['output'];
  /** The number of steps to use for the color scale */
  steps: Scalars['Int']['output'];
};

export type Visualization_CellHtml = {
  __typename?: 'Visualization_CellHtml';
  /** The name of the column (dimension or measure) this html is associated to */
  columnName: Scalars['String']['output'];
  html: Scalars['String']['output'];
  /** The row # this html is associated to (0 based) */
  row: Scalars['Int']['output'];
};

export type Visualization_DrillFields = {
  __typename?: 'Visualization_DrillFields';
  /** The index of the dimension in the dataset */
  dimension: Scalars['Int']['output'];
  fields?: Maybe<Array<Scalars['String']['output']>>;
};

export type Visualization_Links = {
  __typename?: 'Visualization_Links';
  /** The name of the column (dimension or measure) this link is associated to */
  columnName: Scalars['String']['output'];
  /** @deprecated use column name instead, links can be on more than just dimensions */
  dimension: Scalars['String']['output'];
  /** Link: */
  links: Array<Link>;
  /** The row # this link is associated to (0 based) */
  row: Scalars['Int']['output'];
};

export type Visualization_Series = {
  __typename?: 'Visualization_Series';
  color?: Maybe<Scalars['String']['output']>;
  /** Informations related to comparing a series value to a previous series value, or cumulative previous series value */
  comparison?: Maybe<Visualization_Series_Comparison>;
  data?: Maybe<Array<Visualization_Series_Data>>;
  groupPadding?: Maybe<Scalars['Float']['output']>;
  grouping?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stacking?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  valueFormat?: Maybe<Scalars['String']['output']>;
  yAxisIndex?: Maybe<Scalars['Float']['output']>;
  zIndex?: Maybe<Scalars['Float']['output']>;
};

export type Visualization_Series_Comparison = {
  __typename?: 'Visualization_Series_Comparison';
  /** Indicate if positive value should be considered as bad, true if positive is bad, false otherwise. */
  comparisonReverseColors?: Maybe<Scalars['Boolean']['output']>;
  /** The type of comparison display for example "value" just display the value as is, "change" display a up or down arrow... */
  comparisonType?: Maybe<Scalars['String']['output']>;
  /** The value to display as comparison */
  comparisonValue?: Maybe<Scalars['String']['output']>;
  /** The value format of the comparison value (as defined in looker for value format fields) */
  comparisonValueFormat?: Maybe<Scalars['String']['output']>;
  /** Should the comparison be displayed or not */
  showComparison?: Maybe<Scalars['Boolean']['output']>;
};

export type Visualization_Series_Data = {
  __typename?: 'Visualization_Series_Data';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type Visualization_XAxis = {
  __typename?: 'Visualization_XAxis';
  dateTimeFormat?: Maybe<Scalars['String']['output']>;
  labels: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Visualization_YAxes = {
  __typename?: 'Visualization_YAxes';
  labels: Array<Maybe<Scalars['String']['output']>>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  valueFormat?: Maybe<Scalars['String']['output']>;
};

export type Visualization_YAxis = {
  __typename?: 'Visualization_YAxis';
  labels: Array<Maybe<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
};

export type Withdrawal = {
  __typename?: 'Withdrawal';
  date: Scalars['DateTime']['output'];
  userInfos: UserInfo;
};

export type WmTicket = {
  __typename?: 'WmTicket';
  externalJobId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  openedAt: Scalars['DateTime']['output'];
  vendor: TicketVendor;
};

/** Determine the type of entry for this notification */
export enum WmTicketHistoryType {
  Closed = 'CLOSED',
  DeviceStatus = 'DEVICE_STATUS',
  Log = 'LOG',
  Opened = 'OPENED'
}

/** Determine how the device is impacted (Breakdown, trapped passenger, ...) */
export enum WmTicketType {
  Breakdown = 'BREAKDOWN',
  TrappedPassenger = 'TRAPPED_PASSENGER'
}

export type WorkOrderAllPartsAvailable = Activity & {
  __typename?: 'WorkOrderAllPartsAvailable';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  metadata: WorkOrderAllPartsAvailable_Metadata;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderAllPartsAvailableDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderAllPartsAvailableTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkOrderAllPartsAvailableMetadataPart = {
  __typename?: 'WorkOrderAllPartsAvailableMetadataPart';
  item: RequestItem;
};

export type WorkOrderAllPartsAvailable_Metadata = {
  __typename?: 'WorkOrderAllPartsAvailable_Metadata';
  /** WorkOrderAllPartsAvailableMetadataPart: */
  parts: Array<WorkOrderAllPartsAvailableMetadataPart>;
};

export type WorkOrderAllPartsPriced = Activity & {
  __typename?: 'WorkOrderAllPartsPriced';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  metadata: WorkOrderAllPartsPriced_Metadata;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderAllPartsPricedDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderAllPartsPricedTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkOrderAllPartsPricedMetadataPart = {
  __typename?: 'WorkOrderAllPartsPricedMetadataPart';
  item: RequestItem;
  price: Scalars['Float']['output'];
};

export type WorkOrderAllPartsPriced_Metadata = {
  __typename?: 'WorkOrderAllPartsPriced_Metadata';
  /** WorkOrderAllPartsPricedMetadataPart: */
  parts: Array<WorkOrderAllPartsPricedMetadataPart>;
};

export type WorkOrderChargeability = Activity & {
  __typename?: 'WorkOrderChargeability';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  isChargeable: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderChargeabilityDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderChargeabilityTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkOrderCompleted = Activity & {
  __typename?: 'WorkOrderCompleted';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  /** WorkOrderCompletionAction */
  completionAction: WorkOrderCompletionAction;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderCompletedDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderCompletedTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum WorkOrderCompletionAction {
  Completed = 'completed',
  CompletedWithoutValidation = 'completed_without_validation',
  ForcedCompletion = 'forced_completion'
}

export type WorkOrderCreated = Activity & {
  __typename?: 'WorkOrderCreated';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderCreatedDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderCreatedTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkOrderFormAnswerFeatureCreateInput = {
  reason: Scalars['String']['input'];
};

/** WorkOrderFormAnswerFeatureCreateOutput: */
export type WorkOrderFormAnswerFeatureCreateOutput = {
  __typename?: 'WorkOrderFormAnswerFeatureCreateOutput';
  reason: Scalars['String']['output'];
};

/** Props to tell the frontend what kind of work order to create */
export type WorkOrderFormCreationProps = {
  __typename?: 'WorkOrderFormCreationProps';
  /** The type of work order to create (e.g. SHUTDOWN) */
  type: Scalars['String']['output'];
};

/** The work order form feature of a question, including its mode and optional settings */
export type WorkOrderFormFeature = {
  __typename?: 'WorkOrderFormFeature';
  /** Defines the possibility to fill out a work order form and whether it is required to complete it */
  mode: QuestionFeatureMode;
  /** Settings for the work order form feature, if any */
  settings?: Maybe<WorkOrderFormSettings>;
};

/** Settings for the work order form feature */
export type WorkOrderFormSettings = {
  __typename?: 'WorkOrderFormSettings';
  /** Whether the user is allowed to submit without filling in the work order form */
  allowNothingRequired: Scalars['Boolean']['output'];
  /** Whether the user can pick an existing work order rather than creating a new one */
  canPickExisting: Scalars['Boolean']['output'];
  /** Props to tell the frontend what kind of work order to create */
  workOrder?: Maybe<WorkOrderFormCreationProps>;
};

export type WorkOrderPartsIdentified = Activity & {
  __typename?: 'WorkOrderPartsIdentified';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  metadata: WorkOrderPartsIdentified_Metadata;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderPartsIdentifiedDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderPartsIdentifiedTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkOrderPartsIdentifiedMetadataPart = {
  __typename?: 'WorkOrderPartsIdentifiedMetadataPart';
  item: RequestItem;
  quantity: Scalars['String']['output'];
};

export type WorkOrderPartsIdentified_Metadata = {
  __typename?: 'WorkOrderPartsIdentified_Metadata';
  /** WorkOrderPartsIdentifiedMetadataPart: */
  parts: Array<WorkOrderPartsRequestedMetadataPart>;
};

export type WorkOrderPartsPickedUp = Activity & {
  __typename?: 'WorkOrderPartsPickedUp';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  metadata: WorkOrderPartsPickedUp_Metadata;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderPartsPickedUpDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderPartsPickedUpTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkOrderPartsPickedUpMetadataPart = {
  __typename?: 'WorkOrderPartsPickedUpMetadataPart';
  item: RequestItem;
};

export type WorkOrderPartsPickedUp_Metadata = {
  __typename?: 'WorkOrderPartsPickedUp_Metadata';
  /** WorkOrderPartsPickedUpMetadataPart: */
  parts: Array<WorkOrderAllPartsAvailableMetadataPart>;
};

export type WorkOrderPartsRemoved = Activity & {
  __typename?: 'WorkOrderPartsRemoved';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  metadata: WorkOrderPartsRemoved_Metadata;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderPartsRemovedDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderPartsRemovedTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkOrderPartsRemovedMetadataPart = {
  __typename?: 'WorkOrderPartsRemovedMetadataPart';
  item: RequestItem;
};

export type WorkOrderPartsRemoved_Metadata = {
  __typename?: 'WorkOrderPartsRemoved_Metadata';
  /** WorkOrderPartsRemovedMetadataPart: */
  parts: Array<WorkOrderAllPartsAvailableMetadataPart>;
};

export type WorkOrderPartsRequested = Activity & {
  __typename?: 'WorkOrderPartsRequested';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  metadata: WorkOrderPartsRequested_Metadata;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderPartsRequestedDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderPartsRequestedTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkOrderPartsRequestedMetadataPart = {
  __typename?: 'WorkOrderPartsRequestedMetadataPart';
  item: RequestItem;
  quantity: Scalars['String']['output'];
};

export type WorkOrderPartsRequested_Metadata = {
  __typename?: 'WorkOrderPartsRequested_Metadata';
  /** WorkOrderPartsRequestedMetadataPart: */
  parts: Array<WorkOrderPartsRequestedMetadataPart>;
};

/** Whether the problem ended as solved or cancelled */
export enum WorkOrderProblemEndType {
  Cancelled = 'cancelled',
  Solved = 'solved'
}

export type WorkOrderProblemEndedWithOngoingQuote = Activity & {
  __typename?: 'WorkOrderProblemEndedWithOngoingQuote';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  /** WorkOrderProblemEndType:Whether the problem ended as solved or cancelled */
  problemEndType: WorkOrderProblemEndType;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderProblemEndedWithOngoingQuoteDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderProblemEndedWithOngoingQuoteTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkOrderRfqSent = Activity & {
  __typename?: 'WorkOrderRFQSent';
  /** Actor: */
  actor: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  metadata: WorkOrderRfqSent_Metadata;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderRfqSentDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderRfqSentTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** WorkOrderRFQSentMetadataPart: */
export type WorkOrderRfqSentMetadataPart = {
  __typename?: 'WorkOrderRFQSentMetadataPart';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** WorkOrderRFQSentMetadataVendor: */
export type WorkOrderRfqSentMetadataVendor = {
  __typename?: 'WorkOrderRFQSentMetadataVendor';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkOrderRfqSent_Metadata = {
  __typename?: 'WorkOrderRFQSent_Metadata';
  /** WorkOrderRFQSentMetadataPart: */
  parts: Array<WorkOrderRfqSentMetadataPart>;
  /** WorkOrderRFQSentMetadataVendor: */
  vendors: Array<WorkOrderRfqSentMetadataVendor>;
};

export type WorkOrderTaskCompleted = Activity & {
  __typename?: 'WorkOrderTaskCompleted';
  /** Actor: */
  actor: User;
  comment?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  task: Task;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};


export type WorkOrderTaskCompletedDescriptionArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkOrderTaskCompletedTitleArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The type of work order: REPAIR or CALLOUT */
export enum WorkOrderType {
  Callout = 'CALLOUT',
  Repair = 'REPAIR',
  Shutdown = 'SHUTDOWN'
}

/** The reason why a work orders are not linkable at some point */
export enum WorkOrderUnlinkableReason {
  WorkOrderNotLinked = 'WORK_ORDER_NOT_LINKED',
  WorkOrderNotListed = 'WORK_ORDER_NOT_LISTED'
}

export type WorkOrdersConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkOrdersPageInfo = {
  __typename?: 'WorkOrdersPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type WorkOrdersPartBrandGraphqlConnection = {
  __typename?: 'WorkOrdersPartBrandGraphqlConnection';
  edges: Array<WorkOrdersPartBrandGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersPartBrandGraphqlEdge = {
  __typename?: 'WorkOrdersPartBrandGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: PartBrand;
};

export type WorkOrdersPartCategoryGraphqlConnection = {
  __typename?: 'WorkOrdersPartCategoryGraphqlConnection';
  edges: Array<WorkOrdersPartCategoryGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersPartCategoryGraphqlEdge = {
  __typename?: 'WorkOrdersPartCategoryGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: PartCategory;
};

export type WorkOrdersPartGraphqlConnection = {
  __typename?: 'WorkOrdersPartGraphqlConnection';
  edges: Array<WorkOrdersPartGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersPartGraphqlEdge = {
  __typename?: 'WorkOrdersPartGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Part;
};

export type WorkOrdersProblemStateKeyGraphqlConnection = {
  __typename?: 'WorkOrdersProblemStateKeyGraphqlConnection';
  edges: Array<WorkOrdersProblemStateKeyGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersProblemStateKeyGraphqlEdge = {
  __typename?: 'WorkOrdersProblemStateKeyGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: RepairRequestProblemStateKey;
};

export type WorkOrdersQuoteGraphqlConnection = {
  __typename?: 'WorkOrdersQuoteGraphqlConnection';
  edges: Array<WorkOrdersQuoteGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersQuoteGraphqlEdge = {
  __typename?: 'WorkOrdersQuoteGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Quote;
};

/**
 * The status of the quote: TO_SIGN if the quote need the customer review, SIGNED if the customer
 * has review and validated the quote, REFUSED if customer refuse it.
 */
export enum WorkOrdersQuoteStatus {
  Draft = 'DRAFT',
  Refused = 'REFUSED',
  Signed = 'SIGNED',
  ToSign = 'TO_SIGN',
  Validation = 'VALIDATION'
}

export type WorkOrdersRepairRequestActionGraphqlConnection = {
  __typename?: 'WorkOrdersRepairRequestActionGraphqlConnection';
  edges: Array<WorkOrdersRepairRequestActionGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersRepairRequestActionGraphqlEdge = {
  __typename?: 'WorkOrdersRepairRequestActionGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: RepairRequestAction;
};

export type WorkOrdersRepairRequestActionOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: RepairRequestActionOrmEntitySortableFields;
};

export type WorkOrdersRepairRequestBundledRepairRequestGraphqlRepairRequestGraphqlConnection = {
  __typename?: 'WorkOrdersRepairRequestBundledRepairRequestGraphqlRepairRequestGraphqlConnection';
  edges: Array<WorkOrdersRepairRequestBundledRepairRequestGraphqlRepairRequestGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersRepairRequestBundledRepairRequestGraphqlRepairRequestGraphqlEdge = {
  __typename?: 'WorkOrdersRepairRequestBundledRepairRequestGraphqlRepairRequestGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: RepairRequest;
};

/** Represent the type of comment we want to edit. */
export enum WorkOrdersRepairRequestCommentType {
  EngineerComment = 'ENGINEER_COMMENT',
  InternalComment = 'INTERNAL_COMMENT'
}

export type WorkOrdersRepairRequestDeliveryOptionGraphqlConnection = {
  __typename?: 'WorkOrdersRepairRequestDeliveryOptionGraphqlConnection';
  edges: Array<WorkOrdersRepairRequestDeliveryOptionGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersRepairRequestDeliveryOptionGraphqlEdge = {
  __typename?: 'WorkOrdersRepairRequestDeliveryOptionGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: RepairRequestDeliveryOption;
};

export type WorkOrdersRepairRequestGraphqlConnection = {
  __typename?: 'WorkOrdersRepairRequestGraphqlConnection';
  edges: Array<WorkOrdersRepairRequestGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersRepairRequestGraphqlEdge = {
  __typename?: 'WorkOrdersRepairRequestGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: RepairRequest;
};

export type WorkOrdersRepairRequestIssueGraphqlIssueSnapshotConnection = {
  __typename?: 'WorkOrdersRepairRequestIssueGraphqlIssueSnapshotConnection';
  edges: Array<WorkOrdersRepairRequestIssueGraphqlIssueSnapshotEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersRepairRequestIssueGraphqlIssueSnapshotEdge = {
  __typename?: 'WorkOrdersRepairRequestIssueGraphqlIssueSnapshotEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: IssueSnapshot;
};

export type WorkOrdersRepairRequestIssueGraphqlRepairRequestGraphqlConnection = {
  __typename?: 'WorkOrdersRepairRequestIssueGraphqlRepairRequestGraphqlConnection';
  edges: Array<WorkOrdersRepairRequestIssueGraphqlRepairRequestGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersRepairRequestIssueGraphqlRepairRequestGraphqlEdge = {
  __typename?: 'WorkOrdersRepairRequestIssueGraphqlRepairRequestGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: RepairRequest;
};

export type WorkOrdersRepairRequestOrmEntityOrderOptions = {
  direction?: OrderingDirection;
  nulls?: InputMaybe<NullsOrdering>;
  sort: RepairRequestOrmEntitySortableFields;
};

/**
 * Represent the status of a quote from a business point of view in the repair request domain.
 * This state is repair request related and front oriented, this is not the same as the quote.status.
 */
export enum WorkOrdersRepairRequestQuoteState {
  Denied = 'DENIED',
  Done = 'DONE',
  QuoteToBill = 'QUOTE_TO_BILL',
  QuoteToSend = 'QUOTE_TO_SEND',
  QuoteToSignByCustomer = 'QUOTE_TO_SIGN_BY_CUSTOMER',
  QuoteToVerifyPo = 'QUOTE_TO_VERIFY_PO'
}

export type WorkOrdersRepairRequestSupplyManagerGrapqhlConnection = {
  __typename?: 'WorkOrdersRepairRequestSupplyManagerGrapqhlConnection';
  edges: Array<WorkOrdersRepairRequestSupplyManagerGrapqhlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersRepairRequestSupplyManagerGrapqhlEdge = {
  __typename?: 'WorkOrdersRepairRequestSupplyManagerGrapqhlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: RepairRequestSupplyManager;
};

export type WorkOrdersRepairRequestTaskGraphqlTaskConnection = {
  __typename?: 'WorkOrdersRepairRequestTaskGraphqlTaskConnection';
  edges: Array<WorkOrdersRepairRequestTaskGraphqlTaskEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersRepairRequestTaskGraphqlTaskEdge = {
  __typename?: 'WorkOrdersRepairRequestTaskGraphqlTaskEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  /** Indicate if the repair was flagged as completed by the engineer during this task */
  isRepairCompleted: Scalars['Boolean']['output'];
  /** Date at which this task was linked to the repair request */
  linkedDate: Scalars['DateTime']['output'];
  node: Task;
};

export type WorkOrdersVendorGraphqlConnection = {
  __typename?: 'WorkOrdersVendorGraphqlConnection';
  edges: Array<WorkOrdersVendorGraphqlEdge>;
  pageInfo: WorkOrdersPageInfo;
  /** Total count of items found matching the criterias */
  totalCount: Scalars['Int']['output'];
};

export type WorkOrdersVendorGraphqlEdge = {
  __typename?: 'WorkOrdersVendorGraphqlEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Vendor;
};

export type XyChart = QueryResult & {
  __typename?: 'XYChart';
  advancedConfig?: Maybe<Scalars['String']['output']>;
  cellHtml?: Maybe<Array<Visualization_CellHtml>>;
  color?: Maybe<Array<Scalars['String']['output']>>;
  /** ConditionalVisualFormat */
  conditionalVisualFormat?: Maybe<Array<ConditionalVisualFormat>>;
  /** Dataset */
  dataset?: Maybe<Dataset>;
  /** XYChartDisplay */
  display: XyChartDisplay;
  drillFields?: Maybe<Array<Visualization_DrillFields>>;
  labelValueFormat?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Visualization_Links>>;
  /** Note */
  note?: Maybe<Note>;
  series?: Maybe<Array<Visualization_Series>>;
  /** Sort */
  sort?: Maybe<Sort>;
  title?: Maybe<Scalars['String']['output']>;
  /** ValueFormat */
  valueFormat?: Maybe<Array<ValueFormat>>;
  /** VisualMap */
  visualMap?: Maybe<Array<VisualMap>>;
  xAxis?: Maybe<Visualization_XAxis>;
  yAxes?: Maybe<Array<Visualization_YAxes>>;
  yAxis?: Maybe<Visualization_YAxis>;
};

/** XYChartDisplay */
export type XyChartDisplay = {
  __typename?: 'XYChartDisplay';
  /** Orientation */
  orientation: Orientation;
  /** ReferenceLine */
  referenceLines?: Maybe<Array<ReferenceLine>>;
  /** Serie */
  series: Array<Serie>;
  /** YAxis */
  yAxis?: Maybe<Array<YAxis>>;
};

/** YAxis */
export type YAxis = {
  __typename?: 'YAxis';
  dimensions?: Maybe<Array<Scalars['Int']['output']>>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  position: Scalars['String']['output'];
  show?: Maybe<Scalars['Boolean']['output']>;
  /** Formatting value as defined in [ECMA-376] */
  valueFormat?: Maybe<Scalars['String']['output']>;
};

export type YearInput = FormInput & FormThing & {
  __typename?: 'YearInput';
  /** If set, means that changing this field would update 1<->1 to the corresponding key in the entity */
  entityKey?: Maybe<Scalars['String']['output']>;
  /** The identifier of this input, to be sent back to the backend */
  key?: Maybe<Scalars['String']['output']>;
  options: Array<InputOption>;
  settings: YearInputSettings;
  title: Scalars['String']['output'];
  /** Current value associated to the input */
  value?: Maybe<Scalars['ValueOfInput']['output']>;
};

export type YearInputSettings = IInputSettings & {
  __typename?: 'YearInputSettings';
  /** If true, an option "Unknown" can be selected */
  canBeUnknown?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this input should not be editable */
  disabled: Scalars['Boolean']['output'];
  /** The smallest year you can select */
  minYear?: Maybe<Scalars['Int']['output']>;
  /** If true, this input should be considered required */
  required: Scalars['Boolean']['output'];
};

/** Generic yes/no type */
export enum YesNoType {
  No = 'NO',
  Yes = 'YES'
}

/** Filters to apply when fetching visible buildings for a mechanic */
export type AllVisibleBuildingsForMechanicFilter = {
  /** Filter buildings with a search on building name, city name, zipcode or address */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter buildings which have signed contracts */
  withContract?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for closing issues */
export type CancelIssuesInput = {
  /** Reason for cancelling issues */
  closeReason?: InputMaybe<CloseReason>;
  /** Fetch issues by id */
  issueIds: Array<Scalars['ID']['input']>;
};

export type CancelIssuesResult = {
  __typename?: 'cancelIssuesResult';
  /** Snapshots of the issues closed */
  issuesSnapshot: Array<IssueSnapshot>;
};
